! function (t) {
  var n = {};

  function e(i) {
    if (n[i]) return n[i].exports;
    var a = n[i] = {
      i: i,
      l: !1,
      exports: {}
    };
    return t[i].call(a.exports, a, a.exports, e), a.l = !0, a.exports
  }
  e.m = t, e.c = n, e.d = function (t, n, i) {
    e.o(t, n) || Object.defineProperty(t, n, {
      enumerable: !0,
      get: i
    })
  }, e.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    })
  }, e.t = function (t, n) {
    if (1 & n && (t = e(t)), 8 & n) return t;
    if (4 & n && "object" == typeof t && t && t.__esModule) return t;
    var i = Object.create(null);
    if (e.r(i), Object.defineProperty(i, "default", {
        enumerable: !0,
        value: t
      }), 2 & n && "string" != typeof t)
      for (var a in t) e.d(i, a, function (n) {
        return t[n]
      }.bind(null, a));
    return i
  }, e.n = function (t) {
    var n = t && t.__esModule ? function () {
      return t.default
    } : function () {
      return t
    };
    return e.d(n, "a", n), n
  }, e.o = function (t, n) {
    return Object.prototype.hasOwnProperty.call(t, n)
  }, e.p = "", e(e.s = 165)
}([function (t, n, e) {
  var i = e(2),
    a = e(16).f,
    r = e(17),
    o = e(18),
    l = e(91),
    c = e(124),
    s = e(58);
  t.exports = function (t, n) {
    var e, h, u, f, v, p = t.target,
      g = t.global,
      d = t.stat;
    if (e = g ? i : d ? i[p] || l(p, {}) : (i[p] || {}).prototype)
      for (h in n) {
        if (f = n[h], u = t.noTargetGet ? (v = a(e, h)) && v.value : e[h], !s(g ? h : p + (d ? "." : "#") + h, t.forced) && void 0 !== u) {
          if (typeof f == typeof u) continue;
          c(f, u)
        }(t.sham || u && u.sham) && r(f, "sham", !0), o(e, h, f, t)
      }
  }
}, function (t, n) {
  t.exports = function (t) {
    try {
      return !!t()
    } catch (t) {
      return !0
    }
  }
}, function (t, n, e) {
  (function (n) {
    var e = function (t) {
      return t && t.Math == Math && t
    };
    t.exports = e("object" == typeof globalThis && globalThis) || e("object" == typeof window && window) || e("object" == typeof self && self) || e("object" == typeof n && n) || function () {
      return this
    }() || Function("return this")()
  }).call(this, e(168))
}, function (t, n) {
  t.exports = function (t) {
    return "object" == typeof t ? null !== t : "function" == typeof t
  }
}, function (t, n, e) {
  var i = e(3);
  t.exports = function (t) {
    if (!i(t)) throw TypeError(String(t) + " is not an object");
    return t
  }
}, function (t, n, e) {
  var i = e(2),
    a = e(68),
    r = e(12),
    o = e(55),
    l = e(89),
    c = e(120),
    s = a("wks"),
    h = i.Symbol,
    u = c ? h : h && h.withoutSetter || o;
  t.exports = function (t) {
    return r(s, t) && (l || "string" == typeof s[t]) || (l && r(h, t) ? s[t] = h[t] : s[t] = u("Symbol." + t)), s[t]
  }
}, function (t, n, e) {
  var i = e(1);
  t.exports = !i((function () {
    return 7 != Object.defineProperty({}, 1, {
      get: function () {
        return 7
      }
    })[1]
  }))
}, function (t, n, e) {
  var i = e(21),
    a = Math.min;
  t.exports = function (t) {
    return t > 0 ? a(i(t), 9007199254740991) : 0
  }
}, function (t, n, e) {
  "use strict";
  var i, a, r, o = e(106),
    l = e(6),
    c = e(2),
    s = e(3),
    h = e(12),
    u = e(63),
    f = e(17),
    v = e(18),
    p = e(10).f,
    g = e(27),
    d = e(33),
    m = e(5),
    F = e(55),
    M = c.Int8Array,
    w = M && M.prototype,
    z = c.Uint8ClampedArray,
    y = z && z.prototype,
    A = M && g(M),
    U = w && g(w),
    H = Object.prototype,
    x = H.isPrototypeOf,
    E = m("toStringTag"),
    S = F("TYPED_ARRAY_TAG"),
    B = F("TYPED_ARRAY_CONSTRUCTOR"),
    D = o && !!d && "Opera" !== u(c.opera),
    b = !1,
    N = {
      Int8Array: 1,
      Uint8Array: 1,
      Uint8ClampedArray: 1,
      Int16Array: 2,
      Uint16Array: 2,
      Int32Array: 4,
      Uint32Array: 4,
      Float32Array: 4,
      Float64Array: 8
    },
    j = {
      BigInt64Array: 8,
      BigUint64Array: 8
    },
    L = function (t) {
      if (!s(t)) return !1;
      var n = u(t);
      return h(N, n) || h(j, n)
    };
  for (i in N)(r = (a = c[i]) && a.prototype) ? f(r, B, a) : D = !1;
  for (i in j)(r = (a = c[i]) && a.prototype) && f(r, B, a);
  if ((!D || "function" != typeof A || A === Function.prototype) && (A = function () {
      throw TypeError("Incorrect invocation")
    }, D))
    for (i in N) c[i] && d(c[i], A);
  if ((!D || !U || U === H) && (U = A.prototype, D))
    for (i in N) c[i] && d(c[i].prototype, U);
  if (D && g(y) !== U && d(y, U), l && !h(U, E))
    for (i in b = !0, p(U, E, {
        get: function () {
          return s(this) ? this[S] : void 0
        }
      }), N) c[i] && f(c[i], S, i);
  t.exports = {
    NATIVE_ARRAY_BUFFER_VIEWS: D,
    TYPED_ARRAY_CONSTRUCTOR: B,
    TYPED_ARRAY_TAG: b && S,
    aTypedArray: function (t) {
      if (L(t)) return t;
      throw TypeError("Target is not a typed array")
    },
    aTypedArrayConstructor: function (t) {
      if (d && !x.call(A, t)) throw TypeError("Target is not a typed array constructor");
      return t
    },
    exportTypedArrayMethod: function (t, n, e) {
      if (l) {
        if (e)
          for (var i in N) {
            var a = c[i];
            if (a && h(a.prototype, t)) try {
              delete a.prototype[t]
            } catch (t) {}
          }
        U[t] && !e || v(U, t, e ? n : D && w[t] || n)
      }
    },
    exportTypedArrayStaticMethod: function (t, n, e) {
      var i, a;
      if (l) {
        if (d) {
          if (e)
            for (i in N)
              if ((a = c[i]) && h(a, t)) try {
                delete a[t]
              } catch (t) {}
          if (A[t] && !e) return;
          try {
            return v(A, t, e ? n : D && A[t] || n)
          } catch (t) {}
        }
        for (i in N) !(a = c[i]) || a[t] && !e || v(a, t, n)
      }
    },
    isView: function (t) {
      if (!s(t)) return !1;
      var n = u(t);
      return "DataView" === n || h(N, n) || h(j, n)
    },
    isTypedArray: L,
    TypedArray: A,
    TypedArrayPrototype: U
  }
}, function (t, n, e) {
  var i = e(47);
  t.exports = function (t) {
    if (i(t)) throw TypeError("Cannot convert a Symbol value to a string");
    return String(t)
  }
}, function (t, n, e) {
  var i = e(6),
    a = e(122),
    r = e(4),
    o = e(36),
    l = Object.defineProperty;
  n.f = i ? l : function (t, n, e) {
    if (r(t), n = o(n), r(e), a) try {
      return l(t, n, e)
    } catch (t) {}
    if ("get" in e || "set" in e) throw TypeError("Accessors not supported");
    return "value" in e && (t[n] = e.value), t
  }
}, function (t, n, e) {
  var i = e(13);
  t.exports = function (t) {
    return Object(i(t))
  }
}, function (t, n, e) {
  var i = e(11),
    a = {}.hasOwnProperty;
  t.exports = Object.hasOwn || function (t, n) {
    return a.call(i(t), n)
  }
}, function (t, n) {
  t.exports = function (t) {
    if (null == t) throw TypeError("Can't call method on " + t);
    return t
  }
}, function (t, n, e) {
  var i, a, r, o = e(123),
    l = e(2),
    c = e(3),
    s = e(17),
    h = e(12),
    u = e(90),
    f = e(69),
    v = e(56),
    p = l.WeakMap;
  if (o || u.state) {
    var g = u.state || (u.state = new p),
      d = g.get,
      m = g.has,
      F = g.set;
    i = function (t, n) {
      if (m.call(g, t)) throw new TypeError("Object already initialized");
      return n.facade = t, F.call(g, t, n), n
    }, a = function (t) {
      return d.call(g, t) || {}
    }, r = function (t) {
      return m.call(g, t)
    }
  } else {
    var M = f("state");
    v[M] = !0, i = function (t, n) {
      if (h(t, M)) throw new TypeError("Object already initialized");
      return n.facade = t, s(t, M, n), n
    }, a = function (t) {
      return h(t, M) ? t[M] : {}
    }, r = function (t) {
      return h(t, M)
    }
  }
  t.exports = {
    set: i,
    get: a,
    has: r,
    enforce: function (t) {
      return r(t) ? a(t) : i(t, {})
    },
    getterFor: function (t) {
      return function (n) {
        var e;
        if (!c(n) || (e = a(n)).type !== t) throw TypeError("Incompatible receiver, " + t + " required");
        return e
      }
    }
  }
}, function (t, n, e) {
  var i = e(40),
    a = e(54),
    r = e(11),
    o = e(7),
    l = e(60),
    c = [].push,
    s = function (t) {
      var n = 1 == t,
        e = 2 == t,
        s = 3 == t,
        h = 4 == t,
        u = 6 == t,
        f = 7 == t,
        v = 5 == t || u;
      return function (p, g, d, m) {
        for (var F, M, w = r(p), z = a(w), y = i(g, d, 3), A = o(z.length), U = 0, H = m || l, x = n ? H(p, A) : e || f ? H(p, 0) : void 0; A > U; U++)
          if ((v || U in z) && (M = y(F = z[U], U, w), t))
            if (n) x[U] = M;
            else if (M) switch (t) {
          case 3:
            return !0;
          case 5:
            return F;
          case 6:
            return U;
          case 2:
            c.call(x, F)
        } else switch (t) {
          case 4:
            return !1;
          case 7:
            c.call(x, F)
        }
        return u ? -1 : s || h ? h : x
      }
    };
  t.exports = {
    forEach: s(0),
    map: s(1),
    filter: s(2),
    some: s(3),
    every: s(4),
    find: s(5),
    findIndex: s(6),
    filterReject: s(7)
  }
}, function (t, n, e) {
  var i = e(6),
    a = e(67),
    r = e(30),
    o = e(23),
    l = e(36),
    c = e(12),
    s = e(122),
    h = Object.getOwnPropertyDescriptor;
  n.f = i ? h : function (t, n) {
    if (t = o(t), n = l(n), s) try {
      return h(t, n)
    } catch (t) {}
    if (c(t, n)) return r(!a.f.call(t, n), t[n])
  }
}, function (t, n, e) {
  var i = e(6),
    a = e(10),
    r = e(30);
  t.exports = i ? function (t, n, e) {
    return a.f(t, n, r(1, e))
  } : function (t, n, e) {
    return t[n] = e, t
  }
}, function (t, n, e) {
  var i = e(2),
    a = e(17),
    r = e(12),
    o = e(91),
    l = e(93),
    c = e(14),
    s = c.get,
    h = c.enforce,
    u = String(String).split("String");
  (t.exports = function (t, n, e, l) {
    var c, s = !!l && !!l.unsafe,
      f = !!l && !!l.enumerable,
      v = !!l && !!l.noTargetGet;
    "function" == typeof e && ("string" != typeof n || r(e, "name") || a(e, "name", n), (c = h(e)).source || (c.source = u.join("string" == typeof n ? n : ""))), t !== i ? (s ? !v && t[n] && (f = !0) : delete t[n], f ? t[n] = e : a(t, n, e)) : f ? t[n] = e : o(n, e)
  })(Function.prototype, "toString", (function () {
    return "function" == typeof this && s(this).source || l(this)
  }))
}, function (t, n) {
  t.exports = function (t) {
    if ("function" != typeof t) throw TypeError(String(t) + " is not a function");
    return t
  }
}, function (t, n, e) {
  var i = e(2),
    a = function (t) {
      return "function" == typeof t ? t : void 0
    };
  t.exports = function (t, n) {
    return arguments.length < 2 ? a(i[t]) : i[t] && i[t][n]
  }
}, function (t, n) {
  var e = Math.ceil,
    i = Math.floor;
  t.exports = function (t) {
    return isNaN(t = +t) ? 0 : (t > 0 ? i : e)(t)
  }
}, function (t, n, e) {
  var i = e(128),
    a = e(12),
    r = e(127),
    o = e(10).f;
  t.exports = function (t) {
    var n = i.Symbol || (i.Symbol = {});
    a(n, t) || o(n, t, {
      value: r.f(t)
    })
  }
}, function (t, n, e) {
  var i = e(54),
    a = e(13);
  t.exports = function (t) {
    return i(a(t))
  }
}, function (t, n, e) {
  var i = e(13),
    a = e(9),
    r = /"/g;
  t.exports = function (t, n, e, o) {
    var l = a(i(t)),
      c = "<" + n;
    return "" !== e && (c += " " + e + '="' + a(o).replace(r, "&quot;") + '"'), c + ">" + l + "</" + n + ">"
  }
}, function (t, n, e) {
  var i = e(1);
  t.exports = function (t) {
    return i((function () {
      var n = "" [t]('"');
      return n !== n.toLowerCase() || n.split('"').length > 3
    }))
  }
}, function (t, n) {
  t.exports = !1
}, function (t, n, e) {
  var i = e(12),
    a = e(11),
    r = e(69),
    o = e(99),
    l = r("IE_PROTO"),
    c = Object.prototype;
  t.exports = o ? Object.getPrototypeOf : function (t) {
    return t = a(t), i(t, l) ? t[l] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? c : null
  }
}, function (t, n, e) {
  var i, a = e(4),
    r = e(97),
    o = e(95),
    l = e(56),
    c = e(126),
    s = e(92),
    h = e(69),
    u = h("IE_PROTO"),
    f = function () {},
    v = function (t) {
      return "<script>" + t + "<\/script>"
    },
    p = function (t) {
      t.write(v("")), t.close();
      var n = t.parentWindow.Object;
      return t = null, n
    },
    g = function () {
      try {
        i = new ActiveXObject("htmlfile")
      } catch (t) {}
      var t, n;
      g = "undefined" != typeof document ? document.domain && i ? p(i) : ((n = s("iframe")).style.display = "none", c.appendChild(n), n.src = String("javascript:"), (t = n.contentWindow.document).open(), t.write(v("document.F=Object")), t.close(), t.F) : p(i);
      for (var e = o.length; e--;) delete g.prototype[o[e]];
      return g()
    };
  l[u] = !0, t.exports = Object.create || function (t, n) {
    var e;
    return null !== t ? (f.prototype = a(t), e = new f, f.prototype = null, e[u] = t) : e = g(), void 0 === n ? e : r(e, n)
  }
}, function (t, n, e) {
  var i = e(10).f,
    a = e(12),
    r = e(5)("toStringTag");
  t.exports = function (t, n, e) {
    t && !a(t = e ? t : t.prototype, r) && i(t, r, {
      configurable: !0,
      value: n
    })
  }
}, function (t, n) {
  t.exports = function (t, n) {
    return {
      enumerable: !(1 & t),
      configurable: !(2 & t),
      writable: !(4 & t),
      value: n
    }
  }
}, function (t, n) {
  var e = {}.toString;
  t.exports = function (t) {
    return e.call(t).slice(8, -1)
  }
}, function (t, n, e) {
  var i = e(20);
  t.exports = i("navigator", "userAgent") || ""
}, function (t, n, e) {
  var i = e(4),
    a = e(129);
  t.exports = Object.setPrototypeOf || ("__proto__" in {} ? function () {
    var t, n = !1,
      e = {};
    try {
      (t = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set).call(e, []), n = e instanceof Array
    } catch (t) {}
    return function (e, r) {
      return i(e), a(r), n ? t.call(e, r) : e.__proto__ = r, e
    }
  }() : void 0)
}, function (t, n, e) {
  "use strict";
  var i = e(1);
  t.exports = function (t, n) {
    var e = [][t];
    return !!e && i((function () {
      e.call(null, n || function () {
        throw 1
      }, 1)
    }))
  }
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(2),
    r = e(6),
    o = e(118),
    l = e(8),
    c = e(73),
    s = e(43),
    h = e(30),
    u = e(17),
    f = e(110),
    v = e(7),
    p = e(140),
    g = e(158),
    d = e(36),
    m = e(12),
    F = e(63),
    M = e(3),
    w = e(47),
    z = e(28),
    y = e(33),
    A = e(38).f,
    U = e(159),
    H = e(15).forEach,
    x = e(49),
    E = e(10),
    S = e(16),
    B = e(14),
    D = e(75),
    b = B.get,
    N = B.set,
    j = E.f,
    L = S.f,
    C = Math.round,
    T = a.RangeError,
    I = c.ArrayBuffer,
    R = c.DataView,
    V = l.NATIVE_ARRAY_BUFFER_VIEWS,
    k = l.TYPED_ARRAY_CONSTRUCTOR,
    O = l.TYPED_ARRAY_TAG,
    P = l.TypedArray,
    G = l.TypedArrayPrototype,
    K = l.aTypedArrayConstructor,
    W = l.isTypedArray,
    _ = function (t, n) {
      for (var e = 0, i = n.length, a = new(K(t))(i); i > e;) a[e] = n[e++];
      return a
    },
    Y = function (t, n) {
      j(t, n, {
        get: function () {
          return b(this)[n]
        }
      })
    },
    Z = function (t) {
      var n;
      return t instanceof I || "ArrayBuffer" == (n = F(t)) || "SharedArrayBuffer" == n
    },
    J = function (t, n) {
      return W(t) && !w(n) && n in t && f(+n) && n >= 0
    },
    q = function (t, n) {
      return n = d(n), J(t, n) ? h(2, t[n]) : L(t, n)
    },
    X = function (t, n, e) {
      return n = d(n), !(J(t, n) && M(e) && m(e, "value")) || m(e, "get") || m(e, "set") || e.configurable || m(e, "writable") && !e.writable || m(e, "enumerable") && !e.enumerable ? j(t, n, e) : (t[n] = e.value, t)
    };
  r ? (V || (S.f = q, E.f = X, Y(G, "buffer"), Y(G, "byteOffset"), Y(G, "byteLength"), Y(G, "length")), i({
    target: "Object",
    stat: !0,
    forced: !V
  }, {
    getOwnPropertyDescriptor: q,
    defineProperty: X
  }), t.exports = function (t, n, e) {
    var r = t.match(/\d+$/)[0] / 8,
      l = t + (e ? "Clamped" : "") + "Array",
      c = "get" + t,
      h = "set" + t,
      f = a[l],
      d = f,
      m = d && d.prototype,
      F = {},
      w = function (t, n) {
        j(t, n, {
          get: function () {
            return function (t, n) {
              var e = b(t);
              return e.view[c](n * r + e.byteOffset, !0)
            }(this, n)
          },
          set: function (t) {
            return function (t, n, i) {
              var a = b(t);
              e && (i = (i = C(i)) < 0 ? 0 : i > 255 ? 255 : 255 & i), a.view[h](n * r + a.byteOffset, i, !0)
            }(this, n, t)
          },
          enumerable: !0
        })
      };
    V ? o && (d = n((function (t, n, e, i) {
      return s(t, d, l), D(M(n) ? Z(n) ? void 0 !== i ? new f(n, g(e, r), i) : void 0 !== e ? new f(n, g(e, r)) : new f(n) : W(n) ? _(d, n) : U.call(d, n) : new f(p(n)), t, d)
    })), y && y(d, P), H(A(f), (function (t) {
      t in d || u(d, t, f[t])
    })), d.prototype = m) : (d = n((function (t, n, e, i) {
      s(t, d, l);
      var a, o, c, h = 0,
        u = 0;
      if (M(n)) {
        if (!Z(n)) return W(n) ? _(d, n) : U.call(d, n);
        a = n, u = g(e, r);
        var f = n.byteLength;
        if (void 0 === i) {
          if (f % r) throw T("Wrong length");
          if ((o = f - u) < 0) throw T("Wrong length")
        } else if ((o = v(i) * r) + u > f) throw T("Wrong length");
        c = o / r
      } else c = p(n), a = new I(o = c * r);
      for (N(t, {
          buffer: a,
          byteOffset: u,
          byteLength: o,
          length: c,
          view: new R(a)
        }); h < c;) w(t, h++)
    })), y && y(d, P), m = d.prototype = z(G)), m.constructor !== d && u(m, "constructor", d), u(m, k, d), O && u(m, O, l), F[l] = d, i({
      global: !0,
      forced: d != f,
      sham: !V
    }, F), "BYTES_PER_ELEMENT" in d || u(d, "BYTES_PER_ELEMENT", r), "BYTES_PER_ELEMENT" in m || u(m, "BYTES_PER_ELEMENT", r), x(l)
  }) : t.exports = function () {}
}, function (t, n, e) {
  var i = e(88),
    a = e(47);
  t.exports = function (t) {
    var n = i(t, "string");
    return a(n) ? n : String(n)
  }
}, function (t, n, e) {
  var i, a, r = e(2),
    o = e(32),
    l = r.process,
    c = r.Deno,
    s = l && l.versions || c && c.version,
    h = s && s.v8;
  h ? a = (i = h.split("."))[0] < 4 ? 1 : i[0] + i[1] : o && (!(i = o.match(/Edge\/(\d+)/)) || i[1] >= 74) && (i = o.match(/Chrome\/(\d+)/)) && (a = i[1]), t.exports = a && +a
}, function (t, n, e) {
  var i = e(125),
    a = e(95).concat("length", "prototype");
  n.f = Object.getOwnPropertyNames || function (t) {
    return i(t, a)
  }
}, function (t, n, e) {
  var i = e(21),
    a = Math.max,
    r = Math.min;
  t.exports = function (t, n) {
    var e = i(t);
    return e < 0 ? a(e + n, 0) : r(e, n)
  }
}, function (t, n, e) {
  var i = e(19);
  t.exports = function (t, n, e) {
    if (i(t), void 0 === n) return t;
    switch (e) {
      case 0:
        return function () {
          return t.call(n)
        };
      case 1:
        return function (e) {
          return t.call(n, e)
        };
      case 2:
        return function (e, i) {
          return t.call(n, e, i)
        };
      case 3:
        return function (e, i, a) {
          return t.call(n, e, i, a)
        }
    }
    return function () {
      return t.apply(n, arguments)
    }
  }
}, function (t, n, e) {
  var i = e(4),
    a = e(100),
    r = e(7),
    o = e(40),
    l = e(62),
    c = e(130),
    s = function (t, n) {
      this.stopped = t, this.result = n
    };
  t.exports = function (t, n, e) {
    var h, u, f, v, p, g, d, m = e && e.that,
      F = !(!e || !e.AS_ENTRIES),
      M = !(!e || !e.IS_ITERATOR),
      w = !(!e || !e.INTERRUPTED),
      z = o(n, m, 1 + F + w),
      y = function (t) {
        return h && c(h), new s(!0, t)
      },
      A = function (t) {
        return F ? (i(t), w ? z(t[0], t[1], y) : z(t[0], t[1])) : w ? z(t, y) : z(t)
      };
    if (M) h = t;
    else {
      if ("function" != typeof (u = l(t))) throw TypeError("Target is not iterable");
      if (a(u)) {
        for (f = 0, v = r(t.length); v > f; f++)
          if ((p = A(t[f])) && p instanceof s) return p;
        return new s(!1)
      }
      h = u.call(t)
    }
    for (g = h.next; !(d = g.call(h)).done;) {
      try {
        p = A(d.value)
      } catch (t) {
        throw c(h), t
      }
      if ("object" == typeof p && p && p instanceof s) return p
    }
    return new s(!1)
  }
}, function (t, n, e) {
  var i = e(5),
    a = e(28),
    r = e(10),
    o = i("unscopables"),
    l = Array.prototype;
  null == l[o] && r.f(l, o, {
    configurable: !0,
    value: a(null)
  }), t.exports = function (t) {
    l[o][t] = !0
  }
}, function (t, n) {
  t.exports = function (t, n, e) {
    if (!(t instanceof n)) throw TypeError("Incorrect " + (e ? e + " " : "") + "invocation");
    return t
  }
}, function (t, n, e) {
  var i = e(31);
  t.exports = Array.isArray || function (t) {
    return "Array" == i(t)
  }
}, function (t, n, e) {
  "use strict";
  var i = e(36),
    a = e(10),
    r = e(30);
  t.exports = function (t, n, e) {
    var o = i(n);
    o in t ? a.f(t, o, r(0, e)) : t[o] = e
  }
}, function (t, n, e) {
  var i = e(0),
    a = e(56),
    r = e(3),
    o = e(12),
    l = e(10).f,
    c = e(38),
    s = e(98),
    h = e(55),
    u = e(65),
    f = !1,
    v = h("meta"),
    p = 0,
    g = Object.isExtensible || function () {
      return !0
    },
    d = function (t) {
      l(t, v, {
        value: {
          objectID: "O" + p++,
          weakData: {}
        }
      })
    },
    m = t.exports = {
      enable: function () {
        m.enable = function () {}, f = !0;
        var t = c.f,
          n = [].splice,
          e = {};
        e[v] = 1, t(e).length && (c.f = function (e) {
          for (var i = t(e), a = 0, r = i.length; a < r; a++)
            if (i[a] === v) {
              n.call(i, a, 1);
              break
            } return i
        }, i({
          target: "Object",
          stat: !0,
          forced: !0
        }, {
          getOwnPropertyNames: s.f
        }))
      },
      fastKey: function (t, n) {
        if (!r(t)) return "symbol" == typeof t ? t : ("string" == typeof t ? "S" : "P") + t;
        if (!o(t, v)) {
          if (!g(t)) return "F";
          if (!n) return "E";
          d(t)
        }
        return t[v].objectID
      },
      getWeakData: function (t, n) {
        if (!o(t, v)) {
          if (!g(t)) return !0;
          if (!n) return !1;
          d(t)
        }
        return t[v].weakData
      },
      onFreeze: function (t) {
        return u && f && g(t) && !o(t, v) && d(t), t
      }
    };
  a[v] = !0
}, function (t, n, e) {
  var i = e(20),
    a = e(120);
  t.exports = a ? function (t) {
    return "symbol" == typeof t
  } : function (t) {
    var n = i("Symbol");
    return "function" == typeof n && Object(t) instanceof n
  }
}, function (t, n, e) {
  var i = e(31),
    a = e(2);
  t.exports = "process" == i(a.process)
}, function (t, n, e) {
  "use strict";
  var i = e(20),
    a = e(10),
    r = e(5),
    o = e(6),
    l = r("species");
  t.exports = function (t) {
    var n = i(t),
      e = a.f;
    o && n && !n[l] && e(n, l, {
      configurable: !0,
      get: function () {
        return this
      }
    })
  }
}, function (t, n, e) {
  var i = e(18);
  t.exports = function (t, n, e) {
    for (var a in n) i(t, a, n[a], e);
    return t
  }
}, function (t, n, e) {
  var i = e(4),
    a = e(19),
    r = e(5)("species");
  t.exports = function (t, n) {
    var e, o = i(t).constructor;
    return void 0 === o || null == (e = i(o)[r]) ? n : a(e)
  }
}, function (t, n, e) {
  var i = e(13),
    a = e(9),
    r = "[" + e(77) + "]",
    o = RegExp("^" + r + r + "*"),
    l = RegExp(r + r + "*$"),
    c = function (t) {
      return function (n) {
        var e = a(i(n));
        return 1 & t && (e = e.replace(o, "")), 2 & t && (e = e.replace(l, "")), e
      }
    };
  t.exports = {
    start: c(1),
    end: c(2),
    trim: c(3)
  }
}, function (t, n, e) {
  "use strict";
  var i = e(4);
  t.exports = function () {
    var t = i(this),
      n = "";
    return t.global && (n += "g"), t.ignoreCase && (n += "i"), t.multiline && (n += "m"), t.dotAll && (n += "s"), t.unicode && (n += "u"), t.sticky && (n += "y"), n
  }
}, function (t, n, e) {
  var i = e(1),
    a = e(31),
    r = "".split;
  t.exports = i((function () {
    return !Object("z").propertyIsEnumerable(0)
  })) ? function (t) {
    return "String" == a(t) ? r.call(t, "") : Object(t)
  } : Object
}, function (t, n) {
  var e = 0,
    i = Math.random();
  t.exports = function (t) {
    return "Symbol(" + String(void 0 === t ? "" : t) + ")_" + (++e + i).toString(36)
  }
}, function (t, n) {
  t.exports = {}
}, function (t, n, e) {
  var i = e(23),
    a = e(7),
    r = e(39),
    o = function (t) {
      return function (n, e, o) {
        var l, c = i(n),
          s = a(c.length),
          h = r(o, s);
        if (t && e != e) {
          for (; s > h;)
            if ((l = c[h++]) != l) return !0
        } else
          for (; s > h; h++)
            if ((t || h in c) && c[h] === e) return t || h || 0;
        return !t && -1
      }
    };
  t.exports = {
    includes: o(!0),
    indexOf: o(!1)
  }
}, function (t, n, e) {
  var i = e(1),
    a = /#|\.prototype\./,
    r = function (t, n) {
      var e = l[o(t)];
      return e == s || e != c && ("function" == typeof n ? i(n) : !!n)
    },
    o = r.normalize = function (t) {
      return String(t).replace(a, ".").toLowerCase()
    },
    l = r.data = {},
    c = r.NATIVE = "N",
    s = r.POLYFILL = "P";
  t.exports = r
}, function (t, n, e) {
  var i = e(125),
    a = e(95);
  t.exports = Object.keys || function (t) {
    return i(t, a)
  }
}, function (t, n, e) {
  var i = e(169);
  t.exports = function (t, n) {
    return new(i(t))(0 === n ? 0 : n)
  }
}, function (t, n) {
  t.exports = {}
}, function (t, n, e) {
  var i = e(63),
    a = e(61),
    r = e(5)("iterator");
  t.exports = function (t) {
    if (null != t) return t[r] || t["@@iterator"] || a[i(t)]
  }
}, function (t, n, e) {
  var i = e(101),
    a = e(31),
    r = e(5)("toStringTag"),
    o = "Arguments" == a(function () {
      return arguments
    }());
  t.exports = i ? a : function (t) {
    var n, e, i;
    return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (e = function (t, n) {
      try {
        return t[n]
      } catch (t) {}
    }(n = Object(t), r)) ? e : o ? a(n) : "Object" == (i = a(n)) && "function" == typeof n.callee ? "Arguments" : i
  }
}, function (t, n, e) {
  var i = e(1),
    a = e(5),
    r = e(37),
    o = a("species");
  t.exports = function (t) {
    return r >= 51 || !i((function () {
      var n = [];
      return (n.constructor = {})[o] = function () {
        return {
          foo: 1
        }
      }, 1 !== n[t](Boolean).foo
    }))
  }
}, function (t, n, e) {
  var i = e(1);
  t.exports = !i((function () {
    return Object.isExtensible(Object.preventExtensions({}))
  }))
}, function (t, n, e) {
  var i = e(3),
    a = e(31),
    r = e(5)("match");
  t.exports = function (t) {
    var n;
    return i(t) && (void 0 !== (n = t[r]) ? !!n : "RegExp" == a(t))
  }
}, function (t, n, e) {
  "use strict";
  var i = {}.propertyIsEnumerable,
    a = Object.getOwnPropertyDescriptor,
    r = a && !i.call({
      1: 2
    }, 1);
  n.f = r ? function (t) {
    var n = a(this, t);
    return !!n && n.enumerable
  } : i
}, function (t, n, e) {
  var i = e(26),
    a = e(90);
  (t.exports = function (t, n) {
    return a[t] || (a[t] = void 0 !== n ? n : {})
  })("versions", []).push({
    version: "3.16.2",
    mode: i ? "pure" : "global",
    copyright: "© 2021 Denis Pushkarev (zloirock.ru)"
  })
}, function (t, n, e) {
  var i = e(68),
    a = e(55),
    r = i("keys");
  t.exports = function (t) {
    return r[t] || (r[t] = a(t))
  }
}, function (t, n, e) {
  var i = e(5)("iterator"),
    a = !1;
  try {
    var r = 0,
      o = {
        next: function () {
          return {
            done: !!r++
          }
        },
        return: function () {
          a = !0
        }
      };
    o[i] = function () {
      return this
    }, Array.from(o, (function () {
      throw 2
    }))
  } catch (t) {}
  t.exports = function (t, n) {
    if (!n && !a) return !1;
    var e = !1;
    try {
      var r = {};
      r[i] = function () {
        return {
          next: function () {
            return {
              done: e = !0
            }
          }
        }
      }, t(r)
    } catch (t) {}
    return e
  }
}, function (t, n, e) {
  "use strict";
  var i = e(23),
    a = e(42),
    r = e(61),
    o = e(14),
    l = e(103),
    c = o.set,
    s = o.getterFor("Array Iterator");
  t.exports = l(Array, "Array", (function (t, n) {
    c(this, {
      type: "Array Iterator",
      target: i(t),
      index: 0,
      kind: n
    })
  }), (function () {
    var t = s(this),
      n = t.target,
      e = t.kind,
      i = t.index++;
    return !n || i >= n.length ? (t.target = void 0, {
      value: void 0,
      done: !0
    }) : "keys" == e ? {
      value: i,
      done: !1
    } : "values" == e ? {
      value: n[i],
      done: !1
    } : {
      value: [i, n[i]],
      done: !1
    }
  }), "values"), r.Arguments = r.Array, a("keys"), a("values"), a("entries")
}, function (t, n, e) {
  var i = e(19),
    a = e(11),
    r = e(54),
    o = e(7),
    l = function (t) {
      return function (n, e, l, c) {
        i(e);
        var s = a(n),
          h = r(s),
          u = o(s.length),
          f = t ? u - 1 : 0,
          v = t ? -1 : 1;
        if (l < 2)
          for (;;) {
            if (f in h) {
              c = h[f], f += v;
              break
            }
            if (f += v, t ? f < 0 : u <= f) throw TypeError("Reduce of empty array with no initial value")
          }
        for (; t ? f >= 0 : u > f; f += v) f in h && (c = e(c, h[f], f, s));
        return c
      }
    };
  t.exports = {
    left: l(!1),
    right: l(!0)
  }
}, function (t, n, e) {
  "use strict";
  var i = e(2),
    a = e(6),
    r = e(106),
    o = e(17),
    l = e(50),
    c = e(1),
    s = e(43),
    h = e(21),
    u = e(7),
    f = e(140),
    v = e(215),
    p = e(27),
    g = e(33),
    d = e(38).f,
    m = e(10).f,
    F = e(102),
    M = e(29),
    w = e(14),
    z = w.get,
    y = w.set,
    A = i.ArrayBuffer,
    U = A,
    H = i.DataView,
    x = H && H.prototype,
    E = Object.prototype,
    S = i.RangeError,
    B = v.pack,
    D = v.unpack,
    b = function (t) {
      return [255 & t]
    },
    N = function (t) {
      return [255 & t, t >> 8 & 255]
    },
    j = function (t) {
      return [255 & t, t >> 8 & 255, t >> 16 & 255, t >> 24 & 255]
    },
    L = function (t) {
      return t[3] << 24 | t[2] << 16 | t[1] << 8 | t[0]
    },
    C = function (t) {
      return B(t, 23, 4)
    },
    T = function (t) {
      return B(t, 52, 8)
    },
    I = function (t, n) {
      m(t.prototype, n, {
        get: function () {
          return z(this)[n]
        }
      })
    },
    R = function (t, n, e, i) {
      var a = f(e),
        r = z(t);
      if (a + n > r.byteLength) throw S("Wrong index");
      var o = z(r.buffer).bytes,
        l = a + r.byteOffset,
        c = o.slice(l, l + n);
      return i ? c : c.reverse()
    },
    V = function (t, n, e, i, a, r) {
      var o = f(e),
        l = z(t);
      if (o + n > l.byteLength) throw S("Wrong index");
      for (var c = z(l.buffer).bytes, s = o + l.byteOffset, h = i(+a), u = 0; u < n; u++) c[s + u] = h[r ? u : n - u - 1]
    };
  if (r) {
    if (!c((function () {
        A(1)
      })) || !c((function () {
        new A(-1)
      })) || c((function () {
        return new A, new A(1.5), new A(NaN), "ArrayBuffer" != A.name
      }))) {
      for (var k, O = (U = function (t) {
          return s(this, U), new A(f(t))
        }).prototype = A.prototype, P = d(A), G = 0; P.length > G;)(k = P[G++]) in U || o(U, k, A[k]);
      O.constructor = U
    }
    g && p(x) !== E && g(x, E);
    var K = new H(new U(2)),
      W = x.setInt8;
    K.setInt8(0, 2147483648), K.setInt8(1, 2147483649), !K.getInt8(0) && K.getInt8(1) || l(x, {
      setInt8: function (t, n) {
        W.call(this, t, n << 24 >> 24)
      },
      setUint8: function (t, n) {
        W.call(this, t, n << 24 >> 24)
      }
    }, {
      unsafe: !0
    })
  } else U = function (t) {
    s(this, U, "ArrayBuffer");
    var n = f(t);
    y(this, {
      bytes: F.call(new Array(n), 0),
      byteLength: n
    }), a || (this.byteLength = n)
  }, H = function (t, n, e) {
    s(this, H, "DataView"), s(t, U, "DataView");
    var i = z(t).byteLength,
      r = h(n);
    if (r < 0 || r > i) throw S("Wrong offset");
    if (r + (e = void 0 === e ? i - r : u(e)) > i) throw S("Wrong length");
    y(this, {
      buffer: t,
      byteLength: e,
      byteOffset: r
    }), a || (this.buffer = t, this.byteLength = e, this.byteOffset = r)
  }, a && (I(U, "byteLength"), I(H, "buffer"), I(H, "byteLength"), I(H, "byteOffset")), l(H.prototype, {
    getInt8: function (t) {
      return R(this, 1, t)[0] << 24 >> 24
    },
    getUint8: function (t) {
      return R(this, 1, t)[0]
    },
    getInt16: function (t) {
      var n = R(this, 2, t, arguments.length > 1 ? arguments[1] : void 0);
      return (n[1] << 8 | n[0]) << 16 >> 16
    },
    getUint16: function (t) {
      var n = R(this, 2, t, arguments.length > 1 ? arguments[1] : void 0);
      return n[1] << 8 | n[0]
    },
    getInt32: function (t) {
      return L(R(this, 4, t, arguments.length > 1 ? arguments[1] : void 0))
    },
    getUint32: function (t) {
      return L(R(this, 4, t, arguments.length > 1 ? arguments[1] : void 0)) >>> 0
    },
    getFloat32: function (t) {
      return D(R(this, 4, t, arguments.length > 1 ? arguments[1] : void 0), 23)
    },
    getFloat64: function (t) {
      return D(R(this, 8, t, arguments.length > 1 ? arguments[1] : void 0), 52)
    },
    setInt8: function (t, n) {
      V(this, 1, t, b, n)
    },
    setUint8: function (t, n) {
      V(this, 1, t, b, n)
    },
    setInt16: function (t, n) {
      V(this, 2, t, N, n, arguments.length > 2 ? arguments[2] : void 0)
    },
    setUint16: function (t, n) {
      V(this, 2, t, N, n, arguments.length > 2 ? arguments[2] : void 0)
    },
    setInt32: function (t, n) {
      V(this, 4, t, j, n, arguments.length > 2 ? arguments[2] : void 0)
    },
    setUint32: function (t, n) {
      V(this, 4, t, j, n, arguments.length > 2 ? arguments[2] : void 0)
    },
    setFloat32: function (t, n) {
      V(this, 4, t, C, n, arguments.length > 2 ? arguments[2] : void 0)
    },
    setFloat64: function (t, n) {
      V(this, 8, t, T, n, arguments.length > 2 ? arguments[2] : void 0)
    }
  });
  M(U, "ArrayBuffer"), M(H, "DataView"), t.exports = {
    ArrayBuffer: U,
    DataView: H
  }
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(2),
    r = e(58),
    o = e(18),
    l = e(46),
    c = e(41),
    s = e(43),
    h = e(3),
    u = e(1),
    f = e(70),
    v = e(29),
    p = e(75);
  t.exports = function (t, n, e) {
    var g = -1 !== t.indexOf("Map"),
      d = -1 !== t.indexOf("Weak"),
      m = g ? "set" : "add",
      F = a[t],
      M = F && F.prototype,
      w = F,
      z = {},
      y = function (t) {
        var n = M[t];
        o(M, t, "add" == t ? function (t) {
          return n.call(this, 0 === t ? 0 : t), this
        } : "delete" == t ? function (t) {
          return !(d && !h(t)) && n.call(this, 0 === t ? 0 : t)
        } : "get" == t ? function (t) {
          return d && !h(t) ? void 0 : n.call(this, 0 === t ? 0 : t)
        } : "has" == t ? function (t) {
          return !(d && !h(t)) && n.call(this, 0 === t ? 0 : t)
        } : function (t, e) {
          return n.call(this, 0 === t ? 0 : t, e), this
        })
      };
    if (r(t, "function" != typeof F || !(d || M.forEach && !u((function () {
        (new F).entries().next()
      }))))) w = e.getConstructor(n, t, g, m), l.enable();
    else if (r(t, !0)) {
      var A = new w,
        U = A[m](d ? {} : -0, 1) != A,
        H = u((function () {
          A.has(1)
        })),
        x = f((function (t) {
          new F(t)
        })),
        E = !d && u((function () {
          for (var t = new F, n = 5; n--;) t[m](n, n);
          return !t.has(-0)
        }));
      x || ((w = n((function (n, e) {
        s(n, w, t);
        var i = p(new F, n, w);
        return null != e && c(e, i[m], {
          that: i,
          AS_ENTRIES: g
        }), i
      }))).prototype = M, M.constructor = w), (H || E) && (y("delete"), y("has"), g && y("get")), (E || U) && y(m), d && M.clear && delete M.clear
    }
    return z[t] = w, i({
      global: !0,
      forced: w != F
    }, z), v(w, t), d || e.setStrong(w, t, g), w
  }
}, function (t, n, e) {
  var i = e(3),
    a = e(33);
  t.exports = function (t, n, e) {
    var r, o;
    return a && "function" == typeof (r = n.constructor) && r !== e && i(o = r.prototype) && o !== e.prototype && a(t, o), t
  }
}, function (t, n) {
  var e = Math.expm1,
    i = Math.exp;
  t.exports = !e || e(10) > 22025.465794806718 || e(10) < 22025.465794806718 || -2e-17 != e(-2e-17) ? function (t) {
    return 0 == (t = +t) ? t : t > -1e-6 && t < 1e-6 ? t + t * t / 2 : i(t) - 1
  } : e
}, function (t, n) {
  t.exports = "\t\n\v\f\r                　\u2028\u2029\ufeff"
}, function (t, n, e) {
  "use strict";
  var i = e(26),
    a = e(2),
    r = e(1),
    o = e(105);
  t.exports = i || !r((function () {
    if (!(o && o < 535)) {
      var t = Math.random();
      __defineSetter__.call(null, t, (function () {})), delete a[t]
    }
  }))
}, function (t, n, e) {
  "use strict";
  var i = e(19),
    a = function (t) {
      var n, e;
      this.promise = new t((function (t, i) {
        if (void 0 !== n || void 0 !== e) throw TypeError("Bad Promise constructor");
        n = t, e = i
      })), this.resolve = i(n), this.reject = i(e)
    };
  t.exports.f = function (t) {
    return new a(t)
  }
}, function (t, n, e) {
  var i = e(1),
    a = e(2).RegExp;
  n.UNSUPPORTED_Y = i((function () {
    var t = a("a", "y");
    return t.lastIndex = 2, null != t.exec("abcd")
  })), n.BROKEN_CARET = i((function () {
    var t = a("^r", "gy");
    return t.lastIndex = 2, null != t.exec("str")
  }))
}, function (t, n, e) {
  "use strict";
  var i, a, r = e(9),
    o = e(53),
    l = e(80),
    c = e(68),
    s = e(28),
    h = e(14).get,
    u = e(113),
    f = e(154),
    v = RegExp.prototype.exec,
    p = c("native-string-replace", String.prototype.replace),
    g = v,
    d = (i = /a/, a = /b*/g, v.call(i, "a"), v.call(a, "a"), 0 !== i.lastIndex || 0 !== a.lastIndex),
    m = l.UNSUPPORTED_Y || l.BROKEN_CARET,
    F = void 0 !== /()??/.exec("")[1];
  (d || F || m || u || f) && (g = function (t) {
    var n, e, i, a, l, c, u, f = this,
      M = h(f),
      w = r(t),
      z = M.raw;
    if (z) return z.lastIndex = f.lastIndex, n = g.call(z, w), f.lastIndex = z.lastIndex, n;
    var y = M.groups,
      A = m && f.sticky,
      U = o.call(f),
      H = f.source,
      x = 0,
      E = w;
    if (A && (-1 === (U = U.replace("y", "")).indexOf("g") && (U += "g"), E = w.slice(f.lastIndex), f.lastIndex > 0 && (!f.multiline || f.multiline && "\n" !== w.charAt(f.lastIndex - 1)) && (H = "(?: " + H + ")", E = " " + E, x++), e = new RegExp("^(?:" + H + ")", U)), F && (e = new RegExp("^" + H + "$(?!\\s)", U)), d && (i = f.lastIndex), a = v.call(A ? e : f, E), A ? a ? (a.input = a.input.slice(x), a[0] = a[0].slice(x), a.index = f.lastIndex, f.lastIndex += a[0].length) : f.lastIndex = 0 : d && a && (f.lastIndex = f.global ? a.index + a[0].length : i), F && a && a.length > 1 && p.call(a[0], e, (function () {
        for (l = 1; l < arguments.length - 2; l++) void 0 === arguments[l] && (a[l] = void 0)
      })), a && y)
      for (a.groups = c = s(null), l = 0; l < y.length; l++) c[(u = y[l])[0]] = a[u[1]];
    return a
  }), t.exports = g
}, function (t, n, e) {
  var i = e(21),
    a = e(9),
    r = e(13),
    o = function (t) {
      return function (n, e) {
        var o, l, c = a(r(n)),
          s = i(e),
          h = c.length;
        return s < 0 || s >= h ? t ? "" : void 0 : (o = c.charCodeAt(s)) < 55296 || o > 56319 || s + 1 === h || (l = c.charCodeAt(s + 1)) < 56320 || l > 57343 ? t ? c.charAt(s) : o : t ? c.slice(s, s + 2) : l - 56320 + (o - 55296 << 10) + 65536
      }
    };
  t.exports = {
    codeAt: o(!1),
    charAt: o(!0)
  }
}, function (t, n, e) {
  "use strict";
  e(114);
  var i = e(18),
    a = e(81),
    r = e(1),
    o = e(5),
    l = e(17),
    c = o("species"),
    s = RegExp.prototype;
  t.exports = function (t, n, e, h) {
    var u = o(t),
      f = !r((function () {
        var n = {};
        return n[u] = function () {
          return 7
        }, 7 != "" [t](n)
      })),
      v = f && !r((function () {
        var n = !1,
          e = /a/;
        return "split" === t && ((e = {}).constructor = {}, e.constructor[c] = function () {
          return e
        }, e.flags = "", e[u] = /./ [u]), e.exec = function () {
          return n = !0, null
        }, e[u](""), !n
      }));
    if (!f || !v || e) {
      var p = /./ [u],
        g = n(u, "" [t], (function (t, n, e, i, r) {
          var o = n.exec;
          return o === a || o === s.exec ? f && !r ? {
            done: !0,
            value: p.call(n, e, i)
          } : {
            done: !0,
            value: t.call(e, n, i)
          } : {
            done: !1
          }
        }));
      i(String.prototype, t, g[0]), i(s, u, g[1])
    }
    h && l(s[u], "sham", !0)
  }
}, function (t, n, e) {
  "use strict";
  var i = e(82).charAt;
  t.exports = function (t, n, e) {
    return n + (e ? i(t, n).length : 1)
  }
}, function (t, n, e) {
  var i = e(31),
    a = e(81);
  t.exports = function (t, n) {
    var e = t.exec;
    if ("function" == typeof e) {
      var r = e.call(t, n);
      if ("object" != typeof r) throw TypeError("RegExp exec method returned something other than an Object or null");
      return r
    }
    if ("RegExp" !== i(t)) throw TypeError("RegExp#exec called on incompatible receiver");
    return a.call(t, n)
  }
}, function (t, n, e) {
  var i = e(8),
    a = e(51),
    r = i.TYPED_ARRAY_CONSTRUCTOR,
    o = i.aTypedArrayConstructor;
  t.exports = function (t) {
    return o(a(t, t[r]))
  }
}, function (t, n, e) {
  /*! countries-list v2.6.1 by Annexare | MIT */
  t.exports = function () {
    "use strict";
    const t = 2147483647,
      n = 36,
      e = /^xn--/,
      i = /[^\0-\x7E]/,
      a = /[\x2E\u3002\uFF0E\uFF61]/g,
      r = {
        overflow: "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
      },
      o = Math.floor,
      l = String.fromCharCode;

    function c(t) {
      throw new RangeError(r[t])
    }

    function s(t, n) {
      const e = t.split("@");
      let i = "";
      e.length > 1 && (i = e[0] + "@", t = e[1]);
      const r = function (t, n) {
        const e = [];
        let i = t.length;
        for (; i--;) e[i] = n(t[i]);
        return e
      }((t = t.replace(a, ".")).split("."), n).join(".");
      return i + r
    }

    function h(t) {
      const n = [];
      let e = 0;
      const i = t.length;
      for (; e < i;) {
        const a = t.charCodeAt(e++);
        if (a >= 55296 && a <= 56319 && e < i) {
          const i = t.charCodeAt(e++);
          56320 == (64512 & i) ? n.push(((1023 & a) << 10) + (1023 & i) + 65536) : (n.push(a), e--)
        } else n.push(a)
      }
      return n
    }
    const u = function (t, n) {
        return t + 22 + 75 * (t < 26) - ((0 != n) << 5)
      },
      f = function (t, e, i) {
        let a = 0;
        for (t = i ? o(t / 700) : t >> 1, t += o(t / e); t > 455; a += n) t = o(t / 35);
        return o(a + 36 * t / (t + 38))
      },
      v = function (e) {
        const i = [],
          a = e.length;
        let r = 0,
          l = 128,
          s = 72,
          h = e.lastIndexOf("-");
        h < 0 && (h = 0);
        for (let t = 0; t < h; ++t) e.charCodeAt(t) >= 128 && c("not-basic"), i.push(e.charCodeAt(t));
        for (let v = h > 0 ? h + 1 : 0; v < a;) {
          let h = r;
          for (let i = 1, l = n;; l += n) {
            v >= a && c("invalid-input");
            const h = (u = e.charCodeAt(v++)) - 48 < 10 ? u - 22 : u - 65 < 26 ? u - 65 : u - 97 < 26 ? u - 97 : n;
            (h >= n || h > o((t - r) / i)) && c("overflow"), r += h * i;
            const f = l <= s ? 1 : l >= s + 26 ? 26 : l - s;
            if (h < f) break;
            const p = n - f;
            i > o(t / p) && c("overflow"), i *= p
          }
          const p = i.length + 1;
          s = f(r - h, p, 0 == h), o(r / p) > t - l && c("overflow"), l += o(r / p), r %= p, i.splice(r++, 0, l)
        }
        var u;
        return String.fromCodePoint(...i)
      },
      p = function (e) {
        const i = [];
        let a = (e = h(e)).length,
          r = 128,
          s = 0,
          v = 72;
        for (const t of e) t < 128 && i.push(l(t));
        let p = i.length,
          g = p;
        for (p && i.push("-"); g < a;) {
          let a = t;
          for (const t of e) t >= r && t < a && (a = t);
          const h = g + 1;
          a - r > o((t - s) / h) && c("overflow"), s += (a - r) * h, r = a;
          for (const a of e)
            if (a < r && ++s > t && c("overflow"), a == r) {
              let t = s;
              for (let e = n;; e += n) {
                const a = e <= v ? 1 : e >= v + 26 ? 26 : e - v;
                if (t < a) break;
                const r = t - a,
                  c = n - a;
                i.push(l(u(a + r % c, 0))), t = o(r / c)
              }
              i.push(l(u(t, 0))), v = f(s, h, g == p), s = 0, ++g
            }++ s, ++r
        }
        return i.join("")
      };
    var g = {
      version: "2.1.0",
      ucs2: {
        decode: h,
        encode: t => String.fromCodePoint(...t)
      },
      decode: v,
      encode: p,
      toASCII: function (t) {
        return s(t, (function (t) {
          return i.test(t) ? "xn--" + p(t) : t
        }))
      },
      toUnicode: function (t) {
        return s(t, (function (t) {
          return e.test(t) ? v(t.slice(4).toLowerCase()) : t
        }))
      }
    };
    const {
      ucs2: {
        decode: d,
        encode: m
      }
    } = g, F = 127462 - "A".charCodeAt(0), M = /^[A-Z]{2}$/;
    return {
      continents: {
        AF: "Africa",
        AN: "Antarctica",
        AS: "Asia",
        EU: "Europe",
        NA: "North America",
        OC: "Oceania",
        SA: "South America"
      },
      countries: {
        AD: {
          name: "Andorra",
          native: "Andorra",
          phone: "376",
          continent: "EU",
          capital: "Andorra la Vella",
          currency: "EUR",
          languages: ["ca"],
          emoji: "🇦🇩",
          emojiU: "U+1F1E6 U+1F1E9"
        },
        AE: {
          name: "United Arab Emirates",
          native: "دولة الإمارات العربية المتحدة",
          phone: "971",
          continent: "AS",
          capital: "Abu Dhabi",
          currency: "AED",
          languages: ["ar"],
          emoji: "🇦🇪",
          emojiU: "U+1F1E6 U+1F1EA"
        },
        AF: {
          name: "Afghanistan",
          native: "افغانستان",
          phone: "93",
          continent: "AS",
          capital: "Kabul",
          currency: "AFN",
          languages: ["ps", "uz", "tk"],
          emoji: "🇦🇫",
          emojiU: "U+1F1E6 U+1F1EB"
        },
        AG: {
          name: "Antigua and Barbuda",
          native: "Antigua and Barbuda",
          phone: "1268",
          continent: "NA",
          capital: "Saint John's",
          currency: "XCD",
          languages: ["en"],
          emoji: "🇦🇬",
          emojiU: "U+1F1E6 U+1F1EC"
        },
        AI: {
          name: "Anguilla",
          native: "Anguilla",
          phone: "1264",
          continent: "NA",
          capital: "The Valley",
          currency: "XCD",
          languages: ["en"],
          emoji: "🇦🇮",
          emojiU: "U+1F1E6 U+1F1EE"
        },
        AL: {
          name: "Albania",
          native: "Shqipëria",
          phone: "355",
          continent: "EU",
          capital: "Tirana",
          currency: "ALL",
          languages: ["sq"],
          emoji: "🇦🇱",
          emojiU: "U+1F1E6 U+1F1F1"
        },
        AM: {
          name: "Armenia",
          native: "Հայաստան",
          phone: "374",
          continent: "AS",
          capital: "Yerevan",
          currency: "AMD",
          languages: ["hy", "ru"],
          emoji: "🇦🇲",
          emojiU: "U+1F1E6 U+1F1F2"
        },
        AO: {
          name: "Angola",
          native: "Angola",
          phone: "244",
          continent: "AF",
          capital: "Luanda",
          currency: "AOA",
          languages: ["pt"],
          emoji: "🇦🇴",
          emojiU: "U+1F1E6 U+1F1F4"
        },
        AQ: {
          name: "Antarctica",
          native: "Antarctica",
          phone: "672",
          continent: "AN",
          capital: "",
          currency: "",
          languages: [],
          emoji: "🇦🇶",
          emojiU: "U+1F1E6 U+1F1F6"
        },
        AR: {
          name: "Argentina",
          native: "Argentina",
          phone: "54",
          continent: "SA",
          capital: "Buenos Aires",
          currency: "ARS",
          languages: ["es", "gn"],
          emoji: "🇦🇷",
          emojiU: "U+1F1E6 U+1F1F7"
        },
        AS: {
          name: "American Samoa",
          native: "American Samoa",
          phone: "1684",
          continent: "OC",
          capital: "Pago Pago",
          currency: "USD",
          languages: ["en", "sm"],
          emoji: "🇦🇸",
          emojiU: "U+1F1E6 U+1F1F8"
        },
        AT: {
          name: "Austria",
          native: "Österreich",
          phone: "43",
          continent: "EU",
          capital: "Vienna",
          currency: "EUR",
          languages: ["de"],
          emoji: "🇦🇹",
          emojiU: "U+1F1E6 U+1F1F9"
        },
        AU: {
          name: "Australia",
          native: "Australia",
          phone: "61",
          continent: "OC",
          capital: "Canberra",
          currency: "AUD",
          languages: ["en"],
          emoji: "🇦🇺",
          emojiU: "U+1F1E6 U+1F1FA"
        },
        AW: {
          name: "Aruba",
          native: "Aruba",
          phone: "297",
          continent: "NA",
          capital: "Oranjestad",
          currency: "AWG",
          languages: ["nl", "pa"],
          emoji: "🇦🇼",
          emojiU: "U+1F1E6 U+1F1FC"
        },
        AX: {
          name: "Åland",
          native: "Åland",
          phone: "358",
          continent: "EU",
          capital: "Mariehamn",
          currency: "EUR",
          languages: ["sv"],
          emoji: "🇦🇽",
          emojiU: "U+1F1E6 U+1F1FD"
        },
        AZ: {
          name: "Azerbaijan",
          native: "Azərbaycan",
          phone: "994",
          continent: "AS",
          capital: "Baku",
          currency: "AZN",
          languages: ["az"],
          emoji: "🇦🇿",
          emojiU: "U+1F1E6 U+1F1FF"
        },
        BA: {
          name: "Bosnia and Herzegovina",
          native: "Bosna i Hercegovina",
          phone: "387",
          continent: "EU",
          capital: "Sarajevo",
          currency: "BAM",
          languages: ["bs", "hr", "sr"],
          emoji: "🇧🇦",
          emojiU: "U+1F1E7 U+1F1E6"
        },
        BB: {
          name: "Barbados",
          native: "Barbados",
          phone: "1246",
          continent: "NA",
          capital: "Bridgetown",
          currency: "BBD",
          languages: ["en"],
          emoji: "🇧🇧",
          emojiU: "U+1F1E7 U+1F1E7"
        },
        BD: {
          name: "Bangladesh",
          native: "Bangladesh",
          phone: "880",
          continent: "AS",
          capital: "Dhaka",
          currency: "BDT",
          languages: ["bn"],
          emoji: "🇧🇩",
          emojiU: "U+1F1E7 U+1F1E9"
        },
        BE: {
          name: "Belgium",
          native: "België",
          phone: "32",
          continent: "EU",
          capital: "Brussels",
          currency: "EUR",
          languages: ["nl", "fr", "de"],
          emoji: "🇧🇪",
          emojiU: "U+1F1E7 U+1F1EA"
        },
        BF: {
          name: "Burkina Faso",
          native: "Burkina Faso",
          phone: "226",
          continent: "AF",
          capital: "Ouagadougou",
          currency: "XOF",
          languages: ["fr", "ff"],
          emoji: "🇧🇫",
          emojiU: "U+1F1E7 U+1F1EB"
        },
        BG: {
          name: "Bulgaria",
          native: "България",
          phone: "359",
          continent: "EU",
          capital: "Sofia",
          currency: "BGN",
          languages: ["bg"],
          emoji: "🇧🇬",
          emojiU: "U+1F1E7 U+1F1EC"
        },
        BH: {
          name: "Bahrain",
          native: "‏البحرين",
          phone: "973",
          continent: "AS",
          capital: "Manama",
          currency: "BHD",
          languages: ["ar"],
          emoji: "🇧🇭",
          emojiU: "U+1F1E7 U+1F1ED"
        },
        BI: {
          name: "Burundi",
          native: "Burundi",
          phone: "257",
          continent: "AF",
          capital: "Bujumbura",
          currency: "BIF",
          languages: ["fr", "rn"],
          emoji: "🇧🇮",
          emojiU: "U+1F1E7 U+1F1EE"
        },
        BJ: {
          name: "Benin",
          native: "Bénin",
          phone: "229",
          continent: "AF",
          capital: "Porto-Novo",
          currency: "XOF",
          languages: ["fr"],
          emoji: "🇧🇯",
          emojiU: "U+1F1E7 U+1F1EF"
        },
        BL: {
          name: "Saint Barthélemy",
          native: "Saint-Barthélemy",
          phone: "590",
          continent: "NA",
          capital: "Gustavia",
          currency: "EUR",
          languages: ["fr"],
          emoji: "🇧🇱",
          emojiU: "U+1F1E7 U+1F1F1"
        },
        BM: {
          name: "Bermuda",
          native: "Bermuda",
          phone: "1441",
          continent: "NA",
          capital: "Hamilton",
          currency: "BMD",
          languages: ["en"],
          emoji: "🇧🇲",
          emojiU: "U+1F1E7 U+1F1F2"
        },
        BN: {
          name: "Brunei",
          native: "Negara Brunei Darussalam",
          phone: "673",
          continent: "AS",
          capital: "Bandar Seri Begawan",
          currency: "BND",
          languages: ["ms"],
          emoji: "🇧🇳",
          emojiU: "U+1F1E7 U+1F1F3"
        },
        BO: {
          name: "Bolivia",
          native: "Bolivia",
          phone: "591",
          continent: "SA",
          capital: "Sucre",
          currency: "BOB,BOV",
          languages: ["es", "ay", "qu"],
          emoji: "🇧🇴",
          emojiU: "U+1F1E7 U+1F1F4"
        },
        BQ: {
          name: "Bonaire",
          native: "Bonaire",
          phone: "5997",
          continent: "NA",
          capital: "Kralendijk",
          currency: "USD",
          languages: ["nl"],
          emoji: "🇧🇶",
          emojiU: "U+1F1E7 U+1F1F6"
        },
        BR: {
          name: "Brazil",
          native: "Brasil",
          phone: "55",
          continent: "SA",
          capital: "Brasília",
          currency: "BRL",
          languages: ["pt"],
          emoji: "🇧🇷",
          emojiU: "U+1F1E7 U+1F1F7"
        },
        BS: {
          name: "Bahamas",
          native: "Bahamas",
          phone: "1242",
          continent: "NA",
          capital: "Nassau",
          currency: "BSD",
          languages: ["en"],
          emoji: "🇧🇸",
          emojiU: "U+1F1E7 U+1F1F8"
        },
        BT: {
          name: "Bhutan",
          native: "ʼbrug-yul",
          phone: "975",
          continent: "AS",
          capital: "Thimphu",
          currency: "BTN,INR",
          languages: ["dz"],
          emoji: "🇧🇹",
          emojiU: "U+1F1E7 U+1F1F9"
        },
        BV: {
          name: "Bouvet Island",
          native: "Bouvetøya",
          phone: "47",
          continent: "AN",
          capital: "",
          currency: "NOK",
          languages: ["no", "nb", "nn"],
          emoji: "🇧🇻",
          emojiU: "U+1F1E7 U+1F1FB"
        },
        BW: {
          name: "Botswana",
          native: "Botswana",
          phone: "267",
          continent: "AF",
          capital: "Gaborone",
          currency: "BWP",
          languages: ["en", "tn"],
          emoji: "🇧🇼",
          emojiU: "U+1F1E7 U+1F1FC"
        },
        BY: {
          name: "Belarus",
          native: "Белару́сь",
          phone: "375",
          continent: "EU",
          capital: "Minsk",
          currency: "BYN",
          languages: ["be", "ru"],
          emoji: "🇧🇾",
          emojiU: "U+1F1E7 U+1F1FE"
        },
        BZ: {
          name: "Belize",
          native: "Belize",
          phone: "501",
          continent: "NA",
          capital: "Belmopan",
          currency: "BZD",
          languages: ["en", "es"],
          emoji: "🇧🇿",
          emojiU: "U+1F1E7 U+1F1FF"
        },
        CA: {
          name: "Canada",
          native: "Canada",
          phone: "1",
          continent: "NA",
          capital: "Ottawa",
          currency: "CAD",
          languages: ["en", "fr"],
          emoji: "🇨🇦",
          emojiU: "U+1F1E8 U+1F1E6"
        },
        CC: {
          name: "Cocos [Keeling] Islands",
          native: "Cocos (Keeling) Islands",
          phone: "61",
          continent: "AS",
          capital: "West Island",
          currency: "AUD",
          languages: ["en"],
          emoji: "🇨🇨",
          emojiU: "U+1F1E8 U+1F1E8"
        },
        CD: {
          name: "Democratic Republic of the Congo",
          native: "République démocratique du Congo",
          phone: "243",
          continent: "AF",
          capital: "Kinshasa",
          currency: "CDF",
          languages: ["fr", "ln", "kg", "sw", "lu"],
          emoji: "🇨🇩",
          emojiU: "U+1F1E8 U+1F1E9"
        },
        CF: {
          name: "Central African Republic",
          native: "Ködörösêse tî Bêafrîka",
          phone: "236",
          continent: "AF",
          capital: "Bangui",
          currency: "XAF",
          languages: ["fr", "sg"],
          emoji: "🇨🇫",
          emojiU: "U+1F1E8 U+1F1EB"
        },
        CG: {
          name: "Republic of the Congo",
          native: "République du Congo",
          phone: "242",
          continent: "AF",
          capital: "Brazzaville",
          currency: "XAF",
          languages: ["fr", "ln"],
          emoji: "🇨🇬",
          emojiU: "U+1F1E8 U+1F1EC"
        },
        CH: {
          name: "Switzerland",
          native: "Schweiz",
          phone: "41",
          continent: "EU",
          capital: "Bern",
          currency: "CHE,CHF,CHW",
          languages: ["de", "fr", "it"],
          emoji: "🇨🇭",
          emojiU: "U+1F1E8 U+1F1ED"
        },
        CI: {
          name: "Ivory Coast",
          native: "Côte d'Ivoire",
          phone: "225",
          continent: "AF",
          capital: "Yamoussoukro",
          currency: "XOF",
          languages: ["fr"],
          emoji: "🇨🇮",
          emojiU: "U+1F1E8 U+1F1EE"
        },
        CK: {
          name: "Cook Islands",
          native: "Cook Islands",
          phone: "682",
          continent: "OC",
          capital: "Avarua",
          currency: "NZD",
          languages: ["en"],
          emoji: "🇨🇰",
          emojiU: "U+1F1E8 U+1F1F0"
        },
        CL: {
          name: "Chile",
          native: "Chile",
          phone: "56",
          continent: "SA",
          capital: "Santiago",
          currency: "CLF,CLP",
          languages: ["es"],
          emoji: "🇨🇱",
          emojiU: "U+1F1E8 U+1F1F1"
        },
        CM: {
          name: "Cameroon",
          native: "Cameroon",
          phone: "237",
          continent: "AF",
          capital: "Yaoundé",
          currency: "XAF",
          languages: ["en", "fr"],
          emoji: "🇨🇲",
          emojiU: "U+1F1E8 U+1F1F2"
        },
        CN: {
          name: "China",
          native: "中国",
          phone: "86",
          continent: "AS",
          capital: "Beijing",
          currency: "CNY",
          languages: ["zh"],
          emoji: "🇨🇳",
          emojiU: "U+1F1E8 U+1F1F3"
        },
        CO: {
          name: "Colombia",
          native: "Colombia",
          phone: "57",
          continent: "SA",
          capital: "Bogotá",
          currency: "COP",
          languages: ["es"],
          emoji: "🇨🇴",
          emojiU: "U+1F1E8 U+1F1F4"
        },
        CR: {
          name: "Costa Rica",
          native: "Costa Rica",
          phone: "506",
          continent: "NA",
          capital: "San José",
          currency: "CRC",
          languages: ["es"],
          emoji: "🇨🇷",
          emojiU: "U+1F1E8 U+1F1F7"
        },
        CU: {
          name: "Cuba",
          native: "Cuba",
          phone: "53",
          continent: "NA",
          capital: "Havana",
          currency: "CUC,CUP",
          languages: ["es"],
          emoji: "🇨🇺",
          emojiU: "U+1F1E8 U+1F1FA"
        },
        CV: {
          name: "Cape Verde",
          native: "Cabo Verde",
          phone: "238",
          continent: "AF",
          capital: "Praia",
          currency: "CVE",
          languages: ["pt"],
          emoji: "🇨🇻",
          emojiU: "U+1F1E8 U+1F1FB"
        },
        CW: {
          name: "Curacao",
          native: "Curaçao",
          phone: "5999",
          continent: "NA",
          capital: "Willemstad",
          currency: "ANG",
          languages: ["nl", "pa", "en"],
          emoji: "🇨🇼",
          emojiU: "U+1F1E8 U+1F1FC"
        },
        CX: {
          name: "Christmas Island",
          native: "Christmas Island",
          phone: "61",
          continent: "AS",
          capital: "Flying Fish Cove",
          currency: "AUD",
          languages: ["en"],
          emoji: "🇨🇽",
          emojiU: "U+1F1E8 U+1F1FD"
        },
        CY: {
          name: "Cyprus",
          native: "Κύπρος",
          phone: "357",
          continent: "EU",
          capital: "Nicosia",
          currency: "EUR",
          languages: ["el", "tr", "hy"],
          emoji: "🇨🇾",
          emojiU: "U+1F1E8 U+1F1FE"
        },
        CZ: {
          name: "Czech Republic",
          native: "Česká republika",
          phone: "420",
          continent: "EU",
          capital: "Prague",
          currency: "CZK",
          languages: ["cs", "sk"],
          emoji: "🇨🇿",
          emojiU: "U+1F1E8 U+1F1FF"
        },
        DE: {
          name: "Germany",
          native: "Deutschland",
          phone: "49",
          continent: "EU",
          capital: "Berlin",
          currency: "EUR",
          languages: ["de"],
          emoji: "🇩🇪",
          emojiU: "U+1F1E9 U+1F1EA"
        },
        DJ: {
          name: "Djibouti",
          native: "Djibouti",
          phone: "253",
          continent: "AF",
          capital: "Djibouti",
          currency: "DJF",
          languages: ["fr", "ar"],
          emoji: "🇩🇯",
          emojiU: "U+1F1E9 U+1F1EF"
        },
        DK: {
          name: "Denmark",
          native: "Danmark",
          phone: "45",
          continent: "EU",
          capital: "Copenhagen",
          currency: "DKK",
          languages: ["da"],
          emoji: "🇩🇰",
          emojiU: "U+1F1E9 U+1F1F0"
        },
        DM: {
          name: "Dominica",
          native: "Dominica",
          phone: "1767",
          continent: "NA",
          capital: "Roseau",
          currency: "XCD",
          languages: ["en"],
          emoji: "🇩🇲",
          emojiU: "U+1F1E9 U+1F1F2"
        },
        DO: {
          name: "Dominican Republic",
          native: "República Dominicana",
          phone: "1809,1829,1849",
          continent: "NA",
          capital: "Santo Domingo",
          currency: "DOP",
          languages: ["es"],
          emoji: "🇩🇴",
          emojiU: "U+1F1E9 U+1F1F4"
        },
        DZ: {
          name: "Algeria",
          native: "الجزائر",
          phone: "213",
          continent: "AF",
          capital: "Algiers",
          currency: "DZD",
          languages: ["ar"],
          emoji: "🇩🇿",
          emojiU: "U+1F1E9 U+1F1FF"
        },
        EC: {
          name: "Ecuador",
          native: "Ecuador",
          phone: "593",
          continent: "SA",
          capital: "Quito",
          currency: "USD",
          languages: ["es"],
          emoji: "🇪🇨",
          emojiU: "U+1F1EA U+1F1E8"
        },
        EE: {
          name: "Estonia",
          native: "Eesti",
          phone: "372",
          continent: "EU",
          capital: "Tallinn",
          currency: "EUR",
          languages: ["et"],
          emoji: "🇪🇪",
          emojiU: "U+1F1EA U+1F1EA"
        },
        EG: {
          name: "Egypt",
          native: "مصر‎",
          phone: "20",
          continent: "AF",
          capital: "Cairo",
          currency: "EGP",
          languages: ["ar"],
          emoji: "🇪🇬",
          emojiU: "U+1F1EA U+1F1EC"
        },
        EH: {
          name: "Western Sahara",
          native: "الصحراء الغربية",
          phone: "212",
          continent: "AF",
          capital: "El Aaiún",
          currency: "MAD,DZD,MRU",
          languages: ["es"],
          emoji: "🇪🇭",
          emojiU: "U+1F1EA U+1F1ED"
        },
        ER: {
          name: "Eritrea",
          native: "ኤርትራ",
          phone: "291",
          continent: "AF",
          capital: "Asmara",
          currency: "ERN",
          languages: ["ti", "ar", "en"],
          emoji: "🇪🇷",
          emojiU: "U+1F1EA U+1F1F7"
        },
        ES: {
          name: "Spain",
          native: "España",
          phone: "34",
          continent: "EU",
          capital: "Madrid",
          currency: "EUR",
          languages: ["es", "eu", "ca", "gl", "oc"],
          emoji: "🇪🇸",
          emojiU: "U+1F1EA U+1F1F8"
        },
        ET: {
          name: "Ethiopia",
          native: "ኢትዮጵያ",
          phone: "251",
          continent: "AF",
          capital: "Addis Ababa",
          currency: "ETB",
          languages: ["am"],
          emoji: "🇪🇹",
          emojiU: "U+1F1EA U+1F1F9"
        },
        FI: {
          name: "Finland",
          native: "Suomi",
          phone: "358",
          continent: "EU",
          capital: "Helsinki",
          currency: "EUR",
          languages: ["fi", "sv"],
          emoji: "🇫🇮",
          emojiU: "U+1F1EB U+1F1EE"
        },
        FJ: {
          name: "Fiji",
          native: "Fiji",
          phone: "679",
          continent: "OC",
          capital: "Suva",
          currency: "FJD",
          languages: ["en", "fj", "hi", "ur"],
          emoji: "🇫🇯",
          emojiU: "U+1F1EB U+1F1EF"
        },
        FK: {
          name: "Falkland Islands",
          native: "Falkland Islands",
          phone: "500",
          continent: "SA",
          capital: "Stanley",
          currency: "FKP",
          languages: ["en"],
          emoji: "🇫🇰",
          emojiU: "U+1F1EB U+1F1F0"
        },
        FM: {
          name: "Micronesia",
          native: "Micronesia",
          phone: "691",
          continent: "OC",
          capital: "Palikir",
          currency: "USD",
          languages: ["en"],
          emoji: "🇫🇲",
          emojiU: "U+1F1EB U+1F1F2"
        },
        FO: {
          name: "Faroe Islands",
          native: "Føroyar",
          phone: "298",
          continent: "EU",
          capital: "Tórshavn",
          currency: "DKK",
          languages: ["fo"],
          emoji: "🇫🇴",
          emojiU: "U+1F1EB U+1F1F4"
        },
        FR: {
          name: "France",
          native: "France",
          phone: "33",
          continent: "EU",
          capital: "Paris",
          currency: "EUR",
          languages: ["fr"],
          emoji: "🇫🇷",
          emojiU: "U+1F1EB U+1F1F7"
        },
        GA: {
          name: "Gabon",
          native: "Gabon",
          phone: "241",
          continent: "AF",
          capital: "Libreville",
          currency: "XAF",
          languages: ["fr"],
          emoji: "🇬🇦",
          emojiU: "U+1F1EC U+1F1E6"
        },
        GB: {
          name: "United Kingdom",
          native: "United Kingdom",
          phone: "44",
          continent: "EU",
          capital: "London",
          currency: "GBP",
          languages: ["en"],
          emoji: "🇬🇧",
          emojiU: "U+1F1EC U+1F1E7"
        },
        GD: {
          name: "Grenada",
          native: "Grenada",
          phone: "1473",
          continent: "NA",
          capital: "St. George's",
          currency: "XCD",
          languages: ["en"],
          emoji: "🇬🇩",
          emojiU: "U+1F1EC U+1F1E9"
        },
        GE: {
          name: "Georgia",
          native: "საქართველო",
          phone: "995",
          continent: "AS",
          capital: "Tbilisi",
          currency: "GEL",
          languages: ["ka"],
          emoji: "🇬🇪",
          emojiU: "U+1F1EC U+1F1EA"
        },
        GF: {
          name: "French Guiana",
          native: "Guyane française",
          phone: "594",
          continent: "SA",
          capital: "Cayenne",
          currency: "EUR",
          languages: ["fr"],
          emoji: "🇬🇫",
          emojiU: "U+1F1EC U+1F1EB"
        },
        GG: {
          name: "Guernsey",
          native: "Guernsey",
          phone: "44",
          continent: "EU",
          capital: "St. Peter Port",
          currency: "GBP",
          languages: ["en", "fr"],
          emoji: "🇬🇬",
          emojiU: "U+1F1EC U+1F1EC"
        },
        GH: {
          name: "Ghana",
          native: "Ghana",
          phone: "233",
          continent: "AF",
          capital: "Accra",
          currency: "GHS",
          languages: ["en"],
          emoji: "🇬🇭",
          emojiU: "U+1F1EC U+1F1ED"
        },
        GI: {
          name: "Gibraltar",
          native: "Gibraltar",
          phone: "350",
          continent: "EU",
          capital: "Gibraltar",
          currency: "GIP",
          languages: ["en"],
          emoji: "🇬🇮",
          emojiU: "U+1F1EC U+1F1EE"
        },
        GL: {
          name: "Greenland",
          native: "Kalaallit Nunaat",
          phone: "299",
          continent: "NA",
          capital: "Nuuk",
          currency: "DKK",
          languages: ["kl"],
          emoji: "🇬🇱",
          emojiU: "U+1F1EC U+1F1F1"
        },
        GM: {
          name: "Gambia",
          native: "Gambia",
          phone: "220",
          continent: "AF",
          capital: "Banjul",
          currency: "GMD",
          languages: ["en"],
          emoji: "🇬🇲",
          emojiU: "U+1F1EC U+1F1F2"
        },
        GN: {
          name: "Guinea",
          native: "Guinée",
          phone: "224",
          continent: "AF",
          capital: "Conakry",
          currency: "GNF",
          languages: ["fr", "ff"],
          emoji: "🇬🇳",
          emojiU: "U+1F1EC U+1F1F3"
        },
        GP: {
          name: "Guadeloupe",
          native: "Guadeloupe",
          phone: "590",
          continent: "NA",
          capital: "Basse-Terre",
          currency: "EUR",
          languages: ["fr"],
          emoji: "🇬🇵",
          emojiU: "U+1F1EC U+1F1F5"
        },
        GQ: {
          name: "Equatorial Guinea",
          native: "Guinea Ecuatorial",
          phone: "240",
          continent: "AF",
          capital: "Malabo",
          currency: "XAF",
          languages: ["es", "fr"],
          emoji: "🇬🇶",
          emojiU: "U+1F1EC U+1F1F6"
        },
        GR: {
          name: "Greece",
          native: "Ελλάδα",
          phone: "30",
          continent: "EU",
          capital: "Athens",
          currency: "EUR",
          languages: ["el"],
          emoji: "🇬🇷",
          emojiU: "U+1F1EC U+1F1F7"
        },
        GS: {
          name: "South Georgia and the South Sandwich Islands",
          native: "South Georgia",
          phone: "500",
          continent: "AN",
          capital: "King Edward Point",
          currency: "GBP",
          languages: ["en"],
          emoji: "🇬🇸",
          emojiU: "U+1F1EC U+1F1F8"
        },
        GT: {
          name: "Guatemala",
          native: "Guatemala",
          phone: "502",
          continent: "NA",
          capital: "Guatemala City",
          currency: "GTQ",
          languages: ["es"],
          emoji: "🇬🇹",
          emojiU: "U+1F1EC U+1F1F9"
        },
        GU: {
          name: "Guam",
          native: "Guam",
          phone: "1671",
          continent: "OC",
          capital: "Hagåtña",
          currency: "USD",
          languages: ["en", "ch", "es"],
          emoji: "🇬🇺",
          emojiU: "U+1F1EC U+1F1FA"
        },
        GW: {
          name: "Guinea-Bissau",
          native: "Guiné-Bissau",
          phone: "245",
          continent: "AF",
          capital: "Bissau",
          currency: "XOF",
          languages: ["pt"],
          emoji: "🇬🇼",
          emojiU: "U+1F1EC U+1F1FC"
        },
        GY: {
          name: "Guyana",
          native: "Guyana",
          phone: "592",
          continent: "SA",
          capital: "Georgetown",
          currency: "GYD",
          languages: ["en"],
          emoji: "🇬🇾",
          emojiU: "U+1F1EC U+1F1FE"
        },
        HK: {
          name: "Hong Kong",
          native: "香港",
          phone: "852",
          continent: "AS",
          capital: "City of Victoria",
          currency: "HKD",
          languages: ["zh", "en"],
          emoji: "🇭🇰",
          emojiU: "U+1F1ED U+1F1F0"
        },
        HM: {
          name: "Heard Island and McDonald Islands",
          native: "Heard Island and McDonald Islands",
          phone: "61",
          continent: "AN",
          capital: "",
          currency: "AUD",
          languages: ["en"],
          emoji: "🇭🇲",
          emojiU: "U+1F1ED U+1F1F2"
        },
        HN: {
          name: "Honduras",
          native: "Honduras",
          phone: "504",
          continent: "NA",
          capital: "Tegucigalpa",
          currency: "HNL",
          languages: ["es"],
          emoji: "🇭🇳",
          emojiU: "U+1F1ED U+1F1F3"
        },
        HR: {
          name: "Croatia",
          native: "Hrvatska",
          phone: "385",
          continent: "EU",
          capital: "Zagreb",
          currency: "HRK",
          languages: ["hr"],
          emoji: "🇭🇷",
          emojiU: "U+1F1ED U+1F1F7"
        },
        HT: {
          name: "Haiti",
          native: "Haïti",
          phone: "509",
          continent: "NA",
          capital: "Port-au-Prince",
          currency: "HTG,USD",
          languages: ["fr", "ht"],
          emoji: "🇭🇹",
          emojiU: "U+1F1ED U+1F1F9"
        },
        HU: {
          name: "Hungary",
          native: "Magyarország",
          phone: "36",
          continent: "EU",
          capital: "Budapest",
          currency: "HUF",
          languages: ["hu"],
          emoji: "🇭🇺",
          emojiU: "U+1F1ED U+1F1FA"
        },
        ID: {
          name: "Indonesia",
          native: "Indonesia",
          phone: "62",
          continent: "AS",
          capital: "Jakarta",
          currency: "IDR",
          languages: ["id"],
          emoji: "🇮🇩",
          emojiU: "U+1F1EE U+1F1E9"
        },
        IE: {
          name: "Ireland",
          native: "Éire",
          phone: "353",
          continent: "EU",
          capital: "Dublin",
          currency: "EUR",
          languages: ["ga", "en"],
          emoji: "🇮🇪",
          emojiU: "U+1F1EE U+1F1EA"
        },
        IL: {
          name: "Israel",
          native: "יִשְׂרָאֵל",
          phone: "972",
          continent: "AS",
          capital: "Jerusalem",
          currency: "ILS",
          languages: ["he", "ar"],
          emoji: "🇮🇱",
          emojiU: "U+1F1EE U+1F1F1"
        },
        IM: {
          name: "Isle of Man",
          native: "Isle of Man",
          phone: "44",
          continent: "EU",
          capital: "Douglas",
          currency: "GBP",
          languages: ["en", "gv"],
          emoji: "🇮🇲",
          emojiU: "U+1F1EE U+1F1F2"
        },
        IN: {
          name: "India",
          native: "भारत",
          phone: "91",
          continent: "AS",
          capital: "New Delhi",
          currency: "INR",
          languages: ["hi", "en"],
          emoji: "🇮🇳",
          emojiU: "U+1F1EE U+1F1F3"
        },
        IO: {
          name: "British Indian Ocean Territory",
          native: "British Indian Ocean Territory",
          phone: "246",
          continent: "AS",
          capital: "Diego Garcia",
          currency: "USD",
          languages: ["en"],
          emoji: "🇮🇴",
          emojiU: "U+1F1EE U+1F1F4"
        },
        IQ: {
          name: "Iraq",
          native: "العراق",
          phone: "964",
          continent: "AS",
          capital: "Baghdad",
          currency: "IQD",
          languages: ["ar", "ku"],
          emoji: "🇮🇶",
          emojiU: "U+1F1EE U+1F1F6"
        },
        IR: {
          name: "Iran",
          native: "ایران",
          phone: "98",
          continent: "AS",
          capital: "Tehran",
          currency: "IRR",
          languages: ["fa"],
          emoji: "🇮🇷",
          emojiU: "U+1F1EE U+1F1F7"
        },
        IS: {
          name: "Iceland",
          native: "Ísland",
          phone: "354",
          continent: "EU",
          capital: "Reykjavik",
          currency: "ISK",
          languages: ["is"],
          emoji: "🇮🇸",
          emojiU: "U+1F1EE U+1F1F8"
        },
        IT: {
          name: "Italy",
          native: "Italia",
          phone: "39",
          continent: "EU",
          capital: "Rome",
          currency: "EUR",
          languages: ["it"],
          emoji: "🇮🇹",
          emojiU: "U+1F1EE U+1F1F9"
        },
        JE: {
          name: "Jersey",
          native: "Jersey",
          phone: "44",
          continent: "EU",
          capital: "Saint Helier",
          currency: "GBP",
          languages: ["en", "fr"],
          emoji: "🇯🇪",
          emojiU: "U+1F1EF U+1F1EA"
        },
        JM: {
          name: "Jamaica",
          native: "Jamaica",
          phone: "1876",
          continent: "NA",
          capital: "Kingston",
          currency: "JMD",
          languages: ["en"],
          emoji: "🇯🇲",
          emojiU: "U+1F1EF U+1F1F2"
        },
        JO: {
          name: "Jordan",
          native: "الأردن",
          phone: "962",
          continent: "AS",
          capital: "Amman",
          currency: "JOD",
          languages: ["ar"],
          emoji: "🇯🇴",
          emojiU: "U+1F1EF U+1F1F4"
        },
        JP: {
          name: "Japan",
          native: "日本",
          phone: "81",
          continent: "AS",
          capital: "Tokyo",
          currency: "JPY",
          languages: ["ja"],
          emoji: "🇯🇵",
          emojiU: "U+1F1EF U+1F1F5"
        },
        KE: {
          name: "Kenya",
          native: "Kenya",
          phone: "254",
          continent: "AF",
          capital: "Nairobi",
          currency: "KES",
          languages: ["en", "sw"],
          emoji: "🇰🇪",
          emojiU: "U+1F1F0 U+1F1EA"
        },
        KG: {
          name: "Kyrgyzstan",
          native: "Кыргызстан",
          phone: "996",
          continent: "AS",
          capital: "Bishkek",
          currency: "KGS",
          languages: ["ky", "ru"],
          emoji: "🇰🇬",
          emojiU: "U+1F1F0 U+1F1EC"
        },
        KH: {
          name: "Cambodia",
          native: "Kâmpŭchéa",
          phone: "855",
          continent: "AS",
          capital: "Phnom Penh",
          currency: "KHR",
          languages: ["km"],
          emoji: "🇰🇭",
          emojiU: "U+1F1F0 U+1F1ED"
        },
        KI: {
          name: "Kiribati",
          native: "Kiribati",
          phone: "686",
          continent: "OC",
          capital: "South Tarawa",
          currency: "AUD",
          languages: ["en"],
          emoji: "🇰🇮",
          emojiU: "U+1F1F0 U+1F1EE"
        },
        KM: {
          name: "Comoros",
          native: "Komori",
          phone: "269",
          continent: "AF",
          capital: "Moroni",
          currency: "KMF",
          languages: ["ar", "fr"],
          emoji: "🇰🇲",
          emojiU: "U+1F1F0 U+1F1F2"
        },
        KN: {
          name: "Saint Kitts and Nevis",
          native: "Saint Kitts and Nevis",
          phone: "1869",
          continent: "NA",
          capital: "Basseterre",
          currency: "XCD",
          languages: ["en"],
          emoji: "🇰🇳",
          emojiU: "U+1F1F0 U+1F1F3"
        },
        KP: {
          name: "North Korea",
          native: "북한",
          phone: "850",
          continent: "AS",
          capital: "Pyongyang",
          currency: "KPW",
          languages: ["ko"],
          emoji: "🇰🇵",
          emojiU: "U+1F1F0 U+1F1F5"
        },
        KR: {
          name: "South Korea",
          native: "대한민국",
          phone: "82",
          continent: "AS",
          capital: "Seoul",
          currency: "KRW",
          languages: ["ko"],
          emoji: "🇰🇷",
          emojiU: "U+1F1F0 U+1F1F7"
        },
        KW: {
          name: "Kuwait",
          native: "الكويت",
          phone: "965",
          continent: "AS",
          capital: "Kuwait City",
          currency: "KWD",
          languages: ["ar"],
          emoji: "🇰🇼",
          emojiU: "U+1F1F0 U+1F1FC"
        },
        KY: {
          name: "Cayman Islands",
          native: "Cayman Islands",
          phone: "1345",
          continent: "NA",
          capital: "George Town",
          currency: "KYD",
          languages: ["en"],
          emoji: "🇰🇾",
          emojiU: "U+1F1F0 U+1F1FE"
        },
        KZ: {
          name: "Kazakhstan",
          native: "Қазақстан",
          phone: "76,77",
          continent: "AS",
          capital: "Astana",
          currency: "KZT",
          languages: ["kk", "ru"],
          emoji: "🇰🇿",
          emojiU: "U+1F1F0 U+1F1FF"
        },
        LA: {
          name: "Laos",
          native: "ສປປລາວ",
          phone: "856",
          continent: "AS",
          capital: "Vientiane",
          currency: "LAK",
          languages: ["lo"],
          emoji: "🇱🇦",
          emojiU: "U+1F1F1 U+1F1E6"
        },
        LB: {
          name: "Lebanon",
          native: "لبنان",
          phone: "961",
          continent: "AS",
          capital: "Beirut",
          currency: "LBP",
          languages: ["ar", "fr"],
          emoji: "🇱🇧",
          emojiU: "U+1F1F1 U+1F1E7"
        },
        LC: {
          name: "Saint Lucia",
          native: "Saint Lucia",
          phone: "1758",
          continent: "NA",
          capital: "Castries",
          currency: "XCD",
          languages: ["en"],
          emoji: "🇱🇨",
          emojiU: "U+1F1F1 U+1F1E8"
        },
        LI: {
          name: "Liechtenstein",
          native: "Liechtenstein",
          phone: "423",
          continent: "EU",
          capital: "Vaduz",
          currency: "CHF",
          languages: ["de"],
          emoji: "🇱🇮",
          emojiU: "U+1F1F1 U+1F1EE"
        },
        LK: {
          name: "Sri Lanka",
          native: "śrī laṃkāva",
          phone: "94",
          continent: "AS",
          capital: "Colombo",
          currency: "LKR",
          languages: ["si", "ta"],
          emoji: "🇱🇰",
          emojiU: "U+1F1F1 U+1F1F0"
        },
        LR: {
          name: "Liberia",
          native: "Liberia",
          phone: "231",
          continent: "AF",
          capital: "Monrovia",
          currency: "LRD",
          languages: ["en"],
          emoji: "🇱🇷",
          emojiU: "U+1F1F1 U+1F1F7"
        },
        LS: {
          name: "Lesotho",
          native: "Lesotho",
          phone: "266",
          continent: "AF",
          capital: "Maseru",
          currency: "LSL,ZAR",
          languages: ["en", "st"],
          emoji: "🇱🇸",
          emojiU: "U+1F1F1 U+1F1F8"
        },
        LT: {
          name: "Lithuania",
          native: "Lietuva",
          phone: "370",
          continent: "EU",
          capital: "Vilnius",
          currency: "EUR",
          languages: ["lt"],
          emoji: "🇱🇹",
          emojiU: "U+1F1F1 U+1F1F9"
        },
        LU: {
          name: "Luxembourg",
          native: "Luxembourg",
          phone: "352",
          continent: "EU",
          capital: "Luxembourg",
          currency: "EUR",
          languages: ["fr", "de", "lb"],
          emoji: "🇱🇺",
          emojiU: "U+1F1F1 U+1F1FA"
        },
        LV: {
          name: "Latvia",
          native: "Latvija",
          phone: "371",
          continent: "EU",
          capital: "Riga",
          currency: "EUR",
          languages: ["lv"],
          emoji: "🇱🇻",
          emojiU: "U+1F1F1 U+1F1FB"
        },
        LY: {
          name: "Libya",
          native: "‏ليبيا",
          phone: "218",
          continent: "AF",
          capital: "Tripoli",
          currency: "LYD",
          languages: ["ar"],
          emoji: "🇱🇾",
          emojiU: "U+1F1F1 U+1F1FE"
        },
        MA: {
          name: "Morocco",
          native: "المغرب",
          phone: "212",
          continent: "AF",
          capital: "Rabat",
          currency: "MAD",
          languages: ["ar"],
          emoji: "🇲🇦",
          emojiU: "U+1F1F2 U+1F1E6"
        },
        MC: {
          name: "Monaco",
          native: "Monaco",
          phone: "377",
          continent: "EU",
          capital: "Monaco",
          currency: "EUR",
          languages: ["fr"],
          emoji: "🇲🇨",
          emojiU: "U+1F1F2 U+1F1E8"
        },
        MD: {
          name: "Moldova",
          native: "Moldova",
          phone: "373",
          continent: "EU",
          capital: "Chișinău",
          currency: "MDL",
          languages: ["ro"],
          emoji: "🇲🇩",
          emojiU: "U+1F1F2 U+1F1E9"
        },
        ME: {
          name: "Montenegro",
          native: "Црна Гора",
          phone: "382",
          continent: "EU",
          capital: "Podgorica",
          currency: "EUR",
          languages: ["sr", "bs", "sq", "hr"],
          emoji: "🇲🇪",
          emojiU: "U+1F1F2 U+1F1EA"
        },
        MF: {
          name: "Saint Martin",
          native: "Saint-Martin",
          phone: "590",
          continent: "NA",
          capital: "Marigot",
          currency: "EUR",
          languages: ["en", "fr", "nl"],
          emoji: "🇲🇫",
          emojiU: "U+1F1F2 U+1F1EB"
        },
        MG: {
          name: "Madagascar",
          native: "Madagasikara",
          phone: "261",
          continent: "AF",
          capital: "Antananarivo",
          currency: "MGA",
          languages: ["fr", "mg"],
          emoji: "🇲🇬",
          emojiU: "U+1F1F2 U+1F1EC"
        },
        MH: {
          name: "Marshall Islands",
          native: "M̧ajeļ",
          phone: "692",
          continent: "OC",
          capital: "Majuro",
          currency: "USD",
          languages: ["en", "mh"],
          emoji: "🇲🇭",
          emojiU: "U+1F1F2 U+1F1ED"
        },
        MK: {
          name: "North Macedonia",
          native: "Северна Македонија",
          phone: "389",
          continent: "EU",
          capital: "Skopje",
          currency: "MKD",
          languages: ["mk"],
          emoji: "🇲🇰",
          emojiU: "U+1F1F2 U+1F1F0"
        },
        ML: {
          name: "Mali",
          native: "Mali",
          phone: "223",
          continent: "AF",
          capital: "Bamako",
          currency: "XOF",
          languages: ["fr"],
          emoji: "🇲🇱",
          emojiU: "U+1F1F2 U+1F1F1"
        },
        MM: {
          name: "Myanmar [Burma]",
          native: "မြန်မာ",
          phone: "95",
          continent: "AS",
          capital: "Naypyidaw",
          currency: "MMK",
          languages: ["my"],
          emoji: "🇲🇲",
          emojiU: "U+1F1F2 U+1F1F2"
        },
        MN: {
          name: "Mongolia",
          native: "Монгол улс",
          phone: "976",
          continent: "AS",
          capital: "Ulan Bator",
          currency: "MNT",
          languages: ["mn"],
          emoji: "🇲🇳",
          emojiU: "U+1F1F2 U+1F1F3"
        },
        MO: {
          name: "Macao",
          native: "澳門",
          phone: "853",
          continent: "AS",
          capital: "",
          currency: "MOP",
          languages: ["zh", "pt"],
          emoji: "🇲🇴",
          emojiU: "U+1F1F2 U+1F1F4"
        },
        MP: {
          name: "Northern Mariana Islands",
          native: "Northern Mariana Islands",
          phone: "1670",
          continent: "OC",
          capital: "Saipan",
          currency: "USD",
          languages: ["en", "ch"],
          emoji: "🇲🇵",
          emojiU: "U+1F1F2 U+1F1F5"
        },
        MQ: {
          name: "Martinique",
          native: "Martinique",
          phone: "596",
          continent: "NA",
          capital: "Fort-de-France",
          currency: "EUR",
          languages: ["fr"],
          emoji: "🇲🇶",
          emojiU: "U+1F1F2 U+1F1F6"
        },
        MR: {
          name: "Mauritania",
          native: "موريتانيا",
          phone: "222",
          continent: "AF",
          capital: "Nouakchott",
          currency: "MRU",
          languages: ["ar"],
          emoji: "🇲🇷",
          emojiU: "U+1F1F2 U+1F1F7"
        },
        MS: {
          name: "Montserrat",
          native: "Montserrat",
          phone: "1664",
          continent: "NA",
          capital: "Plymouth",
          currency: "XCD",
          languages: ["en"],
          emoji: "🇲🇸",
          emojiU: "U+1F1F2 U+1F1F8"
        },
        MT: {
          name: "Malta",
          native: "Malta",
          phone: "356",
          continent: "EU",
          capital: "Valletta",
          currency: "EUR",
          languages: ["mt", "en"],
          emoji: "🇲🇹",
          emojiU: "U+1F1F2 U+1F1F9"
        },
        MU: {
          name: "Mauritius",
          native: "Maurice",
          phone: "230",
          continent: "AF",
          capital: "Port Louis",
          currency: "MUR",
          languages: ["en"],
          emoji: "🇲🇺",
          emojiU: "U+1F1F2 U+1F1FA"
        },
        MV: {
          name: "Maldives",
          native: "Maldives",
          phone: "960",
          continent: "AS",
          capital: "Malé",
          currency: "MVR",
          languages: ["dv"],
          emoji: "🇲🇻",
          emojiU: "U+1F1F2 U+1F1FB"
        },
        MW: {
          name: "Malawi",
          native: "Malawi",
          phone: "265",
          continent: "AF",
          capital: "Lilongwe",
          currency: "MWK",
          languages: ["en", "ny"],
          emoji: "🇲🇼",
          emojiU: "U+1F1F2 U+1F1FC"
        },
        MX: {
          name: "Mexico",
          native: "México",
          phone: "52",
          continent: "NA",
          capital: "Mexico City",
          currency: "MXN",
          languages: ["es"],
          emoji: "🇲🇽",
          emojiU: "U+1F1F2 U+1F1FD"
        },
        MY: {
          name: "Malaysia",
          native: "Malaysia",
          phone: "60",
          continent: "AS",
          capital: "Kuala Lumpur",
          currency: "MYR",
          languages: ["ms"],
          emoji: "🇲🇾",
          emojiU: "U+1F1F2 U+1F1FE"
        },
        MZ: {
          name: "Mozambique",
          native: "Moçambique",
          phone: "258",
          continent: "AF",
          capital: "Maputo",
          currency: "MZN",
          languages: ["pt"],
          emoji: "🇲🇿",
          emojiU: "U+1F1F2 U+1F1FF"
        },
        NA: {
          name: "Namibia",
          native: "Namibia",
          phone: "264",
          continent: "AF",
          capital: "Windhoek",
          currency: "NAD,ZAR",
          languages: ["en", "af"],
          emoji: "🇳🇦",
          emojiU: "U+1F1F3 U+1F1E6"
        },
        NC: {
          name: "New Caledonia",
          native: "Nouvelle-Calédonie",
          phone: "687",
          continent: "OC",
          capital: "Nouméa",
          currency: "XPF",
          languages: ["fr"],
          emoji: "🇳🇨",
          emojiU: "U+1F1F3 U+1F1E8"
        },
        NE: {
          name: "Niger",
          native: "Niger",
          phone: "227",
          continent: "AF",
          capital: "Niamey",
          currency: "XOF",
          languages: ["fr"],
          emoji: "🇳🇪",
          emojiU: "U+1F1F3 U+1F1EA"
        },
        NF: {
          name: "Norfolk Island",
          native: "Norfolk Island",
          phone: "672",
          continent: "OC",
          capital: "Kingston",
          currency: "AUD",
          languages: ["en"],
          emoji: "🇳🇫",
          emojiU: "U+1F1F3 U+1F1EB"
        },
        NG: {
          name: "Nigeria",
          native: "Nigeria",
          phone: "234",
          continent: "AF",
          capital: "Abuja",
          currency: "NGN",
          languages: ["en"],
          emoji: "🇳🇬",
          emojiU: "U+1F1F3 U+1F1EC"
        },
        NI: {
          name: "Nicaragua",
          native: "Nicaragua",
          phone: "505",
          continent: "NA",
          capital: "Managua",
          currency: "NIO",
          languages: ["es"],
          emoji: "🇳🇮",
          emojiU: "U+1F1F3 U+1F1EE"
        },
        NL: {
          name: "Netherlands",
          native: "Nederland",
          phone: "31",
          continent: "EU",
          capital: "Amsterdam",
          currency: "EUR",
          languages: ["nl"],
          emoji: "🇳🇱",
          emojiU: "U+1F1F3 U+1F1F1"
        },
        NO: {
          name: "Norway",
          native: "Norge",
          phone: "47",
          continent: "EU",
          capital: "Oslo",
          currency: "NOK",
          languages: ["no", "nb", "nn"],
          emoji: "🇳🇴",
          emojiU: "U+1F1F3 U+1F1F4"
        },
        NP: {
          name: "Nepal",
          native: "नपल",
          phone: "977",
          continent: "AS",
          capital: "Kathmandu",
          currency: "NPR",
          languages: ["ne"],
          emoji: "🇳🇵",
          emojiU: "U+1F1F3 U+1F1F5"
        },
        NR: {
          name: "Nauru",
          native: "Nauru",
          phone: "674",
          continent: "OC",
          capital: "Yaren",
          currency: "AUD",
          languages: ["en", "na"],
          emoji: "🇳🇷",
          emojiU: "U+1F1F3 U+1F1F7"
        },
        NU: {
          name: "Niue",
          native: "Niuē",
          phone: "683",
          continent: "OC",
          capital: "Alofi",
          currency: "NZD",
          languages: ["en"],
          emoji: "🇳🇺",
          emojiU: "U+1F1F3 U+1F1FA"
        },
        NZ: {
          name: "New Zealand",
          native: "New Zealand",
          phone: "64",
          continent: "OC",
          capital: "Wellington",
          currency: "NZD",
          languages: ["en", "mi"],
          emoji: "🇳🇿",
          emojiU: "U+1F1F3 U+1F1FF"
        },
        OM: {
          name: "Oman",
          native: "عمان",
          phone: "968",
          continent: "AS",
          capital: "Muscat",
          currency: "OMR",
          languages: ["ar"],
          emoji: "🇴🇲",
          emojiU: "U+1F1F4 U+1F1F2"
        },
        PA: {
          name: "Panama",
          native: "Panamá",
          phone: "507",
          continent: "NA",
          capital: "Panama City",
          currency: "PAB,USD",
          languages: ["es"],
          emoji: "🇵🇦",
          emojiU: "U+1F1F5 U+1F1E6"
        },
        PE: {
          name: "Peru",
          native: "Perú",
          phone: "51",
          continent: "SA",
          capital: "Lima",
          currency: "PEN",
          languages: ["es"],
          emoji: "🇵🇪",
          emojiU: "U+1F1F5 U+1F1EA"
        },
        PF: {
          name: "French Polynesia",
          native: "Polynésie française",
          phone: "689",
          continent: "OC",
          capital: "Papeetē",
          currency: "XPF",
          languages: ["fr"],
          emoji: "🇵🇫",
          emojiU: "U+1F1F5 U+1F1EB"
        },
        PG: {
          name: "Papua New Guinea",
          native: "Papua Niugini",
          phone: "675",
          continent: "OC",
          capital: "Port Moresby",
          currency: "PGK",
          languages: ["en"],
          emoji: "🇵🇬",
          emojiU: "U+1F1F5 U+1F1EC"
        },
        PH: {
          name: "Philippines",
          native: "Pilipinas",
          phone: "63",
          continent: "AS",
          capital: "Manila",
          currency: "PHP",
          languages: ["en"],
          emoji: "🇵🇭",
          emojiU: "U+1F1F5 U+1F1ED"
        },
        PK: {
          name: "Pakistan",
          native: "Pakistan",
          phone: "92",
          continent: "AS",
          capital: "Islamabad",
          currency: "PKR",
          languages: ["en", "ur"],
          emoji: "🇵🇰",
          emojiU: "U+1F1F5 U+1F1F0"
        },
        PL: {
          name: "Poland",
          native: "Polska",
          phone: "48",
          continent: "EU",
          capital: "Warsaw",
          currency: "PLN",
          languages: ["pl"],
          emoji: "🇵🇱",
          emojiU: "U+1F1F5 U+1F1F1"
        },
        PM: {
          name: "Saint Pierre and Miquelon",
          native: "Saint-Pierre-et-Miquelon",
          phone: "508",
          continent: "NA",
          capital: "Saint-Pierre",
          currency: "EUR",
          languages: ["fr"],
          emoji: "🇵🇲",
          emojiU: "U+1F1F5 U+1F1F2"
        },
        PN: {
          name: "Pitcairn Islands",
          native: "Pitcairn Islands",
          phone: "64",
          continent: "OC",
          capital: "Adamstown",
          currency: "NZD",
          languages: ["en"],
          emoji: "🇵🇳",
          emojiU: "U+1F1F5 U+1F1F3"
        },
        PR: {
          name: "Puerto Rico",
          native: "Puerto Rico",
          phone: "1787,1939",
          continent: "NA",
          capital: "San Juan",
          currency: "USD",
          languages: ["es", "en"],
          emoji: "🇵🇷",
          emojiU: "U+1F1F5 U+1F1F7"
        },
        PS: {
          name: "Palestine",
          native: "فلسطين",
          phone: "970",
          continent: "AS",
          capital: "Ramallah",
          currency: "ILS",
          languages: ["ar"],
          emoji: "🇵🇸",
          emojiU: "U+1F1F5 U+1F1F8"
        },
        PT: {
          name: "Portugal",
          native: "Portugal",
          phone: "351",
          continent: "EU",
          capital: "Lisbon",
          currency: "EUR",
          languages: ["pt"],
          emoji: "🇵🇹",
          emojiU: "U+1F1F5 U+1F1F9"
        },
        PW: {
          name: "Palau",
          native: "Palau",
          phone: "680",
          continent: "OC",
          capital: "Ngerulmud",
          currency: "USD",
          languages: ["en"],
          emoji: "🇵🇼",
          emojiU: "U+1F1F5 U+1F1FC"
        },
        PY: {
          name: "Paraguay",
          native: "Paraguay",
          phone: "595",
          continent: "SA",
          capital: "Asunción",
          currency: "PYG",
          languages: ["es", "gn"],
          emoji: "🇵🇾",
          emojiU: "U+1F1F5 U+1F1FE"
        },
        QA: {
          name: "Qatar",
          native: "قطر",
          phone: "974",
          continent: "AS",
          capital: "Doha",
          currency: "QAR",
          languages: ["ar"],
          emoji: "🇶🇦",
          emojiU: "U+1F1F6 U+1F1E6"
        },
        RE: {
          name: "Réunion",
          native: "La Réunion",
          phone: "262",
          continent: "AF",
          capital: "Saint-Denis",
          currency: "EUR",
          languages: ["fr"],
          emoji: "🇷🇪",
          emojiU: "U+1F1F7 U+1F1EA"
        },
        RO: {
          name: "Romania",
          native: "România",
          phone: "40",
          continent: "EU",
          capital: "Bucharest",
          currency: "RON",
          languages: ["ro"],
          emoji: "🇷🇴",
          emojiU: "U+1F1F7 U+1F1F4"
        },
        RS: {
          name: "Serbia",
          native: "Србија",
          phone: "381",
          continent: "EU",
          capital: "Belgrade",
          currency: "RSD",
          languages: ["sr"],
          emoji: "🇷🇸",
          emojiU: "U+1F1F7 U+1F1F8"
        },
        RU: {
          name: "Russia",
          native: "Россия",
          phone: "7",
          continent: "EU",
          capital: "Moscow",
          currency: "RUB",
          languages: ["ru"],
          emoji: "🇷🇺",
          emojiU: "U+1F1F7 U+1F1FA"
        },
        RW: {
          name: "Rwanda",
          native: "Rwanda",
          phone: "250",
          continent: "AF",
          capital: "Kigali",
          currency: "RWF",
          languages: ["rw", "en", "fr"],
          emoji: "🇷🇼",
          emojiU: "U+1F1F7 U+1F1FC"
        },
        SA: {
          name: "Saudi Arabia",
          native: "العربية السعودية",
          phone: "966",
          continent: "AS",
          capital: "Riyadh",
          currency: "SAR",
          languages: ["ar"],
          emoji: "🇸🇦",
          emojiU: "U+1F1F8 U+1F1E6"
        },
        SB: {
          name: "Solomon Islands",
          native: "Solomon Islands",
          phone: "677",
          continent: "OC",
          capital: "Honiara",
          currency: "SBD",
          languages: ["en"],
          emoji: "🇸🇧",
          emojiU: "U+1F1F8 U+1F1E7"
        },
        SC: {
          name: "Seychelles",
          native: "Seychelles",
          phone: "248",
          continent: "AF",
          capital: "Victoria",
          currency: "SCR",
          languages: ["fr", "en"],
          emoji: "🇸🇨",
          emojiU: "U+1F1F8 U+1F1E8"
        },
        SD: {
          name: "Sudan",
          native: "السودان",
          phone: "249",
          continent: "AF",
          capital: "Khartoum",
          currency: "SDG",
          languages: ["ar", "en"],
          emoji: "🇸🇩",
          emojiU: "U+1F1F8 U+1F1E9"
        },
        SE: {
          name: "Sweden",
          native: "Sverige",
          phone: "46",
          continent: "EU",
          capital: "Stockholm",
          currency: "SEK",
          languages: ["sv"],
          emoji: "🇸🇪",
          emojiU: "U+1F1F8 U+1F1EA"
        },
        SG: {
          name: "Singapore",
          native: "Singapore",
          phone: "65",
          continent: "AS",
          capital: "Singapore",
          currency: "SGD",
          languages: ["en", "ms", "ta", "zh"],
          emoji: "🇸🇬",
          emojiU: "U+1F1F8 U+1F1EC"
        },
        SH: {
          name: "Saint Helena",
          native: "Saint Helena",
          phone: "290",
          continent: "AF",
          capital: "Jamestown",
          currency: "SHP",
          languages: ["en"],
          emoji: "🇸🇭",
          emojiU: "U+1F1F8 U+1F1ED"
        },
        SI: {
          name: "Slovenia",
          native: "Slovenija",
          phone: "386",
          continent: "EU",
          capital: "Ljubljana",
          currency: "EUR",
          languages: ["sl"],
          emoji: "🇸🇮",
          emojiU: "U+1F1F8 U+1F1EE"
        },
        SJ: {
          name: "Svalbard and Jan Mayen",
          native: "Svalbard og Jan Mayen",
          phone: "4779",
          continent: "EU",
          capital: "Longyearbyen",
          currency: "NOK",
          languages: ["no"],
          emoji: "🇸🇯",
          emojiU: "U+1F1F8 U+1F1EF"
        },
        SK: {
          name: "Slovakia",
          native: "Slovensko",
          phone: "421",
          continent: "EU",
          capital: "Bratislava",
          currency: "EUR",
          languages: ["sk"],
          emoji: "🇸🇰",
          emojiU: "U+1F1F8 U+1F1F0"
        },
        SL: {
          name: "Sierra Leone",
          native: "Sierra Leone",
          phone: "232",
          continent: "AF",
          capital: "Freetown",
          currency: "SLL",
          languages: ["en"],
          emoji: "🇸🇱",
          emojiU: "U+1F1F8 U+1F1F1"
        },
        SM: {
          name: "San Marino",
          native: "San Marino",
          phone: "378",
          continent: "EU",
          capital: "City of San Marino",
          currency: "EUR",
          languages: ["it"],
          emoji: "🇸🇲",
          emojiU: "U+1F1F8 U+1F1F2"
        },
        SN: {
          name: "Senegal",
          native: "Sénégal",
          phone: "221",
          continent: "AF",
          capital: "Dakar",
          currency: "XOF",
          languages: ["fr"],
          emoji: "🇸🇳",
          emojiU: "U+1F1F8 U+1F1F3"
        },
        SO: {
          name: "Somalia",
          native: "Soomaaliya",
          phone: "252",
          continent: "AF",
          capital: "Mogadishu",
          currency: "SOS",
          languages: ["so", "ar"],
          emoji: "🇸🇴",
          emojiU: "U+1F1F8 U+1F1F4"
        },
        SR: {
          name: "Suriname",
          native: "Suriname",
          phone: "597",
          continent: "SA",
          capital: "Paramaribo",
          currency: "SRD",
          languages: ["nl"],
          emoji: "🇸🇷",
          emojiU: "U+1F1F8 U+1F1F7"
        },
        SS: {
          name: "South Sudan",
          native: "South Sudan",
          phone: "211",
          continent: "AF",
          capital: "Juba",
          currency: "SSP",
          languages: ["en"],
          emoji: "🇸🇸",
          emojiU: "U+1F1F8 U+1F1F8"
        },
        ST: {
          name: "São Tomé and Príncipe",
          native: "São Tomé e Príncipe",
          phone: "239",
          continent: "AF",
          capital: "São Tomé",
          currency: "STN",
          languages: ["pt"],
          emoji: "🇸🇹",
          emojiU: "U+1F1F8 U+1F1F9"
        },
        SV: {
          name: "El Salvador",
          native: "El Salvador",
          phone: "503",
          continent: "NA",
          capital: "San Salvador",
          currency: "SVC,USD",
          languages: ["es"],
          emoji: "🇸🇻",
          emojiU: "U+1F1F8 U+1F1FB"
        },
        SX: {
          name: "Sint Maarten",
          native: "Sint Maarten",
          phone: "1721",
          continent: "NA",
          capital: "Philipsburg",
          currency: "ANG",
          languages: ["nl", "en"],
          emoji: "🇸🇽",
          emojiU: "U+1F1F8 U+1F1FD"
        },
        SY: {
          name: "Syria",
          native: "سوريا",
          phone: "963",
          continent: "AS",
          capital: "Damascus",
          currency: "SYP",
          languages: ["ar"],
          emoji: "🇸🇾",
          emojiU: "U+1F1F8 U+1F1FE"
        },
        SZ: {
          name: "Swaziland",
          native: "Swaziland",
          phone: "268",
          continent: "AF",
          capital: "Lobamba",
          currency: "SZL",
          languages: ["en", "ss"],
          emoji: "🇸🇿",
          emojiU: "U+1F1F8 U+1F1FF"
        },
        TC: {
          name: "Turks and Caicos Islands",
          native: "Turks and Caicos Islands",
          phone: "1649",
          continent: "NA",
          capital: "Cockburn Town",
          currency: "USD",
          languages: ["en"],
          emoji: "🇹🇨",
          emojiU: "U+1F1F9 U+1F1E8"
        },
        TD: {
          name: "Chad",
          native: "Tchad",
          phone: "235",
          continent: "AF",
          capital: "N'Djamena",
          currency: "XAF",
          languages: ["fr", "ar"],
          emoji: "🇹🇩",
          emojiU: "U+1F1F9 U+1F1E9"
        },
        TF: {
          name: "French Southern Territories",
          native: "Territoire des Terres australes et antarctiques fr",
          phone: "262",
          continent: "AN",
          capital: "Port-aux-Français",
          currency: "EUR",
          languages: ["fr"],
          emoji: "🇹🇫",
          emojiU: "U+1F1F9 U+1F1EB"
        },
        TG: {
          name: "Togo",
          native: "Togo",
          phone: "228",
          continent: "AF",
          capital: "Lomé",
          currency: "XOF",
          languages: ["fr"],
          emoji: "🇹🇬",
          emojiU: "U+1F1F9 U+1F1EC"
        },
        TH: {
          name: "Thailand",
          native: "ประเทศไทย",
          phone: "66",
          continent: "AS",
          capital: "Bangkok",
          currency: "THB",
          languages: ["th"],
          emoji: "🇹🇭",
          emojiU: "U+1F1F9 U+1F1ED"
        },
        TJ: {
          name: "Tajikistan",
          native: "Тоҷикистон",
          phone: "992",
          continent: "AS",
          capital: "Dushanbe",
          currency: "TJS",
          languages: ["tg", "ru"],
          emoji: "🇹🇯",
          emojiU: "U+1F1F9 U+1F1EF"
        },
        TK: {
          name: "Tokelau",
          native: "Tokelau",
          phone: "690",
          continent: "OC",
          capital: "Fakaofo",
          currency: "NZD",
          languages: ["en"],
          emoji: "🇹🇰",
          emojiU: "U+1F1F9 U+1F1F0"
        },
        TL: {
          name: "East Timor",
          native: "Timor-Leste",
          phone: "670",
          continent: "OC",
          capital: "Dili",
          currency: "USD",
          languages: ["pt"],
          emoji: "🇹🇱",
          emojiU: "U+1F1F9 U+1F1F1"
        },
        TM: {
          name: "Turkmenistan",
          native: "Türkmenistan",
          phone: "993",
          continent: "AS",
          capital: "Ashgabat",
          currency: "TMT",
          languages: ["tk", "ru"],
          emoji: "🇹🇲",
          emojiU: "U+1F1F9 U+1F1F2"
        },
        TN: {
          name: "Tunisia",
          native: "تونس",
          phone: "216",
          continent: "AF",
          capital: "Tunis",
          currency: "TND",
          languages: ["ar"],
          emoji: "🇹🇳",
          emojiU: "U+1F1F9 U+1F1F3"
        },
        TO: {
          name: "Tonga",
          native: "Tonga",
          phone: "676",
          continent: "OC",
          capital: "Nuku'alofa",
          currency: "TOP",
          languages: ["en", "to"],
          emoji: "🇹🇴",
          emojiU: "U+1F1F9 U+1F1F4"
        },
        TR: {
          name: "Turkey",
          native: "Türkiye",
          phone: "90",
          continent: "AS",
          capital: "Ankara",
          currency: "TRY",
          languages: ["tr"],
          emoji: "🇹🇷",
          emojiU: "U+1F1F9 U+1F1F7"
        },
        TT: {
          name: "Trinidad and Tobago",
          native: "Trinidad and Tobago",
          phone: "1868",
          continent: "NA",
          capital: "Port of Spain",
          currency: "TTD",
          languages: ["en"],
          emoji: "🇹🇹",
          emojiU: "U+1F1F9 U+1F1F9"
        },
        TV: {
          name: "Tuvalu",
          native: "Tuvalu",
          phone: "688",
          continent: "OC",
          capital: "Funafuti",
          currency: "AUD",
          languages: ["en"],
          emoji: "🇹🇻",
          emojiU: "U+1F1F9 U+1F1FB"
        },
        TW: {
          name: "Taiwan",
          native: "臺灣",
          phone: "886",
          continent: "AS",
          capital: "Taipei",
          currency: "TWD",
          languages: ["zh"],
          emoji: "🇹🇼",
          emojiU: "U+1F1F9 U+1F1FC"
        },
        TZ: {
          name: "Tanzania",
          native: "Tanzania",
          phone: "255",
          continent: "AF",
          capital: "Dodoma",
          currency: "TZS",
          languages: ["sw", "en"],
          emoji: "🇹🇿",
          emojiU: "U+1F1F9 U+1F1FF"
        },
        UA: {
          name: "Ukraine",
          native: "Україна",
          phone: "380",
          continent: "EU",
          capital: "Kyiv",
          currency: "UAH",
          languages: ["uk"],
          emoji: "🇺🇦",
          emojiU: "U+1F1FA U+1F1E6"
        },
        UG: {
          name: "Uganda",
          native: "Uganda",
          phone: "256",
          continent: "AF",
          capital: "Kampala",
          currency: "UGX",
          languages: ["en", "sw"],
          emoji: "🇺🇬",
          emojiU: "U+1F1FA U+1F1EC"
        },
        UM: {
          name: "U.S. Minor Outlying Islands",
          native: "United States Minor Outlying Islands",
          phone: "1",
          continent: "OC",
          capital: "",
          currency: "USD",
          languages: ["en"],
          emoji: "🇺🇲",
          emojiU: "U+1F1FA U+1F1F2"
        },
        US: {
          name: "United States",
          native: "United States",
          phone: "1",
          continent: "NA",
          capital: "Washington D.C.",
          currency: "USD,USN,USS",
          languages: ["en"],
          emoji: "🇺🇸",
          emojiU: "U+1F1FA U+1F1F8"
        },
        UY: {
          name: "Uruguay",
          native: "Uruguay",
          phone: "598",
          continent: "SA",
          capital: "Montevideo",
          currency: "UYI,UYU",
          languages: ["es"],
          emoji: "🇺🇾",
          emojiU: "U+1F1FA U+1F1FE"
        },
        UZ: {
          name: "Uzbekistan",
          native: "O‘zbekiston",
          phone: "998",
          continent: "AS",
          capital: "Tashkent",
          currency: "UZS",
          languages: ["uz", "ru"],
          emoji: "🇺🇿",
          emojiU: "U+1F1FA U+1F1FF"
        },
        VA: {
          name: "Vatican City",
          native: "Vaticano",
          phone: "379",
          continent: "EU",
          capital: "Vatican City",
          currency: "EUR",
          languages: ["it", "la"],
          emoji: "🇻🇦",
          emojiU: "U+1F1FB U+1F1E6"
        },
        VC: {
          name: "Saint Vincent and the Grenadines",
          native: "Saint Vincent and the Grenadines",
          phone: "1784",
          continent: "NA",
          capital: "Kingstown",
          currency: "XCD",
          languages: ["en"],
          emoji: "🇻🇨",
          emojiU: "U+1F1FB U+1F1E8"
        },
        VE: {
          name: "Venezuela",
          native: "Venezuela",
          phone: "58",
          continent: "SA",
          capital: "Caracas",
          currency: "VES",
          languages: ["es"],
          emoji: "🇻🇪",
          emojiU: "U+1F1FB U+1F1EA"
        },
        VG: {
          name: "British Virgin Islands",
          native: "British Virgin Islands",
          phone: "1284",
          continent: "NA",
          capital: "Road Town",
          currency: "USD",
          languages: ["en"],
          emoji: "🇻🇬",
          emojiU: "U+1F1FB U+1F1EC"
        },
        VI: {
          name: "U.S. Virgin Islands",
          native: "United States Virgin Islands",
          phone: "1340",
          continent: "NA",
          capital: "Charlotte Amalie",
          currency: "USD",
          languages: ["en"],
          emoji: "🇻🇮",
          emojiU: "U+1F1FB U+1F1EE"
        },
        VN: {
          name: "Vietnam",
          native: "Việt Nam",
          phone: "84",
          continent: "AS",
          capital: "Hanoi",
          currency: "VND",
          languages: ["vi"],
          emoji: "🇻🇳",
          emojiU: "U+1F1FB U+1F1F3"
        },
        VU: {
          name: "Vanuatu",
          native: "Vanuatu",
          phone: "678",
          continent: "OC",
          capital: "Port Vila",
          currency: "VUV",
          languages: ["bi", "en", "fr"],
          emoji: "🇻🇺",
          emojiU: "U+1F1FB U+1F1FA"
        },
        WF: {
          name: "Wallis and Futuna",
          native: "Wallis et Futuna",
          phone: "681",
          continent: "OC",
          capital: "Mata-Utu",
          currency: "XPF",
          languages: ["fr"],
          emoji: "🇼🇫",
          emojiU: "U+1F1FC U+1F1EB"
        },
        WS: {
          name: "Samoa",
          native: "Samoa",
          phone: "685",
          continent: "OC",
          capital: "Apia",
          currency: "WST",
          languages: ["sm", "en"],
          emoji: "🇼🇸",
          emojiU: "U+1F1FC U+1F1F8"
        },
        XK: {
          name: "Kosovo",
          native: "Republika e Kosovës",
          phone: "377,381,383,386",
          continent: "EU",
          capital: "Pristina",
          currency: "EUR",
          languages: ["sq", "sr"],
          emoji: "🇽🇰",
          emojiU: "U+1F1FD U+1F1F0"
        },
        YE: {
          name: "Yemen",
          native: "اليَمَن",
          phone: "967",
          continent: "AS",
          capital: "Sana'a",
          currency: "YER",
          languages: ["ar"],
          emoji: "🇾🇪",
          emojiU: "U+1F1FE U+1F1EA"
        },
        YT: {
          name: "Mayotte",
          native: "Mayotte",
          phone: "262",
          continent: "AF",
          capital: "Mamoudzou",
          currency: "EUR",
          languages: ["fr"],
          emoji: "🇾🇹",
          emojiU: "U+1F1FE U+1F1F9"
        },
        ZA: {
          name: "South Africa",
          native: "South Africa",
          phone: "27",
          continent: "AF",
          capital: "Pretoria",
          currency: "ZAR",
          languages: ["af", "en", "nr", "st", "ss", "tn", "ts", "ve", "xh", "zu"],
          emoji: "🇿🇦",
          emojiU: "U+1F1FF U+1F1E6"
        },
        ZM: {
          name: "Zambia",
          native: "Zambia",
          phone: "260",
          continent: "AF",
          capital: "Lusaka",
          currency: "ZMW",
          languages: ["en"],
          emoji: "🇿🇲",
          emojiU: "U+1F1FF U+1F1F2"
        },
        ZW: {
          name: "Zimbabwe",
          native: "Zimbabwe",
          phone: "263",
          continent: "AF",
          capital: "Harare",
          currency: "USD,ZAR,BWP,GBP,AUD,CNY,INR,JPY",
          languages: ["en", "sn", "nd"],
          emoji: "🇿🇼",
          emojiU: "U+1F1FF U+1F1FC"
        }
      },
      languages: {
        af: {
          name: "Afrikaans",
          native: "Afrikaans"
        },
        am: {
          name: "Amharic",
          native: "አማርኛ"
        },
        ar: {
          name: "Arabic",
          native: "العربية",
          rtl: 1
        },
        ay: {
          name: "Aymara",
          native: "Aymar"
        },
        az: {
          name: "Azerbaijani",
          native: "Azərbaycanca / آذربايجان"
        },
        be: {
          name: "Belarusian",
          native: "Беларуская"
        },
        bg: {
          name: "Bulgarian",
          native: "Български"
        },
        bi: {
          name: "Bislama",
          native: "Bislama"
        },
        bn: {
          name: "Bengali",
          native: "বাংলা"
        },
        bs: {
          name: "Bosnian",
          native: "Bosanski"
        },
        ca: {
          name: "Catalan",
          native: "Català"
        },
        ch: {
          name: "Chamorro",
          native: "Chamoru"
        },
        cs: {
          name: "Czech",
          native: "Čeština"
        },
        da: {
          name: "Danish",
          native: "Dansk"
        },
        de: {
          name: "German",
          native: "Deutsch"
        },
        dv: {
          name: "Divehi",
          native: "ދިވެހިބަސް",
          rtl: 1
        },
        dz: {
          name: "Dzongkha",
          native: "ཇོང་ཁ"
        },
        el: {
          name: "Greek",
          native: "Ελληνικά"
        },
        en: {
          name: "English",
          native: "English"
        },
        es: {
          name: "Spanish",
          native: "Español"
        },
        et: {
          name: "Estonian",
          native: "Eesti"
        },
        eu: {
          name: "Basque",
          native: "Euskara"
        },
        fa: {
          name: "Persian",
          native: "فارسی",
          rtl: 1
        },
        ff: {
          name: "Peul",
          native: "Fulfulde"
        },
        fi: {
          name: "Finnish",
          native: "Suomi"
        },
        fj: {
          name: "Fijian",
          native: "Na Vosa Vakaviti"
        },
        fo: {
          name: "Faroese",
          native: "Føroyskt"
        },
        fr: {
          name: "French",
          native: "Français"
        },
        ga: {
          name: "Irish",
          native: "Gaeilge"
        },
        gl: {
          name: "Galician",
          native: "Galego"
        },
        gn: {
          name: "Guarani",
          native: "Avañe'ẽ"
        },
        gv: {
          name: "Manx",
          native: "Gaelg"
        },
        he: {
          name: "Hebrew",
          native: "עברית",
          rtl: 1
        },
        hi: {
          name: "Hindi",
          native: "हिन्दी"
        },
        hr: {
          name: "Croatian",
          native: "Hrvatski"
        },
        ht: {
          name: "Haitian",
          native: "Krèyol ayisyen"
        },
        hu: {
          name: "Hungarian",
          native: "Magyar"
        },
        hy: {
          name: "Armenian",
          native: "Հայերեն"
        },
        id: {
          name: "Indonesian",
          native: "Bahasa Indonesia"
        },
        is: {
          name: "Icelandic",
          native: "Íslenska"
        },
        it: {
          name: "Italian",
          native: "Italiano"
        },
        ja: {
          name: "Japanese",
          native: "日本語"
        },
        ka: {
          name: "Georgian",
          native: "ქართული"
        },
        kg: {
          name: "Kongo",
          native: "KiKongo"
        },
        kk: {
          name: "Kazakh",
          native: "Қазақша"
        },
        kl: {
          name: "Greenlandic",
          native: "Kalaallisut"
        },
        km: {
          name: "Cambodian",
          native: "ភាសាខ្មែរ"
        },
        ko: {
          name: "Korean",
          native: "한국어"
        },
        ku: {
          name: "Kurdish",
          native: "Kurdî / كوردی",
          rtl: 1
        },
        ky: {
          name: "Kyrgyz",
          native: "Кыргызча"
        },
        la: {
          name: "Latin",
          native: "Latina"
        },
        lb: {
          name: "Luxembourgish",
          native: "Lëtzebuergesch"
        },
        ln: {
          name: "Lingala",
          native: "Lingála"
        },
        lo: {
          name: "Laotian",
          native: "ລາວ / Pha xa lao"
        },
        lt: {
          name: "Lithuanian",
          native: "Lietuvių"
        },
        lu: {
          name: "Luba-Katanga",
          native: "Tshiluba"
        },
        lv: {
          name: "Latvian",
          native: "Latviešu"
        },
        mg: {
          name: "Malagasy",
          native: "Malagasy"
        },
        mh: {
          name: "Marshallese",
          native: "Kajin Majel / Ebon"
        },
        mi: {
          name: "Maori",
          native: "Māori"
        },
        mk: {
          name: "Macedonian",
          native: "Македонски"
        },
        mn: {
          name: "Mongolian",
          native: "Монгол"
        },
        ms: {
          name: "Malay",
          native: "Bahasa Melayu"
        },
        mt: {
          name: "Maltese",
          native: "bil-Malti"
        },
        my: {
          name: "Burmese",
          native: "မြန်မာစာ"
        },
        na: {
          name: "Nauruan",
          native: "Dorerin Naoero"
        },
        nb: {
          name: "Norwegian Bokmål",
          native: "Norsk bokmål"
        },
        nd: {
          name: "North Ndebele",
          native: "Sindebele"
        },
        ne: {
          name: "Nepali",
          native: "नेपाली"
        },
        nl: {
          name: "Dutch",
          native: "Nederlands"
        },
        nn: {
          name: "Norwegian Nynorsk",
          native: "Norsk nynorsk"
        },
        no: {
          name: "Norwegian",
          native: "Norsk"
        },
        nr: {
          name: "South Ndebele",
          native: "isiNdebele"
        },
        ny: {
          name: "Chichewa",
          native: "Chi-Chewa"
        },
        oc: {
          name: "Occitan",
          native: "Occitan"
        },
        pa: {
          name: "Panjabi / Punjabi",
          native: "ਪੰਜਾਬੀ / पंजाबी / پنجابي"
        },
        pl: {
          name: "Polish",
          native: "Polski"
        },
        ps: {
          name: "Pashto",
          native: "پښتو",
          rtl: 1
        },
        pt: {
          name: "Portuguese",
          native: "Português"
        },
        qu: {
          name: "Quechua",
          native: "Runa Simi"
        },
        rn: {
          name: "Kirundi",
          native: "Kirundi"
        },
        ro: {
          name: "Romanian",
          native: "Română"
        },
        ru: {
          name: "Russian",
          native: "Русский"
        },
        rw: {
          name: "Rwandi",
          native: "Kinyarwandi"
        },
        sg: {
          name: "Sango",
          native: "Sängö"
        },
        si: {
          name: "Sinhalese",
          native: "සිංහල"
        },
        sk: {
          name: "Slovak",
          native: "Slovenčina"
        },
        sl: {
          name: "Slovenian",
          native: "Slovenščina"
        },
        sm: {
          name: "Samoan",
          native: "Gagana Samoa"
        },
        sn: {
          name: "Shona",
          native: "chiShona"
        },
        so: {
          name: "Somalia",
          native: "Soomaaliga"
        },
        sq: {
          name: "Albanian",
          native: "Shqip"
        },
        sr: {
          name: "Serbian",
          native: "Српски"
        },
        ss: {
          name: "Swati",
          native: "SiSwati"
        },
        st: {
          name: "Southern Sotho",
          native: "Sesotho"
        },
        sv: {
          name: "Swedish",
          native: "Svenska"
        },
        sw: {
          name: "Swahili",
          native: "Kiswahili"
        },
        ta: {
          name: "Tamil",
          native: "தமிழ்"
        },
        tg: {
          name: "Tajik",
          native: "Тоҷикӣ"
        },
        th: {
          name: "Thai",
          native: "ไทย / Phasa Thai"
        },
        ti: {
          name: "Tigrinya",
          native: "ትግርኛ"
        },
        tk: {
          name: "Turkmen",
          native: "Туркмен / تركمن"
        },
        tn: {
          name: "Tswana",
          native: "Setswana"
        },
        to: {
          name: "Tonga",
          native: "Lea Faka-Tonga"
        },
        tr: {
          name: "Turkish",
          native: "Türkçe"
        },
        ts: {
          name: "Tsonga",
          native: "Xitsonga"
        },
        uk: {
          name: "Ukrainian",
          native: "Українська"
        },
        ur: {
          name: "Urdu",
          native: "اردو",
          rtl: 1
        },
        uz: {
          name: "Uzbek",
          native: "Ўзбек"
        },
        ve: {
          name: "Venda",
          native: "Tshivenḓa"
        },
        vi: {
          name: "Vietnamese",
          native: "Tiếng Việt"
        },
        xh: {
          name: "Xhosa",
          native: "isiXhosa"
        },
        zh: {
          name: "Chinese",
          native: "中文"
        },
        zu: {
          name: "Zulu",
          native: "isiZulu"
        }
      },
      languagesAll: {
        aa: {
          name: "Afar",
          native: "Afar"
        },
        ab: {
          name: "Abkhazian",
          native: "Аҧсуа"
        },
        af: {
          name: "Afrikaans",
          native: "Afrikaans"
        },
        ak: {
          name: "Akan",
          native: "Akana"
        },
        am: {
          name: "Amharic",
          native: "አማርኛ"
        },
        an: {
          name: "Aragonese",
          native: "Aragonés"
        },
        ar: {
          name: "Arabic",
          native: "العربية",
          rtl: 1
        },
        as: {
          name: "Assamese",
          native: "অসমীয়া"
        },
        av: {
          name: "Avar",
          native: "Авар"
        },
        ay: {
          name: "Aymara",
          native: "Aymar"
        },
        az: {
          name: "Azerbaijani",
          native: "Azərbaycanca / آذربايجان"
        },
        ba: {
          name: "Bashkir",
          native: "Башҡорт"
        },
        be: {
          name: "Belarusian",
          native: "Беларуская"
        },
        bg: {
          name: "Bulgarian",
          native: "Български"
        },
        bh: {
          name: "Bihari",
          native: "भोजपुरी"
        },
        bi: {
          name: "Bislama",
          native: "Bislama"
        },
        bm: {
          name: "Bambara",
          native: "Bamanankan"
        },
        bn: {
          name: "Bengali",
          native: "বাংলা"
        },
        bo: {
          name: "Tibetan",
          native: "བོད་ཡིག / Bod skad"
        },
        br: {
          name: "Breton",
          native: "Brezhoneg"
        },
        bs: {
          name: "Bosnian",
          native: "Bosanski"
        },
        ca: {
          name: "Catalan",
          native: "Català"
        },
        ce: {
          name: "Chechen",
          native: "Нохчийн"
        },
        ch: {
          name: "Chamorro",
          native: "Chamoru"
        },
        co: {
          name: "Corsican",
          native: "Corsu"
        },
        cr: {
          name: "Cree",
          native: "Nehiyaw"
        },
        cs: {
          name: "Czech",
          native: "Čeština"
        },
        cu: {
          name: "Old Church Slavonic / Old Bulgarian",
          native: "словѣньскъ / slověnĭskŭ"
        },
        cv: {
          name: "Chuvash",
          native: "Чăваш"
        },
        cy: {
          name: "Welsh",
          native: "Cymraeg"
        },
        da: {
          name: "Danish",
          native: "Dansk"
        },
        de: {
          name: "German",
          native: "Deutsch"
        },
        dv: {
          name: "Divehi",
          native: "ދިވެހިބަސް",
          rtl: 1
        },
        dz: {
          name: "Dzongkha",
          native: "ཇོང་ཁ"
        },
        ee: {
          name: "Ewe",
          native: "Ɛʋɛ"
        },
        el: {
          name: "Greek",
          native: "Ελληνικά"
        },
        en: {
          name: "English",
          native: "English"
        },
        eo: {
          name: "Esperanto",
          native: "Esperanto"
        },
        es: {
          name: "Spanish",
          native: "Español"
        },
        et: {
          name: "Estonian",
          native: "Eesti"
        },
        eu: {
          name: "Basque",
          native: "Euskara"
        },
        fa: {
          name: "Persian",
          native: "فارسی",
          rtl: 1
        },
        ff: {
          name: "Peul",
          native: "Fulfulde"
        },
        fi: {
          name: "Finnish",
          native: "Suomi"
        },
        fj: {
          name: "Fijian",
          native: "Na Vosa Vakaviti"
        },
        fo: {
          name: "Faroese",
          native: "Føroyskt"
        },
        fr: {
          name: "French",
          native: "Français"
        },
        fy: {
          name: "West Frisian",
          native: "Frysk"
        },
        ga: {
          name: "Irish",
          native: "Gaeilge"
        },
        gd: {
          name: "Scottish Gaelic",
          native: "Gàidhlig"
        },
        gl: {
          name: "Galician",
          native: "Galego"
        },
        gn: {
          name: "Guarani",
          native: "Avañe'ẽ"
        },
        gu: {
          name: "Gujarati",
          native: "ગુજરાતી"
        },
        gv: {
          name: "Manx",
          native: "Gaelg"
        },
        ha: {
          name: "Hausa",
          native: "هَوُسَ",
          rtl: 1
        },
        he: {
          name: "Hebrew",
          native: "עברית",
          rtl: 1
        },
        hi: {
          name: "Hindi",
          native: "हिन्दी"
        },
        ho: {
          name: "Hiri Motu",
          native: "Hiri Motu"
        },
        hr: {
          name: "Croatian",
          native: "Hrvatski"
        },
        ht: {
          name: "Haitian",
          native: "Krèyol ayisyen"
        },
        hu: {
          name: "Hungarian",
          native: "Magyar"
        },
        hy: {
          name: "Armenian",
          native: "Հայերեն"
        },
        hz: {
          name: "Herero",
          native: "Otsiherero"
        },
        ia: {
          name: "Interlingua",
          native: "Interlingua"
        },
        id: {
          name: "Indonesian",
          native: "Bahasa Indonesia"
        },
        ie: {
          name: "Interlingue",
          native: "Interlingue"
        },
        ig: {
          name: "Igbo",
          native: "Igbo"
        },
        ii: {
          name: "Sichuan Yi",
          native: "ꆇꉙ / 四川彝语"
        },
        ik: {
          name: "Inupiak",
          native: "Iñupiak"
        },
        io: {
          name: "Ido",
          native: "Ido"
        },
        is: {
          name: "Icelandic",
          native: "Íslenska"
        },
        it: {
          name: "Italian",
          native: "Italiano"
        },
        iu: {
          name: "Inuktitut",
          native: "ᐃᓄᒃᑎᑐᑦ"
        },
        ja: {
          name: "Japanese",
          native: "日本語"
        },
        jv: {
          name: "Javanese",
          native: "Basa Jawa"
        },
        ka: {
          name: "Georgian",
          native: "ქართული"
        },
        kg: {
          name: "Kongo",
          native: "KiKongo"
        },
        ki: {
          name: "Kikuyu",
          native: "Gĩkũyũ"
        },
        kj: {
          name: "Kuanyama",
          native: "Kuanyama"
        },
        kk: {
          name: "Kazakh",
          native: "Қазақша"
        },
        kl: {
          name: "Greenlandic",
          native: "Kalaallisut"
        },
        km: {
          name: "Cambodian",
          native: "ភាសាខ្មែរ"
        },
        kn: {
          name: "Kannada",
          native: "ಕನ್ನಡ"
        },
        ko: {
          name: "Korean",
          native: "한국어"
        },
        kr: {
          name: "Kanuri",
          native: "Kanuri"
        },
        ks: {
          name: "Kashmiri",
          native: "कश्मीरी / كشميري",
          rtl: 1
        },
        ku: {
          name: "Kurdish",
          native: "Kurdî / كوردی",
          rtl: 1
        },
        kv: {
          name: "Komi",
          native: "Коми"
        },
        kw: {
          name: "Cornish",
          native: "Kernewek"
        },
        ky: {
          name: "Kyrgyz",
          native: "Кыргызча"
        },
        la: {
          name: "Latin",
          native: "Latina"
        },
        lb: {
          name: "Luxembourgish",
          native: "Lëtzebuergesch"
        },
        lg: {
          name: "Ganda",
          native: "Luganda"
        },
        li: {
          name: "Limburgian",
          native: "Limburgs"
        },
        ln: {
          name: "Lingala",
          native: "Lingála"
        },
        lo: {
          name: "Laotian",
          native: "ລາວ / Pha xa lao"
        },
        lt: {
          name: "Lithuanian",
          native: "Lietuvių"
        },
        lu: {
          name: "Luba-Katanga",
          native: "Tshiluba"
        },
        lv: {
          name: "Latvian",
          native: "Latviešu"
        },
        mg: {
          name: "Malagasy",
          native: "Malagasy"
        },
        mh: {
          name: "Marshallese",
          native: "Kajin Majel / Ebon"
        },
        mi: {
          name: "Maori",
          native: "Māori"
        },
        mk: {
          name: "Macedonian",
          native: "Македонски"
        },
        ml: {
          name: "Malayalam",
          native: "മലയാളം"
        },
        mn: {
          name: "Mongolian",
          native: "Монгол"
        },
        mo: {
          name: "Moldovan",
          native: "Moldovenească"
        },
        mr: {
          name: "Marathi",
          native: "मराठी"
        },
        ms: {
          name: "Malay",
          native: "Bahasa Melayu"
        },
        mt: {
          name: "Maltese",
          native: "bil-Malti"
        },
        my: {
          name: "Burmese",
          native: "မြန်မာစာ"
        },
        na: {
          name: "Nauruan",
          native: "Dorerin Naoero"
        },
        nb: {
          name: "Norwegian Bokmål",
          native: "Norsk bokmål"
        },
        nd: {
          name: "North Ndebele",
          native: "Sindebele"
        },
        ne: {
          name: "Nepali",
          native: "नेपाली"
        },
        ng: {
          name: "Ndonga",
          native: "Oshiwambo"
        },
        nl: {
          name: "Dutch",
          native: "Nederlands"
        },
        nn: {
          name: "Norwegian Nynorsk",
          native: "Norsk nynorsk"
        },
        no: {
          name: "Norwegian",
          native: "Norsk"
        },
        nr: {
          name: "South Ndebele",
          native: "isiNdebele"
        },
        nv: {
          name: "Navajo",
          native: "Diné bizaad"
        },
        ny: {
          name: "Chichewa",
          native: "Chi-Chewa"
        },
        oc: {
          name: "Occitan",
          native: "Occitan"
        },
        oj: {
          name: "Ojibwa",
          native: "ᐊᓂᔑᓈᐯᒧᐎᓐ / Anishinaabemowin"
        },
        om: {
          name: "Oromo",
          native: "Oromoo"
        },
        or: {
          name: "Oriya",
          native: "ଓଡ଼ିଆ"
        },
        os: {
          name: "Ossetian / Ossetic",
          native: "Иронау"
        },
        pa: {
          name: "Panjabi / Punjabi",
          native: "ਪੰਜਾਬੀ / पंजाबी / پنجابي"
        },
        pi: {
          name: "Pali",
          native: "Pāli / पाऴि"
        },
        pl: {
          name: "Polish",
          native: "Polski"
        },
        ps: {
          name: "Pashto",
          native: "پښتو",
          rtl: 1
        },
        pt: {
          name: "Portuguese",
          native: "Português"
        },
        qu: {
          name: "Quechua",
          native: "Runa Simi"
        },
        rm: {
          name: "Raeto Romance",
          native: "Rumantsch"
        },
        rn: {
          name: "Kirundi",
          native: "Kirundi"
        },
        ro: {
          name: "Romanian",
          native: "Română"
        },
        ru: {
          name: "Russian",
          native: "Русский"
        },
        rw: {
          name: "Rwandi",
          native: "Kinyarwandi"
        },
        sa: {
          name: "Sanskrit",
          native: "संस्कृतम्"
        },
        sc: {
          name: "Sardinian",
          native: "Sardu"
        },
        sd: {
          name: "Sindhi",
          native: "सिनधि"
        },
        se: {
          name: "Northern Sami",
          native: "Sámegiella"
        },
        sg: {
          name: "Sango",
          native: "Sängö"
        },
        sh: {
          name: "Serbo-Croatian",
          native: "Srpskohrvatski / Српскохрватски"
        },
        si: {
          name: "Sinhalese",
          native: "සිංහල"
        },
        sk: {
          name: "Slovak",
          native: "Slovenčina"
        },
        sl: {
          name: "Slovenian",
          native: "Slovenščina"
        },
        sm: {
          name: "Samoan",
          native: "Gagana Samoa"
        },
        sn: {
          name: "Shona",
          native: "chiShona"
        },
        so: {
          name: "Somalia",
          native: "Soomaaliga"
        },
        sq: {
          name: "Albanian",
          native: "Shqip"
        },
        sr: {
          name: "Serbian",
          native: "Српски"
        },
        ss: {
          name: "Swati",
          native: "SiSwati"
        },
        st: {
          name: "Southern Sotho",
          native: "Sesotho"
        },
        su: {
          name: "Sundanese",
          native: "Basa Sunda"
        },
        sv: {
          name: "Swedish",
          native: "Svenska"
        },
        sw: {
          name: "Swahili",
          native: "Kiswahili"
        },
        ta: {
          name: "Tamil",
          native: "தமிழ்"
        },
        te: {
          name: "Telugu",
          native: "తెలుగు"
        },
        tg: {
          name: "Tajik",
          native: "Тоҷикӣ"
        },
        th: {
          name: "Thai",
          native: "ไทย / Phasa Thai"
        },
        ti: {
          name: "Tigrinya",
          native: "ትግርኛ"
        },
        tk: {
          name: "Turkmen",
          native: "Туркмен / تركمن"
        },
        tl: {
          name: "Tagalog / Filipino",
          native: "Tagalog"
        },
        tn: {
          name: "Tswana",
          native: "Setswana"
        },
        to: {
          name: "Tonga",
          native: "Lea Faka-Tonga"
        },
        tr: {
          name: "Turkish",
          native: "Türkçe"
        },
        ts: {
          name: "Tsonga",
          native: "Xitsonga"
        },
        tt: {
          name: "Tatar",
          native: "Tatarça"
        },
        tw: {
          name: "Twi",
          native: "Twi"
        },
        ty: {
          name: "Tahitian",
          native: "Reo Mā`ohi"
        },
        ug: {
          name: "Uyghur",
          native: "Uyƣurqə / ئۇيغۇرچە"
        },
        uk: {
          name: "Ukrainian",
          native: "Українська"
        },
        ur: {
          name: "Urdu",
          native: "اردو",
          rtl: 1
        },
        uz: {
          name: "Uzbek",
          native: "Ўзбек"
        },
        ve: {
          name: "Venda",
          native: "Tshivenḓa"
        },
        vi: {
          name: "Vietnamese",
          native: "Tiếng Việt"
        },
        vo: {
          name: "Volapük",
          native: "Volapük"
        },
        wa: {
          name: "Walloon",
          native: "Walon"
        },
        wo: {
          name: "Wolof",
          native: "Wollof"
        },
        xh: {
          name: "Xhosa",
          native: "isiXhosa"
        },
        yi: {
          name: "Yiddish",
          native: "ייִדיש",
          rtl: 1
        },
        yo: {
          name: "Yoruba",
          native: "Yorùbá"
        },
        za: {
          name: "Zhuang",
          native: "Cuengh / Tôô / 壮语"
        },
        zh: {
          name: "Chinese",
          native: "中文"
        },
        zu: {
          name: "Zulu",
          native: "isiZulu"
        }
      },
      getEmojiFlag: t => M.test(t) ? m(t.split("").map(t => F + t.charCodeAt(0))) : "",
      getUnicode: t => d(t).map(t => "U+" + Number(t).toString(16).toUpperCase()).join(" ")
    }
  }()
}, function (t, n, e) {
  var i = e(3),
    a = e(47),
    r = e(121),
    o = e(5)("toPrimitive");
  t.exports = function (t, n) {
    if (!i(t) || a(t)) return t;
    var e, l = t[o];
    if (void 0 !== l) {
      if (void 0 === n && (n = "default"), e = l.call(t, n), !i(e) || a(e)) return e;
      throw TypeError("Can't convert object to primitive value")
    }
    return void 0 === n && (n = "number"), r(t, n)
  }
}, function (t, n, e) {
  var i = e(37),
    a = e(1);
  t.exports = !!Object.getOwnPropertySymbols && !a((function () {
    var t = Symbol();
    return !String(t) || !(Object(t) instanceof Symbol) || !Symbol.sham && i && i < 41
  }))
}, function (t, n, e) {
  var i = e(2),
    a = e(91),
    r = i["__core-js_shared__"] || a("__core-js_shared__", {});
  t.exports = r
}, function (t, n, e) {
  var i = e(2);
  t.exports = function (t, n) {
    try {
      Object.defineProperty(i, t, {
        value: n,
        configurable: !0,
        writable: !0
      })
    } catch (e) {
      i[t] = n
    }
    return n
  }
}, function (t, n, e) {
  var i = e(2),
    a = e(3),
    r = i.document,
    o = a(r) && a(r.createElement);
  t.exports = function (t) {
    return o ? r.createElement(t) : {}
  }
}, function (t, n, e) {
  var i = e(90),
    a = Function.toString;
  "function" != typeof i.inspectSource && (i.inspectSource = function (t) {
    return a.call(t)
  }), t.exports = i.inspectSource
}, function (t, n, e) {
  var i = e(20),
    a = e(38),
    r = e(96),
    o = e(4);
  t.exports = i("Reflect", "ownKeys") || function (t) {
    var n = a.f(o(t)),
      e = r.f;
    return e ? n.concat(e(t)) : n
  }
}, function (t, n) {
  t.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"]
}, function (t, n) {
  n.f = Object.getOwnPropertySymbols
}, function (t, n, e) {
  var i = e(6),
    a = e(10),
    r = e(4),
    o = e(59);
  t.exports = i ? Object.defineProperties : function (t, n) {
    r(t);
    for (var e, i = o(n), l = i.length, c = 0; l > c;) a.f(t, e = i[c++], n[e]);
    return t
  }
}, function (t, n, e) {
  var i = e(23),
    a = e(38).f,
    r = {}.toString,
    o = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
  t.exports.f = function (t) {
    return o && "[object Window]" == r.call(t) ? function (t) {
      try {
        return a(t)
      } catch (t) {
        return o.slice()
      }
    }(t) : a(i(t))
  }
}, function (t, n, e) {
  var i = e(1);
  t.exports = !i((function () {
    function t() {}
    return t.prototype.constructor = null, Object.getPrototypeOf(new t) !== t.prototype
  }))
}, function (t, n, e) {
  var i = e(5),
    a = e(61),
    r = i("iterator"),
    o = Array.prototype;
  t.exports = function (t) {
    return void 0 !== t && (a.Array === t || o[r] === t)
  }
}, function (t, n, e) {
  var i = {};
  i[e(5)("toStringTag")] = "z", t.exports = "[object z]" === String(i)
}, function (t, n, e) {
  "use strict";
  var i = e(11),
    a = e(39),
    r = e(7);
  t.exports = function (t) {
    for (var n = i(this), e = r(n.length), o = arguments.length, l = a(o > 1 ? arguments[1] : void 0, e), c = o > 2 ? arguments[2] : void 0, s = void 0 === c ? e : a(c, e); s > l;) n[l++] = t;
    return n
  }
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(104),
    r = e(27),
    o = e(33),
    l = e(29),
    c = e(17),
    s = e(18),
    h = e(5),
    u = e(26),
    f = e(61),
    v = e(135),
    p = v.IteratorPrototype,
    g = v.BUGGY_SAFARI_ITERATORS,
    d = h("iterator"),
    m = function () {
      return this
    };
  t.exports = function (t, n, e, h, v, F, M) {
    a(e, n, h);
    var w, z, y, A = function (t) {
        if (t === v && S) return S;
        if (!g && t in x) return x[t];
        switch (t) {
          case "keys":
          case "values":
          case "entries":
            return function () {
              return new e(this, t)
            }
        }
        return function () {
          return new e(this)
        }
      },
      U = n + " Iterator",
      H = !1,
      x = t.prototype,
      E = x[d] || x["@@iterator"] || v && x[v],
      S = !g && E || A(v),
      B = "Array" == n && x.entries || E;
    if (B && (w = r(B.call(new t)), p !== Object.prototype && w.next && (u || r(w) === p || (o ? o(w, p) : "function" != typeof w[d] && c(w, d, m)), l(w, U, !0, !0), u && (f[U] = m))), "values" == v && E && "values" !== E.name && (H = !0, S = function () {
        return E.call(this)
      }), u && !M || x[d] === S || c(x, d, S), f[n] = S, v)
      if (z = {
          values: A("values"),
          keys: F ? S : A("keys"),
          entries: A("entries")
        }, M)
        for (y in z)(g || H || !(y in x)) && s(x, y, z[y]);
      else i({
        target: n,
        proto: !0,
        forced: g || H
      }, z);
    return z
  }
}, function (t, n, e) {
  "use strict";
  var i = e(135).IteratorPrototype,
    a = e(28),
    r = e(30),
    o = e(29),
    l = e(61),
    c = function () {
      return this
    };
  t.exports = function (t, n, e) {
    var s = n + " Iterator";
    return t.prototype = a(i, {
      next: r(1, e)
    }), o(t, s, !1, !0), l[s] = c, t
  }
}, function (t, n, e) {
  var i = e(32).match(/AppleWebKit\/(\d+)\./);
  t.exports = !!i && +i[1]
}, function (t, n) {
  t.exports = "undefined" != typeof ArrayBuffer && "undefined" != typeof DataView
}, function (t, n, e) {
  var i = e(7),
    a = e(9),
    r = e(108),
    o = e(13),
    l = Math.ceil,
    c = function (t) {
      return function (n, e, c) {
        var s, h, u = a(o(n)),
          f = u.length,
          v = void 0 === c ? " " : a(c),
          p = i(e);
        return p <= f || "" == v ? u : (s = p - f, (h = r.call(v, l(s / v.length))).length > s && (h = h.slice(0, s)), t ? u + h : h + u)
      }
    };
  t.exports = {
    start: c(!1),
    end: c(!0)
  }
}, function (t, n, e) {
  "use strict";
  var i = e(21),
    a = e(9),
    r = e(13);
  t.exports = function (t) {
    var n = a(r(this)),
      e = "",
      o = i(t);
    if (o < 0 || o == 1 / 0) throw RangeError("Wrong number of repetitions");
    for (; o > 0;
      (o >>>= 1) && (n += n)) 1 & o && (e += n);
    return e
  }
}, function (t, n) {
  t.exports = Math.sign || function (t) {
    return 0 == (t = +t) || t != t ? t : t < 0 ? -1 : 1
  }
}, function (t, n, e) {
  var i = e(3),
    a = Math.floor;
  t.exports = function (t) {
    return !i(t) && isFinite(t) && a(t) === t
  }
}, function (t, n, e) {
  var i, a, r, o, l = e(2),
    c = e(1),
    s = e(40),
    h = e(126),
    u = e(92),
    f = e(151),
    v = e(48),
    p = l.setImmediate,
    g = l.clearImmediate,
    d = l.process,
    m = l.MessageChannel,
    F = l.Dispatch,
    M = 0,
    w = {};
  try {
    i = l.location
  } catch (t) {}
  var z = function (t) {
      if (w.hasOwnProperty(t)) {
        var n = w[t];
        delete w[t], n()
      }
    },
    y = function (t) {
      return function () {
        z(t)
      }
    },
    A = function (t) {
      z(t.data)
    },
    U = function (t) {
      l.postMessage(String(t), i.protocol + "//" + i.host)
    };
  p && g || (p = function (t) {
    for (var n = [], e = arguments.length, i = 1; e > i;) n.push(arguments[i++]);
    return w[++M] = function () {
      ("function" == typeof t ? t : Function(t)).apply(void 0, n)
    }, a(M), M
  }, g = function (t) {
    delete w[t]
  }, v ? a = function (t) {
    d.nextTick(y(t))
  } : F && F.now ? a = function (t) {
    F.now(y(t))
  } : m && !f ? (o = (r = new m).port2, r.port1.onmessage = A, a = s(o.postMessage, o, 1)) : l.addEventListener && "function" == typeof postMessage && !l.importScripts && i && "file:" !== i.protocol && !c(U) ? (a = U, l.addEventListener("message", A, !1)) : a = "onreadystatechange" in u("script") ? function (t) {
    h.appendChild(u("script")).onreadystatechange = function () {
      h.removeChild(this), z(t)
    }
  } : function (t) {
    setTimeout(y(t), 0)
  }), t.exports = {
    set: p,
    clear: g
  }
}, function (t, n) {
  t.exports = function (t) {
    try {
      return {
        error: !1,
        value: t()
      }
    } catch (t) {
      return {
        error: !0,
        value: t
      }
    }
  }
}, function (t, n, e) {
  var i = e(1),
    a = e(2).RegExp;
  t.exports = i((function () {
    var t = a(".", "s");
    return !(t.dotAll && t.exec("\n") && "s" === t.flags)
  }))
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(81);
  i({
    target: "RegExp",
    proto: !0,
    forced: /./.exec !== a
  }, {
    exec: a
  })
}, function (t, n, e) {
  var i = e(66);
  t.exports = function (t) {
    if (i(t)) throw TypeError("The method doesn't accept regular expressions");
    return t
  }
}, function (t, n, e) {
  var i = e(5)("match");
  t.exports = function (t) {
    var n = /./;
    try {
      "/./" [t](n)
    } catch (e) {
      try {
        return n[i] = !1, "/./" [t](n)
      } catch (t) {}
    }
    return !1
  }
}, function (t, n, e) {
  var i = e(1),
    a = e(77);
  t.exports = function (t) {
    return i((function () {
      return !!a[t]() || "​᠎" != "​᠎" [t]() || a[t].name !== t
    }))
  }
}, function (t, n, e) {
  var i = e(2),
    a = e(1),
    r = e(70),
    o = e(8).NATIVE_ARRAY_BUFFER_VIEWS,
    l = i.ArrayBuffer,
    c = i.Int8Array;
  t.exports = !o || !a((function () {
    c(1)
  })) || !a((function () {
    new c(-1)
  })) || !r((function (t) {
    new c, new c(null), new c(1.5), new c(t)
  }), !0) || a((function () {
    return 1 !== new c(new l(2), 1, void 0).length
  }))
}, function (t, n, e) {
  t.exports = function () {
    "use strict";

    function t(t) {
      for (var n = 1; n < arguments.length; n++) {
        var e = arguments[n];
        for (var i in e) t[i] = e[i]
      }
      return t
    }
    return function n(e, i) {
      function a(n, a, r) {
        if ("undefined" != typeof document) {
          "number" == typeof (r = t({}, i, r)).expires && (r.expires = new Date(Date.now() + 864e5 * r.expires)), r.expires && (r.expires = r.expires.toUTCString()), n = encodeURIComponent(n).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
          var o = "";
          for (var l in r) r[l] && (o += "; " + l, !0 !== r[l] && (o += "=" + r[l].split(";")[0]));
          return document.cookie = n + "=" + e.write(a, n) + o
        }
      }
      return Object.create({
        set: a,
        get: function (t) {
          if ("undefined" != typeof document && (!arguments.length || t)) {
            for (var n = document.cookie ? document.cookie.split("; ") : [], i = {}, a = 0; a < n.length; a++) {
              var r = n[a].split("="),
                o = r.slice(1).join("=");
              try {
                var l = decodeURIComponent(r[0]);
                if (i[l] = e.read(o, l), t === l) break
              } catch (t) {}
            }
            return t ? i[t] : i
          }
        },
        remove: function (n, e) {
          a(n, "", t({}, e, {
            expires: -1
          }))
        },
        withAttributes: function (e) {
          return n(this.converter, t({}, this.attributes, e))
        },
        withConverter: function (e) {
          return n(t({}, this.converter, e), this.attributes)
        }
      }, {
        attributes: {
          value: Object.freeze(i)
        },
        converter: {
          value: Object.freeze(e)
        }
      })
    }({
      read: function (t) {
        return '"' === t[0] && (t = t.slice(1, -1)), t.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
      },
      write: function (t) {
        return encodeURIComponent(t).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent)
      }
    }, {
      path: "/"
    })
  }()
}, function (t, n, e) {
  var i = e(89);
  t.exports = i && !Symbol.sham && "symbol" == typeof Symbol.iterator
}, function (t, n, e) {
  var i = e(3);
  t.exports = function (t, n) {
    var e, a;
    if ("string" === n && "function" == typeof (e = t.toString) && !i(a = e.call(t))) return a;
    if ("function" == typeof (e = t.valueOf) && !i(a = e.call(t))) return a;
    if ("string" !== n && "function" == typeof (e = t.toString) && !i(a = e.call(t))) return a;
    throw TypeError("Can't convert object to primitive value")
  }
}, function (t, n, e) {
  var i = e(6),
    a = e(1),
    r = e(92);
  t.exports = !i && !a((function () {
    return 7 != Object.defineProperty(r("div"), "a", {
      get: function () {
        return 7
      }
    }).a
  }))
}, function (t, n, e) {
  var i = e(2),
    a = e(93),
    r = i.WeakMap;
  t.exports = "function" == typeof r && /native code/.test(a(r))
}, function (t, n, e) {
  var i = e(12),
    a = e(94),
    r = e(16),
    o = e(10);
  t.exports = function (t, n) {
    for (var e = a(n), l = o.f, c = r.f, s = 0; s < e.length; s++) {
      var h = e[s];
      i(t, h) || l(t, h, c(n, h))
    }
  }
}, function (t, n, e) {
  var i = e(12),
    a = e(23),
    r = e(57).indexOf,
    o = e(56);
  t.exports = function (t, n) {
    var e, l = a(t),
      c = 0,
      s = [];
    for (e in l) !i(o, e) && i(l, e) && s.push(e);
    for (; n.length > c;) i(l, e = n[c++]) && (~r(s, e) || s.push(e));
    return s
  }
}, function (t, n, e) {
  var i = e(20);
  t.exports = i("document", "documentElement")
}, function (t, n, e) {
  var i = e(5);
  n.f = i
}, function (t, n, e) {
  var i = e(2);
  t.exports = i
}, function (t, n, e) {
  var i = e(3);
  t.exports = function (t) {
    if (!i(t) && null !== t) throw TypeError("Can't set " + String(t) + " as a prototype");
    return t
  }
}, function (t, n, e) {
  var i = e(4);
  t.exports = function (t) {
    var n = t.return;
    if (void 0 !== n) return i(n.call(t)).value
  }
}, function (t, n, e) {
  "use strict";
  var i = e(11),
    a = e(39),
    r = e(7),
    o = Math.min;
  t.exports = [].copyWithin || function (t, n) {
    var e = i(this),
      l = r(e.length),
      c = a(t, l),
      s = a(n, l),
      h = arguments.length > 2 ? arguments[2] : void 0,
      u = o((void 0 === h ? l : a(h, l)) - s, l - c),
      f = 1;
    for (s < c && c < s + u && (f = -1, s += u - 1, c += u - 1); u-- > 0;) s in e ? e[c] = e[s] : delete e[c], c += f, s += f;
    return e
  }
}, function (t, n, e) {
  "use strict";
  var i = e(44),
    a = e(7),
    r = e(40),
    o = function (t, n, e, l, c, s, h, u) {
      for (var f, v = c, p = 0, g = !!h && r(h, u, 3); p < l;) {
        if (p in e) {
          if (f = g ? g(e[p], p, n) : e[p], s > 0 && i(f)) v = o(t, n, f, a(f.length), v, s - 1) - 1;
          else {
            if (v >= 9007199254740991) throw TypeError("Exceed the acceptable array length");
            t[v] = f
          }
          v++
        }
        p++
      }
      return v
    };
  t.exports = o
}, function (t, n, e) {
  "use strict";
  var i = e(15).forEach,
    a = e(34)("forEach");
  t.exports = a ? [].forEach : function (t) {
    return i(this, t, arguments.length > 1 ? arguments[1] : void 0)
  }
}, function (t, n, e) {
  "use strict";
  var i = e(40),
    a = e(11),
    r = e(196),
    o = e(100),
    l = e(7),
    c = e(45),
    s = e(62);
  t.exports = function (t) {
    var n, e, h, u, f, v, p = a(t),
      g = "function" == typeof this ? this : Array,
      d = arguments.length,
      m = d > 1 ? arguments[1] : void 0,
      F = void 0 !== m,
      M = s(p),
      w = 0;
    if (F && (m = i(m, d > 2 ? arguments[2] : void 0, 2)), null == M || g == Array && o(M))
      for (e = new g(n = l(p.length)); n > w; w++) v = F ? m(p[w], w) : p[w], c(e, w, v);
    else
      for (f = (u = M.call(p)).next, e = new g; !(h = f.call(u)).done; w++) v = F ? r(u, m, [h.value, w], !0) : h.value, c(e, w, v);
    return e.length = w, e
  }
}, function (t, n, e) {
  "use strict";
  var i, a, r, o = e(1),
    l = e(27),
    c = e(17),
    s = e(12),
    h = e(5),
    u = e(26),
    f = h("iterator"),
    v = !1;
  [].keys && ("next" in (r = [].keys()) ? (a = l(l(r))) !== Object.prototype && (i = a) : v = !0);
  var p = null == i || o((function () {
    var t = {};
    return i[f].call(t) !== t
  }));
  p && (i = {}), u && !p || s(i, f) || c(i, f, (function () {
    return this
  })), t.exports = {
    IteratorPrototype: i,
    BUGGY_SAFARI_ITERATORS: v
  }
}, function (t, n, e) {
  "use strict";
  var i = e(23),
    a = e(21),
    r = e(7),
    o = e(34),
    l = Math.min,
    c = [].lastIndexOf,
    s = !!c && 1 / [1].lastIndexOf(1, -0) < 0,
    h = o("lastIndexOf"),
    u = s || !h;
  t.exports = u ? function (t) {
    if (s) return c.apply(this, arguments) || 0;
    var n = i(this),
      e = r(n.length),
      o = e - 1;
    for (arguments.length > 1 && (o = l(o, a(arguments[1]))), o < 0 && (o = e + o); o >= 0; o--)
      if (o in n && n[o] === t) return o || 0;
    return -1
  } : c
}, function (t, n) {
  var e = Math.floor,
    i = function (t, n) {
      var o = t.length,
        l = e(o / 2);
      return o < 8 ? a(t, n) : r(i(t.slice(0, l), n), i(t.slice(l), n), n)
    },
    a = function (t, n) {
      for (var e, i, a = t.length, r = 1; r < a;) {
        for (i = r, e = t[r]; i && n(t[i - 1], e) > 0;) t[i] = t[--i];
        i !== r++ && (t[i] = e)
      }
      return t
    },
    r = function (t, n, e) {
      for (var i = t.length, a = n.length, r = 0, o = 0, l = []; r < i || o < a;) r < i && o < a ? l.push(e(t[r], n[o]) <= 0 ? t[r++] : n[o++]) : l.push(r < i ? t[r++] : n[o++]);
      return l
    };
  t.exports = i
}, function (t, n, e) {
  var i = e(32).match(/firefox\/(\d+)/i);
  t.exports = !!i && +i[1]
}, function (t, n, e) {
  var i = e(32);
  t.exports = /MSIE|Trident/.test(i)
}, function (t, n, e) {
  var i = e(21),
    a = e(7);
  t.exports = function (t) {
    if (void 0 === t) return 0;
    var n = i(t),
      e = a(n);
    if (n !== e) throw RangeError("Wrong length or index");
    return e
  }
}, function (t, n, e) {
  "use strict";
  var i = e(19),
    a = e(3),
    r = [].slice,
    o = {},
    l = function (t, n, e) {
      if (!(n in o)) {
        for (var i = [], a = 0; a < n; a++) i[a] = "a[" + a + "]";
        o[n] = Function("C,a", "return new C(" + i.join(",") + ")")
      }
      return o[n](t, e)
    };
  t.exports = Function.bind || function (t) {
    var n = i(this),
      e = r.call(arguments, 1),
      o = function () {
        var i = e.concat(r.call(arguments));
        return this instanceof o ? l(n, i.length, i) : n.apply(t, i)
      };
    return a(n.prototype) && (o.prototype = n.prototype), o
  }
}, function (t, n, e) {
  "use strict";
  var i = e(10).f,
    a = e(28),
    r = e(50),
    o = e(40),
    l = e(43),
    c = e(41),
    s = e(103),
    h = e(49),
    u = e(6),
    f = e(46).fastKey,
    v = e(14),
    p = v.set,
    g = v.getterFor;
  t.exports = {
    getConstructor: function (t, n, e, s) {
      var h = t((function (t, i) {
          l(t, h, n), p(t, {
            type: n,
            index: a(null),
            first: void 0,
            last: void 0,
            size: 0
          }), u || (t.size = 0), null != i && c(i, t[s], {
            that: t,
            AS_ENTRIES: e
          })
        })),
        v = g(n),
        d = function (t, n, e) {
          var i, a, r = v(t),
            o = m(t, n);
          return o ? o.value = e : (r.last = o = {
            index: a = f(n, !0),
            key: n,
            value: e,
            previous: i = r.last,
            next: void 0,
            removed: !1
          }, r.first || (r.first = o), i && (i.next = o), u ? r.size++ : t.size++, "F" !== a && (r.index[a] = o)), t
        },
        m = function (t, n) {
          var e, i = v(t),
            a = f(n);
          if ("F" !== a) return i.index[a];
          for (e = i.first; e; e = e.next)
            if (e.key == n) return e
        };
      return r(h.prototype, {
        clear: function () {
          for (var t = v(this), n = t.index, e = t.first; e;) e.removed = !0, e.previous && (e.previous = e.previous.next = void 0), delete n[e.index], e = e.next;
          t.first = t.last = void 0, u ? t.size = 0 : this.size = 0
        },
        delete: function (t) {
          var n = v(this),
            e = m(this, t);
          if (e) {
            var i = e.next,
              a = e.previous;
            delete n.index[e.index], e.removed = !0, a && (a.next = i), i && (i.previous = a), n.first == e && (n.first = i), n.last == e && (n.last = a), u ? n.size-- : this.size--
          }
          return !!e
        },
        forEach: function (t) {
          for (var n, e = v(this), i = o(t, arguments.length > 1 ? arguments[1] : void 0, 3); n = n ? n.next : e.first;)
            for (i(n.value, n.key, this); n && n.removed;) n = n.previous
        },
        has: function (t) {
          return !!m(this, t)
        }
      }), r(h.prototype, e ? {
        get: function (t) {
          var n = m(this, t);
          return n && n.value
        },
        set: function (t, n) {
          return d(this, 0 === t ? 0 : t, n)
        }
      } : {
        add: function (t) {
          return d(this, t = 0 === t ? 0 : t, t)
        }
      }), u && i(h.prototype, "size", {
        get: function () {
          return v(this).size
        }
      }), h
    },
    setStrong: function (t, n, e) {
      var i = n + " Iterator",
        a = g(n),
        r = g(i);
      s(t, n, (function (t, n) {
        p(this, {
          type: i,
          target: t,
          state: a(t),
          kind: n,
          last: void 0
        })
      }), (function () {
        for (var t = r(this), n = t.kind, e = t.last; e && e.removed;) e = e.previous;
        return t.target && (t.last = e = e ? e.next : t.state.first) ? "keys" == n ? {
          value: e.key,
          done: !1
        } : "values" == n ? {
          value: e.value,
          done: !1
        } : {
          value: [e.key, e.value],
          done: !1
        } : (t.target = void 0, {
          value: void 0,
          done: !0
        })
      }), e ? "entries" : "values", !e, !0), h(n)
    }
  }
}, function (t, n) {
  var e = Math.log;
  t.exports = Math.log1p || function (t) {
    return (t = +t) > -1e-8 && t < 1e-8 ? t - t * t / 2 : e(1 + t)
  }
}, function (t, n, e) {
  var i = e(2),
    a = e(9),
    r = e(52).trim,
    o = e(77),
    l = i.parseFloat,
    c = 1 / l(o + "-0") != -1 / 0;
  t.exports = c ? function (t) {
    var n = r(a(t)),
      e = l(n);
    return 0 === e && "-" == n.charAt(0) ? -0 : e
  } : l
}, function (t, n, e) {
  var i = e(2),
    a = e(9),
    r = e(52).trim,
    o = e(77),
    l = i.parseInt,
    c = /^[+-]?0[Xx]/,
    s = 8 !== l(o + "08") || 22 !== l(o + "0x16");
  t.exports = s ? function (t, n) {
    var e = r(a(t));
    return l(e, n >>> 0 || (c.test(e) ? 16 : 10))
  } : l
}, function (t, n, e) {
  var i = e(31);
  t.exports = function (t) {
    if ("number" != typeof t && "Number" != i(t)) throw TypeError("Incorrect invocation");
    return +t
  }
}, function (t, n, e) {
  "use strict";
  var i = e(6),
    a = e(1),
    r = e(59),
    o = e(96),
    l = e(67),
    c = e(11),
    s = e(54),
    h = Object.assign,
    u = Object.defineProperty;
  t.exports = !h || a((function () {
    if (i && 1 !== h({
        b: 1
      }, h(u({}, "a", {
        enumerable: !0,
        get: function () {
          u(this, "b", {
            value: 3,
            enumerable: !1
          })
        }
      }), {
        b: 2
      })).b) return !0;
    var t = {},
      n = {},
      e = Symbol();
    return t[e] = 7, "abcdefghijklmnopqrst".split("").forEach((function (t) {
      n[t] = t
    })), 7 != h({}, t)[e] || "abcdefghijklmnopqrst" != r(h({}, n)).join("")
  })) ? function (t, n) {
    for (var e = c(t), a = arguments.length, h = 1, u = o.f, f = l.f; a > h;)
      for (var v, p = s(arguments[h++]), g = u ? r(p).concat(u(p)) : r(p), d = g.length, m = 0; d > m;) v = g[m++], i && !f.call(p, v) || (e[v] = p[v]);
    return e
  } : h
}, function (t, n, e) {
  var i = e(6),
    a = e(59),
    r = e(23),
    o = e(67).f,
    l = function (t) {
      return function (n) {
        for (var e, l = r(n), c = a(l), s = c.length, h = 0, u = []; s > h;) e = c[h++], i && !o.call(l, e) || u.push(t ? [e, l[e]] : l[e]);
        return u
      }
    };
  t.exports = {
    entries: l(!0),
    values: l(!1)
  }
}, function (t, n) {
  t.exports = Object.is || function (t, n) {
    return t === n ? 0 !== t || 1 / t == 1 / n : t != t && n != n
  }
}, function (t, n, e) {
  var i = e(2);
  t.exports = i.Promise
}, function (t, n, e) {
  var i = e(32);
  t.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(i)
}, function (t, n, e) {
  var i, a, r, o, l, c, s, h, u = e(2),
    f = e(16).f,
    v = e(111).set,
    p = e(151),
    g = e(298),
    d = e(299),
    m = e(48),
    F = u.MutationObserver || u.WebKitMutationObserver,
    M = u.document,
    w = u.process,
    z = u.Promise,
    y = f(u, "queueMicrotask"),
    A = y && y.value;
  A || (i = function () {
    var t, n;
    for (m && (t = w.domain) && t.exit(); a;) {
      n = a.fn, a = a.next;
      try {
        n()
      } catch (t) {
        throw a ? o() : r = void 0, t
      }
    }
    r = void 0, t && t.enter()
  }, p || m || d || !F || !M ? !g && z && z.resolve ? ((s = z.resolve(void 0)).constructor = z, h = s.then, o = function () {
    h.call(s, i)
  }) : o = m ? function () {
    w.nextTick(i)
  } : function () {
    v.call(u, i)
  } : (l = !0, c = M.createTextNode(""), new F(i).observe(c, {
    characterData: !0
  }), o = function () {
    c.data = l = !l
  })), t.exports = A || function (t) {
    var n = {
      fn: t,
      next: void 0
    };
    r && (r.next = n), a || (a = n, o()), r = n
  }
}, function (t, n, e) {
  var i = e(4),
    a = e(3),
    r = e(79);
  t.exports = function (t, n) {
    if (i(t), a(n) && n.constructor === t) return n;
    var e = r.f(t);
    return (0, e.resolve)(n), e.promise
  }
}, function (t, n, e) {
  var i = e(1),
    a = e(2).RegExp;
  t.exports = i((function () {
    var t = a("(?<a>b)", "g");
    return "b" !== t.exec("b").groups.a || "bc" !== "b".replace(t, "$<a>c")
  }))
}, function (t, n, e) {
  "use strict";
  var i = e(82).charAt,
    a = e(9),
    r = e(14),
    o = e(103),
    l = r.set,
    c = r.getterFor("String Iterator");
  o(String, "String", (function (t) {
    l(this, {
      type: "String Iterator",
      string: a(t),
      index: 0
    })
  }), (function () {
    var t, n = c(this),
      e = n.string,
      a = n.index;
    return a >= e.length ? {
      value: void 0,
      done: !0
    } : (t = i(e, a), n.index += t.length, {
      value: t,
      done: !1
    })
  }))
}, function (t, n, e) {
  var i = e(32);
  t.exports = /Version\/10(?:\.\d+){1,2}(?: [\w./]+)?(?: Mobile\/\w+)? Safari\//.test(i)
}, function (t, n, e) {
  var i = e(11),
    a = Math.floor,
    r = "".replace,
    o = /\$([$&'`]|\d{1,2}|<[^>]*>)/g,
    l = /\$([$&'`]|\d{1,2})/g;
  t.exports = function (t, n, e, c, s, h) {
    var u = e + t.length,
      f = c.length,
      v = l;
    return void 0 !== s && (s = i(s), v = o), r.call(h, v, (function (i, r) {
      var o;
      switch (r.charAt(0)) {
        case "$":
          return "$";
        case "&":
          return t;
        case "`":
          return n.slice(0, e);
        case "'":
          return n.slice(u);
        case "<":
          o = s[r.slice(1, -1)];
          break;
        default:
          var l = +r;
          if (0 === l) return i;
          if (l > f) {
            var h = a(l / 10);
            return 0 === h ? i : h <= f ? void 0 === c[h - 1] ? r.charAt(1) : c[h - 1] + r.charAt(1) : i
          }
          o = c[l - 1]
      }
      return void 0 === o ? "" : o
    }))
  }
}, function (t, n, e) {
  var i = e(359);
  t.exports = function (t, n) {
    var e = i(t);
    if (e % n) throw RangeError("Wrong offset");
    return e
  }
}, function (t, n, e) {
  var i = e(11),
    a = e(7),
    r = e(62),
    o = e(100),
    l = e(40),
    c = e(8).aTypedArrayConstructor;
  t.exports = function (t) {
    var n, e, s, h, u, f, v = i(t),
      p = arguments.length,
      g = p > 1 ? arguments[1] : void 0,
      d = void 0 !== g,
      m = r(v);
    if (null != m && !o(m))
      for (f = (u = m.call(v)).next, v = []; !(h = f.call(u)).done;) v.push(h.value);
    for (d && p > 2 && (g = l(g, arguments[2], 2)), e = a(v.length), s = new(c(this))(e), n = 0; e > n; n++) s[n] = d ? g(v[n], n) : v[n];
    return s
  }
}, function (t, n, e) {
  "use strict";
  var i = e(50),
    a = e(46).getWeakData,
    r = e(4),
    o = e(3),
    l = e(43),
    c = e(41),
    s = e(15),
    h = e(12),
    u = e(14),
    f = u.set,
    v = u.getterFor,
    p = s.find,
    g = s.findIndex,
    d = 0,
    m = function (t) {
      return t.frozen || (t.frozen = new F)
    },
    F = function () {
      this.entries = []
    },
    M = function (t, n) {
      return p(t.entries, (function (t) {
        return t[0] === n
      }))
    };
  F.prototype = {
    get: function (t) {
      var n = M(this, t);
      if (n) return n[1]
    },
    has: function (t) {
      return !!M(this, t)
    },
    set: function (t, n) {
      var e = M(this, t);
      e ? e[1] = n : this.entries.push([t, n])
    },
    delete: function (t) {
      var n = g(this.entries, (function (n) {
        return n[0] === t
      }));
      return ~n && this.entries.splice(n, 1), !!~n
    }
  }, t.exports = {
    getConstructor: function (t, n, e, s) {
      var u = t((function (t, i) {
          l(t, u, n), f(t, {
            type: n,
            id: d++,
            frozen: void 0
          }), null != i && c(i, t[s], {
            that: t,
            AS_ENTRIES: e
          })
        })),
        p = v(n),
        g = function (t, n, e) {
          var i = p(t),
            o = a(r(n), !0);
          return !0 === o ? m(i).set(n, e) : o[i.id] = e, t
        };
      return i(u.prototype, {
        delete: function (t) {
          var n = p(this);
          if (!o(t)) return !1;
          var e = a(t);
          return !0 === e ? m(n).delete(t) : e && h(e, n.id) && delete e[n.id]
        },
        has: function (t) {
          var n = p(this);
          if (!o(t)) return !1;
          var e = a(t);
          return !0 === e ? m(n).has(t) : e && h(e, n.id)
        }
      }), i(u.prototype, e ? {
        get: function (t) {
          var n = p(this);
          if (o(t)) {
            var e = a(t);
            return !0 === e ? m(n).get(t) : e ? e[n.id] : void 0
          }
        },
        set: function (t, n) {
          return g(this, t, n)
        }
      } : {
        add: function (t) {
          return g(this, t, !0)
        }
      }), u
    }
  }
}, function (t, n) {
  t.exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
  }
}, function (t, n, e) {
  var i = e(1),
    a = e(5),
    r = e(26),
    o = a("iterator");
  t.exports = !i((function () {
    var t = new URL("b?a=1&b=2&c=3", "http://a"),
      n = t.searchParams,
      e = "";
    return t.pathname = "c%20d", n.forEach((function (t, i) {
      n.delete("b"), e += i + t
    })), r && !t.toJSON || !n.sort || "http://a/c%20d?a=1&c=3" !== t.href || "3" !== n.get("c") || "a=1" !== String(new URLSearchParams("?a=1")) || !n[o] || "a" !== new URL("https://a@b").username || "b" !== new URLSearchParams(new URLSearchParams("a=b")).get("a") || "xn--e1aybc" !== new URL("http://тест").host || "#%D0%B1" !== new URL("http://a#б").hash || "a1c3" !== e || "x" !== new URL("http://x", void 0).host
  }))
}, function (t, n, e) {
  "use strict";
  e(71);
  var i = e(0),
    a = e(20),
    r = e(162),
    o = e(18),
    l = e(50),
    c = e(29),
    s = e(104),
    h = e(14),
    u = e(43),
    f = e(12),
    v = e(40),
    p = e(63),
    g = e(4),
    d = e(3),
    m = e(9),
    F = e(28),
    M = e(30),
    w = e(405),
    z = e(62),
    y = e(5),
    A = a("fetch"),
    U = a("Request"),
    H = U && U.prototype,
    x = a("Headers"),
    E = y("iterator"),
    S = h.set,
    B = h.getterFor("URLSearchParams"),
    D = h.getterFor("URLSearchParamsIterator"),
    b = /\+/g,
    N = Array(4),
    j = function (t) {
      return N[t - 1] || (N[t - 1] = RegExp("((?:%[\\da-f]{2}){" + t + "})", "gi"))
    },
    L = function (t) {
      try {
        return decodeURIComponent(t)
      } catch (n) {
        return t
      }
    },
    C = function (t) {
      var n = t.replace(b, " "),
        e = 4;
      try {
        return decodeURIComponent(n)
      } catch (t) {
        for (; e;) n = n.replace(j(e--), L);
        return n
      }
    },
    T = /[!'()~]|%20/g,
    I = {
      "!": "%21",
      "'": "%27",
      "(": "%28",
      ")": "%29",
      "~": "%7E",
      "%20": "+"
    },
    R = function (t) {
      return I[t]
    },
    V = function (t) {
      return encodeURIComponent(t).replace(T, R)
    },
    k = function (t, n) {
      if (n)
        for (var e, i, a = n.split("&"), r = 0; r < a.length;)(e = a[r++]).length && (i = e.split("="), t.push({
          key: C(i.shift()),
          value: C(i.join("="))
        }))
    },
    O = function (t) {
      this.entries.length = 0, k(this.entries, t)
    },
    P = function (t, n) {
      if (t < n) throw TypeError("Not enough arguments")
    },
    G = s((function (t, n) {
      S(this, {
        type: "URLSearchParamsIterator",
        iterator: w(B(t).entries),
        kind: n
      })
    }), "Iterator", (function () {
      var t = D(this),
        n = t.kind,
        e = t.iterator.next(),
        i = e.value;
      return e.done || (e.value = "keys" === n ? i.key : "values" === n ? i.value : [i.key, i.value]), e
    })),
    K = function () {
      u(this, K, "URLSearchParams");
      var t, n, e, i, a, r, o, l, c, s = arguments.length > 0 ? arguments[0] : void 0,
        h = this,
        v = [];
      if (S(h, {
          type: "URLSearchParams",
          entries: v,
          updateURL: function () {},
          updateSearchParams: O
        }), void 0 !== s)
        if (d(s))
          if ("function" == typeof (t = z(s)))
            for (e = (n = t.call(s)).next; !(i = e.call(n)).done;) {
              if ((o = (r = (a = w(g(i.value))).next).call(a)).done || (l = r.call(a)).done || !r.call(a).done) throw TypeError("Expected sequence with length 2");
              v.push({
                key: m(o.value),
                value: m(l.value)
              })
            } else
              for (c in s) f(s, c) && v.push({
                key: c,
                value: m(s[c])
              });
          else k(v, "string" == typeof s ? "?" === s.charAt(0) ? s.slice(1) : s : m(s))
    },
    W = K.prototype;
  if (l(W, {
      append: function (t, n) {
        P(arguments.length, 2);
        var e = B(this);
        e.entries.push({
          key: m(t),
          value: m(n)
        }), e.updateURL()
      },
      delete: function (t) {
        P(arguments.length, 1);
        for (var n = B(this), e = n.entries, i = m(t), a = 0; a < e.length;) e[a].key === i ? e.splice(a, 1) : a++;
        n.updateURL()
      },
      get: function (t) {
        P(arguments.length, 1);
        for (var n = B(this).entries, e = m(t), i = 0; i < n.length; i++)
          if (n[i].key === e) return n[i].value;
        return null
      },
      getAll: function (t) {
        P(arguments.length, 1);
        for (var n = B(this).entries, e = m(t), i = [], a = 0; a < n.length; a++) n[a].key === e && i.push(n[a].value);
        return i
      },
      has: function (t) {
        P(arguments.length, 1);
        for (var n = B(this).entries, e = m(t), i = 0; i < n.length;)
          if (n[i++].key === e) return !0;
        return !1
      },
      set: function (t, n) {
        P(arguments.length, 1);
        for (var e, i = B(this), a = i.entries, r = !1, o = m(t), l = m(n), c = 0; c < a.length; c++)(e = a[c]).key === o && (r ? a.splice(c--, 1) : (r = !0, e.value = l));
        r || a.push({
          key: o,
          value: l
        }), i.updateURL()
      },
      sort: function () {
        var t, n, e, i = B(this),
          a = i.entries,
          r = a.slice();
        for (a.length = 0, e = 0; e < r.length; e++) {
          for (t = r[e], n = 0; n < e; n++)
            if (a[n].key > t.key) {
              a.splice(n, 0, t);
              break
            } n === e && a.push(t)
        }
        i.updateURL()
      },
      forEach: function (t) {
        for (var n, e = B(this).entries, i = v(t, arguments.length > 1 ? arguments[1] : void 0, 3), a = 0; a < e.length;) i((n = e[a++]).value, n.key, this)
      },
      keys: function () {
        return new G(this, "keys")
      },
      values: function () {
        return new G(this, "values")
      },
      entries: function () {
        return new G(this, "entries")
      }
    }, {
      enumerable: !0
    }), o(W, E, W.entries), o(W, "toString", (function () {
      for (var t, n = B(this).entries, e = [], i = 0; i < n.length;) t = n[i++], e.push(V(t.key) + "=" + V(t.value));
      return e.join("&")
    }), {
      enumerable: !0
    }), c(K, "URLSearchParams"), i({
      global: !0,
      forced: !r
    }, {
      URLSearchParams: K
    }), !r && "function" == typeof x) {
    var _ = function (t) {
      if (d(t)) {
        var n, e = t.body;
        if ("URLSearchParams" === p(e)) return (n = t.headers ? new x(t.headers) : new x).has("content-type") || n.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"), F(t, {
          body: M(0, String(e)),
          headers: M(0, n)
        })
      }
      return t
    };
    if ("function" == typeof A && i({
        global: !0,
        enumerable: !0,
        forced: !0
      }, {
        fetch: function (t) {
          return A(t, arguments.length > 1 ? _(arguments[1]) : {})
        }
      }), "function" == typeof U) {
      var Y = function (t) {
        return u(this, Y, "Request"), new U(t, arguments.length > 1 ? _(arguments[1]) : {})
      };
      H.constructor = Y, Y.prototype = H, i({
        global: !0,
        forced: !0
      }, {
        Request: Y
      })
    }
  }
  t.exports = {
    URLSearchParams: K,
    getState: B
  }
}, function (t, n) {
  function e(t, n) {
    for (var e = 0; e < i.length; e++)
      if (i[e][t] === n) return i[e];
    return null
  }
  t.exports.byFips = function (t) {
    return e("fips", t.toUpperCase())
  }, t.exports.byIso = function (t) {
    if (!isNaN(parseInt(t))) return e("isoNo", t.toString());
    if (2 === t.length) return e("iso2", t.toUpperCase());
    if (3 === t.length) return e("iso3", t.toUpperCase());
    throw new Error("cannot determine ISO code type")
  }, t.exports.byInternet = function (t) {
    return e("internet", t.toUpperCase())
  }, t.exports.byCountry = function (t) {
    return e("country", t)
  };
  var i = [{
    continent: "Asia",
    region: "South Asia",
    country: "Afghanistan",
    capital: "Kabul",
    fips: "AF",
    iso2: "AF",
    iso3: "AFG",
    isoNo: "4",
    internet: "AF"
  }, {
    continent: "Europe",
    region: "South East Europe",
    country: "Albania",
    capital: "Tirana",
    fips: "AL",
    iso2: "AL",
    iso3: "ALB",
    isoNo: "8",
    internet: "AL"
  }, {
    continent: "Africa",
    region: "Northern Africa",
    country: "Algeria",
    capital: "Algiers",
    fips: "AG",
    iso2: "DZ",
    iso3: "DZA",
    isoNo: "12",
    internet: "DZ"
  }, {
    continent: "Oceania",
    region: "Pacific",
    country: "American Samoa",
    capital: "Pago Pago",
    fips: "AQ",
    iso2: "AS",
    iso3: "ASM",
    isoNo: "16",
    internet: "AS"
  }, {
    continent: "Europe",
    region: "South West Europe",
    country: "Andorra",
    capital: "Andorra la Vella",
    fips: "AN",
    iso2: "AD",
    iso3: "AND",
    isoNo: "20",
    internet: "AD"
  }, {
    continent: "Africa",
    region: "Southern Africa",
    country: "Angola",
    capital: "Luanda",
    fips: "AO",
    iso2: "AO",
    iso3: "AGO",
    isoNo: "24",
    internet: "AO"
  }, {
    continent: "Americas",
    region: "West Indies",
    country: "Anguilla",
    capital: "The Valley",
    fips: "AV",
    iso2: "AI",
    iso3: "AIA",
    isoNo: "660",
    internet: "AI"
  }, {
    continent: "Americas",
    region: "West Indies",
    country: "Antigua and Barbuda",
    capital: "Saint John's",
    fips: "AC",
    iso2: "AG",
    iso3: "ATG",
    isoNo: "28",
    internet: "AG"
  }, {
    continent: "Americas",
    region: "South America",
    country: "Argentina",
    capital: "Buenos Aires",
    fips: "AR",
    iso2: "AR",
    iso3: "ARG",
    isoNo: "32",
    internet: "AR"
  }, {
    continent: "Asia",
    region: "South West Asia",
    country: "Armenia",
    capital: "Yerevan",
    fips: "AM",
    iso2: "AM",
    iso3: "ARM",
    isoNo: "51",
    internet: "AM"
  }, {
    continent: "Americas",
    region: "West Indies",
    country: "Aruba",
    capital: "Oranjestad",
    fips: "AA",
    iso2: "AW",
    iso3: "ABW",
    isoNo: "533",
    internet: "AW"
  }, {
    continent: "Oceania",
    region: "Pacific",
    country: "Australia",
    capital: "Canberra",
    fips: "AS",
    iso2: "AU",
    iso3: "AUS",
    isoNo: "36",
    internet: "AU"
  }, {
    continent: "Europe",
    region: "Central Europe",
    country: "Austria",
    capital: "Vienna",
    fips: "AU",
    iso2: "AT",
    iso3: "AUT",
    isoNo: "40",
    internet: "AT"
  }, {
    continent: "Asia",
    region: "South West Asia",
    country: "Azerbaijan",
    capital: "Baku (Baki)",
    fips: "AJ",
    iso2: "AZ",
    iso3: "AZE",
    isoNo: "31",
    internet: "AZ"
  }, {
    continent: "Americas",
    region: "West Indies",
    country: "The Bahamas",
    capital: "Nassau",
    fips: "BF",
    iso2: "BS",
    iso3: "BHS",
    isoNo: "44",
    internet: "BS"
  }, {
    continent: "Asia",
    region: "South West Asia",
    country: "Bahrain",
    capital: "Manama",
    fips: "BA",
    iso2: "BH",
    iso3: "BHR",
    isoNo: "48",
    internet: "BH"
  }, {
    continent: "Asia",
    region: "South Asia",
    country: "Bangladesh",
    capital: "Dhaka",
    fips: "BG",
    iso2: "BD",
    iso3: "BGD",
    isoNo: "50",
    internet: "BD"
  }, {
    continent: "Americas",
    region: "West Indies",
    country: "Barbados",
    capital: "Bridgetown",
    fips: "BB",
    iso2: "BB",
    iso3: "BRB",
    isoNo: "52",
    internet: "BB"
  }, {
    continent: "Europe",
    region: "Eastern Europe",
    country: "Belarus",
    capital: "Minsk",
    fips: "BO",
    iso2: "BY",
    iso3: "BLR",
    isoNo: "112",
    internet: "BY"
  }, {
    continent: "Europe",
    region: "Western Europe",
    country: "Belgium",
    capital: "Brussels",
    fips: "BE",
    iso2: "BE",
    iso3: "BEL",
    isoNo: "56",
    internet: "BE"
  }, {
    continent: "Americas",
    region: "Central America",
    country: "Belize",
    capital: "Belmopan",
    fips: "BH",
    iso2: "BZ",
    iso3: "BLZ",
    isoNo: "84",
    internet: "BZ"
  }, {
    continent: "Africa",
    region: "Western Africa",
    country: "Benin",
    capital: "Porto-Novo��",
    fips: "BN",
    iso2: "BJ",
    iso3: "BEN",
    isoNo: "204",
    internet: "BJ"
  }, {
    continent: "Americas",
    region: "West Indies",
    country: "Bermuda",
    capital: "Hamilton",
    fips: "BD",
    iso2: "BM",
    iso3: "BMU",
    isoNo: "60",
    internet: "BM"
  }, {
    continent: "Asia",
    region: "South Asia",
    country: "Bhutan",
    capital: "Thimphu",
    fips: "BT",
    iso2: "BT",
    iso3: "BTN",
    isoNo: "64",
    internet: "BT"
  }, {
    continent: "Americas",
    region: "South America",
    country: "Bolivia",
    capital: "La Paz / Sucre",
    fips: "BL",
    iso2: "BO",
    iso3: "BOL",
    isoNo: "68",
    internet: "BO"
  }, {
    continent: "Europe",
    region: "South East Europe",
    country: "Bosnia and Herzegovina",
    capital: "Sarajevo",
    fips: "BK",
    iso2: "BA",
    iso3: "BIH",
    isoNo: "70",
    internet: "BA"
  }, {
    continent: "Africa",
    region: "Southern Africa",
    country: "Botswana",
    capital: "Gaborone",
    fips: "BC",
    iso2: "BW",
    iso3: "BWA",
    isoNo: "72",
    internet: "BW"
  }, {
    continent: "Americas",
    region: "South America",
    country: "Brazil",
    capital: "Brasilia",
    fips: "BR",
    iso2: "BR",
    iso3: "BRA",
    isoNo: "76",
    internet: "BR"
  }, {
    continent: "Americas",
    region: "West Indies",
    country: "British Virgin Islands",
    capital: "Road Town",
    fips: "VI",
    iso2: "VG",
    iso3: "VGB",
    isoNo: "92",
    internet: "VG"
  }, {
    continent: "Asia",
    region: "South East Asia",
    country: "Brunei",
    capital: "Bandar Seri Begawan",
    fips: "BX",
    iso2: "BN",
    iso3: "BRN",
    isoNo: "96",
    internet: "BN"
  }, {
    continent: "Europe",
    region: "South East Europe",
    country: "Bulgaria",
    capital: "Sofia",
    fips: "BU",
    iso2: "BG",
    iso3: "BGR",
    isoNo: "100",
    internet: "BG"
  }, {
    continent: "Africa",
    region: "Western Africa",
    country: "Burkina Faso",
    capital: "Ouagadougou",
    fips: "UV",
    iso2: "BF",
    iso3: "BFA",
    isoNo: "854",
    internet: "BF"
  }, {
    continent: "Africa",
    region: "Central Africa",
    country: "Burundi",
    capital: "Bujumbura",
    fips: "BY",
    iso2: "BI",
    iso3: "BDI",
    isoNo: "108",
    internet: "BI"
  }, {
    continent: "Asia",
    region: "South East Asia",
    country: "Cambodia",
    capital: "Phnom Penh",
    fips: "CB",
    iso2: "KH",
    iso3: "KHM",
    isoNo: "116",
    internet: "KH"
  }, {
    continent: "Africa",
    region: "Western Africa",
    country: "Cameroon",
    capital: "Yaounde",
    fips: "CM",
    iso2: "CM",
    iso3: "CMR",
    isoNo: "120",
    internet: "CM"
  }, {
    continent: "Americas",
    region: "North America",
    country: "Canada",
    capital: "Ottawa",
    fips: "CA",
    iso2: "CA",
    iso3: "CAN",
    isoNo: "124",
    internet: "CA"
  }, {
    continent: "Africa",
    region: "Western Africa",
    country: "Cape Verde",
    capital: "Praia",
    fips: "CV",
    iso2: "CV",
    iso3: "CPV",
    isoNo: "132",
    internet: "CV"
  }, {
    continent: "Americas",
    region: "West Indies",
    country: "Cayman Islands",
    capital: "George Town",
    fips: "CJ",
    iso2: "KY",
    iso3: "CYM",
    isoNo: "136",
    internet: "KY"
  }, {
    continent: "Africa",
    region: "Central Africa",
    country: "Central African Republic",
    capital: "Bangui",
    fips: "CT",
    iso2: "CF",
    iso3: "CAF",
    isoNo: "140",
    internet: "CF"
  }, {
    continent: "Africa",
    region: "Central Africa",
    country: "Chad",
    capital: "N'Djamena",
    fips: "CD",
    iso2: "TD",
    iso3: "TCD",
    isoNo: "148",
    internet: "TD"
  }, {
    continent: "Americas",
    region: "South America",
    country: "Chile",
    capital: "Santiago",
    fips: "CI",
    iso2: "CL",
    iso3: "CHL",
    isoNo: "152",
    internet: "CL"
  }, {
    continent: "Asia",
    region: "East Asia",
    country: "China",
    capital: "Beijing",
    fips: "CH",
    iso2: "CN",
    iso3: "CHN",
    isoNo: "156",
    internet: "CN"
  }, {
    continent: "Asia",
    region: "South East Asia",
    country: "Christmas Island",
    capital: "The Settlement",
    fips: "KT",
    iso2: "CX",
    iso3: "CXR",
    isoNo: "162",
    internet: "CX"
  }, {
    continent: "Asia",
    region: "South East Asia",
    country: "Cocos (Keeling) Islands",
    capital: "West Island",
    fips: "CK",
    iso2: "CC",
    iso3: "CCK",
    isoNo: "166",
    internet: "CC"
  }, {
    continent: "Americas",
    region: "South America",
    country: "Colombia",
    capital: "Bogota",
    fips: "CO",
    iso2: "CO",
    iso3: "COL",
    isoNo: "170",
    internet: "CO"
  }, {
    continent: "Africa",
    region: "Indian Ocean",
    country: "Comoros",
    capital: "Moroni",
    fips: "CN",
    iso2: "KM",
    iso3: "COM",
    isoNo: "174",
    internet: "KM"
  }, {
    continent: "Africa",
    region: "Central Africa",
    country: "Republic of the Congo",
    capital: "Brazzaville",
    fips: "CF",
    iso2: "CG",
    iso3: "COG",
    isoNo: "178",
    internet: "CG"
  }, {
    continent: "Oceania",
    region: "Pacific",
    country: "Cook Islands",
    capital: "Avarua",
    fips: "CW",
    iso2: "CK",
    iso3: "COK",
    isoNo: "184",
    internet: "CK"
  }, {
    continent: "Americas",
    region: "Central America",
    country: "Costa Rica",
    capital: "San Jose",
    fips: "CS",
    iso2: "CR",
    iso3: "CRI",
    isoNo: "188",
    internet: "CR"
  }, {
    continent: "Africa",
    region: "Western Africa",
    country: "Cote d'Ivoire",
    capital: "Yamoussoukro",
    fips: "IV",
    iso2: "CI",
    iso3: "CIV",
    isoNo: "384",
    internet: "CI"
  }, {
    continent: "Europe",
    region: "South East Europe",
    country: "Croatia",
    capital: "Zagreb",
    fips: "HR",
    iso2: "HR",
    iso3: "HRV",
    isoNo: "191",
    internet: "HR"
  }, {
    continent: "Americas",
    region: "West Indies",
    country: "Cuba",
    capital: "Havana",
    fips: "CU",
    iso2: "CU",
    iso3: "CUB",
    isoNo: "192",
    internet: "CU"
  }, {
    continent: "Asia",
    region: "South West Asia",
    country: "Cyprus",
    capital: "Nicosia",
    fips: "CY",
    iso2: "CY",
    iso3: "CYP",
    isoNo: "196",
    internet: "CY"
  }, {
    continent: "Europe",
    region: "Central Europe",
    country: "Czech Republic",
    capital: "Prague",
    fips: "EZ",
    iso2: "CZ",
    iso3: "CZE",
    isoNo: "203",
    internet: "CZ"
  }, {
    continent: "Europe",
    region: "Northern Europe",
    country: "Denmark",
    capital: "Copenhagen",
    fips: "DA",
    iso2: "DK",
    iso3: "DNK",
    isoNo: "208",
    internet: "DK"
  }, {
    continent: "Africa",
    region: "Eastern Africa",
    country: "Djibouti",
    capital: "Djibouti",
    fips: "DJ",
    iso2: "DJ",
    iso3: "DJI",
    isoNo: "262",
    internet: "DJ"
  }, {
    continent: "Americas",
    region: "West Indies",
    country: "Dominica",
    capital: "Roseau",
    fips: "DO",
    iso2: "DM",
    iso3: "DMA",
    isoNo: "212",
    internet: "DM"
  }, {
    continent: "Americas",
    region: "West Indies",
    country: "Dominican Republic",
    capital: "Santo Domingo",
    fips: "DR",
    iso2: "DO",
    iso3: "DOM",
    isoNo: "214",
    internet: "DO"
  }, {
    continent: "Americas",
    region: "South America",
    country: "Ecuador",
    capital: "Quito",
    fips: "EC",
    iso2: "EC",
    iso3: "ECU",
    isoNo: "218",
    internet: "EC"
  }, {
    continent: "Africa",
    region: "Northern Africa",
    country: "Egypt",
    capital: "Cairo",
    fips: "EG",
    iso2: "EG",
    iso3: "EGY",
    isoNo: "818",
    internet: "EG"
  }, {
    continent: "Americas",
    region: "Central America",
    country: "El Salvador",
    capital: "San Salvador",
    fips: "ES",
    iso2: "SV",
    iso3: "SLV",
    isoNo: "222",
    internet: "SV"
  }, {
    continent: "Africa",
    region: "Western Africa",
    country: "Equatorial Guinea",
    capital: "Malabo",
    fips: "EK",
    iso2: "GQ",
    iso3: "GNQ",
    isoNo: "226",
    internet: "GQ"
  }, {
    continent: "Africa",
    region: "Eastern Africa",
    country: "Eritrea",
    capital: "Asmara",
    fips: "ER",
    iso2: "ER",
    iso3: "ERI",
    isoNo: "232",
    internet: "ER"
  }, {
    continent: "Europe",
    region: "Eastern Europe",
    country: "Estonia",
    capital: "Tallinn",
    fips: "EN",
    iso2: "EE",
    iso3: "EST",
    isoNo: "233",
    internet: "EE"
  }, {
    continent: "Africa",
    region: "Eastern Africa",
    country: "Ethiopia",
    capital: "Addis Ababa",
    fips: "ET",
    iso2: "ET",
    iso3: "ETH",
    isoNo: "231",
    internet: "ET"
  }, {
    continent: "Americas",
    region: "South America",
    country: "Falkland Islands (Islas Malvinas)",
    capital: "Stanley",
    fips: "FA",
    iso2: "FK",
    iso3: "FLK",
    isoNo: "238",
    internet: "FK"
  }, {
    continent: "Europe",
    region: "Northern Europe",
    country: "Faroe Islands",
    capital: "Torshavn",
    fips: "FO",
    iso2: "FO",
    iso3: "FRO",
    isoNo: "234",
    internet: "FO"
  }, {
    continent: "Oceania",
    region: "Pacific",
    country: "Fiji",
    capital: "Suva",
    fips: "FJ",
    iso2: "FJ",
    iso3: "FJI",
    isoNo: "242",
    internet: "FJ"
  }, {
    continent: "Europe",
    region: "Northern Europe",
    country: "Finland",
    capital: "Helsinki",
    fips: "FI",
    iso2: "FI",
    iso3: "FIN",
    isoNo: "246",
    internet: "FI"
  }, {
    continent: "Europe",
    region: "Western Europe",
    country: "France",
    capital: "Paris",
    fips: "FR",
    iso2: "FR",
    iso3: "FRA",
    isoNo: "250",
    internet: "FR"
  }, {
    continent: "Americas",
    region: "South America",
    country: "French Guiana",
    capital: "Cayenne",
    fips: "FG",
    iso2: "GF",
    iso3: "GUF",
    isoNo: "254",
    internet: "GF"
  }, {
    continent: "Oceania",
    region: "Pacific",
    country: "French Polynesia",
    capital: "Papeete",
    fips: "FP",
    iso2: "PF",
    iso3: "PYF",
    isoNo: "258",
    internet: "PF"
  }, {
    continent: "Africa",
    region: "Western Africa",
    country: "Gabon",
    capital: "Libreville",
    fips: "GB",
    iso2: "GA",
    iso3: "GAB",
    isoNo: "266",
    internet: "GA"
  }, {
    continent: "Africa",
    region: "Western Africa",
    country: "The Gambia",
    capital: "Banjul",
    fips: "GA",
    iso2: "GM",
    iso3: "GMB",
    isoNo: "270",
    internet: "GM"
  }, {
    continent: "Asia",
    region: "South West Asia",
    country: "Georgia",
    capital: "T'bilisi",
    fips: "GG",
    iso2: "GE",
    iso3: "GEO",
    isoNo: "268",
    internet: "GE"
  }, {
    continent: "Europe",
    region: "Western Europe",
    country: "Germany",
    capital: "Berlin",
    fips: "GM",
    iso2: "DE",
    iso3: "DEU",
    isoNo: "276",
    internet: "DE"
  }, {
    continent: "Africa",
    region: "Western Africa",
    country: "Ghana",
    capital: "Accra",
    fips: "GH",
    iso2: "GH",
    iso3: "GHA",
    isoNo: "288",
    internet: "GH"
  }, {
    continent: "Europe",
    region: "South West Europe",
    country: "Gibraltar",
    capital: "Gibraltar",
    fips: "GI",
    iso2: "GI",
    iso3: "GIB",
    isoNo: "292",
    internet: "GI"
  }, {
    continent: "Europe",
    region: "South East Europe",
    country: "Greece",
    capital: "Athens",
    fips: "GR",
    iso2: "GR",
    iso3: "GRC",
    isoNo: "300",
    internet: "GR"
  }, {
    continent: "Americas",
    region: "North America",
    country: "Greenland",
    capital: "Nuuk (Godthab)",
    fips: "GL",
    iso2: "GL",
    iso3: "GRL",
    isoNo: "304",
    internet: "GL"
  }, {
    continent: "Americas",
    region: "West Indies",
    country: "Grenada",
    capital: "Saint George's",
    fips: "GJ",
    iso2: "GD",
    iso3: "GRD",
    isoNo: "308",
    internet: "GD"
  }, {
    continent: "Americas",
    region: "West Indies",
    country: "Guadeloupe",
    capital: "Basse-Terre",
    fips: "GP",
    iso2: "GP",
    iso3: "GLP",
    isoNo: "312",
    internet: "GP"
  }, {
    continent: "Oceania",
    region: "Pacific",
    country: "Guam",
    capital: "Hagatna (Agana)",
    fips: "GQ",
    iso2: "GU",
    iso3: "GUM",
    isoNo: "316",
    internet: "GU"
  }, {
    continent: "Americas",
    region: "Central America",
    country: "Guatemala",
    capital: "Guatemala",
    fips: "GT",
    iso2: "GT",
    iso3: "GTM",
    isoNo: "320",
    internet: "GT"
  }, {
    continent: "Africa",
    region: "Western Africa",
    country: "Guinea",
    capital: "Conakry",
    fips: "GV",
    iso2: "GN",
    iso3: "GIN",
    isoNo: "324",
    internet: "GN"
  }, {
    continent: "Africa",
    region: "Western Africa",
    country: "Guinea-Bissau",
    capital: "Bissau",
    fips: "PU",
    iso2: "GW",
    iso3: "GNB",
    isoNo: "624",
    internet: "GW"
  }, {
    continent: "Americas",
    region: "South America",
    country: "Guyana",
    capital: "Georgetown",
    fips: "GY",
    iso2: "GY",
    iso3: "GUY",
    isoNo: "328",
    internet: "GY"
  }, {
    continent: "Americas",
    region: "West Indies",
    country: "Haiti",
    capital: "Port-au-Prince",
    fips: "HA",
    iso2: "HT",
    iso3: "HTI",
    isoNo: "332",
    internet: "HT"
  }, {
    continent: "Europe",
    region: "Southern Europe",
    country: "Holy See (Vatican City)",
    capital: "Vatican City",
    fips: "VT",
    iso2: "VA",
    iso3: "VAT",
    isoNo: "336",
    internet: "VA"
  }, {
    continent: "Americas",
    region: "Central America",
    country: "Honduras",
    capital: "Tegucigalpa",
    fips: "HO",
    iso2: "HN",
    iso3: "HND",
    isoNo: "340",
    internet: "HN"
  }, {
    continent: "Europe",
    region: "Central Europe",
    country: "Hungary",
    capital: "Budapest",
    fips: "HU",
    iso2: "HU",
    iso3: "HUN",
    isoNo: "348",
    internet: "HU"
  }, {
    continent: "Europe",
    region: "Northern Europe",
    country: "Iceland",
    capital: "Reykjavik",
    fips: "IC",
    iso2: "IS",
    iso3: "ISL",
    isoNo: "352",
    internet: "IS"
  }, {
    continent: "Asia",
    region: "South Asia",
    country: "India",
    capital: "New Delhi",
    fips: "IN",
    iso2: "IN",
    iso3: "IND",
    isoNo: "356",
    internet: "IN"
  }, {
    continent: "Asia",
    region: "South East Asia",
    country: "Indonesia",
    capital: "Jakarta",
    fips: "ID",
    iso2: "ID",
    iso3: "IDN",
    isoNo: "360",
    internet: "ID"
  }, {
    continent: "Asia",
    region: "South West Asia",
    country: "Iran",
    capital: "Tehran",
    fips: "IR",
    iso2: "IR",
    iso3: "IRN",
    isoNo: "364",
    internet: "IR"
  }, {
    continent: "Asia",
    region: "South West Asia",
    country: "Iraq",
    capital: "Baghdad",
    fips: "IZ",
    iso2: "IQ",
    iso3: "IRQ",
    isoNo: "368",
    internet: "IQ"
  }, {
    continent: "Europe",
    region: "Western Europe",
    country: "Ireland",
    capital: "Dublin",
    fips: "EI",
    iso2: "IE",
    iso3: "IRL",
    isoNo: "372",
    internet: "IE"
  }, {
    continent: "Asia",
    region: "South West Asia",
    country: "Israel",
    capital: "Jerusalem",
    fips: "IS",
    iso2: "IL",
    iso3: "ISR",
    isoNo: "376",
    internet: "IL"
  }, {
    continent: "Europe",
    region: "Southern Europe",
    country: "Italy",
    capital: "Rome",
    fips: "IT",
    iso2: "IT",
    iso3: "ITA",
    isoNo: "380",
    internet: "IT"
  }, {
    continent: "Americas",
    region: "West Indies",
    country: "Jamaica",
    capital: "Kingston",
    fips: "JM",
    iso2: "JM",
    iso3: "JAM",
    isoNo: "388",
    internet: "JM"
  }, {
    continent: "Asia",
    region: "East Asia",
    country: "Japan",
    capital: "Tokyo",
    fips: "JA",
    iso2: "JP",
    iso3: "JPN",
    isoNo: "392",
    internet: "JP"
  }, {
    continent: "Asia",
    region: "South West Asia",
    country: "Jordan",
    capital: "Amman",
    fips: "JO",
    iso2: "JO",
    iso3: "JOR",
    isoNo: "400",
    internet: "JO"
  }, {
    continent: "Asia",
    region: "Central Asia",
    country: "Kazakhstan",
    capital: "Astana (Akmola)",
    fips: "KZ",
    iso2: "KZ",
    iso3: "KAZ",
    isoNo: "398",
    internet: "KZ"
  }, {
    continent: "Africa",
    region: "Eastern Africa",
    country: "Kenya",
    capital: "Nairobi",
    fips: "KE",
    iso2: "KE",
    iso3: "KEN",
    isoNo: "404",
    internet: "KE"
  }, {
    continent: "Oceania",
    region: "Pacific",
    country: "Kiribati",
    capital: "Tarawa",
    fips: "KR",
    iso2: "KI",
    iso3: "KIR",
    isoNo: "296",
    internet: "KI"
  }, {
    continent: "Asia",
    region: "East Asia",
    country: "North Korea",
    capital: "P'yongyang",
    fips: "KN",
    iso2: "KP",
    iso3: "PRK",
    isoNo: "408",
    internet: "KP"
  }, {
    continent: "Asia",
    region: "East Asia",
    country: "South Korea",
    capital: "Seoul",
    fips: "KS",
    iso2: "KR",
    iso3: "KOR",
    isoNo: "410",
    internet: "KR"
  }, {
    continent: "Asia",
    region: "South West Asia",
    country: "Kuwait",
    capital: "Kuwait",
    fips: "KU",
    iso2: "KW",
    iso3: "KWT",
    isoNo: "414",
    internet: "KW"
  }, {
    continent: "Asia",
    region: "Central Asia",
    country: "Kyrgyzstan",
    capital: "Bishkek",
    fips: "KG",
    iso2: "KG",
    iso3: "KGZ",
    isoNo: "417",
    internet: "KG"
  }, {
    continent: "Asia",
    region: "South East Asia",
    country: "Laos",
    capital: "Vientiane",
    fips: "LA",
    iso2: "LA",
    iso3: "LAO",
    isoNo: "418",
    internet: "LA"
  }, {
    continent: "Europe",
    region: "Eastern Europe",
    country: "Latvia",
    capital: "Riga",
    fips: "LG",
    iso2: "LV",
    iso3: "LVA",
    isoNo: "428",
    internet: "LV"
  }, {
    continent: "Asia",
    region: "South West Asia",
    country: "Lebanon",
    capital: "Beirut",
    fips: "LE",
    iso2: "LB",
    iso3: "LBN",
    isoNo: "422",
    internet: "LB"
  }, {
    continent: "Africa",
    region: "Southern Africa",
    country: "Lesotho",
    capital: "Maseru",
    fips: "LT",
    iso2: "LS",
    iso3: "LSO",
    isoNo: "426",
    internet: "LS"
  }, {
    continent: "Africa",
    region: "Western Africa",
    country: "Liberia",
    capital: "Monrovia",
    fips: "LI",
    iso2: "LR",
    iso3: "LBR",
    isoNo: "430",
    internet: "LR"
  }, {
    continent: "Africa",
    region: "Northern Africa",
    country: "Libya",
    capital: "Tripoli",
    fips: "LY",
    iso2: "LY",
    iso3: "LBY",
    isoNo: "434",
    internet: "LY"
  }, {
    continent: "Europe",
    region: "Central Europe",
    country: "Liechtenstein",
    capital: "Vaduz",
    fips: "LS",
    iso2: "LI",
    iso3: "LIE",
    isoNo: "438",
    internet: "LI"
  }, {
    continent: "Europe",
    region: "Eastern Europe",
    country: "Lithuania",
    capital: "Vilnius",
    fips: "LH",
    iso2: "LT",
    iso3: "LTU",
    isoNo: "440",
    internet: "LT"
  }, {
    continent: "Europe",
    region: "Western Europe",
    country: "Luxembourg",
    capital: "Luxembourg",
    fips: "LU",
    iso2: "LU",
    iso3: "LUX",
    isoNo: "442",
    internet: "LU"
  }, {
    continent: "Europe",
    region: "South East Europe",
    country: "North Macedonia",
    capital: "Skopje",
    fips: "MK",
    iso2: "MK",
    iso3: "MKD",
    isoNo: "807",
    internet: "MK"
  }, {
    continent: "Africa",
    region: "Indian Ocean",
    country: "Madagascar",
    capital: "Antananarivo",
    fips: "MA",
    iso2: "MG",
    iso3: "MDG",
    isoNo: "450",
    internet: "MG"
  }, {
    continent: "Africa",
    region: "Southern Africa",
    country: "Malawi",
    capital: "Lilongwe",
    fips: "MI",
    iso2: "MW",
    iso3: "MWI",
    isoNo: "454",
    internet: "MW"
  }, {
    continent: "Asia",
    region: "South East Asia",
    country: "Malaysia",
    capital: "Kuala Lumpur",
    fips: "MY",
    iso2: "MY",
    iso3: "MYS",
    isoNo: "458",
    internet: "MY"
  }, {
    continent: "Asia",
    region: "South Asia",
    country: "Maldives",
    capital: "Male (Maale)",
    fips: "MV",
    iso2: "MV",
    iso3: "MDV",
    isoNo: "462",
    internet: "MV"
  }, {
    continent: "Africa",
    region: "Western Africa",
    country: "Mali",
    capital: "Bamako",
    fips: "ML",
    iso2: "ML",
    iso3: "MLI",
    isoNo: "466",
    internet: "ML"
  }, {
    continent: "Europe",
    region: "Southern Europe",
    country: "Malta",
    capital: "Valletta",
    fips: "MT",
    iso2: "MT",
    iso3: "MLT",
    isoNo: "470",
    internet: "MT"
  }, {
    continent: "Europe",
    region: "Western Europe",
    country: "Isle of Man",
    capital: "Douglas",
    fips: "IM",
    iso2: "IM",
    iso3: "IMN",
    isoNo: "833",
    internet: "IM"
  }, {
    continent: "Oceania",
    region: "Pacific",
    country: "Marshall Islands",
    capital: "Majuro",
    fips: "RM",
    iso2: "MH",
    iso3: "MHL",
    isoNo: "584",
    internet: "MH"
  }, {
    continent: "Americas",
    region: "West Indies",
    country: "Martinique",
    capital: "Fort-de-France",
    fips: "MB",
    iso2: "MQ",
    iso3: "MTQ",
    isoNo: "474",
    internet: "MQ"
  }, {
    continent: "Africa",
    region: "Western Africa",
    country: "Mauritania",
    capital: "Nouakchott",
    fips: "MR",
    iso2: "MR",
    iso3: "MRT",
    isoNo: "478",
    internet: "MR"
  }, {
    continent: "Africa",
    region: "Indian Ocean",
    country: "Mauritius",
    capital: "Port Louis",
    fips: "MP",
    iso2: "MU",
    iso3: "MUS",
    isoNo: "480",
    internet: "MU"
  }, {
    continent: "Africa",
    region: "Indian Ocean",
    country: "Mayotte",
    capital: "Mamoutzou",
    fips: "MF",
    iso2: "YT",
    iso3: "MYT",
    isoNo: "175",
    internet: "YT"
  }, {
    continent: "Americas",
    region: "Central America",
    country: "Mexico",
    capital: "Mexico",
    fips: "MX",
    iso2: "MX",
    iso3: "MEX",
    isoNo: "484",
    internet: "MX"
  }, {
    continent: "Oceania",
    region: "Pacific",
    country: "Federated States of Micronesia",
    capital: "Palikir",
    fips: "",
    iso2: "FM",
    iso3: "FSM",
    isoNo: "583",
    internet: "FM"
  }, {
    continent: "Europe",
    region: "Eastern Europe",
    country: "Moldova",
    capital: "Chisinau",
    fips: "MD",
    iso2: "MD",
    iso3: "MDA",
    isoNo: "498",
    internet: "MD"
  }, {
    continent: "Europe",
    region: "Western Europe",
    country: "Monaco",
    capital: "Monaco",
    fips: "MN",
    iso2: "MC",
    iso3: "MCO",
    isoNo: "492",
    internet: "MC"
  }, {
    continent: "Asia",
    region: "Northern Asia",
    country: "Mongolia",
    capital: "Ulaanbaatar",
    fips: "MG",
    iso2: "MN",
    iso3: "MNG",
    isoNo: "496",
    internet: "MN"
  }, {
    continent: "Americas",
    region: "West Indies",
    country: "Montserrat",
    capital: "Plymouth",
    fips: "MH",
    iso2: "MS",
    iso3: "MSR",
    isoNo: "500",
    internet: "MS"
  }, {
    continent: "Africa",
    region: "Northern Africa",
    country: "Morocco",
    capital: "Rabat",
    fips: "MO",
    iso2: "MA",
    iso3: "MAR",
    isoNo: "504",
    internet: "MA"
  }, {
    continent: "Africa",
    region: "Southern Africa",
    country: "Mozambique",
    capital: "Maputo",
    fips: "MZ",
    iso2: "MZ",
    iso3: "MOZ",
    isoNo: "508",
    internet: "MZ"
  }, {
    continent: "Asia",
    region: "South East Asia",
    country: "Myanmar (Burma)",
    capital: "Rangoon (Yangon)",
    fips: "BM",
    iso2: "MM",
    iso3: "MMR",
    isoNo: "104",
    internet: "MM"
  }, {
    continent: "Africa",
    region: "Southern Africa",
    country: "Namibia",
    capital: "Windhoek",
    fips: "WA",
    iso2: "NA",
    iso3: "NAM",
    isoNo: "516",
    internet: "NA"
  }, {
    continent: "Oceania",
    region: "Pacific",
    country: "Nauru",
    capital: "no official capital",
    fips: "NR",
    iso2: "NR",
    iso3: "NRU",
    isoNo: "520",
    internet: "NR"
  }, {
    continent: "Asia",
    region: "South Asia",
    country: "Nepal",
    capital: "Kathmandu",
    fips: "NP",
    iso2: "NP",
    iso3: "NPL",
    isoNo: "524",
    internet: "NP"
  }, {
    continent: "Europe",
    region: "Western Europe",
    country: "Netherlands",
    capital: "Amsterdam",
    fips: "NL",
    iso2: "NL",
    iso3: "NLD",
    isoNo: "528",
    internet: "NL"
  }, {
    continent: "Americas",
    region: "West Indies",
    country: "Netherlands Antilles",
    capital: "Willemstad",
    fips: "NT",
    iso2: "AN",
    iso3: "ANT",
    isoNo: "530",
    internet: "AN"
  }, {
    continent: "Oceania",
    region: "Pacific",
    country: "New Caledonia",
    capital: "Noumea",
    fips: "NC",
    iso2: "NC",
    iso3: "NCL",
    isoNo: "540",
    internet: "NC"
  }, {
    continent: "Oceania",
    region: "Pacific",
    country: "New Zealand",
    capital: "Wellington",
    fips: "NZ",
    iso2: "NZ",
    iso3: "NZL",
    isoNo: "554",
    internet: "NZ"
  }, {
    continent: "Americas",
    region: "Central America",
    country: "Nicaragua",
    capital: "Managua",
    fips: "NU",
    iso2: "NI",
    iso3: "NIC",
    isoNo: "558",
    internet: "NI"
  }, {
    continent: "Africa",
    region: "Western Africa",
    country: "Niger",
    capital: "Niamey",
    fips: "NG",
    iso2: "NE",
    iso3: "NER",
    isoNo: "562",
    internet: "NE"
  }, {
    continent: "Africa",
    region: "Western Africa",
    country: "Nigeria",
    capital: "Abuja",
    fips: "NI",
    iso2: "NG",
    iso3: "NGA",
    isoNo: "566",
    internet: "NG"
  }, {
    continent: "Oceania",
    region: "Pacific",
    country: "Niue",
    capital: "Alofi",
    fips: "NE",
    iso2: "NU",
    iso3: "NIU",
    isoNo: "570",
    internet: "NU"
  }, {
    continent: "Oceania",
    region: "Pacific",
    country: "Norfolk Island",
    capital: "Kingston",
    fips: "NF",
    iso2: "NF",
    iso3: "NFK",
    isoNo: "574",
    internet: "NF"
  }, {
    continent: "Oceania",
    region: "Pacific",
    country: "Northern Mariana Islands",
    capital: "Saipan",
    fips: "CQ",
    iso2: "MP",
    iso3: "MNP",
    isoNo: "580",
    internet: "MP"
  }, {
    continent: "Europe",
    region: "Northern Europe",
    country: "Norway",
    capital: "Oslo",
    fips: "NO",
    iso2: "NO",
    iso3: "NOR",
    isoNo: "578",
    internet: "NO"
  }, {
    continent: "Asia",
    region: "South West Asia",
    country: "Oman",
    capital: "Muscat",
    fips: "MU",
    iso2: "OM",
    iso3: "OMN",
    isoNo: "512",
    internet: "OM"
  }, {
    continent: "Asia",
    region: "South Asia",
    country: "Pakistan",
    capital: "Islamabad",
    fips: "PK",
    iso2: "PK",
    iso3: "PAK",
    isoNo: "586",
    internet: "PK"
  }, {
    continent: "Oceania",
    region: "Pacific",
    country: "Palau",
    capital: "Koror",
    fips: "PS",
    iso2: "PW",
    iso3: "PLW",
    isoNo: "585",
    internet: "PW"
  }, {
    continent: "Asia",
    region: "South West Asia",
    country: "Palestinian Territory",
    capital: "East Jerusalem",
    fips: "WE",
    iso2: "PS",
    iso3: "PSE",
    isoNo: "275",
    internet: "PS"
  }, {
    continent: "Americas",
    region: "Central America",
    country: "Panama",
    capital: "Panama",
    fips: "PM",
    iso2: "PA",
    iso3: "PAN",
    isoNo: "591",
    internet: "PA"
  }, {
    continent: "Oceania",
    region: "Pacific",
    country: "Papua New Guinea",
    capital: "Port Moresby",
    fips: "PP",
    iso2: "PG",
    iso3: "PNG",
    isoNo: "598",
    internet: "PG"
  }, {
    continent: "Americas",
    region: "South America",
    country: "Paraguay",
    capital: "Asuncion",
    fips: "PA",
    iso2: "PY",
    iso3: "PRY",
    isoNo: "600",
    internet: "PY"
  }, {
    continent: "Americas",
    region: "South America",
    country: "Peru",
    capital: "Lima",
    fips: "PE",
    iso2: "PE",
    iso3: "PER",
    isoNo: "604",
    internet: "PE"
  }, {
    continent: "Asia",
    region: "South East Asia",
    country: "Philippines",
    capital: "Manila",
    fips: "RP",
    iso2: "PH",
    iso3: "PHL",
    isoNo: "608",
    internet: "PH"
  }, {
    continent: "Oceania",
    region: "Pacific",
    country: "Pitcairn Islands",
    capital: "Adamstown",
    fips: "PC",
    iso2: "PN",
    iso3: "PCN",
    isoNo: "612",
    internet: "PN"
  }, {
    continent: "Europe",
    region: "Eastern Europe",
    country: "Poland",
    capital: "Warsaw",
    fips: "PL",
    iso2: "PL",
    iso3: "POL",
    isoNo: "616",
    internet: "PL"
  }, {
    continent: "Europe",
    region: "South West Europe",
    country: "Portugal",
    capital: "Lisbon",
    fips: "PO",
    iso2: "PT",
    iso3: "PRT",
    isoNo: "620",
    internet: "PT"
  }, {
    continent: "Americas",
    region: "West Indies",
    country: "Puerto Rico",
    capital: "San Juan",
    fips: "RQ",
    iso2: "PR",
    iso3: "PRI",
    isoNo: "630",
    internet: "PR"
  }, {
    continent: "Asia",
    region: "South West Asia",
    country: "Qatar",
    capital: "Doha",
    fips: "QA",
    iso2: "QA",
    iso3: "QAT",
    isoNo: "634",
    internet: "QA"
  }, {
    continent: "Africa",
    region: "Indian Ocean",
    country: "Reunion",
    capital: "Saint-Denis",
    fips: "RE",
    iso2: "RE",
    iso3: "REU",
    isoNo: "638",
    internet: "RE"
  }, {
    continent: "Europe",
    region: "South East Europe",
    country: "Romania",
    capital: "Bucharest",
    fips: "RO",
    iso2: "RO",
    iso3: "ROU",
    isoNo: "642",
    internet: "RO"
  }, {
    continent: "Asia",
    region: "Northern Asia",
    country: "Russia",
    capital: "Moscow",
    fips: "RS",
    iso2: "RU",
    iso3: "RUS",
    isoNo: "643",
    internet: "RU"
  }, {
    continent: "Africa",
    region: "Central Africa",
    country: "Rwanda",
    capital: "Kigali",
    fips: "RW",
    iso2: "RW",
    iso3: "RWA",
    isoNo: "646",
    internet: "RW"
  }, {
    continent: "Americas",
    region: "West Indies",
    country: "Saint Kitts and Nevis",
    capital: "Basseterre",
    fips: "SC",
    iso2: "KN",
    iso3: "KNA",
    isoNo: "659",
    internet: "KN"
  }, {
    continent: "Americas",
    region: "West Indies",
    country: "Saint Lucia",
    capital: "Castries",
    fips: "ST",
    iso2: "LC",
    iso3: "LCA",
    isoNo: "662",
    internet: "LC"
  }, {
    continent: "Americas",
    region: "North America",
    country: "Saint Pierre and Miquelon",
    capital: "Saint-Pierre",
    fips: "SB",
    iso2: "PM",
    iso3: "SPM",
    isoNo: "666",
    internet: "PM"
  }, {
    continent: "Americas",
    region: "West Indies",
    country: "Saint Vincent and the Grenadines",
    capital: "Kingstown",
    fips: "VC",
    iso2: "VC",
    iso3: "VCT",
    isoNo: "670",
    internet: "VC"
  }, {
    continent: "Europe",
    region: "Southern Europe",
    country: "San Marino",
    capital: "San Marino",
    fips: "SM",
    iso2: "SM",
    iso3: "SMR",
    isoNo: "674",
    internet: "SM"
  }, {
    continent: "Africa",
    region: "Western Africa",
    country: "Sao Tome and Principe",
    capital: "Sao Tome",
    fips: "TP",
    iso2: "ST",
    iso3: "STP",
    isoNo: "678",
    internet: "ST"
  }, {
    continent: "Asia",
    region: "South West Asia",
    country: "Saudi Arabia",
    capital: "Riyadh",
    fips: "SA",
    iso2: "SA",
    iso3: "SAU",
    isoNo: "682",
    internet: "SA"
  }, {
    continent: "Africa",
    region: "Western Africa",
    country: "Senegal",
    capital: "Dakar",
    fips: "SG",
    iso2: "SN",
    iso3: "SEN",
    isoNo: "686",
    internet: "SN"
  }, {
    continent: "Africa",
    region: "Indian Ocean",
    country: "Seychelles",
    capital: "Victoria",
    fips: "SE",
    iso2: "SC",
    iso3: "SYC",
    isoNo: "690",
    internet: "SC"
  }, {
    continent: "Africa",
    region: "Western Africa",
    country: "Sierra Leone",
    capital: "Freetown",
    fips: "SL",
    iso2: "SL",
    iso3: "SLE",
    isoNo: "694",
    internet: "SL"
  }, {
    continent: "Asia",
    region: "South East Asia",
    country: "Singapore",
    capital: "Singapore",
    fips: "SN",
    iso2: "SG",
    iso3: "SGP",
    isoNo: "702",
    internet: "SG"
  }, {
    continent: "Europe",
    region: "Central Europe",
    country: "Slovakia",
    capital: "Bratislava",
    fips: "LO",
    iso2: "SK",
    iso3: "SVK",
    isoNo: "703",
    internet: "SK"
  }, {
    continent: "Europe",
    region: "South East Europe",
    country: "Slovenia",
    capital: "Ljubljana",
    fips: "SI",
    iso2: "SI",
    iso3: "SVN",
    isoNo: "705",
    internet: "SI"
  }, {
    continent: "Oceania",
    region: "Pacific",
    country: "Solomon Islands",
    capital: "Honiara",
    fips: "BP",
    iso2: "SB",
    iso3: "SLB",
    isoNo: "90",
    internet: "SB"
  }, {
    continent: "Africa",
    region: "Eastern Africa",
    country: "Somalia",
    capital: "Mogadishu",
    fips: "SO",
    iso2: "SO",
    iso3: "SOM",
    isoNo: "706",
    internet: "SO"
  }, {
    continent: "Africa",
    region: "Southern Africa",
    country: "South Africa",
    capital: "Pretoria��",
    fips: "SF",
    iso2: "ZA",
    iso3: "ZAF",
    isoNo: "710",
    internet: "ZA"
  }, {
    continent: "Europe",
    region: "South West Europe",
    country: "Spain",
    capital: "Madrid",
    fips: "SP",
    iso2: "ES",
    iso3: "ESP",
    isoNo: "724",
    internet: "ES"
  }, {
    continent: "Asia",
    region: "South Asia",
    country: "Sri Lanka",
    capital: "Colombo",
    fips: "CE",
    iso2: "LK",
    iso3: "LKA",
    isoNo: "144",
    internet: "LK"
  }, {
    continent: "Africa",
    region: "Northern Africa",
    country: "Sudan",
    capital: "Khartoum",
    fips: "SU",
    iso2: "SD",
    iso3: "SDN",
    isoNo: "736",
    internet: "SD"
  }, {
    continent: "Americas",
    region: "South America",
    country: "Suriname",
    capital: "Paramaribo",
    fips: "NS",
    iso2: "SR",
    iso3: "SUR",
    isoNo: "740",
    internet: "SR"
  }, {
    continent: "Europe",
    region: "Northern Europe",
    country: "Svalbard",
    capital: "Longyearbyen",
    fips: "SV",
    iso2: "SJ",
    iso3: "SJM",
    isoNo: "744",
    internet: "SJ"
  }, {
    continent: "Africa",
    region: "Southern Africa",
    country: "Eswatini",
    capital: "Mbabane",
    fips: "WZ",
    iso2: "SZ",
    iso3: "SWZ",
    isoNo: "748",
    internet: "SZ"
  }, {
    continent: "Europe",
    region: "Northern Europe",
    country: "Sweden",
    capital: "Stockholm",
    fips: "SW",
    iso2: "SE",
    iso3: "SWE",
    isoNo: "752",
    internet: "SE"
  }, {
    continent: "Europe",
    region: "Central Europe",
    country: "Switzerland",
    capital: "Bern",
    fips: "SZ",
    iso2: "CH",
    iso3: "CHE",
    isoNo: "756",
    internet: "CH"
  }, {
    continent: "Asia",
    region: "South West Asia",
    country: "Syria",
    capital: "Damascus",
    fips: "SY",
    iso2: "SY",
    iso3: "SYR",
    isoNo: "760",
    internet: "SY"
  }, {
    continent: "Asia",
    region: "East Asia",
    country: "Taiwan",
    capital: "Taipei",
    fips: "TW",
    iso2: "TW",
    iso3: "TWN",
    isoNo: "158",
    internet: "TW"
  }, {
    continent: "Asia",
    region: "Central Asia",
    country: "Tajikistan",
    capital: "Dushanbe",
    fips: "TI",
    iso2: "TJ",
    iso3: "TJK",
    isoNo: "762",
    internet: "TJ"
  }, {
    continent: "Africa",
    region: "Eastern Africa",
    country: "Tanzania",
    capital: "Dar es Salaam",
    fips: "TZ",
    iso2: "TZ",
    iso3: "TZA",
    isoNo: "834",
    internet: "TZ"
  }, {
    continent: "Asia",
    region: "South East Asia",
    country: "Thailand",
    capital: "Bangkok",
    fips: "TH",
    iso2: "TH",
    iso3: "THA",
    isoNo: "764",
    internet: "TH"
  }, {
    continent: "Africa",
    region: "Western Africa",
    country: "Togo",
    capital: "Lome",
    fips: "TO",
    iso2: "TG",
    iso3: "TGO",
    isoNo: "768",
    internet: "TG"
  }, {
    continent: "Oceania",
    region: "Pacific",
    country: "Tokelau",
    capital: "none",
    fips: "TL",
    iso2: "TK",
    iso3: "TKL",
    isoNo: "772",
    internet: "TK"
  }, {
    continent: "Oceania",
    region: "Pacific",
    country: "Tonga",
    capital: "Nuku'alofa",
    fips: "TN",
    iso2: "TO",
    iso3: "TON",
    isoNo: "776",
    internet: "TO"
  }, {
    continent: "Americas",
    region: "West Indies",
    country: "Trinidad and Tobago",
    capital: "Port-of-Spain",
    fips: "TD",
    iso2: "TT",
    iso3: "TTO",
    isoNo: "780",
    internet: "TT"
  }, {
    continent: "Africa",
    region: "Northern Africa",
    country: "Tunisia",
    capital: "Tunis",
    fips: "TS",
    iso2: "TN",
    iso3: "TUN",
    isoNo: "788",
    internet: "TN"
  }, {
    continent: "Asia",
    region: "South West Asia",
    country: "Turkey",
    capital: "Ankara",
    fips: "TU",
    iso2: "TR",
    iso3: "TUR",
    isoNo: "792",
    internet: "TR"
  }, {
    continent: "Asia",
    region: "Central Asia",
    country: "Turkmenistan",
    capital: "Ashgabat",
    fips: "TX",
    iso2: "TM",
    iso3: "TKM",
    isoNo: "795",
    internet: "TM"
  }, {
    continent: "Americas",
    region: "West Indies",
    country: "Turks and Caicos Islands",
    capital: "Grand Turk",
    fips: "TK",
    iso2: "TC",
    iso3: "TCA",
    isoNo: "796",
    internet: "TC"
  }, {
    continent: "Oceania",
    region: "Pacific",
    country: "Tuvalu",
    capital: "Funafuti",
    fips: "TV",
    iso2: "TV",
    iso3: "TUV",
    isoNo: "798",
    internet: "TV"
  }, {
    continent: "Africa",
    region: "Eastern Africa",
    country: "Uganda",
    capital: "Kampala",
    fips: "UG",
    iso2: "UG",
    iso3: "UGA",
    isoNo: "800",
    internet: "UG"
  }, {
    continent: "Europe",
    region: "Eastern Europe",
    country: "Ukraine",
    capital: "Kiev",
    fips: "UP",
    iso2: "UA",
    iso3: "UKR",
    isoNo: "804",
    internet: "UA"
  }, {
    continent: "Asia",
    region: "South West Asia",
    country: "United Arab Emirates",
    capital: "Abu Dhabi",
    fips: "TC",
    iso2: "AE",
    iso3: "ARE",
    isoNo: "784",
    internet: "AE"
  }, {
    continent: "Europe",
    region: "Western Europe",
    country: "United Kingdom",
    capital: "London",
    fips: "UK",
    iso2: "GB",
    iso3: "GBR",
    isoNo: "826",
    internet: "UK"
  }, {
    continent: "Americas",
    region: "North America",
    country: "United States",
    capital: "Washington DC",
    fips: "US",
    iso2: "US",
    iso3: "USA",
    isoNo: "840",
    internet: "US"
  }, {
    continent: "Americas",
    region: "North America",
    country: "United States Minor Outlying Islands",
    capital: "Washington DC",
    fips: "",
    iso2: "UM",
    iso3: "UMI",
    isoNo: "581",
    internet: "US"
  }, {
    continent: "Americas",
    region: "South America",
    country: "Uruguay",
    capital: "Montevideo",
    fips: "UY",
    iso2: "UY",
    iso3: "URY",
    isoNo: "858",
    internet: "UY"
  }, {
    continent: "Asia",
    region: "Central Asia",
    country: "Uzbekistan",
    capital: "Tashkent (Toshkent)",
    fips: "UZ",
    iso2: "UZ",
    iso3: "UZB",
    isoNo: "860",
    internet: "UZ"
  }, {
    continent: "Oceania",
    region: "Pacific",
    country: "Vanuatu",
    capital: "Port-Vila",
    fips: "NH",
    iso2: "VU",
    iso3: "VUT",
    isoNo: "548",
    internet: "VU"
  }, {
    continent: "Americas",
    region: "South America",
    country: "Venezuela",
    capital: "Caracas",
    fips: "VE",
    iso2: "VE",
    iso3: "VEN",
    isoNo: "862",
    internet: "UE"
  }, {
    continent: "Asia",
    region: "South East Asia",
    country: "Vietnam",
    capital: "Hanoi",
    fips: "VN",
    iso2: "VN",
    iso3: "VNM",
    isoNo: "704",
    internet: "VN"
  }, {
    continent: "Americas",
    region: "West Indies",
    country: "Virgin Islands",
    capital: "Charlotte Amalie",
    fips: "VQ",
    iso2: "VI",
    iso3: "VIR",
    isoNo: "850",
    internet: "VI"
  }, {
    continent: "Oceania",
    region: "Pacific",
    country: "Wallis and Futuna",
    capital: "Mata-Utu (on Ile Uvea)",
    fips: "WF",
    iso2: "WF",
    iso3: "WLF",
    isoNo: "876",
    internet: "WF"
  }, {
    continent: "Africa",
    region: "Northern Africa",
    country: "Western Sahara",
    capital: "none",
    fips: "WI",
    iso2: "EH",
    iso3: "ESH",
    isoNo: "732",
    internet: "EH"
  }, {
    continent: "Oceania",
    region: "Pacific",
    country: "Western Samoa",
    capital: "Apia",
    fips: "WS",
    iso2: "WS",
    iso3: "WSM",
    isoNo: "882",
    internet: "WS"
  }, {
    continent: "Asia",
    region: "South West Asia",
    country: "Yemen",
    capital: "Sanaa",
    fips: "YM",
    iso2: "YE",
    iso3: "YEM",
    isoNo: "887",
    internet: "YE"
  }, {
    continent: "Africa",
    region: "Central Africa",
    country: "Democratic Republic of the Congo",
    capital: "Kinshasa",
    fips: "CG",
    iso2: "CD",
    iso3: "COD",
    isoNo: "180",
    internet: "ZR"
  }, {
    continent: "Africa",
    region: "Southern Africa",
    country: "Zambia",
    capital: "Lusaka",
    fips: "ZA",
    iso2: "ZM",
    iso3: "ZMB",
    isoNo: "894",
    internet: "ZM"
  }, {
    continent: "Africa",
    region: "Southern Africa",
    country: "Zimbabwe",
    capital: "Harare",
    fips: "ZI",
    iso2: "ZW",
    iso3: "ZWE",
    isoNo: "716",
    internet: "ZW"
  }, {
    continent: "Asia",
    region: "East Asia",
    country: "Hong Kong",
    capital: "Victoria",
    fips: "HK",
    iso2: "HK",
    iso3: "HKG",
    isoNo: "344",
    internet: "HK"
  }, {
    continent: "Asia",
    region: "East Asia",
    country: "Macau",
    capital: "Macau",
    fips: "MC",
    iso2: "MO",
    iso3: "MAC",
    isoNo: "446",
    internet: "MO"
  }, {
    continent: "Antarctica",
    region: "Antarctica",
    country: "Antarctica",
    capital: "",
    fips: "AY",
    iso2: "AQ",
    iso3: "ATA",
    isoNo: "10",
    internet: "AQ"
  }, {
    continent: "Atlantic Ocean",
    region: "South Atlantic Ocean",
    country: "Bouvet Island",
    capital: "",
    fips: "BV",
    iso2: "BV",
    iso3: "BVT",
    isoNo: "74",
    internet: "BV"
  }, {
    continent: "Asia",
    region: "South Asia",
    country: "British Indian Ocean Territory",
    capital: "",
    fips: "IO",
    iso2: "IO",
    iso3: "IOT",
    isoNo: "86",
    internet: "IO"
  }, {
    continent: "Indian Ocean",
    region: "Southern Indian Ocean",
    country: "French Southern and Antarctic Lands",
    capital: "",
    fips: "FS",
    iso2: "TF",
    iso3: "ATF",
    isoNo: "260",
    internet: "--"
  }, {
    continent: "Indian Ocean",
    region: "Southern Indian Ocean",
    country: "Heard Island and McDonald Islands",
    capital: "",
    fips: "HM",
    iso2: "HM",
    iso3: "HMD",
    isoNo: "334",
    internet: "HM"
  }, {
    continent: "Atlantic Ocean",
    region: "South Atlantic Ocean",
    country: "Saint Helena",
    capital: "",
    fips: "SH",
    iso2: "SH",
    iso3: "SHN",
    isoNo: "654",
    internet: "SH"
  }, {
    continent: "Atlantic Ocean",
    region: "South Atlantic Ocean",
    country: "South Georgia and the South Sandwich Islands",
    capital: "",
    fips: "SX",
    iso2: "GS",
    iso3: "SGS",
    isoNo: "239",
    internet: "GS"
  }, {
    continent: "Europe",
    region: "Western Europe",
    country: "Guernsey",
    capital: "Saint Peter Port",
    fips: "GK",
    iso2: "GG",
    iso3: "GGY",
    isoNo: "831",
    internet: "GG"
  }, {
    continent: "Europe",
    region: "South East Europe",
    country: "Serbia",
    capital: "Belgrade",
    fips: "RI",
    iso2: "RS",
    iso3: "SRB",
    isoNo: "688",
    internet: "RS"
  }, {
    continent: "Americas",
    region: "West Indies",
    country: "Saint Barthélemy",
    capital: "Gustavia",
    fips: "TB",
    iso2: "BL",
    iso3: "BLM",
    isoNo: "652",
    internet: "BL"
  }, {
    continent: "Europe",
    region: "South East Europe",
    country: "Montenegro",
    capital: "Podgorica",
    fips: "MJ",
    iso2: "ME",
    iso3: "MNE",
    isoNo: "499",
    internet: "ME"
  }, {
    continent: "Europe",
    region: "Western Europe",
    country: "Jersey",
    capital: "Saint Helier",
    fips: "JE",
    iso2: "JE",
    iso3: "JEY",
    isoNo: "832",
    internet: "JE"
  }, {
    continent: "Americas",
    region: "West Indies",
    country: "Curaçao",
    capital: "Willemstad",
    fips: "UC",
    iso2: "CW",
    iso3: "CUW",
    isoNo: "531",
    internet: "CW"
  }, {
    continent: "Americas",
    region: "West Indies",
    country: "Saint Martin",
    capital: "Marigot",
    fips: "RN",
    iso2: "MF",
    iso3: "MAF",
    isoNo: "663",
    internet: "MF"
  }, {
    continent: "Americas",
    region: "West Indies",
    country: "Sint Maarten",
    capital: "Philipsburg",
    fips: "NN",
    iso2: "SX",
    iso3: "SXM",
    isoNo: "534",
    internet: "SX"
  }, {
    continent: "Asia",
    region: "South East Asia",
    country: "Timor-Leste",
    capital: "Dili",
    fips: "TT",
    iso2: "TL",
    iso3: "TLS",
    isoNo: "626",
    internet: "TL"
  }, {
    continent: "Africa",
    region: "Northern Africa",
    country: "South Sudan",
    capital: "Juba",
    fips: "OD",
    iso2: "SS",
    iso3: "SSD",
    isoNo: "728",
    internet: "SS"
  }, {
    continent: "Europe",
    region: "Northern Europe",
    country: "Åland Islands",
    capital: "Mariehamn",
    fips: "AX",
    iso2: "AX",
    iso3: "ALA",
    isoNo: "248",
    internet: "AX"
  }, {
    continent: "Americas",
    region: "West Indies",
    country: "Bonaire",
    capital: "Kralendijk",
    fips: "BQ",
    iso2: "BQ",
    iso3: "BES",
    isoNo: "535",
    internet: "BQ"
  }, {
    continent: "Europe",
    region: "South East Europe",
    country: "Republic of Kosovo",
    capital: "Pristina",
    fips: "XK",
    iso2: "XK",
    iso3: "UNK",
    isoNo: null,
    internet: "XK"
  }];
  t.exports.countries = i
}, function (t, n, e) {
  t.exports = e(416)
}, function (t, n, e) {
  e(167), e(170), e(171), e(172), e(173), e(174), e(175), e(176), e(177), e(178), e(179), e(180), e(181), e(182), e(183), e(184), e(185), e(186), e(187), e(188), e(189), e(190), e(191), e(192), e(193), e(194), e(195), e(197), e(198), e(199), e(71), e(200), e(201), e(202), e(203), e(204), e(205), e(206), e(207), e(208), e(209), e(210), e(211), e(212), e(213), e(214), e(216), e(217), e(218), e(219), e(220), e(221), e(222), e(223), e(225), e(226), e(228), e(229), e(230), e(231), e(232), e(233), e(234), e(235), e(236), e(237), e(238), e(239), e(240), e(241), e(242), e(243), e(244), e(246), e(247), e(248), e(249), e(250), e(251), e(252), e(253), e(254), e(255), e(256), e(257), e(258), e(260), e(261), e(262), e(263), e(264), e(265), e(266), e(267), e(268), e(269), e(270), e(271), e(272), e(273), e(274), e(275), e(276), e(277), e(278), e(279), e(280), e(281), e(282), e(283), e(284), e(285), e(286), e(287), e(288), e(289), e(290), e(291), e(292), e(294), e(295), e(296), e(297), e(302), e(303), e(304), e(305), e(306), e(307), e(308), e(309), e(310), e(311), e(312), e(313), e(314), e(315), e(316), e(317), e(318), e(319), e(320), e(114), e(321), e(322), e(323), e(324), e(325), e(326), e(327), e(328), e(329), e(155), e(330), e(331), e(332), e(333), e(334), e(335), e(336), e(337), e(338), e(339), e(340), e(341), e(342), e(343), e(344), e(345), e(346), e(347), e(348), e(349), e(350), e(351), e(352), e(353), e(354), e(355), e(356), e(357), e(358), e(360), e(361), e(362), e(363), e(364), e(365), e(366), e(367), e(368), e(369), e(370), e(371), e(374), e(375), e(376), e(377), e(378), e(379), e(380), e(381), e(382), e(383), e(384), e(385), e(386), e(387), e(388), e(389), e(390), e(391), e(392), e(393), e(394), e(395), e(396), e(397), e(398), e(399), e(400), e(401), e(402), e(403), e(406), e(163), t.exports = e(128)
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(2),
    r = e(20),
    o = e(26),
    l = e(6),
    c = e(89),
    s = e(1),
    h = e(12),
    u = e(44),
    f = e(3),
    v = e(47),
    p = e(4),
    g = e(11),
    d = e(23),
    m = e(36),
    F = e(9),
    M = e(30),
    w = e(28),
    z = e(59),
    y = e(38),
    A = e(98),
    U = e(96),
    H = e(16),
    x = e(10),
    E = e(67),
    S = e(17),
    B = e(18),
    D = e(68),
    b = e(69),
    N = e(56),
    j = e(55),
    L = e(5),
    C = e(127),
    T = e(22),
    I = e(29),
    R = e(14),
    V = e(15).forEach,
    k = b("hidden"),
    O = L("toPrimitive"),
    P = R.set,
    G = R.getterFor("Symbol"),
    K = Object.prototype,
    W = a.Symbol,
    _ = r("JSON", "stringify"),
    Y = H.f,
    Z = x.f,
    J = A.f,
    q = E.f,
    X = D("symbols"),
    $ = D("op-symbols"),
    Q = D("string-to-symbol-registry"),
    tt = D("symbol-to-string-registry"),
    nt = D("wks"),
    et = a.QObject,
    it = !et || !et.prototype || !et.prototype.findChild,
    at = l && s((function () {
      return 7 != w(Z({}, "a", {
        get: function () {
          return Z(this, "a", {
            value: 7
          }).a
        }
      })).a
    })) ? function (t, n, e) {
      var i = Y(K, n);
      i && delete K[n], Z(t, n, e), i && t !== K && Z(K, n, i)
    } : Z,
    rt = function (t, n) {
      var e = X[t] = w(W.prototype);
      return P(e, {
        type: "Symbol",
        tag: t,
        description: n
      }), l || (e.description = n), e
    },
    ot = function (t, n, e) {
      t === K && ot($, n, e), p(t);
      var i = m(n);
      return p(e), h(X, i) ? (e.enumerable ? (h(t, k) && t[k][i] && (t[k][i] = !1), e = w(e, {
        enumerable: M(0, !1)
      })) : (h(t, k) || Z(t, k, M(1, {})), t[k][i] = !0), at(t, i, e)) : Z(t, i, e)
    },
    lt = function (t, n) {
      p(t);
      var e = d(n),
        i = z(e).concat(ut(e));
      return V(i, (function (n) {
        l && !ct.call(e, n) || ot(t, n, e[n])
      })), t
    },
    ct = function (t) {
      var n = m(t),
        e = q.call(this, n);
      return !(this === K && h(X, n) && !h($, n)) && (!(e || !h(this, n) || !h(X, n) || h(this, k) && this[k][n]) || e)
    },
    st = function (t, n) {
      var e = d(t),
        i = m(n);
      if (e !== K || !h(X, i) || h($, i)) {
        var a = Y(e, i);
        return !a || !h(X, i) || h(e, k) && e[k][i] || (a.enumerable = !0), a
      }
    },
    ht = function (t) {
      var n = J(d(t)),
        e = [];
      return V(n, (function (t) {
        h(X, t) || h(N, t) || e.push(t)
      })), e
    },
    ut = function (t) {
      var n = t === K,
        e = J(n ? $ : d(t)),
        i = [];
      return V(e, (function (t) {
        !h(X, t) || n && !h(K, t) || i.push(X[t])
      })), i
    };
  (c || (B((W = function () {
    if (this instanceof W) throw TypeError("Symbol is not a constructor");
    var t = arguments.length && void 0 !== arguments[0] ? F(arguments[0]) : void 0,
      n = j(t),
      e = function (t) {
        this === K && e.call($, t), h(this, k) && h(this[k], n) && (this[k][n] = !1), at(this, n, M(1, t))
      };
    return l && it && at(K, n, {
      configurable: !0,
      set: e
    }), rt(n, t)
  }).prototype, "toString", (function () {
    return G(this).tag
  })), B(W, "withoutSetter", (function (t) {
    return rt(j(t), t)
  })), E.f = ct, x.f = ot, H.f = st, y.f = A.f = ht, U.f = ut, C.f = function (t) {
    return rt(L(t), t)
  }, l && (Z(W.prototype, "description", {
    configurable: !0,
    get: function () {
      return G(this).description
    }
  }), o || B(K, "propertyIsEnumerable", ct, {
    unsafe: !0
  }))), i({
    global: !0,
    wrap: !0,
    forced: !c,
    sham: !c
  }, {
    Symbol: W
  }), V(z(nt), (function (t) {
    T(t)
  })), i({
    target: "Symbol",
    stat: !0,
    forced: !c
  }, {
    for: function (t) {
      var n = F(t);
      if (h(Q, n)) return Q[n];
      var e = W(n);
      return Q[n] = e, tt[e] = n, e
    },
    keyFor: function (t) {
      if (!v(t)) throw TypeError(t + " is not a symbol");
      if (h(tt, t)) return tt[t]
    },
    useSetter: function () {
      it = !0
    },
    useSimple: function () {
      it = !1
    }
  }), i({
    target: "Object",
    stat: !0,
    forced: !c,
    sham: !l
  }, {
    create: function (t, n) {
      return void 0 === n ? w(t) : lt(w(t), n)
    },
    defineProperty: ot,
    defineProperties: lt,
    getOwnPropertyDescriptor: st
  }), i({
    target: "Object",
    stat: !0,
    forced: !c
  }, {
    getOwnPropertyNames: ht,
    getOwnPropertySymbols: ut
  }), i({
    target: "Object",
    stat: !0,
    forced: s((function () {
      U.f(1)
    }))
  }, {
    getOwnPropertySymbols: function (t) {
      return U.f(g(t))
    }
  }), _) && i({
    target: "JSON",
    stat: !0,
    forced: !c || s((function () {
      var t = W();
      return "[null]" != _([t]) || "{}" != _({
        a: t
      }) || "{}" != _(Object(t))
    }))
  }, {
    stringify: function (t, n, e) {
      for (var i, a = [t], r = 1; arguments.length > r;) a.push(arguments[r++]);
      if (i = n, (f(n) || void 0 !== t) && !v(t)) return u(n) || (n = function (t, n) {
        if ("function" == typeof i && (n = i.call(this, t, n)), !v(n)) return n
      }), a[1] = n, _.apply(null, a)
    }
  });
  W.prototype[O] || S(W.prototype, O, W.prototype.valueOf), I(W, "Symbol"), N[k] = !0
}, function (t, n) {
  var e;
  e = function () {
    return this
  }();
  try {
    e = e || new Function("return this")()
  } catch (t) {
    "object" == typeof window && (e = window)
  }
  t.exports = e
}, function (t, n, e) {
  var i = e(3),
    a = e(44),
    r = e(5)("species");
  t.exports = function (t) {
    var n;
    return a(t) && ("function" != typeof (n = t.constructor) || n !== Array && !a(n.prototype) ? i(n) && null === (n = n[r]) && (n = void 0) : n = void 0), void 0 === n ? Array : n
  }
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(6),
    r = e(2),
    o = e(12),
    l = e(3),
    c = e(10).f,
    s = e(124),
    h = r.Symbol;
  if (a && "function" == typeof h && (!("description" in h.prototype) || void 0 !== h().description)) {
    var u = {},
      f = function () {
        var t = arguments.length < 1 || void 0 === arguments[0] ? void 0 : String(arguments[0]),
          n = this instanceof f ? new h(t) : void 0 === t ? h() : h(t);
        return "" === t && (u[n] = !0), n
      };
    s(f, h);
    var v = f.prototype = h.prototype;
    v.constructor = f;
    var p = v.toString,
      g = "Symbol(test)" == String(h("test")),
      d = /^Symbol\((.*)\)[^)]+$/;
    c(v, "description", {
      configurable: !0,
      get: function () {
        var t = l(this) ? this.valueOf() : this,
          n = p.call(t);
        if (o(u, t)) return "";
        var e = g ? n.slice(7, -1) : n.replace(d, "$1");
        return "" === e ? void 0 : e
      }
    }), i({
      global: !0,
      forced: !0
    }, {
      Symbol: f
    })
  }
}, function (t, n, e) {
  e(22)("asyncIterator")
}, function (t, n, e) {
  e(22)("hasInstance")
}, function (t, n, e) {
  e(22)("isConcatSpreadable")
}, function (t, n, e) {
  e(22)("iterator")
}, function (t, n, e) {
  e(22)("match")
}, function (t, n, e) {
  e(22)("matchAll")
}, function (t, n, e) {
  e(22)("replace")
}, function (t, n, e) {
  e(22)("search")
}, function (t, n, e) {
  e(22)("species")
}, function (t, n, e) {
  e(22)("split")
}, function (t, n, e) {
  e(22)("toPrimitive")
}, function (t, n, e) {
  e(22)("toStringTag")
}, function (t, n, e) {
  e(22)("unscopables")
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(27),
    r = e(33),
    o = e(28),
    l = e(17),
    c = e(30),
    s = e(41),
    h = e(9),
    u = function (t, n) {
      var e = this;
      if (!(e instanceof u)) return new u(t, n);
      r && (e = r(new Error(void 0), a(e))), void 0 !== n && l(e, "message", h(n));
      var i = [];
      return s(t, i.push, {
        that: i
      }), l(e, "errors", i), e
    };
  u.prototype = o(Error.prototype, {
    constructor: c(5, u),
    message: c(5, ""),
    name: c(5, "AggregateError")
  }), i({
    global: !0
  }, {
    AggregateError: u
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(1),
    r = e(44),
    o = e(3),
    l = e(11),
    c = e(7),
    s = e(45),
    h = e(60),
    u = e(64),
    f = e(5),
    v = e(37),
    p = f("isConcatSpreadable"),
    g = v >= 51 || !a((function () {
      var t = [];
      return t[p] = !1, t.concat()[0] !== t
    })),
    d = u("concat"),
    m = function (t) {
      if (!o(t)) return !1;
      var n = t[p];
      return void 0 !== n ? !!n : r(t)
    };
  i({
    target: "Array",
    proto: !0,
    forced: !g || !d
  }, {
    concat: function (t) {
      var n, e, i, a, r, o = l(this),
        u = h(o, 0),
        f = 0;
      for (n = -1, i = arguments.length; n < i; n++)
        if (m(r = -1 === n ? o : arguments[n])) {
          if (f + (a = c(r.length)) > 9007199254740991) throw TypeError("Maximum allowed index exceeded");
          for (e = 0; e < a; e++, f++) e in r && s(u, f, r[e])
        } else {
          if (f >= 9007199254740991) throw TypeError("Maximum allowed index exceeded");
          s(u, f++, r)
        } return u.length = f, u
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(131),
    r = e(42);
  i({
    target: "Array",
    proto: !0
  }, {
    copyWithin: a
  }), r("copyWithin")
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(15).every;
  i({
    target: "Array",
    proto: !0,
    forced: !e(34)("every")
  }, {
    every: function (t) {
      return a(this, t, arguments.length > 1 ? arguments[1] : void 0)
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(102),
    r = e(42);
  i({
    target: "Array",
    proto: !0
  }, {
    fill: a
  }), r("fill")
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(15).filter;
  i({
    target: "Array",
    proto: !0,
    forced: !e(64)("filter")
  }, {
    filter: function (t) {
      return a(this, t, arguments.length > 1 ? arguments[1] : void 0)
    }
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(15).find,
    r = e(42),
    o = !0;
  "find" in [] && Array(1).find((function () {
    o = !1
  })), i({
    target: "Array",
    proto: !0,
    forced: o
  }, {
    find: function (t) {
      return a(this, t, arguments.length > 1 ? arguments[1] : void 0)
    }
  }), r("find")
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(15).findIndex,
    r = e(42),
    o = !0;
  "findIndex" in [] && Array(1).findIndex((function () {
    o = !1
  })), i({
    target: "Array",
    proto: !0,
    forced: o
  }, {
    findIndex: function (t) {
      return a(this, t, arguments.length > 1 ? arguments[1] : void 0)
    }
  }), r("findIndex")
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(132),
    r = e(11),
    o = e(7),
    l = e(21),
    c = e(60);
  i({
    target: "Array",
    proto: !0
  }, {
    flat: function () {
      var t = arguments.length ? arguments[0] : void 0,
        n = r(this),
        e = o(n.length),
        i = c(n, 0);
      return i.length = a(i, n, n, e, 0, void 0 === t ? 1 : l(t)), i
    }
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(132),
    r = e(11),
    o = e(7),
    l = e(19),
    c = e(60);
  i({
    target: "Array",
    proto: !0
  }, {
    flatMap: function (t) {
      var n, e = r(this),
        i = o(e.length);
      return l(t), (n = c(e, 0)).length = a(n, e, e, i, 0, 1, t, arguments.length > 1 ? arguments[1] : void 0), n
    }
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(133);
  i({
    target: "Array",
    proto: !0,
    forced: [].forEach != a
  }, {
    forEach: a
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(134);
  i({
    target: "Array",
    stat: !0,
    forced: !e(70)((function (t) {
      Array.from(t)
    }))
  }, {
    from: a
  })
}, function (t, n, e) {
  var i = e(4),
    a = e(130);
  t.exports = function (t, n, e, r) {
    try {
      return r ? n(i(e)[0], e[1]) : n(e)
    } catch (n) {
      throw a(t), n
    }
  }
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(57).includes,
    r = e(42);
  i({
    target: "Array",
    proto: !0
  }, {
    includes: function (t) {
      return a(this, t, arguments.length > 1 ? arguments[1] : void 0)
    }
  }), r("includes")
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(57).indexOf,
    r = e(34),
    o = [].indexOf,
    l = !!o && 1 / [1].indexOf(1, -0) < 0,
    c = r("indexOf");
  i({
    target: "Array",
    proto: !0,
    forced: l || !c
  }, {
    indexOf: function (t) {
      return l ? o.apply(this, arguments) || 0 : a(this, t, arguments.length > 1 ? arguments[1] : void 0)
    }
  })
}, function (t, n, e) {
  e(0)({
    target: "Array",
    stat: !0
  }, {
    isArray: e(44)
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(54),
    r = e(23),
    o = e(34),
    l = [].join,
    c = a != Object,
    s = o("join", ",");
  i({
    target: "Array",
    proto: !0,
    forced: c || !s
  }, {
    join: function (t) {
      return l.call(r(this), void 0 === t ? "," : t)
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(136);
  i({
    target: "Array",
    proto: !0,
    forced: a !== [].lastIndexOf
  }, {
    lastIndexOf: a
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(15).map;
  i({
    target: "Array",
    proto: !0,
    forced: !e(64)("map")
  }, {
    map: function (t) {
      return a(this, t, arguments.length > 1 ? arguments[1] : void 0)
    }
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(1),
    r = e(45);
  i({
    target: "Array",
    stat: !0,
    forced: a((function () {
      function t() {}
      return !(Array.of.call(t) instanceof t)
    }))
  }, {
    of: function () {
      for (var t = 0, n = arguments.length, e = new("function" == typeof this ? this : Array)(n); n > t;) r(e, t, arguments[t++]);
      return e.length = n, e
    }
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(72).left,
    r = e(34),
    o = e(37),
    l = e(48);
  i({
    target: "Array",
    proto: !0,
    forced: !r("reduce") || !l && o > 79 && o < 83
  }, {
    reduce: function (t) {
      return a(this, t, arguments.length, arguments.length > 1 ? arguments[1] : void 0)
    }
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(72).right,
    r = e(34),
    o = e(37),
    l = e(48);
  i({
    target: "Array",
    proto: !0,
    forced: !r("reduceRight") || !l && o > 79 && o < 83
  }, {
    reduceRight: function (t) {
      return a(this, t, arguments.length, arguments.length > 1 ? arguments[1] : void 0)
    }
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(44),
    r = [].reverse,
    o = [1, 2];
  i({
    target: "Array",
    proto: !0,
    forced: String(o) === String(o.reverse())
  }, {
    reverse: function () {
      return a(this) && (this.length = this.length), r.call(this)
    }
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(3),
    r = e(44),
    o = e(39),
    l = e(7),
    c = e(23),
    s = e(45),
    h = e(5),
    u = e(64)("slice"),
    f = h("species"),
    v = [].slice,
    p = Math.max;
  i({
    target: "Array",
    proto: !0,
    forced: !u
  }, {
    slice: function (t, n) {
      var e, i, h, u = c(this),
        g = l(u.length),
        d = o(t, g),
        m = o(void 0 === n ? g : n, g);
      if (r(u) && ("function" != typeof (e = u.constructor) || e !== Array && !r(e.prototype) ? a(e) && null === (e = e[f]) && (e = void 0) : e = void 0, e === Array || void 0 === e)) return v.call(u, d, m);
      for (i = new(void 0 === e ? Array : e)(p(m - d, 0)), h = 0; d < m; d++, h++) d in u && s(i, h, u[d]);
      return i.length = h, i
    }
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(15).some;
  i({
    target: "Array",
    proto: !0,
    forced: !e(34)("some")
  }, {
    some: function (t) {
      return a(this, t, arguments.length > 1 ? arguments[1] : void 0)
    }
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(19),
    r = e(11),
    o = e(7),
    l = e(9),
    c = e(1),
    s = e(137),
    h = e(34),
    u = e(138),
    f = e(139),
    v = e(37),
    p = e(105),
    g = [],
    d = g.sort,
    m = c((function () {
      g.sort(void 0)
    })),
    F = c((function () {
      g.sort(null)
    })),
    M = h("sort"),
    w = !c((function () {
      if (v) return v < 70;
      if (!(u && u > 3)) {
        if (f) return !0;
        if (p) return p < 603;
        var t, n, e, i, a = "";
        for (t = 65; t < 76; t++) {
          switch (n = String.fromCharCode(t), t) {
            case 66:
            case 69:
            case 70:
            case 72:
              e = 3;
              break;
            case 68:
            case 71:
              e = 4;
              break;
            default:
              e = 2
          }
          for (i = 0; i < 47; i++) g.push({
            k: n + i,
            v: e
          })
        }
        for (g.sort((function (t, n) {
            return n.v - t.v
          })), i = 0; i < g.length; i++) n = g[i].k.charAt(0), a.charAt(a.length - 1) !== n && (a += n);
        return "DGBEFHACIJK" !== a
      }
    }));
  i({
    target: "Array",
    proto: !0,
    forced: m || !F || !M || !w
  }, {
    sort: function (t) {
      void 0 !== t && a(t);
      var n = r(this);
      if (w) return void 0 === t ? d.call(n) : d.call(n, t);
      var e, i, c = [],
        h = o(n.length);
      for (i = 0; i < h; i++) i in n && c.push(n[i]);
      for (e = (c = s(c, function (t) {
          return function (n, e) {
            return void 0 === e ? -1 : void 0 === n ? 1 : void 0 !== t ? +t(n, e) || 0 : l(n) > l(e) ? 1 : -1
          }
        }(t))).length, i = 0; i < e;) n[i] = c[i++];
      for (; i < h;) delete n[i++];
      return n
    }
  })
}, function (t, n, e) {
  e(49)("Array")
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(39),
    r = e(21),
    o = e(7),
    l = e(11),
    c = e(60),
    s = e(45),
    h = e(64)("splice"),
    u = Math.max,
    f = Math.min;
  i({
    target: "Array",
    proto: !0,
    forced: !h
  }, {
    splice: function (t, n) {
      var e, i, h, v, p, g, d = l(this),
        m = o(d.length),
        F = a(t, m),
        M = arguments.length;
      if (0 === M ? e = i = 0 : 1 === M ? (e = 0, i = m - F) : (e = M - 2, i = f(u(r(n), 0), m - F)), m + e - i > 9007199254740991) throw TypeError("Maximum allowed length exceeded");
      for (h = c(d, i), v = 0; v < i; v++)(p = F + v) in d && s(h, v, d[p]);
      if (h.length = i, e < i) {
        for (v = F; v < m - i; v++) g = v + e, (p = v + i) in d ? d[g] = d[p] : delete d[g];
        for (v = m; v > m - i + e; v--) delete d[v - 1]
      } else if (e > i)
        for (v = m - i; v > F; v--) g = v + e - 1, (p = v + i - 1) in d ? d[g] = d[p] : delete d[g];
      for (v = 0; v < e; v++) d[v + F] = arguments[v + 2];
      return d.length = m - i + e, h
    }
  })
}, function (t, n, e) {
  e(42)("flat")
}, function (t, n, e) {
  e(42)("flatMap")
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(2),
    r = e(73),
    o = e(49),
    l = r.ArrayBuffer;
  i({
    global: !0,
    forced: a.ArrayBuffer !== l
  }, {
    ArrayBuffer: l
  }), o("ArrayBuffer")
}, function (t, n) {
  var e = Math.abs,
    i = Math.pow,
    a = Math.floor,
    r = Math.log,
    o = Math.LN2;
  t.exports = {
    pack: function (t, n, l) {
      var c, s, h, u = new Array(l),
        f = 8 * l - n - 1,
        v = (1 << f) - 1,
        p = v >> 1,
        g = 23 === n ? i(2, -24) - i(2, -77) : 0,
        d = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0,
        m = 0;
      for ((t = e(t)) != t || t === 1 / 0 ? (s = t != t ? 1 : 0, c = v) : (c = a(r(t) / o), t * (h = i(2, -c)) < 1 && (c--, h *= 2), (t += c + p >= 1 ? g / h : g * i(2, 1 - p)) * h >= 2 && (c++, h /= 2), c + p >= v ? (s = 0, c = v) : c + p >= 1 ? (s = (t * h - 1) * i(2, n), c += p) : (s = t * i(2, p - 1) * i(2, n), c = 0)); n >= 8; u[m++] = 255 & s, s /= 256, n -= 8);
      for (c = c << n | s, f += n; f > 0; u[m++] = 255 & c, c /= 256, f -= 8);
      return u[--m] |= 128 * d, u
    },
    unpack: function (t, n) {
      var e, a = t.length,
        r = 8 * a - n - 1,
        o = (1 << r) - 1,
        l = o >> 1,
        c = r - 7,
        s = a - 1,
        h = t[s--],
        u = 127 & h;
      for (h >>= 7; c > 0; u = 256 * u + t[s], s--, c -= 8);
      for (e = u & (1 << -c) - 1, u >>= -c, c += n; c > 0; e = 256 * e + t[s], s--, c -= 8);
      if (0 === u) u = 1 - l;
      else {
        if (u === o) return e ? NaN : h ? -1 / 0 : 1 / 0;
        e += i(2, n), u -= l
      }
      return (h ? -1 : 1) * e * i(2, u - n)
    }
  }
}, function (t, n, e) {
  var i = e(0),
    a = e(8);
  i({
    target: "ArrayBuffer",
    stat: !0,
    forced: !a.NATIVE_ARRAY_BUFFER_VIEWS
  }, {
    isView: a.isView
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(1),
    r = e(73),
    o = e(4),
    l = e(39),
    c = e(7),
    s = e(51),
    h = r.ArrayBuffer,
    u = r.DataView,
    f = h.prototype.slice;
  i({
    target: "ArrayBuffer",
    proto: !0,
    unsafe: !0,
    forced: a((function () {
      return !new h(2).slice(1, void 0).byteLength
    }))
  }, {
    slice: function (t, n) {
      if (void 0 !== f && void 0 === n) return f.call(o(this), t);
      for (var e = o(this).byteLength, i = l(t, e), a = l(void 0 === n ? e : n, e), r = new(s(this, h))(c(a - i)), v = new u(this), p = new u(r), g = 0; i < a;) p.setUint8(g++, v.getUint8(i++));
      return r
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(73);
  i({
    global: !0,
    forced: !e(106)
  }, {
    DataView: a.DataView
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(1)((function () {
      return 120 !== new Date(16e11).getYear()
    })),
    r = Date.prototype.getFullYear;
  i({
    target: "Date",
    proto: !0,
    forced: a
  }, {
    getYear: function () {
      return r.call(this) - 1900
    }
  })
}, function (t, n, e) {
  e(0)({
    target: "Date",
    stat: !0
  }, {
    now: function () {
      return (new Date).getTime()
    }
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(21),
    r = Date.prototype.getTime,
    o = Date.prototype.setFullYear;
  i({
    target: "Date",
    proto: !0
  }, {
    setYear: function (t) {
      r.call(this);
      var n = a(t),
        e = 0 <= n && n <= 99 ? n + 1900 : n;
      return o.call(this, e)
    }
  })
}, function (t, n, e) {
  e(0)({
    target: "Date",
    proto: !0
  }, {
    toGMTString: Date.prototype.toUTCString
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(224);
  i({
    target: "Date",
    proto: !0,
    forced: Date.prototype.toISOString !== a
  }, {
    toISOString: a
  })
}, function (t, n, e) {
  "use strict";
  var i = e(1),
    a = e(107).start,
    r = Math.abs,
    o = Date.prototype,
    l = o.getTime,
    c = o.toISOString;
  t.exports = i((function () {
    return "0385-07-25T07:06:39.999Z" != c.call(new Date(-50000000000001))
  })) || !i((function () {
    c.call(new Date(NaN))
  })) ? function () {
    if (!isFinite(l.call(this))) throw RangeError("Invalid time value");
    var t = this.getUTCFullYear(),
      n = this.getUTCMilliseconds(),
      e = t < 0 ? "-" : t > 9999 ? "+" : "";
    return e + a(r(t), e ? 6 : 4, 0) + "-" + a(this.getUTCMonth() + 1, 2, 0) + "-" + a(this.getUTCDate(), 2, 0) + "T" + a(this.getUTCHours(), 2, 0) + ":" + a(this.getUTCMinutes(), 2, 0) + ":" + a(this.getUTCSeconds(), 2, 0) + "." + a(n, 3, 0) + "Z"
  } : c
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(1),
    r = e(11),
    o = e(88);
  i({
    target: "Date",
    proto: !0,
    forced: a((function () {
      return null !== new Date(NaN).toJSON() || 1 !== Date.prototype.toJSON.call({
        toISOString: function () {
          return 1
        }
      })
    }))
  }, {
    toJSON: function (t) {
      var n = r(this),
        e = o(n, "number");
      return "number" != typeof e || isFinite(e) ? n.toISOString() : null
    }
  })
}, function (t, n, e) {
  var i = e(17),
    a = e(227),
    r = e(5)("toPrimitive"),
    o = Date.prototype;
  r in o || i(o, r, a)
}, function (t, n, e) {
  "use strict";
  var i = e(4),
    a = e(121);
  t.exports = function (t) {
    if (i(this), "string" === t || "default" === t) t = "string";
    else if ("number" !== t) throw TypeError("Incorrect hint");
    return a(this, t)
  }
}, function (t, n, e) {
  var i = e(18),
    a = Date.prototype,
    r = a.toString,
    o = a.getTime;
  "Invalid Date" != String(new Date(NaN)) && i(a, "toString", (function () {
    var t = o.call(this);
    return t == t ? r.call(this) : "Invalid Date"
  }))
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(9),
    r = /[\w*+\-./@]/,
    o = function (t, n) {
      for (var e = t.toString(16); e.length < n;) e = "0" + e;
      return e
    };
  i({
    global: !0
  }, {
    escape: function (t) {
      for (var n, e, i = a(t), l = "", c = i.length, s = 0; s < c;) n = i.charAt(s++), r.test(n) ? l += n : l += (e = n.charCodeAt(0)) < 256 ? "%" + o(e, 2) : "%u" + o(e, 4).toUpperCase();
      return l
    }
  })
}, function (t, n, e) {
  e(0)({
    target: "Function",
    proto: !0
  }, {
    bind: e(141)
  })
}, function (t, n, e) {
  "use strict";
  var i = e(3),
    a = e(10),
    r = e(27),
    o = e(5)("hasInstance"),
    l = Function.prototype;
  o in l || a.f(l, o, {
    value: function (t) {
      if ("function" != typeof this || !i(t)) return !1;
      if (!i(this.prototype)) return t instanceof this;
      for (; t = r(t);)
        if (this.prototype === t) return !0;
      return !1
    }
  })
}, function (t, n, e) {
  var i = e(6),
    a = e(10).f,
    r = Function.prototype,
    o = r.toString,
    l = /^\s*function ([^ (]*)/;
  i && !("name" in r) && a(r, "name", {
    configurable: !0,
    get: function () {
      try {
        return o.call(this).match(l)[1]
      } catch (t) {
        return ""
      }
    }
  })
}, function (t, n, e) {
  e(0)({
    global: !0
  }, {
    globalThis: e(2)
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(20),
    r = e(1),
    o = a("JSON", "stringify"),
    l = /[\uD800-\uDFFF]/g,
    c = /^[\uD800-\uDBFF]$/,
    s = /^[\uDC00-\uDFFF]$/,
    h = function (t, n, e) {
      var i = e.charAt(n - 1),
        a = e.charAt(n + 1);
      return c.test(t) && !s.test(a) || s.test(t) && !c.test(i) ? "\\u" + t.charCodeAt(0).toString(16) : t
    },
    u = r((function () {
      return '"\\udf06\\ud834"' !== o("\udf06\ud834") || '"\\udead"' !== o("\udead")
    }));
  o && i({
    target: "JSON",
    stat: !0,
    forced: u
  }, {
    stringify: function (t, n, e) {
      var i = o.apply(null, arguments);
      return "string" == typeof i ? i.replace(l, h) : i
    }
  })
}, function (t, n, e) {
  var i = e(2);
  e(29)(i.JSON, "JSON", !0)
}, function (t, n, e) {
  "use strict";
  var i = e(74),
    a = e(142);
  t.exports = i("Map", (function (t) {
    return function () {
      return t(this, arguments.length ? arguments[0] : void 0)
    }
  }), a)
}, function (t, n, e) {
  var i = e(0),
    a = e(143),
    r = Math.acosh,
    o = Math.log,
    l = Math.sqrt,
    c = Math.LN2;
  i({
    target: "Math",
    stat: !0,
    forced: !r || 710 != Math.floor(r(Number.MAX_VALUE)) || r(1 / 0) != 1 / 0
  }, {
    acosh: function (t) {
      return (t = +t) < 1 ? NaN : t > 94906265.62425156 ? o(t) + c : a(t - 1 + l(t - 1) * l(t + 1))
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = Math.asinh,
    r = Math.log,
    o = Math.sqrt;
  i({
    target: "Math",
    stat: !0,
    forced: !(a && 1 / a(0) > 0)
  }, {
    asinh: function t(n) {
      return isFinite(n = +n) && 0 != n ? n < 0 ? -t(-n) : r(n + o(n * n + 1)) : n
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = Math.atanh,
    r = Math.log;
  i({
    target: "Math",
    stat: !0,
    forced: !(a && 1 / a(-0) < 0)
  }, {
    atanh: function (t) {
      return 0 == (t = +t) ? t : r((1 + t) / (1 - t)) / 2
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(109),
    r = Math.abs,
    o = Math.pow;
  i({
    target: "Math",
    stat: !0
  }, {
    cbrt: function (t) {
      return a(t = +t) * o(r(t), 1 / 3)
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = Math.floor,
    r = Math.log,
    o = Math.LOG2E;
  i({
    target: "Math",
    stat: !0
  }, {
    clz32: function (t) {
      return (t >>>= 0) ? 31 - a(r(t + .5) * o) : 32
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(76),
    r = Math.cosh,
    o = Math.abs,
    l = Math.E;
  i({
    target: "Math",
    stat: !0,
    forced: !r || r(710) === 1 / 0
  }, {
    cosh: function (t) {
      var n = a(o(t) - 1) + 1;
      return (n + 1 / (n * l * l)) * (l / 2)
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(76);
  i({
    target: "Math",
    stat: !0,
    forced: a != Math.expm1
  }, {
    expm1: a
  })
}, function (t, n, e) {
  e(0)({
    target: "Math",
    stat: !0
  }, {
    fround: e(245)
  })
}, function (t, n, e) {
  var i = e(109),
    a = Math.abs,
    r = Math.pow,
    o = r(2, -52),
    l = r(2, -23),
    c = r(2, 127) * (2 - l),
    s = r(2, -126);
  t.exports = Math.fround || function (t) {
    var n, e, r = a(t),
      h = i(t);
    return r < s ? h * (r / s / l + 1 / o - 1 / o) * s * l : (e = (n = (1 + l / o) * r) - (n - r)) > c || e != e ? h * (1 / 0) : h * e
  }
}, function (t, n, e) {
  var i = e(0),
    a = Math.hypot,
    r = Math.abs,
    o = Math.sqrt;
  i({
    target: "Math",
    stat: !0,
    forced: !!a && a(1 / 0, NaN) !== 1 / 0
  }, {
    hypot: function (t, n) {
      for (var e, i, a = 0, l = 0, c = arguments.length, s = 0; l < c;) s < (e = r(arguments[l++])) ? (a = a * (i = s / e) * i + 1, s = e) : a += e > 0 ? (i = e / s) * i : e;
      return s === 1 / 0 ? 1 / 0 : s * o(a)
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(1),
    r = Math.imul;
  i({
    target: "Math",
    stat: !0,
    forced: a((function () {
      return -5 != r(4294967295, 5) || 2 != r.length
    }))
  }, {
    imul: function (t, n) {
      var e = +t,
        i = +n,
        a = 65535 & e,
        r = 65535 & i;
      return 0 | a * r + ((65535 & e >>> 16) * r + a * (65535 & i >>> 16) << 16 >>> 0)
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = Math.log,
    r = Math.LOG10E;
  i({
    target: "Math",
    stat: !0
  }, {
    log10: function (t) {
      return a(t) * r
    }
  })
}, function (t, n, e) {
  e(0)({
    target: "Math",
    stat: !0
  }, {
    log1p: e(143)
  })
}, function (t, n, e) {
  var i = e(0),
    a = Math.log,
    r = Math.LN2;
  i({
    target: "Math",
    stat: !0
  }, {
    log2: function (t) {
      return a(t) / r
    }
  })
}, function (t, n, e) {
  e(0)({
    target: "Math",
    stat: !0
  }, {
    sign: e(109)
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(1),
    r = e(76),
    o = Math.abs,
    l = Math.exp,
    c = Math.E;
  i({
    target: "Math",
    stat: !0,
    forced: a((function () {
      return -2e-17 != Math.sinh(-2e-17)
    }))
  }, {
    sinh: function (t) {
      return o(t = +t) < 1 ? (r(t) - r(-t)) / 2 : (l(t - 1) - l(-t - 1)) * (c / 2)
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(76),
    r = Math.exp;
  i({
    target: "Math",
    stat: !0
  }, {
    tanh: function (t) {
      var n = a(t = +t),
        e = a(-t);
      return n == 1 / 0 ? 1 : e == 1 / 0 ? -1 : (n - e) / (r(t) + r(-t))
    }
  })
}, function (t, n, e) {
  e(29)(Math, "Math", !0)
}, function (t, n, e) {
  var i = e(0),
    a = Math.ceil,
    r = Math.floor;
  i({
    target: "Math",
    stat: !0
  }, {
    trunc: function (t) {
      return (t > 0 ? r : a)(t)
    }
  })
}, function (t, n, e) {
  "use strict";
  var i = e(6),
    a = e(2),
    r = e(58),
    o = e(18),
    l = e(12),
    c = e(31),
    s = e(75),
    h = e(47),
    u = e(88),
    f = e(1),
    v = e(28),
    p = e(38).f,
    g = e(16).f,
    d = e(10).f,
    m = e(52).trim,
    F = a.Number,
    M = F.prototype,
    w = "Number" == c(v(M)),
    z = function (t) {
      if (h(t)) throw TypeError("Cannot convert a Symbol value to a number");
      var n, e, i, a, r, o, l, c, s = u(t, "number");
      if ("string" == typeof s && s.length > 2)
        if (43 === (n = (s = m(s)).charCodeAt(0)) || 45 === n) {
          if (88 === (e = s.charCodeAt(2)) || 120 === e) return NaN
        } else if (48 === n) {
        switch (s.charCodeAt(1)) {
          case 66:
          case 98:
            i = 2, a = 49;
            break;
          case 79:
          case 111:
            i = 8, a = 55;
            break;
          default:
            return +s
        }
        for (o = (r = s.slice(2)).length, l = 0; l < o; l++)
          if ((c = r.charCodeAt(l)) < 48 || c > a) return NaN;
        return parseInt(r, i)
      }
      return +s
    };
  if (r("Number", !F(" 0o1") || !F("0b1") || F("+0x1"))) {
    for (var y, A = function (t) {
        var n = arguments.length < 1 ? 0 : t,
          e = this;
        return e instanceof A && (w ? f((function () {
          M.valueOf.call(e)
        })) : "Number" != c(e)) ? s(new F(z(n)), e, A) : z(n)
      }, U = i ? p(F) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger,fromString,range".split(","), H = 0; U.length > H; H++) l(F, y = U[H]) && !l(A, y) && d(A, y, g(F, y));
    A.prototype = M, M.constructor = A, o(a, "Number", A)
  }
}, function (t, n, e) {
  e(0)({
    target: "Number",
    stat: !0
  }, {
    EPSILON: Math.pow(2, -52)
  })
}, function (t, n, e) {
  e(0)({
    target: "Number",
    stat: !0
  }, {
    isFinite: e(259)
  })
}, function (t, n, e) {
  var i = e(2).isFinite;
  t.exports = Number.isFinite || function (t) {
    return "number" == typeof t && i(t)
  }
}, function (t, n, e) {
  e(0)({
    target: "Number",
    stat: !0
  }, {
    isInteger: e(110)
  })
}, function (t, n, e) {
  e(0)({
    target: "Number",
    stat: !0
  }, {
    isNaN: function (t) {
      return t != t
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(110),
    r = Math.abs;
  i({
    target: "Number",
    stat: !0
  }, {
    isSafeInteger: function (t) {
      return a(t) && r(t) <= 9007199254740991
    }
  })
}, function (t, n, e) {
  e(0)({
    target: "Number",
    stat: !0
  }, {
    MAX_SAFE_INTEGER: 9007199254740991
  })
}, function (t, n, e) {
  e(0)({
    target: "Number",
    stat: !0
  }, {
    MIN_SAFE_INTEGER: -9007199254740991
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(144);
  i({
    target: "Number",
    stat: !0,
    forced: Number.parseFloat != a
  }, {
    parseFloat: a
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(145);
  i({
    target: "Number",
    stat: !0,
    forced: Number.parseInt != a
  }, {
    parseInt: a
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(21),
    r = e(146),
    o = e(108),
    l = e(1),
    c = 1..toFixed,
    s = Math.floor,
    h = function (t, n, e) {
      return 0 === n ? e : n % 2 == 1 ? h(t, n - 1, e * t) : h(t * t, n / 2, e)
    },
    u = function (t, n, e) {
      for (var i = -1, a = e; ++i < 6;) a += n * t[i], t[i] = a % 1e7, a = s(a / 1e7)
    },
    f = function (t, n) {
      for (var e = 6, i = 0; --e >= 0;) i += t[e], t[e] = s(i / n), i = i % n * 1e7
    },
    v = function (t) {
      for (var n = 6, e = ""; --n >= 0;)
        if ("" !== e || 0 === n || 0 !== t[n]) {
          var i = String(t[n]);
          e = "" === e ? i : e + o.call("0", 7 - i.length) + i
        } return e
    };
  i({
    target: "Number",
    proto: !0,
    forced: c && ("0.000" !== 8e-5.toFixed(3) || "1" !== .9.toFixed(0) || "1.25" !== 1.255.toFixed(2) || "1000000000000000128" !== (0xde0b6b3a7640080).toFixed(0)) || !l((function () {
      c.call({})
    }))
  }, {
    toFixed: function (t) {
      var n, e, i, l, c = r(this),
        s = a(t),
        p = [0, 0, 0, 0, 0, 0],
        g = "",
        d = "0";
      if (s < 0 || s > 20) throw RangeError("Incorrect fraction digits");
      if (c != c) return "NaN";
      if (c <= -1e21 || c >= 1e21) return String(c);
      if (c < 0 && (g = "-", c = -c), c > 1e-21)
        if (e = (n = function (t) {
            for (var n = 0, e = t; e >= 4096;) n += 12, e /= 4096;
            for (; e >= 2;) n += 1, e /= 2;
            return n
          }(c * h(2, 69, 1)) - 69) < 0 ? c * h(2, -n, 1) : c / h(2, n, 1), e *= 4503599627370496, (n = 52 - n) > 0) {
          for (u(p, 0, e), i = s; i >= 7;) u(p, 1e7, 0), i -= 7;
          for (u(p, h(10, i, 1), 0), i = n - 1; i >= 23;) f(p, 1 << 23), i -= 23;
          f(p, 1 << i), u(p, 1, 1), f(p, 2), d = v(p)
        } else u(p, 0, e), u(p, 1 << -n, 0), d = v(p) + o.call("0", s);
      return d = s > 0 ? g + ((l = d.length) <= s ? "0." + o.call("0", s - l) + d : d.slice(0, l - s) + "." + d.slice(l - s)) : g + d
    }
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(1),
    r = e(146),
    o = 1..toPrecision;
  i({
    target: "Number",
    proto: !0,
    forced: a((function () {
      return "1" !== o.call(1, void 0)
    })) || !a((function () {
      o.call({})
    }))
  }, {
    toPrecision: function (t) {
      return void 0 === t ? o.call(r(this)) : o.call(r(this), t)
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(147);
  i({
    target: "Object",
    stat: !0,
    forced: Object.assign !== a
  }, {
    assign: a
  })
}, function (t, n, e) {
  e(0)({
    target: "Object",
    stat: !0,
    sham: !e(6)
  }, {
    create: e(28)
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(6),
    r = e(78),
    o = e(11),
    l = e(19),
    c = e(10);
  a && i({
    target: "Object",
    proto: !0,
    forced: r
  }, {
    __defineGetter__: function (t, n) {
      c.f(o(this), t, {
        get: l(n),
        enumerable: !0,
        configurable: !0
      })
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(6);
  i({
    target: "Object",
    stat: !0,
    forced: !a,
    sham: !a
  }, {
    defineProperties: e(97)
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(6);
  i({
    target: "Object",
    stat: !0,
    forced: !a,
    sham: !a
  }, {
    defineProperty: e(10).f
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(6),
    r = e(78),
    o = e(11),
    l = e(19),
    c = e(10);
  a && i({
    target: "Object",
    proto: !0,
    forced: r
  }, {
    __defineSetter__: function (t, n) {
      c.f(o(this), t, {
        set: l(n),
        enumerable: !0,
        configurable: !0
      })
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(148).entries;
  i({
    target: "Object",
    stat: !0
  }, {
    entries: function (t) {
      return a(t)
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(65),
    r = e(1),
    o = e(3),
    l = e(46).onFreeze,
    c = Object.freeze;
  i({
    target: "Object",
    stat: !0,
    forced: r((function () {
      c(1)
    })),
    sham: !a
  }, {
    freeze: function (t) {
      return c && o(t) ? c(l(t)) : t
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(41),
    r = e(45);
  i({
    target: "Object",
    stat: !0
  }, {
    fromEntries: function (t) {
      var n = {};
      return a(t, (function (t, e) {
        r(n, t, e)
      }), {
        AS_ENTRIES: !0
      }), n
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(1),
    r = e(23),
    o = e(16).f,
    l = e(6),
    c = a((function () {
      o(1)
    }));
  i({
    target: "Object",
    stat: !0,
    forced: !l || c,
    sham: !l
  }, {
    getOwnPropertyDescriptor: function (t, n) {
      return o(r(t), n)
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(6),
    r = e(94),
    o = e(23),
    l = e(16),
    c = e(45);
  i({
    target: "Object",
    stat: !0,
    sham: !a
  }, {
    getOwnPropertyDescriptors: function (t) {
      for (var n, e, i = o(t), a = l.f, s = r(i), h = {}, u = 0; s.length > u;) void 0 !== (e = a(i, n = s[u++])) && c(h, n, e);
      return h
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(1),
    r = e(98).f;
  i({
    target: "Object",
    stat: !0,
    forced: a((function () {
      return !Object.getOwnPropertyNames(1)
    }))
  }, {
    getOwnPropertyNames: r
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(1),
    r = e(11),
    o = e(27),
    l = e(99);
  i({
    target: "Object",
    stat: !0,
    forced: a((function () {
      o(1)
    })),
    sham: !l
  }, {
    getPrototypeOf: function (t) {
      return o(r(t))
    }
  })
}, function (t, n, e) {
  e(0)({
    target: "Object",
    stat: !0
  }, {
    is: e(149)
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(1),
    r = e(3),
    o = Object.isExtensible;
  i({
    target: "Object",
    stat: !0,
    forced: a((function () {
      o(1)
    }))
  }, {
    isExtensible: function (t) {
      return !!r(t) && (!o || o(t))
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(1),
    r = e(3),
    o = Object.isFrozen;
  i({
    target: "Object",
    stat: !0,
    forced: a((function () {
      o(1)
    }))
  }, {
    isFrozen: function (t) {
      return !r(t) || !!o && o(t)
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(1),
    r = e(3),
    o = Object.isSealed;
  i({
    target: "Object",
    stat: !0,
    forced: a((function () {
      o(1)
    }))
  }, {
    isSealed: function (t) {
      return !r(t) || !!o && o(t)
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(11),
    r = e(59);
  i({
    target: "Object",
    stat: !0,
    forced: e(1)((function () {
      r(1)
    }))
  }, {
    keys: function (t) {
      return r(a(t))
    }
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(6),
    r = e(78),
    o = e(11),
    l = e(36),
    c = e(27),
    s = e(16).f;
  a && i({
    target: "Object",
    proto: !0,
    forced: r
  }, {
    __lookupGetter__: function (t) {
      var n, e = o(this),
        i = l(t);
      do {
        if (n = s(e, i)) return n.get
      } while (e = c(e))
    }
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(6),
    r = e(78),
    o = e(11),
    l = e(36),
    c = e(27),
    s = e(16).f;
  a && i({
    target: "Object",
    proto: !0,
    forced: r
  }, {
    __lookupSetter__: function (t) {
      var n, e = o(this),
        i = l(t);
      do {
        if (n = s(e, i)) return n.set
      } while (e = c(e))
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(3),
    r = e(46).onFreeze,
    o = e(65),
    l = e(1),
    c = Object.preventExtensions;
  i({
    target: "Object",
    stat: !0,
    forced: l((function () {
      c(1)
    })),
    sham: !o
  }, {
    preventExtensions: function (t) {
      return c && a(t) ? c(r(t)) : t
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(3),
    r = e(46).onFreeze,
    o = e(65),
    l = e(1),
    c = Object.seal;
  i({
    target: "Object",
    stat: !0,
    forced: l((function () {
      c(1)
    })),
    sham: !o
  }, {
    seal: function (t) {
      return c && a(t) ? c(r(t)) : t
    }
  })
}, function (t, n, e) {
  e(0)({
    target: "Object",
    stat: !0
  }, {
    setPrototypeOf: e(33)
  })
}, function (t, n, e) {
  var i = e(101),
    a = e(18),
    r = e(293);
  i || a(Object.prototype, "toString", r, {
    unsafe: !0
  })
}, function (t, n, e) {
  "use strict";
  var i = e(101),
    a = e(63);
  t.exports = i ? {}.toString : function () {
    return "[object " + a(this) + "]"
  }
}, function (t, n, e) {
  var i = e(0),
    a = e(148).values;
  i({
    target: "Object",
    stat: !0
  }, {
    values: function (t) {
      return a(t)
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(144);
  i({
    global: !0,
    forced: parseFloat != a
  }, {
    parseFloat: a
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(145);
  i({
    global: !0,
    forced: parseInt != a
  }, {
    parseInt: a
  })
}, function (t, n, e) {
  "use strict";
  var i, a, r, o, l = e(0),
    c = e(26),
    s = e(2),
    h = e(20),
    u = e(150),
    f = e(18),
    v = e(50),
    p = e(33),
    g = e(29),
    d = e(49),
    m = e(3),
    F = e(19),
    M = e(43),
    w = e(93),
    z = e(41),
    y = e(70),
    A = e(51),
    U = e(111).set,
    H = e(152),
    x = e(153),
    E = e(300),
    S = e(79),
    B = e(112),
    D = e(14),
    b = e(58),
    N = e(5),
    j = e(301),
    L = e(48),
    C = e(37),
    T = N("species"),
    I = "Promise",
    R = D.get,
    V = D.set,
    k = D.getterFor(I),
    O = u && u.prototype,
    P = u,
    G = O,
    K = s.TypeError,
    W = s.document,
    _ = s.process,
    Y = S.f,
    Z = Y,
    J = !!(W && W.createEvent && s.dispatchEvent),
    q = "function" == typeof PromiseRejectionEvent,
    X = !1,
    $ = b(I, (function () {
      var t = w(P),
        n = t !== String(P);
      if (!n && 66 === C) return !0;
      if (c && !G.finally) return !0;
      if (C >= 51 && /native code/.test(t)) return !1;
      var e = new P((function (t) {
          t(1)
        })),
        i = function (t) {
          t((function () {}), (function () {}))
        };
      return (e.constructor = {})[T] = i, !(X = e.then((function () {})) instanceof i) || !n && j && !q
    })),
    Q = $ || !y((function (t) {
      P.all(t).catch((function () {}))
    })),
    tt = function (t) {
      var n;
      return !(!m(t) || "function" != typeof (n = t.then)) && n
    },
    nt = function (t, n) {
      if (!t.notified) {
        t.notified = !0;
        var e = t.reactions;
        H((function () {
          for (var i = t.value, a = 1 == t.state, r = 0; e.length > r;) {
            var o, l, c, s = e[r++],
              h = a ? s.ok : s.fail,
              u = s.resolve,
              f = s.reject,
              v = s.domain;
            try {
              h ? (a || (2 === t.rejection && rt(t), t.rejection = 1), !0 === h ? o = i : (v && v.enter(), o = h(i), v && (v.exit(), c = !0)), o === s.promise ? f(K("Promise-chain cycle")) : (l = tt(o)) ? l.call(o, u, f) : u(o)) : f(i)
            } catch (t) {
              v && !c && v.exit(), f(t)
            }
          }
          t.reactions = [], t.notified = !1, n && !t.rejection && it(t)
        }))
      }
    },
    et = function (t, n, e) {
      var i, a;
      J ? ((i = W.createEvent("Event")).promise = n, i.reason = e, i.initEvent(t, !1, !0), s.dispatchEvent(i)) : i = {
        promise: n,
        reason: e
      }, !q && (a = s["on" + t]) ? a(i) : "unhandledrejection" === t && E("Unhandled promise rejection", e)
    },
    it = function (t) {
      U.call(s, (function () {
        var n, e = t.facade,
          i = t.value;
        if (at(t) && (n = B((function () {
            L ? _.emit("unhandledRejection", i, e) : et("unhandledrejection", e, i)
          })), t.rejection = L || at(t) ? 2 : 1, n.error)) throw n.value
      }))
    },
    at = function (t) {
      return 1 !== t.rejection && !t.parent
    },
    rt = function (t) {
      U.call(s, (function () {
        var n = t.facade;
        L ? _.emit("rejectionHandled", n) : et("rejectionhandled", n, t.value)
      }))
    },
    ot = function (t, n, e) {
      return function (i) {
        t(n, i, e)
      }
    },
    lt = function (t, n, e) {
      t.done || (t.done = !0, e && (t = e), t.value = n, t.state = 2, nt(t, !0))
    },
    ct = function (t, n, e) {
      if (!t.done) {
        t.done = !0, e && (t = e);
        try {
          if (t.facade === n) throw K("Promise can't be resolved itself");
          var i = tt(n);
          i ? H((function () {
            var e = {
              done: !1
            };
            try {
              i.call(n, ot(ct, e, t), ot(lt, e, t))
            } catch (n) {
              lt(e, n, t)
            }
          })) : (t.value = n, t.state = 1, nt(t, !1))
        } catch (n) {
          lt({
            done: !1
          }, n, t)
        }
      }
    };
  if ($ && (G = (P = function (t) {
      M(this, P, I), F(t), i.call(this);
      var n = R(this);
      try {
        t(ot(ct, n), ot(lt, n))
      } catch (t) {
        lt(n, t)
      }
    }).prototype, (i = function (t) {
      V(this, {
        type: I,
        done: !1,
        notified: !1,
        parent: !1,
        reactions: [],
        rejection: !1,
        state: 0,
        value: void 0
      })
    }).prototype = v(G, {
      then: function (t, n) {
        var e = k(this),
          i = Y(A(this, P));
        return i.ok = "function" != typeof t || t, i.fail = "function" == typeof n && n, i.domain = L ? _.domain : void 0, e.parent = !0, e.reactions.push(i), 0 != e.state && nt(e, !1), i.promise
      },
      catch: function (t) {
        return this.then(void 0, t)
      }
    }), a = function () {
      var t = new i,
        n = R(t);
      this.promise = t, this.resolve = ot(ct, n), this.reject = ot(lt, n)
    }, S.f = Y = function (t) {
      return t === P || t === r ? new a(t) : Z(t)
    }, !c && "function" == typeof u && O !== Object.prototype)) {
    o = O.then, X || (f(O, "then", (function (t, n) {
      var e = this;
      return new P((function (t, n) {
        o.call(e, t, n)
      })).then(t, n)
    }), {
      unsafe: !0
    }), f(O, "catch", G.catch, {
      unsafe: !0
    }));
    try {
      delete O.constructor
    } catch (t) {}
    p && p(O, G)
  }
  l({
    global: !0,
    wrap: !0,
    forced: $
  }, {
    Promise: P
  }), g(P, I, !1, !0), d(I), r = h(I), l({
    target: I,
    stat: !0,
    forced: $
  }, {
    reject: function (t) {
      var n = Y(this);
      return n.reject.call(void 0, t), n.promise
    }
  }), l({
    target: I,
    stat: !0,
    forced: c || $
  }, {
    resolve: function (t) {
      return x(c && this === r ? P : this, t)
    }
  }), l({
    target: I,
    stat: !0,
    forced: Q
  }, {
    all: function (t) {
      var n = this,
        e = Y(n),
        i = e.resolve,
        a = e.reject,
        r = B((function () {
          var e = F(n.resolve),
            r = [],
            o = 0,
            l = 1;
          z(t, (function (t) {
            var c = o++,
              s = !1;
            r.push(void 0), l++, e.call(n, t).then((function (t) {
              s || (s = !0, r[c] = t, --l || i(r))
            }), a)
          })), --l || i(r)
        }));
      return r.error && a(r.value), e.promise
    },
    race: function (t) {
      var n = this,
        e = Y(n),
        i = e.reject,
        a = B((function () {
          var a = F(n.resolve);
          z(t, (function (t) {
            a.call(n, t).then(e.resolve, i)
          }))
        }));
      return a.error && i(a.value), e.promise
    }
  })
}, function (t, n, e) {
  var i = e(32),
    a = e(2);
  t.exports = /ipad|iphone|ipod/i.test(i) && void 0 !== a.Pebble
}, function (t, n, e) {
  var i = e(32);
  t.exports = /web0s(?!.*chrome)/i.test(i)
}, function (t, n, e) {
  var i = e(2);
  t.exports = function (t, n) {
    var e = i.console;
    e && e.error && (1 === arguments.length ? e.error(t) : e.error(t, n))
  }
}, function (t, n) {
  t.exports = "object" == typeof window
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(19),
    r = e(79),
    o = e(112),
    l = e(41);
  i({
    target: "Promise",
    stat: !0
  }, {
    allSettled: function (t) {
      var n = this,
        e = r.f(n),
        i = e.resolve,
        c = e.reject,
        s = o((function () {
          var e = a(n.resolve),
            r = [],
            o = 0,
            c = 1;
          l(t, (function (t) {
            var a = o++,
              l = !1;
            r.push(void 0), c++, e.call(n, t).then((function (t) {
              l || (l = !0, r[a] = {
                status: "fulfilled",
                value: t
              }, --c || i(r))
            }), (function (t) {
              l || (l = !0, r[a] = {
                status: "rejected",
                reason: t
              }, --c || i(r))
            }))
          })), --c || i(r)
        }));
      return s.error && c(s.value), e.promise
    }
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(19),
    r = e(20),
    o = e(79),
    l = e(112),
    c = e(41);
  i({
    target: "Promise",
    stat: !0
  }, {
    any: function (t) {
      var n = this,
        e = o.f(n),
        i = e.resolve,
        s = e.reject,
        h = l((function () {
          var e = a(n.resolve),
            o = [],
            l = 0,
            h = 1,
            u = !1;
          c(t, (function (t) {
            var a = l++,
              c = !1;
            o.push(void 0), h++, e.call(n, t).then((function (t) {
              c || u || (u = !0, i(t))
            }), (function (t) {
              c || u || (c = !0, o[a] = t, --h || s(new(r("AggregateError"))(o, "No one promise resolved")))
            }))
          })), --h || s(new(r("AggregateError"))(o, "No one promise resolved"))
        }));
      return h.error && s(h.value), e.promise
    }
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(26),
    r = e(150),
    o = e(1),
    l = e(20),
    c = e(51),
    s = e(153),
    h = e(18);
  if (i({
      target: "Promise",
      proto: !0,
      real: !0,
      forced: !!r && o((function () {
        r.prototype.finally.call({
          then: function () {}
        }, (function () {}))
      }))
    }, {
      finally: function (t) {
        var n = c(this, l("Promise")),
          e = "function" == typeof t;
        return this.then(e ? function (e) {
          return s(n, t()).then((function () {
            return e
          }))
        } : t, e ? function (e) {
          return s(n, t()).then((function () {
            throw e
          }))
        } : t)
      }
    }), !a && "function" == typeof r) {
    var u = l("Promise").prototype.finally;
    r.prototype.finally !== u && h(r.prototype, "finally", u, {
      unsafe: !0
    })
  }
}, function (t, n, e) {
  var i = e(0),
    a = e(20),
    r = e(19),
    o = e(4),
    l = e(1),
    c = a("Reflect", "apply"),
    s = Function.apply;
  i({
    target: "Reflect",
    stat: !0,
    forced: !l((function () {
      c((function () {}))
    }))
  }, {
    apply: function (t, n, e) {
      return r(t), o(e), c ? c(t, n, e) : s.call(t, n, e)
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(20),
    r = e(19),
    o = e(4),
    l = e(3),
    c = e(28),
    s = e(141),
    h = e(1),
    u = a("Reflect", "construct"),
    f = h((function () {
      function t() {}
      return !(u((function () {}), [], t) instanceof t)
    })),
    v = !h((function () {
      u((function () {}))
    })),
    p = f || v;
  i({
    target: "Reflect",
    stat: !0,
    forced: p,
    sham: p
  }, {
    construct: function (t, n) {
      r(t), o(n);
      var e = arguments.length < 3 ? t : r(arguments[2]);
      if (v && !f) return u(t, n, e);
      if (t == e) {
        switch (n.length) {
          case 0:
            return new t;
          case 1:
            return new t(n[0]);
          case 2:
            return new t(n[0], n[1]);
          case 3:
            return new t(n[0], n[1], n[2]);
          case 4:
            return new t(n[0], n[1], n[2], n[3])
        }
        var i = [null];
        return i.push.apply(i, n), new(s.apply(t, i))
      }
      var a = e.prototype,
        h = c(l(a) ? a : Object.prototype),
        p = Function.apply.call(t, h, n);
      return l(p) ? p : h
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(6),
    r = e(4),
    o = e(36),
    l = e(10);
  i({
    target: "Reflect",
    stat: !0,
    forced: e(1)((function () {
      Reflect.defineProperty(l.f({}, 1, {
        value: 1
      }), 1, {
        value: 2
      })
    })),
    sham: !a
  }, {
    defineProperty: function (t, n, e) {
      r(t);
      var i = o(n);
      r(e);
      try {
        return l.f(t, i, e), !0
      } catch (t) {
        return !1
      }
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(4),
    r = e(16).f;
  i({
    target: "Reflect",
    stat: !0
  }, {
    deleteProperty: function (t, n) {
      var e = r(a(t), n);
      return !(e && !e.configurable) && delete t[n]
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(3),
    r = e(4),
    o = e(12),
    l = e(16),
    c = e(27);
  i({
    target: "Reflect",
    stat: !0
  }, {
    get: function t(n, e) {
      var i, s, h = arguments.length < 3 ? n : arguments[2];
      return r(n) === h ? n[e] : (i = l.f(n, e)) ? o(i, "value") ? i.value : void 0 === i.get ? void 0 : i.get.call(h) : a(s = c(n)) ? t(s, e, h) : void 0
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(6),
    r = e(4),
    o = e(16);
  i({
    target: "Reflect",
    stat: !0,
    sham: !a
  }, {
    getOwnPropertyDescriptor: function (t, n) {
      return o.f(r(t), n)
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(4),
    r = e(27);
  i({
    target: "Reflect",
    stat: !0,
    sham: !e(99)
  }, {
    getPrototypeOf: function (t) {
      return r(a(t))
    }
  })
}, function (t, n, e) {
  e(0)({
    target: "Reflect",
    stat: !0
  }, {
    has: function (t, n) {
      return n in t
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(4),
    r = Object.isExtensible;
  i({
    target: "Reflect",
    stat: !0
  }, {
    isExtensible: function (t) {
      return a(t), !r || r(t)
    }
  })
}, function (t, n, e) {
  e(0)({
    target: "Reflect",
    stat: !0
  }, {
    ownKeys: e(94)
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(20),
    r = e(4);
  i({
    target: "Reflect",
    stat: !0,
    sham: !e(65)
  }, {
    preventExtensions: function (t) {
      r(t);
      try {
        var n = a("Object", "preventExtensions");
        return n && n(t), !0
      } catch (t) {
        return !1
      }
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(4),
    r = e(3),
    o = e(12),
    l = e(1),
    c = e(10),
    s = e(16),
    h = e(27),
    u = e(30);
  i({
    target: "Reflect",
    stat: !0,
    forced: l((function () {
      var t = function () {},
        n = c.f(new t, "a", {
          configurable: !0
        });
      return !1 !== Reflect.set(t.prototype, "a", 1, n)
    }))
  }, {
    set: function t(n, e, i) {
      var l, f, v = arguments.length < 4 ? n : arguments[3],
        p = s.f(a(n), e);
      if (!p) {
        if (r(f = h(n))) return t(f, e, i, v);
        p = u(0)
      }
      if (o(p, "value")) {
        if (!1 === p.writable || !r(v)) return !1;
        if (l = s.f(v, e)) {
          if (l.get || l.set || !1 === l.writable) return !1;
          l.value = i, c.f(v, e, l)
        } else c.f(v, e, u(0, i));
        return !0
      }
      return void 0 !== p.set && (p.set.call(v, i), !0)
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(4),
    r = e(129),
    o = e(33);
  o && i({
    target: "Reflect",
    stat: !0
  }, {
    setPrototypeOf: function (t, n) {
      a(t), r(n);
      try {
        return o(t, n), !0
      } catch (t) {
        return !1
      }
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(2),
    r = e(29);
  i({
    global: !0
  }, {
    Reflect: {}
  }), r(a.Reflect, "Reflect", !0)
}, function (t, n, e) {
  var i = e(6),
    a = e(2),
    r = e(58),
    o = e(75),
    l = e(17),
    c = e(10).f,
    s = e(38).f,
    h = e(66),
    u = e(9),
    f = e(53),
    v = e(80),
    p = e(18),
    g = e(1),
    d = e(12),
    m = e(14).enforce,
    F = e(49),
    M = e(5),
    w = e(113),
    z = e(154),
    y = M("match"),
    A = a.RegExp,
    U = A.prototype,
    H = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/,
    x = /a/g,
    E = /a/g,
    S = new A(x) !== x,
    B = v.UNSUPPORTED_Y,
    D = i && (!S || B || w || z || g((function () {
      return E[y] = !1, A(x) != x || A(E) == E || "/a/i" != A(x, "i")
    })));
  if (r("RegExp", D)) {
    for (var b = function (t, n) {
        var e, i, a, r, c, s, v = this instanceof b,
          p = h(t),
          g = void 0 === n,
          F = [],
          M = t;
        if (!v && p && g && t.constructor === b) return t;
        if ((p || t instanceof b) && (t = t.source, g && (n = "flags" in M ? M.flags : f.call(M))), t = void 0 === t ? "" : u(t), n = void 0 === n ? "" : u(n), M = t, w && "dotAll" in x && (i = !!n && n.indexOf("s") > -1) && (n = n.replace(/s/g, "")), e = n, B && "sticky" in x && (a = !!n && n.indexOf("y") > -1) && (n = n.replace(/y/g, "")), z && (t = (r = function (t) {
            for (var n, e = t.length, i = 0, a = "", r = [], o = {}, l = !1, c = !1, s = 0, h = ""; i <= e; i++) {
              if ("\\" === (n = t.charAt(i))) n += t.charAt(++i);
              else if ("]" === n) l = !1;
              else if (!l) switch (!0) {
                case "[" === n:
                  l = !0;
                  break;
                case "(" === n:
                  H.test(t.slice(i + 1)) && (i += 2, c = !0), a += n, s++;
                  continue;
                case ">" === n && c:
                  if ("" === h || d(o, h)) throw new SyntaxError("Invalid capture group name");
                  o[h] = !0, r.push([h, s]), c = !1, h = "";
                  continue
              }
              c ? h += n : a += n
            }
            return [a, r]
          }(t))[0], F = r[1]), c = o(A(t, n), v ? this : U, b), (i || a || F.length) && (s = m(c), i && (s.dotAll = !0, s.raw = b(function (t) {
            for (var n, e = t.length, i = 0, a = "", r = !1; i <= e; i++) "\\" !== (n = t.charAt(i)) ? r || "." !== n ? ("[" === n ? r = !0 : "]" === n && (r = !1), a += n) : a += "[\\s\\S]" : a += n + t.charAt(++i);
            return a
          }(t), e)), a && (s.sticky = !0), F.length && (s.groups = F)), t !== M) try {
          l(c, "source", "" === M ? "(?:)" : M)
        } catch (t) {}
        return c
      }, N = function (t) {
        t in b || c(b, t, {
          configurable: !0,
          get: function () {
            return A[t]
          },
          set: function (n) {
            A[t] = n
          }
        })
      }, j = s(A), L = 0; j.length > L;) N(j[L++]);
    U.constructor = b, b.prototype = U, p(a, "RegExp", b)
  }
  F("RegExp")
}, function (t, n, e) {
  var i = e(6),
    a = e(113),
    r = e(10).f,
    o = e(14).get,
    l = RegExp.prototype;
  i && a && r(l, "dotAll", {
    configurable: !0,
    get: function () {
      if (this !== l) {
        if (this instanceof RegExp) return !!o(this).dotAll;
        throw TypeError("Incompatible receiver, RegExp required")
      }
    }
  })
}, function (t, n, e) {
  var i = e(6),
    a = e(10),
    r = e(53),
    o = e(1);
  i && o((function () {
    return "sy" !== Object.getOwnPropertyDescriptor(RegExp.prototype, "flags").get.call({
      dotAll: !0,
      sticky: !0
    })
  })) && a.f(RegExp.prototype, "flags", {
    configurable: !0,
    get: r
  })
}, function (t, n, e) {
  var i = e(6),
    a = e(80).UNSUPPORTED_Y,
    r = e(10).f,
    o = e(14).get,
    l = RegExp.prototype;
  i && a && r(l, "sticky", {
    configurable: !0,
    get: function () {
      if (this !== l) {
        if (this instanceof RegExp) return !!o(this).sticky;
        throw TypeError("Incompatible receiver, RegExp required")
      }
    }
  })
}, function (t, n, e) {
  "use strict";
  e(114);
  var i, a, r = e(0),
    o = e(3),
    l = (i = !1, (a = /[ac]/).exec = function () {
      return i = !0, /./.exec.apply(this, arguments)
    }, !0 === a.test("abc") && i),
    c = /./.test;
  r({
    target: "RegExp",
    proto: !0,
    forced: !l
  }, {
    test: function (t) {
      if ("function" != typeof this.exec) return c.call(this, t);
      var n = this.exec(t);
      if (null !== n && !o(n)) throw new Error("RegExp exec method returned something other than an Object or null");
      return !!n
    }
  })
}, function (t, n, e) {
  "use strict";
  var i = e(18),
    a = e(4),
    r = e(9),
    o = e(1),
    l = e(53),
    c = RegExp.prototype,
    s = c.toString,
    h = o((function () {
      return "/a/b" != s.call({
        source: "a",
        flags: "b"
      })
    })),
    u = "toString" != s.name;
  (h || u) && i(RegExp.prototype, "toString", (function () {
    var t = a(this),
      n = r(t.source),
      e = t.flags;
    return "/" + n + "/" + r(void 0 === e && t instanceof RegExp && !("flags" in c) ? l.call(t) : e)
  }), {
    unsafe: !0
  })
}, function (t, n, e) {
  "use strict";
  var i = e(74),
    a = e(142);
  t.exports = i("Set", (function (t) {
    return function () {
      return t(this, arguments.length ? arguments[0] : void 0)
    }
  }), a)
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(82).codeAt;
  i({
    target: "String",
    proto: !0
  }, {
    codePointAt: function (t) {
      return a(this, t)
    }
  })
}, function (t, n, e) {
  "use strict";
  var i, a = e(0),
    r = e(16).f,
    o = e(7),
    l = e(9),
    c = e(115),
    s = e(13),
    h = e(116),
    u = e(26),
    f = "".endsWith,
    v = Math.min,
    p = h("endsWith");
  a({
    target: "String",
    proto: !0,
    forced: !!(u || p || (i = r(String.prototype, "endsWith"), !i || i.writable)) && !p
  }, {
    endsWith: function (t) {
      var n = l(s(this));
      c(t);
      var e = arguments.length > 1 ? arguments[1] : void 0,
        i = o(n.length),
        a = void 0 === e ? i : v(o(e), i),
        r = l(t);
      return f ? f.call(n, r, a) : n.slice(a - r.length, a) === r
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(39),
    r = String.fromCharCode,
    o = String.fromCodePoint;
  i({
    target: "String",
    stat: !0,
    forced: !!o && 1 != o.length
  }, {
    fromCodePoint: function (t) {
      for (var n, e = [], i = arguments.length, o = 0; i > o;) {
        if (n = +arguments[o++], a(n, 1114111) !== n) throw RangeError(n + " is not a valid code point");
        e.push(n < 65536 ? r(n) : r(55296 + ((n -= 65536) >> 10), n % 1024 + 56320))
      }
      return e.join("")
    }
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(115),
    r = e(13),
    o = e(9);
  i({
    target: "String",
    proto: !0,
    forced: !e(116)("includes")
  }, {
    includes: function (t) {
      return !!~o(r(this)).indexOf(o(a(t)), arguments.length > 1 ? arguments[1] : void 0)
    }
  })
}, function (t, n, e) {
  "use strict";
  var i = e(83),
    a = e(4),
    r = e(7),
    o = e(9),
    l = e(13),
    c = e(84),
    s = e(85);
  i("match", (function (t, n, e) {
    return [function (n) {
      var e = l(this),
        i = null == n ? void 0 : n[t];
      return void 0 !== i ? i.call(n, e) : new RegExp(n)[t](o(e))
    }, function (t) {
      var i = a(this),
        l = o(t),
        h = e(n, i, l);
      if (h.done) return h.value;
      if (!i.global) return s(i, l);
      var u = i.unicode;
      i.lastIndex = 0;
      for (var f, v = [], p = 0; null !== (f = s(i, l));) {
        var g = o(f[0]);
        v[p] = g, "" === g && (i.lastIndex = c(l, r(i.lastIndex), u)), p++
      }
      return 0 === p ? null : v
    }]
  }))
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(104),
    r = e(13),
    o = e(7),
    l = e(9),
    c = e(19),
    s = e(4),
    h = e(31),
    u = e(66),
    f = e(53),
    v = e(17),
    p = e(1),
    g = e(5),
    d = e(51),
    m = e(84),
    F = e(14),
    M = e(26),
    w = g("matchAll"),
    z = F.set,
    y = F.getterFor("RegExp String Iterator"),
    A = RegExp.prototype,
    U = A.exec,
    H = "".matchAll,
    x = !!H && !p((function () {
      "a".matchAll(/./)
    })),
    E = a((function (t, n, e, i) {
      z(this, {
        type: "RegExp String Iterator",
        regexp: t,
        string: n,
        global: e,
        unicode: i,
        done: !1
      })
    }), "RegExp String", (function () {
      var t = y(this);
      if (t.done) return {
        value: void 0,
        done: !0
      };
      var n = t.regexp,
        e = t.string,
        i = function (t, n) {
          var e, i = t.exec;
          if ("function" == typeof i) {
            if ("object" != typeof (e = i.call(t, n))) throw TypeError("Incorrect exec result");
            return e
          }
          return U.call(t, n)
        }(n, e);
      return null === i ? {
        value: void 0,
        done: t.done = !0
      } : t.global ? ("" === l(i[0]) && (n.lastIndex = m(e, o(n.lastIndex), t.unicode)), {
        value: i,
        done: !1
      }) : (t.done = !0, {
        value: i,
        done: !1
      })
    })),
    S = function (t) {
      var n, e, i, a, r, c, h = s(this),
        u = l(t);
      return n = d(h, RegExp), void 0 === (e = h.flags) && h instanceof RegExp && !("flags" in A) && (e = f.call(h)), i = void 0 === e ? "" : l(e), a = new n(n === RegExp ? h.source : h, i), r = !!~i.indexOf("g"), c = !!~i.indexOf("u"), a.lastIndex = o(h.lastIndex), new E(a, u, r, c)
    };
  i({
    target: "String",
    proto: !0,
    forced: x
  }, {
    matchAll: function (t) {
      var n, e, i, a = r(this);
      if (null != t) {
        if (u(t) && !~l(r("flags" in A ? t.flags : f.call(t))).indexOf("g")) throw TypeError("`.matchAll` does not allow non-global regexes");
        if (x) return H.apply(a, arguments);
        if (void 0 === (e = t[w]) && M && "RegExp" == h(t) && (e = S), null != e) return c(e).call(t, a)
      } else if (x) return H.apply(a, arguments);
      return n = l(a), i = new RegExp(t, "g"), M ? S.call(i, n) : i[w](n)
    }
  }), M || w in A || v(A, w, S)
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(107).end;
  i({
    target: "String",
    proto: !0,
    forced: e(156)
  }, {
    padEnd: function (t) {
      return a(this, t, arguments.length > 1 ? arguments[1] : void 0)
    }
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(107).start;
  i({
    target: "String",
    proto: !0,
    forced: e(156)
  }, {
    padStart: function (t) {
      return a(this, t, arguments.length > 1 ? arguments[1] : void 0)
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(23),
    r = e(7),
    o = e(9);
  i({
    target: "String",
    stat: !0
  }, {
    raw: function (t) {
      for (var n = a(t.raw), e = r(n.length), i = arguments.length, l = [], c = 0; e > c;) l.push(o(n[c++])), c < i && l.push(o(arguments[c]));
      return l.join("")
    }
  })
}, function (t, n, e) {
  e(0)({
    target: "String",
    proto: !0
  }, {
    repeat: e(108)
  })
}, function (t, n, e) {
  "use strict";
  var i = e(83),
    a = e(1),
    r = e(4),
    o = e(21),
    l = e(7),
    c = e(9),
    s = e(13),
    h = e(84),
    u = e(157),
    f = e(85),
    v = e(5)("replace"),
    p = Math.max,
    g = Math.min,
    d = "$0" === "a".replace(/./, "$0"),
    m = !!/./ [v] && "" === /./ [v]("a", "$0");
  i("replace", (function (t, n, e) {
    var i = m ? "$" : "$0";
    return [function (t, e) {
      var i = s(this),
        a = null == t ? void 0 : t[v];
      return void 0 !== a ? a.call(t, i, e) : n.call(c(i), t, e)
    }, function (t, a) {
      var s = r(this),
        v = c(t);
      if ("string" == typeof a && -1 === a.indexOf(i) && -1 === a.indexOf("$<")) {
        var d = e(n, s, v, a);
        if (d.done) return d.value
      }
      var m = "function" == typeof a;
      m || (a = c(a));
      var F = s.global;
      if (F) {
        var M = s.unicode;
        s.lastIndex = 0
      }
      for (var w = [];;) {
        var z = f(s, v);
        if (null === z) break;
        if (w.push(z), !F) break;
        "" === c(z[0]) && (s.lastIndex = h(v, l(s.lastIndex), M))
      }
      for (var y, A = "", U = 0, H = 0; H < w.length; H++) {
        z = w[H];
        for (var x = c(z[0]), E = p(g(o(z.index), v.length), 0), S = [], B = 1; B < z.length; B++) S.push(void 0 === (y = z[B]) ? y : String(y));
        var D = z.groups;
        if (m) {
          var b = [x].concat(S, E, v);
          void 0 !== D && b.push(D);
          var N = c(a.apply(void 0, b))
        } else N = u(x, v, E, S, D, a);
        E >= U && (A += v.slice(U, E) + N, U = E + x.length)
      }
      return A + v.slice(U)
    }]
  }), !!a((function () {
    var t = /./;
    return t.exec = function () {
      var t = [];
      return t.groups = {
        a: "7"
      }, t
    }, "7" !== "".replace(t, "$<a>")
  })) || !d || m)
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(13),
    r = e(66),
    o = e(9),
    l = e(53),
    c = e(157),
    s = e(5),
    h = e(26),
    u = s("replace"),
    f = RegExp.prototype,
    v = Math.max,
    p = function (t, n, e) {
      return e > t.length ? -1 : "" === n ? e : t.indexOf(n, e)
    };
  i({
    target: "String",
    proto: !0
  }, {
    replaceAll: function (t, n) {
      var e, i, s, g, d, m, F, M, w = a(this),
        z = 0,
        y = 0,
        A = "";
      if (null != t) {
        if ((e = r(t)) && !~o(a("flags" in f ? t.flags : l.call(t))).indexOf("g")) throw TypeError("`.replaceAll` does not allow non-global regexes");
        if (void 0 !== (i = t[u])) return i.call(t, w, n);
        if (h && e) return o(w).replace(t, n)
      }
      for (s = o(w), g = o(t), (d = "function" == typeof n) || (n = o(n)), m = g.length, F = v(1, m), z = p(s, g, 0); - 1 !== z;) M = d ? o(n(g, z, s)) : c(g, s, z, [], void 0, n), A += s.slice(y, z) + M, y = z + m, z = p(s, g, z + F);
      return y < s.length && (A += s.slice(y)), A
    }
  })
}, function (t, n, e) {
  "use strict";
  var i = e(83),
    a = e(4),
    r = e(13),
    o = e(149),
    l = e(9),
    c = e(85);
  i("search", (function (t, n, e) {
    return [function (n) {
      var e = r(this),
        i = null == n ? void 0 : n[t];
      return void 0 !== i ? i.call(n, e) : new RegExp(n)[t](l(e))
    }, function (t) {
      var i = a(this),
        r = l(t),
        s = e(n, i, r);
      if (s.done) return s.value;
      var h = i.lastIndex;
      o(h, 0) || (i.lastIndex = 0);
      var u = c(i, r);
      return o(i.lastIndex, h) || (i.lastIndex = h), null === u ? -1 : u.index
    }]
  }))
}, function (t, n, e) {
  "use strict";
  var i = e(83),
    a = e(66),
    r = e(4),
    o = e(13),
    l = e(51),
    c = e(84),
    s = e(7),
    h = e(9),
    u = e(85),
    f = e(81),
    v = e(80),
    p = e(1),
    g = v.UNSUPPORTED_Y,
    d = [].push,
    m = Math.min;
  i("split", (function (t, n, e) {
    var i;
    return i = "c" == "abbc".split(/(b)*/)[1] || 4 != "test".split(/(?:)/, -1).length || 2 != "ab".split(/(?:ab)*/).length || 4 != ".".split(/(.?)(.?)/).length || ".".split(/()()/).length > 1 || "".split(/.?/).length ? function (t, e) {
      var i = h(o(this)),
        r = void 0 === e ? 4294967295 : e >>> 0;
      if (0 === r) return [];
      if (void 0 === t) return [i];
      if (!a(t)) return n.call(i, t, r);
      for (var l, c, s, u = [], v = (t.ignoreCase ? "i" : "") + (t.multiline ? "m" : "") + (t.unicode ? "u" : "") + (t.sticky ? "y" : ""), p = 0, g = new RegExp(t.source, v + "g");
        (l = f.call(g, i)) && !((c = g.lastIndex) > p && (u.push(i.slice(p, l.index)), l.length > 1 && l.index < i.length && d.apply(u, l.slice(1)), s = l[0].length, p = c, u.length >= r));) g.lastIndex === l.index && g.lastIndex++;
      return p === i.length ? !s && g.test("") || u.push("") : u.push(i.slice(p)), u.length > r ? u.slice(0, r) : u
    } : "0".split(void 0, 0).length ? function (t, e) {
      return void 0 === t && 0 === e ? [] : n.call(this, t, e)
    } : n, [function (n, e) {
      var a = o(this),
        r = null == n ? void 0 : n[t];
      return void 0 !== r ? r.call(n, a, e) : i.call(h(a), n, e)
    }, function (t, a) {
      var o = r(this),
        f = h(t),
        v = e(i, o, f, a, i !== n);
      if (v.done) return v.value;
      var p = l(o, RegExp),
        d = o.unicode,
        F = (o.ignoreCase ? "i" : "") + (o.multiline ? "m" : "") + (o.unicode ? "u" : "") + (g ? "g" : "y"),
        M = new p(g ? "^(?:" + o.source + ")" : o, F),
        w = void 0 === a ? 4294967295 : a >>> 0;
      if (0 === w) return [];
      if (0 === f.length) return null === u(M, f) ? [f] : [];
      for (var z = 0, y = 0, A = []; y < f.length;) {
        M.lastIndex = g ? 0 : y;
        var U, H = u(M, g ? f.slice(y) : f);
        if (null === H || (U = m(s(M.lastIndex + (g ? y : 0)), f.length)) === z) y = c(f, y, d);
        else {
          if (A.push(f.slice(z, y)), A.length === w) return A;
          for (var x = 1; x <= H.length - 1; x++)
            if (A.push(H[x]), A.length === w) return A;
          y = z = U
        }
      }
      return A.push(f.slice(z)), A
    }]
  }), !!p((function () {
    var t = /(?:)/,
      n = t.exec;
    t.exec = function () {
      return n.apply(this, arguments)
    };
    var e = "ab".split(t);
    return 2 !== e.length || "a" !== e[0] || "b" !== e[1]
  })), g)
}, function (t, n, e) {
  "use strict";
  var i, a = e(0),
    r = e(16).f,
    o = e(7),
    l = e(9),
    c = e(115),
    s = e(13),
    h = e(116),
    u = e(26),
    f = "".startsWith,
    v = Math.min,
    p = h("startsWith");
  a({
    target: "String",
    proto: !0,
    forced: !!(u || p || (i = r(String.prototype, "startsWith"), !i || i.writable)) && !p
  }, {
    startsWith: function (t) {
      var n = l(s(this));
      c(t);
      var e = o(v(arguments.length > 1 ? arguments[1] : void 0, n.length)),
        i = l(t);
      return f ? f.call(n, i, e) : n.slice(e, e + i.length) === i
    }
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(13),
    r = e(21),
    o = e(9),
    l = "".slice,
    c = Math.max,
    s = Math.min;
  i({
    target: "String",
    proto: !0
  }, {
    substr: function (t, n) {
      var e, i, h = o(a(this)),
        u = h.length,
        f = r(t);
      return f === 1 / 0 && (f = 0), f < 0 && (f = c(u + f, 0)), (e = void 0 === n ? u : r(n)) <= 0 || e === 1 / 0 || f >= (i = s(f + e, u)) ? "" : l.call(h, f, i)
    }
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(52).trim;
  i({
    target: "String",
    proto: !0,
    forced: e(117)("trim")
  }, {
    trim: function () {
      return a(this)
    }
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(52).end,
    r = e(117)("trimEnd"),
    o = r ? function () {
      return a(this)
    } : "".trimEnd;
  i({
    target: "String",
    proto: !0,
    forced: r
  }, {
    trimEnd: o,
    trimRight: o
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(52).start,
    r = e(117)("trimStart"),
    o = r ? function () {
      return a(this)
    } : "".trimStart;
  i({
    target: "String",
    proto: !0,
    forced: r
  }, {
    trimStart: o,
    trimLeft: o
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(24);
  i({
    target: "String",
    proto: !0,
    forced: e(25)("anchor")
  }, {
    anchor: function (t) {
      return a(this, "a", "name", t)
    }
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(24);
  i({
    target: "String",
    proto: !0,
    forced: e(25)("big")
  }, {
    big: function () {
      return a(this, "big", "", "")
    }
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(24);
  i({
    target: "String",
    proto: !0,
    forced: e(25)("blink")
  }, {
    blink: function () {
      return a(this, "blink", "", "")
    }
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(24);
  i({
    target: "String",
    proto: !0,
    forced: e(25)("bold")
  }, {
    bold: function () {
      return a(this, "b", "", "")
    }
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(24);
  i({
    target: "String",
    proto: !0,
    forced: e(25)("fixed")
  }, {
    fixed: function () {
      return a(this, "tt", "", "")
    }
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(24);
  i({
    target: "String",
    proto: !0,
    forced: e(25)("fontcolor")
  }, {
    fontcolor: function (t) {
      return a(this, "font", "color", t)
    }
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(24);
  i({
    target: "String",
    proto: !0,
    forced: e(25)("fontsize")
  }, {
    fontsize: function (t) {
      return a(this, "font", "size", t)
    }
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(24);
  i({
    target: "String",
    proto: !0,
    forced: e(25)("italics")
  }, {
    italics: function () {
      return a(this, "i", "", "")
    }
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(24);
  i({
    target: "String",
    proto: !0,
    forced: e(25)("link")
  }, {
    link: function (t) {
      return a(this, "a", "href", t)
    }
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(24);
  i({
    target: "String",
    proto: !0,
    forced: e(25)("small")
  }, {
    small: function () {
      return a(this, "small", "", "")
    }
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(24);
  i({
    target: "String",
    proto: !0,
    forced: e(25)("strike")
  }, {
    strike: function () {
      return a(this, "strike", "", "")
    }
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(24);
  i({
    target: "String",
    proto: !0,
    forced: e(25)("sub")
  }, {
    sub: function () {
      return a(this, "sub", "", "")
    }
  })
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(24);
  i({
    target: "String",
    proto: !0,
    forced: e(25)("sup")
  }, {
    sup: function () {
      return a(this, "sup", "", "")
    }
  })
}, function (t, n, e) {
  e(35)("Float32", (function (t) {
    return function (n, e, i) {
      return t(this, n, e, i)
    }
  }))
}, function (t, n, e) {
  var i = e(21);
  t.exports = function (t) {
    var n = i(t);
    if (n < 0) throw RangeError("The argument can't be less than 0");
    return n
  }
}, function (t, n, e) {
  e(35)("Float64", (function (t) {
    return function (n, e, i) {
      return t(this, n, e, i)
    }
  }))
}, function (t, n, e) {
  e(35)("Int8", (function (t) {
    return function (n, e, i) {
      return t(this, n, e, i)
    }
  }))
}, function (t, n, e) {
  e(35)("Int16", (function (t) {
    return function (n, e, i) {
      return t(this, n, e, i)
    }
  }))
}, function (t, n, e) {
  e(35)("Int32", (function (t) {
    return function (n, e, i) {
      return t(this, n, e, i)
    }
  }))
}, function (t, n, e) {
  e(35)("Uint8", (function (t) {
    return function (n, e, i) {
      return t(this, n, e, i)
    }
  }))
}, function (t, n, e) {
  e(35)("Uint8", (function (t) {
    return function (n, e, i) {
      return t(this, n, e, i)
    }
  }), !0)
}, function (t, n, e) {
  e(35)("Uint16", (function (t) {
    return function (n, e, i) {
      return t(this, n, e, i)
    }
  }))
}, function (t, n, e) {
  e(35)("Uint32", (function (t) {
    return function (n, e, i) {
      return t(this, n, e, i)
    }
  }))
}, function (t, n, e) {
  "use strict";
  var i = e(8),
    a = e(131),
    r = i.aTypedArray;
  (0, i.exportTypedArrayMethod)("copyWithin", (function (t, n) {
    return a.call(r(this), t, n, arguments.length > 2 ? arguments[2] : void 0)
  }))
}, function (t, n, e) {
  "use strict";
  var i = e(8),
    a = e(15).every,
    r = i.aTypedArray;
  (0, i.exportTypedArrayMethod)("every", (function (t) {
    return a(r(this), t, arguments.length > 1 ? arguments[1] : void 0)
  }))
}, function (t, n, e) {
  "use strict";
  var i = e(8),
    a = e(102),
    r = i.aTypedArray;
  (0, i.exportTypedArrayMethod)("fill", (function (t) {
    return a.apply(r(this), arguments)
  }))
}, function (t, n, e) {
  "use strict";
  var i = e(8),
    a = e(15).filter,
    r = e(372),
    o = i.aTypedArray;
  (0, i.exportTypedArrayMethod)("filter", (function (t) {
    var n = a(o(this), t, arguments.length > 1 ? arguments[1] : void 0);
    return r(this, n)
  }))
}, function (t, n, e) {
  var i = e(373),
    a = e(86);
  t.exports = function (t, n) {
    return i(a(t), n)
  }
}, function (t, n) {
  t.exports = function (t, n) {
    for (var e = 0, i = n.length, a = new t(i); i > e;) a[e] = n[e++];
    return a
  }
}, function (t, n, e) {
  "use strict";
  var i = e(8),
    a = e(15).find,
    r = i.aTypedArray;
  (0, i.exportTypedArrayMethod)("find", (function (t) {
    return a(r(this), t, arguments.length > 1 ? arguments[1] : void 0)
  }))
}, function (t, n, e) {
  "use strict";
  var i = e(8),
    a = e(15).findIndex,
    r = i.aTypedArray;
  (0, i.exportTypedArrayMethod)("findIndex", (function (t) {
    return a(r(this), t, arguments.length > 1 ? arguments[1] : void 0)
  }))
}, function (t, n, e) {
  "use strict";
  var i = e(8),
    a = e(15).forEach,
    r = i.aTypedArray;
  (0, i.exportTypedArrayMethod)("forEach", (function (t) {
    a(r(this), t, arguments.length > 1 ? arguments[1] : void 0)
  }))
}, function (t, n, e) {
  "use strict";
  var i = e(118);
  (0, e(8).exportTypedArrayStaticMethod)("from", e(159), i)
}, function (t, n, e) {
  "use strict";
  var i = e(8),
    a = e(57).includes,
    r = i.aTypedArray;
  (0, i.exportTypedArrayMethod)("includes", (function (t) {
    return a(r(this), t, arguments.length > 1 ? arguments[1] : void 0)
  }))
}, function (t, n, e) {
  "use strict";
  var i = e(8),
    a = e(57).indexOf,
    r = i.aTypedArray;
  (0, i.exportTypedArrayMethod)("indexOf", (function (t) {
    return a(r(this), t, arguments.length > 1 ? arguments[1] : void 0)
  }))
}, function (t, n, e) {
  "use strict";
  var i = e(2),
    a = e(8),
    r = e(71),
    o = e(5)("iterator"),
    l = i.Uint8Array,
    c = r.values,
    s = r.keys,
    h = r.entries,
    u = a.aTypedArray,
    f = a.exportTypedArrayMethod,
    v = l && l.prototype[o],
    p = !!v && ("values" == v.name || null == v.name),
    g = function () {
      return c.call(u(this))
    };
  f("entries", (function () {
    return h.call(u(this))
  })), f("keys", (function () {
    return s.call(u(this))
  })), f("values", g, !p), f(o, g, !p)
}, function (t, n, e) {
  "use strict";
  var i = e(8),
    a = i.aTypedArray,
    r = i.exportTypedArrayMethod,
    o = [].join;
  r("join", (function (t) {
    return o.apply(a(this), arguments)
  }))
}, function (t, n, e) {
  "use strict";
  var i = e(8),
    a = e(136),
    r = i.aTypedArray;
  (0, i.exportTypedArrayMethod)("lastIndexOf", (function (t) {
    return a.apply(r(this), arguments)
  }))
}, function (t, n, e) {
  "use strict";
  var i = e(8),
    a = e(15).map,
    r = e(86),
    o = i.aTypedArray;
  (0, i.exportTypedArrayMethod)("map", (function (t) {
    return a(o(this), t, arguments.length > 1 ? arguments[1] : void 0, (function (t, n) {
      return new(r(t))(n)
    }))
  }))
}, function (t, n, e) {
  "use strict";
  var i = e(8),
    a = e(118),
    r = i.aTypedArrayConstructor;
  (0, i.exportTypedArrayStaticMethod)("of", (function () {
    for (var t = 0, n = arguments.length, e = new(r(this))(n); n > t;) e[t] = arguments[t++];
    return e
  }), a)
}, function (t, n, e) {
  "use strict";
  var i = e(8),
    a = e(72).left,
    r = i.aTypedArray;
  (0, i.exportTypedArrayMethod)("reduce", (function (t) {
    return a(r(this), t, arguments.length, arguments.length > 1 ? arguments[1] : void 0)
  }))
}, function (t, n, e) {
  "use strict";
  var i = e(8),
    a = e(72).right,
    r = i.aTypedArray;
  (0, i.exportTypedArrayMethod)("reduceRight", (function (t) {
    return a(r(this), t, arguments.length, arguments.length > 1 ? arguments[1] : void 0)
  }))
}, function (t, n, e) {
  "use strict";
  var i = e(8),
    a = i.aTypedArray,
    r = i.exportTypedArrayMethod,
    o = Math.floor;
  r("reverse", (function () {
    for (var t, n = a(this).length, e = o(n / 2), i = 0; i < e;) t = this[i], this[i++] = this[--n], this[n] = t;
    return this
  }))
}, function (t, n, e) {
  "use strict";
  var i = e(8),
    a = e(7),
    r = e(158),
    o = e(11),
    l = e(1),
    c = i.aTypedArray;
  (0, i.exportTypedArrayMethod)("set", (function (t) {
    c(this);
    var n = r(arguments.length > 1 ? arguments[1] : void 0, 1),
      e = this.length,
      i = o(t),
      l = a(i.length),
      s = 0;
    if (l + n > e) throw RangeError("Wrong length");
    for (; s < l;) this[n + s] = i[s++]
  }), l((function () {
    new Int8Array(1).set({})
  })))
}, function (t, n, e) {
  "use strict";
  var i = e(8),
    a = e(86),
    r = e(1),
    o = i.aTypedArray,
    l = i.exportTypedArrayMethod,
    c = [].slice;
  l("slice", (function (t, n) {
    for (var e = c.call(o(this), t, n), i = a(this), r = 0, l = e.length, s = new i(l); l > r;) s[r] = e[r++];
    return s
  }), r((function () {
    new Int8Array(1).slice()
  })))
}, function (t, n, e) {
  "use strict";
  var i = e(8),
    a = e(15).some,
    r = i.aTypedArray;
  (0, i.exportTypedArrayMethod)("some", (function (t) {
    return a(r(this), t, arguments.length > 1 ? arguments[1] : void 0)
  }))
}, function (t, n, e) {
  "use strict";
  var i = e(8),
    a = e(2),
    r = e(1),
    o = e(19),
    l = e(7),
    c = e(137),
    s = e(138),
    h = e(139),
    u = e(37),
    f = e(105),
    v = i.aTypedArray,
    p = i.exportTypedArrayMethod,
    g = a.Uint16Array,
    d = g && g.prototype.sort,
    m = !!d && !r((function () {
      var t = new g(2);
      t.sort(null), t.sort({})
    })),
    F = !!d && !r((function () {
      if (u) return u < 74;
      if (s) return s < 67;
      if (h) return !0;
      if (f) return f < 602;
      var t, n, e = new g(516),
        i = Array(516);
      for (t = 0; t < 516; t++) n = t % 4, e[t] = 515 - t, i[t] = t - 2 * n + 3;
      for (e.sort((function (t, n) {
          return (t / 4 | 0) - (n / 4 | 0)
        })), t = 0; t < 516; t++)
        if (e[t] !== i[t]) return !0
    }));
  p("sort", (function (t) {
    if (void 0 !== t && o(t), F) return d.call(this, t);
    v(this);
    var n, e = l(this.length),
      i = Array(e);
    for (n = 0; n < e; n++) i[n] = this[n];
    for (i = c(this, function (t) {
        return function (n, e) {
          return void 0 !== t ? +t(n, e) || 0 : e != e ? -1 : n != n ? 1 : 0 === n && 0 === e ? 1 / n > 0 && 1 / e < 0 ? 1 : -1 : n > e
        }
      }(t)), n = 0; n < e; n++) this[n] = i[n];
    return this
  }), !F || m)
}, function (t, n, e) {
  "use strict";
  var i = e(8),
    a = e(7),
    r = e(39),
    o = e(86),
    l = i.aTypedArray;
  (0, i.exportTypedArrayMethod)("subarray", (function (t, n) {
    var e = l(this),
      i = e.length,
      c = r(t, i);
    return new(o(e))(e.buffer, e.byteOffset + c * e.BYTES_PER_ELEMENT, a((void 0 === n ? i : r(n, i)) - c))
  }))
}, function (t, n, e) {
  "use strict";
  var i = e(2),
    a = e(8),
    r = e(1),
    o = i.Int8Array,
    l = a.aTypedArray,
    c = a.exportTypedArrayMethod,
    s = [].toLocaleString,
    h = [].slice,
    u = !!o && r((function () {
      s.call(new o(1))
    }));
  c("toLocaleString", (function () {
    return s.apply(u ? h.call(l(this)) : l(this), arguments)
  }), r((function () {
    return [1, 2].toLocaleString() != new o([1, 2]).toLocaleString()
  })) || !r((function () {
    o.prototype.toLocaleString.call([1, 2])
  })))
}, function (t, n, e) {
  "use strict";
  var i = e(8).exportTypedArrayMethod,
    a = e(1),
    r = e(2).Uint8Array,
    o = r && r.prototype || {},
    l = [].toString,
    c = [].join;
  a((function () {
    l.call({})
  })) && (l = function () {
    return c.call(this)
  });
  var s = o.toString != l;
  i("toString", l, s)
}, function (t, n, e) {
  "use strict";
  var i = e(0),
    a = e(9),
    r = String.fromCharCode,
    o = /^[\da-f]{2}$/i,
    l = /^[\da-f]{4}$/i;
  i({
    global: !0
  }, {
    unescape: function (t) {
      for (var n, e, i = a(t), c = "", s = i.length, h = 0; h < s;) {
        if ("%" === (n = i.charAt(h++)))
          if ("u" === i.charAt(h)) {
            if (e = i.slice(h + 1, h + 5), l.test(e)) {
              c += r(parseInt(e, 16)), h += 5;
              continue
            }
          } else if (e = i.slice(h, h + 2), o.test(e)) {
          c += r(parseInt(e, 16)), h += 2;
          continue
        }
        c += n
      }
      return c
    }
  })
}, function (t, n, e) {
  "use strict";
  var i, a = e(2),
    r = e(50),
    o = e(46),
    l = e(74),
    c = e(160),
    s = e(3),
    h = e(14).enforce,
    u = e(123),
    f = !a.ActiveXObject && "ActiveXObject" in a,
    v = Object.isExtensible,
    p = function (t) {
      return function () {
        return t(this, arguments.length ? arguments[0] : void 0)
      }
    },
    g = t.exports = l("WeakMap", p, c);
  if (u && f) {
    i = c.getConstructor(p, "WeakMap", !0), o.enable();
    var d = g.prototype,
      m = d.delete,
      F = d.has,
      M = d.get,
      w = d.set;
    r(d, {
      delete: function (t) {
        if (s(t) && !v(t)) {
          var n = h(this);
          return n.frozen || (n.frozen = new i), m.call(this, t) || n.frozen.delete(t)
        }
        return m.call(this, t)
      },
      has: function (t) {
        if (s(t) && !v(t)) {
          var n = h(this);
          return n.frozen || (n.frozen = new i), F.call(this, t) || n.frozen.has(t)
        }
        return F.call(this, t)
      },
      get: function (t) {
        if (s(t) && !v(t)) {
          var n = h(this);
          return n.frozen || (n.frozen = new i), F.call(this, t) ? M.call(this, t) : n.frozen.get(t)
        }
        return M.call(this, t)
      },
      set: function (t, n) {
        if (s(t) && !v(t)) {
          var e = h(this);
          e.frozen || (e.frozen = new i), F.call(this, t) ? w.call(this, t, n) : e.frozen.set(t, n)
        } else w.call(this, t, n);
        return this
      }
    })
  }
}, function (t, n, e) {
  "use strict";
  e(74)("WeakSet", (function (t) {
    return function () {
      return t(this, arguments.length ? arguments[0] : void 0)
    }
  }), e(160))
}, function (t, n, e) {
  var i = e(2),
    a = e(161),
    r = e(133),
    o = e(17);
  for (var l in a) {
    var c = i[l],
      s = c && c.prototype;
    if (s && s.forEach !== r) try {
      o(s, "forEach", r)
    } catch (t) {
      s.forEach = r
    }
  }
}, function (t, n, e) {
  var i = e(2),
    a = e(161),
    r = e(71),
    o = e(17),
    l = e(5),
    c = l("iterator"),
    s = l("toStringTag"),
    h = r.values;
  for (var u in a) {
    var f = i[u],
      v = f && f.prototype;
    if (v) {
      if (v[c] !== h) try {
        o(v, c, h)
      } catch (t) {
        v[c] = h
      }
      if (v[s] || o(v, s, u), a[u])
        for (var p in r)
          if (v[p] !== r[p]) try {
            o(v, p, r[p])
          } catch (t) {
            v[p] = r[p]
          }
    }
  }
}, function (t, n, e) {
  var i = e(0),
    a = e(2),
    r = e(111);
  i({
    global: !0,
    bind: !0,
    enumerable: !0,
    forced: !a.setImmediate || !a.clearImmediate
  }, {
    setImmediate: r.set,
    clearImmediate: r.clear
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(2),
    r = e(152),
    o = e(48),
    l = a.process;
  i({
    global: !0,
    enumerable: !0,
    noTargetGet: !0
  }, {
    queueMicrotask: function (t) {
      var n = o && l.domain;
      r(n ? n.bind(t) : t)
    }
  })
}, function (t, n, e) {
  var i = e(0),
    a = e(2),
    r = e(32),
    o = [].slice,
    l = function (t) {
      return function (n, e) {
        var i = arguments.length > 2,
          a = i ? o.call(arguments, 2) : void 0;
        return t(i ? function () {
          ("function" == typeof n ? n : Function(n)).apply(this, a)
        } : n, e)
      }
    };
  i({
    global: !0,
    bind: !0,
    forced: /MSIE .\./.test(r)
  }, {
    setTimeout: l(a.setTimeout),
    setInterval: l(a.setInterval)
  })
}, function (t, n, e) {
  "use strict";
  e(155);
  var i, a = e(0),
    r = e(6),
    o = e(162),
    l = e(2),
    c = e(97),
    s = e(18),
    h = e(43),
    u = e(12),
    f = e(147),
    v = e(134),
    p = e(82).codeAt,
    g = e(404),
    d = e(9),
    m = e(29),
    F = e(163),
    M = e(14),
    w = l.URL,
    z = F.URLSearchParams,
    y = F.getState,
    A = M.set,
    U = M.getterFor("URL"),
    H = Math.floor,
    x = Math.pow,
    E = /[A-Za-z]/,
    S = /[\d+-.A-Za-z]/,
    B = /\d/,
    D = /^0x/i,
    b = /^[0-7]+$/,
    N = /^\d+$/,
    j = /^[\dA-Fa-f]+$/,
    L = /[\0\t\n\r #%/:<>?@[\\\]^|]/,
    C = /[\0\t\n\r #/:<>?@[\\\]^|]/,
    T = /^[\u0000-\u0020]+|[\u0000-\u0020]+$/g,
    I = /[\t\n\r]/g,
    R = function (t, n) {
      var e, i, a;
      if ("[" == n.charAt(0)) {
        if ("]" != n.charAt(n.length - 1)) return "Invalid host";
        if (!(e = k(n.slice(1, -1)))) return "Invalid host";
        t.host = e
      } else if (Z(t)) {
        if (n = g(n), L.test(n)) return "Invalid host";
        if (null === (e = V(n))) return "Invalid host";
        t.host = e
      } else {
        if (C.test(n)) return "Invalid host";
        for (e = "", i = v(n), a = 0; a < i.length; a++) e += _(i[a], P);
        t.host = e
      }
    },
    V = function (t) {
      var n, e, i, a, r, o, l, c = t.split(".");
      if (c.length && "" == c[c.length - 1] && c.pop(), (n = c.length) > 4) return t;
      for (e = [], i = 0; i < n; i++) {
        if ("" == (a = c[i])) return t;
        if (r = 10, a.length > 1 && "0" == a.charAt(0) && (r = D.test(a) ? 16 : 8, a = a.slice(8 == r ? 1 : 2)), "" === a) o = 0;
        else {
          if (!(10 == r ? N : 8 == r ? b : j).test(a)) return t;
          o = parseInt(a, r)
        }
        e.push(o)
      }
      for (i = 0; i < n; i++)
        if (o = e[i], i == n - 1) {
          if (o >= x(256, 5 - n)) return null
        } else if (o > 255) return null;
      for (l = e.pop(), i = 0; i < e.length; i++) l += e[i] * x(256, 3 - i);
      return l
    },
    k = function (t) {
      var n, e, i, a, r, o, l, c = [0, 0, 0, 0, 0, 0, 0, 0],
        s = 0,
        h = null,
        u = 0,
        f = function () {
          return t.charAt(u)
        };
      if (":" == f()) {
        if (":" != t.charAt(1)) return;
        u += 2, h = ++s
      }
      for (; f();) {
        if (8 == s) return;
        if (":" != f()) {
          for (n = e = 0; e < 4 && j.test(f());) n = 16 * n + parseInt(f(), 16), u++, e++;
          if ("." == f()) {
            if (0 == e) return;
            if (u -= e, s > 6) return;
            for (i = 0; f();) {
              if (a = null, i > 0) {
                if (!("." == f() && i < 4)) return;
                u++
              }
              if (!B.test(f())) return;
              for (; B.test(f());) {
                if (r = parseInt(f(), 10), null === a) a = r;
                else {
                  if (0 == a) return;
                  a = 10 * a + r
                }
                if (a > 255) return;
                u++
              }
              c[s] = 256 * c[s] + a, 2 != ++i && 4 != i || s++
            }
            if (4 != i) return;
            break
          }
          if (":" == f()) {
            if (u++, !f()) return
          } else if (f()) return;
          c[s++] = n
        } else {
          if (null !== h) return;
          u++, h = ++s
        }
      }
      if (null !== h)
        for (o = s - h, s = 7; 0 != s && o > 0;) l = c[s], c[s--] = c[h + o - 1], c[h + --o] = l;
      else if (8 != s) return;
      return c
    },
    O = function (t) {
      var n, e, i, a;
      if ("number" == typeof t) {
        for (n = [], e = 0; e < 4; e++) n.unshift(t % 256), t = H(t / 256);
        return n.join(".")
      }
      if ("object" == typeof t) {
        for (n = "", i = function (t) {
            for (var n = null, e = 1, i = null, a = 0, r = 0; r < 8; r++) 0 !== t[r] ? (a > e && (n = i, e = a), i = null, a = 0) : (null === i && (i = r), ++a);
            return a > e && (n = i, e = a), n
          }(t), e = 0; e < 8; e++) a && 0 === t[e] || (a && (a = !1), i === e ? (n += e ? ":" : "::", a = !0) : (n += t[e].toString(16), e < 7 && (n += ":")));
        return "[" + n + "]"
      }
      return t
    },
    P = {},
    G = f({}, P, {
      " ": 1,
      '"': 1,
      "<": 1,
      ">": 1,
      "`": 1
    }),
    K = f({}, G, {
      "#": 1,
      "?": 1,
      "{": 1,
      "}": 1
    }),
    W = f({}, K, {
      "/": 1,
      ":": 1,
      ";": 1,
      "=": 1,
      "@": 1,
      "[": 1,
      "\\": 1,
      "]": 1,
      "^": 1,
      "|": 1
    }),
    _ = function (t, n) {
      var e = p(t, 0);
      return e > 32 && e < 127 && !u(n, t) ? t : encodeURIComponent(t)
    },
    Y = {
      ftp: 21,
      file: null,
      http: 80,
      https: 443,
      ws: 80,
      wss: 443
    },
    Z = function (t) {
      return u(Y, t.scheme)
    },
    J = function (t) {
      return "" != t.username || "" != t.password
    },
    q = function (t) {
      return !t.host || t.cannotBeABaseURL || "file" == t.scheme
    },
    X = function (t, n) {
      var e;
      return 2 == t.length && E.test(t.charAt(0)) && (":" == (e = t.charAt(1)) || !n && "|" == e)
    },
    $ = function (t) {
      var n;
      return t.length > 1 && X(t.slice(0, 2)) && (2 == t.length || "/" === (n = t.charAt(2)) || "\\" === n || "?" === n || "#" === n)
    },
    Q = function (t) {
      var n = t.path,
        e = n.length;
      !e || "file" == t.scheme && 1 == e && X(n[0], !0) || n.pop()
    },
    tt = function (t) {
      return "." === t || "%2e" === t.toLowerCase()
    },
    nt = {},
    et = {},
    it = {},
    at = {},
    rt = {},
    ot = {},
    lt = {},
    ct = {},
    st = {},
    ht = {},
    ut = {},
    ft = {},
    vt = {},
    pt = {},
    gt = {},
    dt = {},
    mt = {},
    Ft = {},
    Mt = {},
    wt = {},
    zt = {},
    yt = function (t, n, e, a) {
      var r, o, l, c, s, h = e || nt,
        f = 0,
        p = "",
        g = !1,
        d = !1,
        m = !1;
      for (e || (t.scheme = "", t.username = "", t.password = "", t.host = null, t.port = null, t.path = [], t.query = null, t.fragment = null, t.cannotBeABaseURL = !1, n = n.replace(T, "")), n = n.replace(I, ""), r = v(n); f <= r.length;) {
        switch (o = r[f], h) {
          case nt:
            if (!o || !E.test(o)) {
              if (e) return "Invalid scheme";
              h = it;
              continue
            }
            p += o.toLowerCase(), h = et;
            break;
          case et:
            if (o && (S.test(o) || "+" == o || "-" == o || "." == o)) p += o.toLowerCase();
            else {
              if (":" != o) {
                if (e) return "Invalid scheme";
                p = "", h = it, f = 0;
                continue
              }
              if (e && (Z(t) != u(Y, p) || "file" == p && (J(t) || null !== t.port) || "file" == t.scheme && !t.host)) return;
              if (t.scheme = p, e) return void(Z(t) && Y[t.scheme] == t.port && (t.port = null));
              p = "", "file" == t.scheme ? h = pt : Z(t) && a && a.scheme == t.scheme ? h = at : Z(t) ? h = ct : "/" == r[f + 1] ? (h = rt, f++) : (t.cannotBeABaseURL = !0, t.path.push(""), h = Mt)
            }
            break;
          case it:
            if (!a || a.cannotBeABaseURL && "#" != o) return "Invalid scheme";
            if (a.cannotBeABaseURL && "#" == o) {
              t.scheme = a.scheme, t.path = a.path.slice(), t.query = a.query, t.fragment = "", t.cannotBeABaseURL = !0, h = zt;
              break
            }
            h = "file" == a.scheme ? pt : ot;
            continue;
          case at:
            if ("/" != o || "/" != r[f + 1]) {
              h = ot;
              continue
            }
            h = st, f++;
            break;
          case rt:
            if ("/" == o) {
              h = ht;
              break
            }
            h = Ft;
            continue;
          case ot:
            if (t.scheme = a.scheme, o == i) t.username = a.username, t.password = a.password, t.host = a.host, t.port = a.port, t.path = a.path.slice(), t.query = a.query;
            else if ("/" == o || "\\" == o && Z(t)) h = lt;
            else if ("?" == o) t.username = a.username, t.password = a.password, t.host = a.host, t.port = a.port, t.path = a.path.slice(), t.query = "", h = wt;
            else {
              if ("#" != o) {
                t.username = a.username, t.password = a.password, t.host = a.host, t.port = a.port, t.path = a.path.slice(), t.path.pop(), h = Ft;
                continue
              }
              t.username = a.username, t.password = a.password, t.host = a.host, t.port = a.port, t.path = a.path.slice(), t.query = a.query, t.fragment = "", h = zt
            }
            break;
          case lt:
            if (!Z(t) || "/" != o && "\\" != o) {
              if ("/" != o) {
                t.username = a.username, t.password = a.password, t.host = a.host, t.port = a.port, h = Ft;
                continue
              }
              h = ht
            } else h = st;
            break;
          case ct:
            if (h = st, "/" != o || "/" != p.charAt(f + 1)) continue;
            f++;
            break;
          case st:
            if ("/" != o && "\\" != o) {
              h = ht;
              continue
            }
            break;
          case ht:
            if ("@" == o) {
              g && (p = "%40" + p), g = !0, l = v(p);
              for (var F = 0; F < l.length; F++) {
                var M = l[F];
                if (":" != M || m) {
                  var w = _(M, W);
                  m ? t.password += w : t.username += w
                } else m = !0
              }
              p = ""
            } else if (o == i || "/" == o || "?" == o || "#" == o || "\\" == o && Z(t)) {
              if (g && "" == p) return "Invalid authority";
              f -= v(p).length + 1, p = "", h = ut
            } else p += o;
            break;
          case ut:
          case ft:
            if (e && "file" == t.scheme) {
              h = dt;
              continue
            }
            if (":" != o || d) {
              if (o == i || "/" == o || "?" == o || "#" == o || "\\" == o && Z(t)) {
                if (Z(t) && "" == p) return "Invalid host";
                if (e && "" == p && (J(t) || null !== t.port)) return;
                if (c = R(t, p)) return c;
                if (p = "", h = mt, e) return;
                continue
              }
              "[" == o ? d = !0 : "]" == o && (d = !1), p += o
            } else {
              if ("" == p) return "Invalid host";
              if (c = R(t, p)) return c;
              if (p = "", h = vt, e == ft) return
            }
            break;
          case vt:
            if (!B.test(o)) {
              if (o == i || "/" == o || "?" == o || "#" == o || "\\" == o && Z(t) || e) {
                if ("" != p) {
                  var z = parseInt(p, 10);
                  if (z > 65535) return "Invalid port";
                  t.port = Z(t) && z === Y[t.scheme] ? null : z, p = ""
                }
                if (e) return;
                h = mt;
                continue
              }
              return "Invalid port"
            }
            p += o;
            break;
          case pt:
            if (t.scheme = "file", "/" == o || "\\" == o) h = gt;
            else {
              if (!a || "file" != a.scheme) {
                h = Ft;
                continue
              }
              if (o == i) t.host = a.host, t.path = a.path.slice(), t.query = a.query;
              else if ("?" == o) t.host = a.host, t.path = a.path.slice(), t.query = "", h = wt;
              else {
                if ("#" != o) {
                  $(r.slice(f).join("")) || (t.host = a.host, t.path = a.path.slice(), Q(t)), h = Ft;
                  continue
                }
                t.host = a.host, t.path = a.path.slice(), t.query = a.query, t.fragment = "", h = zt
              }
            }
            break;
          case gt:
            if ("/" == o || "\\" == o) {
              h = dt;
              break
            }
            a && "file" == a.scheme && !$(r.slice(f).join("")) && (X(a.path[0], !0) ? t.path.push(a.path[0]) : t.host = a.host), h = Ft;
            continue;
          case dt:
            if (o == i || "/" == o || "\\" == o || "?" == o || "#" == o) {
              if (!e && X(p)) h = Ft;
              else if ("" == p) {
                if (t.host = "", e) return;
                h = mt
              } else {
                if (c = R(t, p)) return c;
                if ("localhost" == t.host && (t.host = ""), e) return;
                p = "", h = mt
              }
              continue
            }
            p += o;
            break;
          case mt:
            if (Z(t)) {
              if (h = Ft, "/" != o && "\\" != o) continue
            } else if (e || "?" != o)
              if (e || "#" != o) {
                if (o != i && (h = Ft, "/" != o)) continue
              } else t.fragment = "", h = zt;
            else t.query = "", h = wt;
            break;
          case Ft:
            if (o == i || "/" == o || "\\" == o && Z(t) || !e && ("?" == o || "#" == o)) {
              if (".." === (s = (s = p).toLowerCase()) || "%2e." === s || ".%2e" === s || "%2e%2e" === s ? (Q(t), "/" == o || "\\" == o && Z(t) || t.path.push("")) : tt(p) ? "/" == o || "\\" == o && Z(t) || t.path.push("") : ("file" == t.scheme && !t.path.length && X(p) && (t.host && (t.host = ""), p = p.charAt(0) + ":"), t.path.push(p)), p = "", "file" == t.scheme && (o == i || "?" == o || "#" == o))
                for (; t.path.length > 1 && "" === t.path[0];) t.path.shift();
              "?" == o ? (t.query = "", h = wt) : "#" == o && (t.fragment = "", h = zt)
            } else p += _(o, K);
            break;
          case Mt:
            "?" == o ? (t.query = "", h = wt) : "#" == o ? (t.fragment = "", h = zt) : o != i && (t.path[0] += _(o, P));
            break;
          case wt:
            e || "#" != o ? o != i && ("'" == o && Z(t) ? t.query += "%27" : t.query += "#" == o ? "%23" : _(o, P)) : (t.fragment = "", h = zt);
            break;
          case zt:
            o != i && (t.fragment += _(o, G))
        }
        f++
      }
    },
    At = function (t) {
      var n, e, i = h(this, At, "URL"),
        a = arguments.length > 1 ? arguments[1] : void 0,
        o = d(t),
        l = A(i, {
          type: "URL"
        });
      if (void 0 !== a)
        if (a instanceof At) n = U(a);
        else if (e = yt(n = {}, d(a))) throw TypeError(e);
      if (e = yt(l, o, null, n)) throw TypeError(e);
      var c = l.searchParams = new z,
        s = y(c);
      s.updateSearchParams(l.query), s.updateURL = function () {
        l.query = String(c) || null
      }, r || (i.href = Ht.call(i), i.origin = xt.call(i), i.protocol = Et.call(i), i.username = St.call(i), i.password = Bt.call(i), i.host = Dt.call(i), i.hostname = bt.call(i), i.port = Nt.call(i), i.pathname = jt.call(i), i.search = Lt.call(i), i.searchParams = Ct.call(i), i.hash = Tt.call(i))
    },
    Ut = At.prototype,
    Ht = function () {
      var t = U(this),
        n = t.scheme,
        e = t.username,
        i = t.password,
        a = t.host,
        r = t.port,
        o = t.path,
        l = t.query,
        c = t.fragment,
        s = n + ":";
      return null !== a ? (s += "//", J(t) && (s += e + (i ? ":" + i : "") + "@"), s += O(a), null !== r && (s += ":" + r)) : "file" == n && (s += "//"), s += t.cannotBeABaseURL ? o[0] : o.length ? "/" + o.join("/") : "", null !== l && (s += "?" + l), null !== c && (s += "#" + c), s
    },
    xt = function () {
      var t = U(this),
        n = t.scheme,
        e = t.port;
      if ("blob" == n) try {
        return new At(n.path[0]).origin
      } catch (t) {
        return "null"
      }
      return "file" != n && Z(t) ? n + "://" + O(t.host) + (null !== e ? ":" + e : "") : "null"
    },
    Et = function () {
      return U(this).scheme + ":"
    },
    St = function () {
      return U(this).username
    },
    Bt = function () {
      return U(this).password
    },
    Dt = function () {
      var t = U(this),
        n = t.host,
        e = t.port;
      return null === n ? "" : null === e ? O(n) : O(n) + ":" + e
    },
    bt = function () {
      var t = U(this).host;
      return null === t ? "" : O(t)
    },
    Nt = function () {
      var t = U(this).port;
      return null === t ? "" : String(t)
    },
    jt = function () {
      var t = U(this),
        n = t.path;
      return t.cannotBeABaseURL ? n[0] : n.length ? "/" + n.join("/") : ""
    },
    Lt = function () {
      var t = U(this).query;
      return t ? "?" + t : ""
    },
    Ct = function () {
      return U(this).searchParams
    },
    Tt = function () {
      var t = U(this).fragment;
      return t ? "#" + t : ""
    },
    It = function (t, n) {
      return {
        get: t,
        set: n,
        configurable: !0,
        enumerable: !0
      }
    };
  if (r && c(Ut, {
      href: It(Ht, (function (t) {
        var n = U(this),
          e = d(t),
          i = yt(n, e);
        if (i) throw TypeError(i);
        y(n.searchParams).updateSearchParams(n.query)
      })),
      origin: It(xt),
      protocol: It(Et, (function (t) {
        var n = U(this);
        yt(n, d(t) + ":", nt)
      })),
      username: It(St, (function (t) {
        var n = U(this),
          e = v(d(t));
        if (!q(n)) {
          n.username = "";
          for (var i = 0; i < e.length; i++) n.username += _(e[i], W)
        }
      })),
      password: It(Bt, (function (t) {
        var n = U(this),
          e = v(d(t));
        if (!q(n)) {
          n.password = "";
          for (var i = 0; i < e.length; i++) n.password += _(e[i], W)
        }
      })),
      host: It(Dt, (function (t) {
        var n = U(this);
        n.cannotBeABaseURL || yt(n, d(t), ut)
      })),
      hostname: It(bt, (function (t) {
        var n = U(this);
        n.cannotBeABaseURL || yt(n, d(t), ft)
      })),
      port: It(Nt, (function (t) {
        var n = U(this);
        q(n) || ("" == (t = d(t)) ? n.port = null : yt(n, t, vt))
      })),
      pathname: It(jt, (function (t) {
        var n = U(this);
        n.cannotBeABaseURL || (n.path = [], yt(n, d(t), mt))
      })),
      search: It(Lt, (function (t) {
        var n = U(this);
        "" == (t = d(t)) ? n.query = null: ("?" == t.charAt(0) && (t = t.slice(1)), n.query = "", yt(n, t, wt)), y(n.searchParams).updateSearchParams(n.query)
      })),
      searchParams: It(Ct),
      hash: It(Tt, (function (t) {
        var n = U(this);
        "" != (t = d(t)) ? ("#" == t.charAt(0) && (t = t.slice(1)), n.fragment = "", yt(n, t, zt)) : n.fragment = null
      }))
    }), s(Ut, "toJSON", (function () {
      return Ht.call(this)
    }), {
      enumerable: !0
    }), s(Ut, "toString", (function () {
      return Ht.call(this)
    }), {
      enumerable: !0
    }), w) {
    var Rt = w.createObjectURL,
      Vt = w.revokeObjectURL;
    Rt && s(At, "createObjectURL", (function (t) {
      return Rt.apply(w, arguments)
    })), Vt && s(At, "revokeObjectURL", (function (t) {
      return Vt.apply(w, arguments)
    }))
  }
  m(At, "URL"), a({
    global: !0,
    forced: !o,
    sham: !r
  }, {
    URL: At
  })
}, function (t, n, e) {
  "use strict";
  var i = /[^\0-\u007E]/,
    a = /[.\u3002\uFF0E\uFF61]/g,
    r = "Overflow: input needs wider integers to process",
    o = Math.floor,
    l = String.fromCharCode,
    c = function (t) {
      return t + 22 + 75 * (t < 26)
    },
    s = function (t, n, e) {
      var i = 0;
      for (t = e ? o(t / 700) : t >> 1, t += o(t / n); t > 455; i += 36) t = o(t / 35);
      return o(i + 36 * t / (t + 38))
    },
    h = function (t) {
      var n, e, i = [],
        a = (t = function (t) {
          for (var n = [], e = 0, i = t.length; e < i;) {
            var a = t.charCodeAt(e++);
            if (a >= 55296 && a <= 56319 && e < i) {
              var r = t.charCodeAt(e++);
              56320 == (64512 & r) ? n.push(((1023 & a) << 10) + (1023 & r) + 65536) : (n.push(a), e--)
            } else n.push(a)
          }
          return n
        }(t)).length,
        h = 128,
        u = 0,
        f = 72;
      for (n = 0; n < t.length; n++)(e = t[n]) < 128 && i.push(l(e));
      var v = i.length,
        p = v;
      for (v && i.push("-"); p < a;) {
        var g = 2147483647;
        for (n = 0; n < t.length; n++)(e = t[n]) >= h && e < g && (g = e);
        var d = p + 1;
        if (g - h > o((2147483647 - u) / d)) throw RangeError(r);
        for (u += (g - h) * d, h = g, n = 0; n < t.length; n++) {
          if ((e = t[n]) < h && ++u > 2147483647) throw RangeError(r);
          if (e == h) {
            for (var m = u, F = 36;; F += 36) {
              var M = F <= f ? 1 : F >= f + 26 ? 26 : F - f;
              if (m < M) break;
              var w = m - M,
                z = 36 - M;
              i.push(l(c(M + w % z))), m = o(w / z)
            }
            i.push(l(c(m))), f = s(u, d, p == v), u = 0, ++p
          }
        }++u, ++h
      }
      return i.join("")
    };
  t.exports = function (t) {
    var n, e, r = [],
      o = t.toLowerCase().replace(a, ".").split(".");
    for (n = 0; n < o.length; n++) e = o[n], r.push(i.test(e) ? "xn--" + h(e) : e);
    return r.join(".")
  }
}, function (t, n, e) {
  var i = e(4),
    a = e(62);
  t.exports = function (t) {
    var n = a(t);
    if ("function" != typeof n) throw TypeError(String(t) + " is not iterable");
    return i(n.call(t))
  }
}, function (t, n, e) {
  "use strict";
  e(0)({
    target: "URL",
    proto: !0,
    enumerable: !0
  }, {
    toJSON: function () {
      return URL.prototype.toString.call(this)
    }
  })
}, function (t, n, e) {
  var i = function (t) {
    "use strict";
    var n = Object.prototype,
      e = n.hasOwnProperty,
      i = "function" == typeof Symbol ? Symbol : {},
      a = i.iterator || "@@iterator",
      r = i.asyncIterator || "@@asyncIterator",
      o = i.toStringTag || "@@toStringTag";

    function l(t, n, e) {
      return Object.defineProperty(t, n, {
        value: e,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), t[n]
    }
    try {
      l({}, "")
    } catch (t) {
      l = function (t, n, e) {
        return t[n] = e
      }
    }

    function c(t, n, e, i) {
      var a = n && n.prototype instanceof u ? n : u,
        r = Object.create(a.prototype),
        o = new A(i || []);
      return r._invoke = function (t, n, e) {
        var i = "suspendedStart";
        return function (a, r) {
          if ("executing" === i) throw new Error("Generator is already running");
          if ("completed" === i) {
            if ("throw" === a) throw r;
            return H()
          }
          for (e.method = a, e.arg = r;;) {
            var o = e.delegate;
            if (o) {
              var l = w(o, e);
              if (l) {
                if (l === h) continue;
                return l
              }
            }
            if ("next" === e.method) e.sent = e._sent = e.arg;
            else if ("throw" === e.method) {
              if ("suspendedStart" === i) throw i = "completed", e.arg;
              e.dispatchException(e.arg)
            } else "return" === e.method && e.abrupt("return", e.arg);
            i = "executing";
            var c = s(t, n, e);
            if ("normal" === c.type) {
              if (i = e.done ? "completed" : "suspendedYield", c.arg === h) continue;
              return {
                value: c.arg,
                done: e.done
              }
            }
            "throw" === c.type && (i = "completed", e.method = "throw", e.arg = c.arg)
          }
        }
      }(t, e, o), r
    }

    function s(t, n, e) {
      try {
        return {
          type: "normal",
          arg: t.call(n, e)
        }
      } catch (t) {
        return {
          type: "throw",
          arg: t
        }
      }
    }
    t.wrap = c;
    var h = {};

    function u() {}

    function f() {}

    function v() {}
    var p = {};
    l(p, a, (function () {
      return this
    }));
    var g = Object.getPrototypeOf,
      d = g && g(g(U([])));
    d && d !== n && e.call(d, a) && (p = d);
    var m = v.prototype = u.prototype = Object.create(p);

    function F(t) {
      ["next", "throw", "return"].forEach((function (n) {
        l(t, n, (function (t) {
          return this._invoke(n, t)
        }))
      }))
    }

    function M(t, n) {
      var i;
      this._invoke = function (a, r) {
        function o() {
          return new n((function (i, o) {
            ! function i(a, r, o, l) {
              var c = s(t[a], t, r);
              if ("throw" !== c.type) {
                var h = c.arg,
                  u = h.value;
                return u && "object" == typeof u && e.call(u, "__await") ? n.resolve(u.__await).then((function (t) {
                  i("next", t, o, l)
                }), (function (t) {
                  i("throw", t, o, l)
                })) : n.resolve(u).then((function (t) {
                  h.value = t, o(h)
                }), (function (t) {
                  return i("throw", t, o, l)
                }))
              }
              l(c.arg)
            }(a, r, i, o)
          }))
        }
        return i = i ? i.then(o, o) : o()
      }
    }

    function w(t, n) {
      var e = t.iterator[n.method];
      if (void 0 === e) {
        if (n.delegate = null, "throw" === n.method) {
          if (t.iterator.return && (n.method = "return", n.arg = void 0, w(t, n), "throw" === n.method)) return h;
          n.method = "throw", n.arg = new TypeError("The iterator does not provide a 'throw' method")
        }
        return h
      }
      var i = s(e, t.iterator, n.arg);
      if ("throw" === i.type) return n.method = "throw", n.arg = i.arg, n.delegate = null, h;
      var a = i.arg;
      return a ? a.done ? (n[t.resultName] = a.value, n.next = t.nextLoc, "return" !== n.method && (n.method = "next", n.arg = void 0), n.delegate = null, h) : a : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, h)
    }

    function z(t) {
      var n = {
        tryLoc: t[0]
      };
      1 in t && (n.catchLoc = t[1]), 2 in t && (n.finallyLoc = t[2], n.afterLoc = t[3]), this.tryEntries.push(n)
    }

    function y(t) {
      var n = t.completion || {};
      n.type = "normal", delete n.arg, t.completion = n
    }

    function A(t) {
      this.tryEntries = [{
        tryLoc: "root"
      }], t.forEach(z, this), this.reset(!0)
    }

    function U(t) {
      if (t) {
        var n = t[a];
        if (n) return n.call(t);
        if ("function" == typeof t.next) return t;
        if (!isNaN(t.length)) {
          var i = -1,
            r = function n() {
              for (; ++i < t.length;)
                if (e.call(t, i)) return n.value = t[i], n.done = !1, n;
              return n.value = void 0, n.done = !0, n
            };
          return r.next = r
        }
      }
      return {
        next: H
      }
    }

    function H() {
      return {
        value: void 0,
        done: !0
      }
    }
    return f.prototype = v, l(m, "constructor", v), l(v, "constructor", f), f.displayName = l(v, o, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
      var n = "function" == typeof t && t.constructor;
      return !!n && (n === f || "GeneratorFunction" === (n.displayName || n.name))
    }, t.mark = function (t) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(t, v) : (t.__proto__ = v, l(t, o, "GeneratorFunction")), t.prototype = Object.create(m), t
    }, t.awrap = function (t) {
      return {
        __await: t
      }
    }, F(M.prototype), l(M.prototype, r, (function () {
      return this
    })), t.AsyncIterator = M, t.async = function (n, e, i, a, r) {
      void 0 === r && (r = Promise);
      var o = new M(c(n, e, i, a), r);
      return t.isGeneratorFunction(e) ? o : o.next().then((function (t) {
        return t.done ? t.value : o.next()
      }))
    }, F(m), l(m, o, "Generator"), l(m, a, (function () {
      return this
    })), l(m, "toString", (function () {
      return "[object Generator]"
    })), t.keys = function (t) {
      var n = [];
      for (var e in t) n.push(e);
      return n.reverse(),
        function e() {
          for (; n.length;) {
            var i = n.pop();
            if (i in t) return e.value = i, e.done = !1, e
          }
          return e.done = !0, e
        }
    }, t.values = U, A.prototype = {
      constructor: A,
      reset: function (t) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(y), !t)
          for (var n in this) "t" === n.charAt(0) && e.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = void 0)
      },
      stop: function () {
        this.done = !0;
        var t = this.tryEntries[0].completion;
        if ("throw" === t.type) throw t.arg;
        return this.rval
      },
      dispatchException: function (t) {
        if (this.done) throw t;
        var n = this;

        function i(e, i) {
          return o.type = "throw", o.arg = t, n.next = e, i && (n.method = "next", n.arg = void 0), !!i
        }
        for (var a = this.tryEntries.length - 1; a >= 0; --a) {
          var r = this.tryEntries[a],
            o = r.completion;
          if ("root" === r.tryLoc) return i("end");
          if (r.tryLoc <= this.prev) {
            var l = e.call(r, "catchLoc"),
              c = e.call(r, "finallyLoc");
            if (l && c) {
              if (this.prev < r.catchLoc) return i(r.catchLoc, !0);
              if (this.prev < r.finallyLoc) return i(r.finallyLoc)
            } else if (l) {
              if (this.prev < r.catchLoc) return i(r.catchLoc, !0)
            } else {
              if (!c) throw new Error("try statement without catch or finally");
              if (this.prev < r.finallyLoc) return i(r.finallyLoc)
            }
          }
        }
      },
      abrupt: function (t, n) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var a = this.tryEntries[i];
          if (a.tryLoc <= this.prev && e.call(a, "finallyLoc") && this.prev < a.finallyLoc) {
            var r = a;
            break
          }
        }
        r && ("break" === t || "continue" === t) && r.tryLoc <= n && n <= r.finallyLoc && (r = null);
        var o = r ? r.completion : {};
        return o.type = t, o.arg = n, r ? (this.method = "next", this.next = r.finallyLoc, h) : this.complete(o)
      },
      complete: function (t, n) {
        if ("throw" === t.type) throw t.arg;
        return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && n && (this.next = n), h
      },
      finish: function (t) {
        for (var n = this.tryEntries.length - 1; n >= 0; --n) {
          var e = this.tryEntries[n];
          if (e.finallyLoc === t) return this.complete(e.completion, e.afterLoc), y(e), h
        }
      },
      catch: function (t) {
        for (var n = this.tryEntries.length - 1; n >= 0; --n) {
          var e = this.tryEntries[n];
          if (e.tryLoc === t) {
            var i = e.completion;
            if ("throw" === i.type) {
              var a = i.arg;
              y(e)
            }
            return a
          }
        }
        throw new Error("illegal catch attempt")
      },
      delegateYield: function (t, n, e) {
        return this.delegate = {
          iterator: U(t),
          resultName: n,
          nextLoc: e
        }, "next" === this.method && (this.arg = void 0), h
      }
    }, t
  }(t.exports);
  try {
    regeneratorRuntime = i
  } catch (t) {
    "object" == typeof globalThis ? globalThis.regeneratorRuntime = i : Function("r", "regeneratorRuntime = r")(i)
  }
}, , , , , , , , , function (t, n, e) {
  "use strict";
  e.r(n);
  var i = {};
  e.r(i), e.d(i, "AC", (function () {
    return o
  })), e.d(i, "AD", (function () {
    return l
  })), e.d(i, "AE", (function () {
    return c
  })), e.d(i, "AF", (function () {
    return s
  })), e.d(i, "AG", (function () {
    return h
  })), e.d(i, "AI", (function () {
    return u
  })), e.d(i, "AL", (function () {
    return f
  })), e.d(i, "AM", (function () {
    return v
  })), e.d(i, "AO", (function () {
    return p
  })), e.d(i, "AQ", (function () {
    return g
  })), e.d(i, "AR", (function () {
    return d
  })), e.d(i, "AS", (function () {
    return m
  })), e.d(i, "AT", (function () {
    return F
  })), e.d(i, "AU", (function () {
    return M
  })), e.d(i, "AW", (function () {
    return w
  })), e.d(i, "AX", (function () {
    return z
  })), e.d(i, "AZ", (function () {
    return y
  })), e.d(i, "BA", (function () {
    return A
  })), e.d(i, "BB", (function () {
    return U
  })), e.d(i, "BD", (function () {
    return H
  })), e.d(i, "BE", (function () {
    return x
  })), e.d(i, "BF", (function () {
    return E
  })), e.d(i, "BG", (function () {
    return S
  })), e.d(i, "BH", (function () {
    return B
  })), e.d(i, "BI", (function () {
    return D
  })), e.d(i, "BJ", (function () {
    return b
  })), e.d(i, "BL", (function () {
    return N
  })), e.d(i, "BM", (function () {
    return j
  })), e.d(i, "BN", (function () {
    return L
  })), e.d(i, "BO", (function () {
    return C
  })), e.d(i, "BQ", (function () {
    return T
  })), e.d(i, "BR", (function () {
    return I
  })), e.d(i, "BS", (function () {
    return R
  })), e.d(i, "BT", (function () {
    return V
  })), e.d(i, "BV", (function () {
    return k
  })), e.d(i, "BW", (function () {
    return O
  })), e.d(i, "BY", (function () {
    return P
  })), e.d(i, "BZ", (function () {
    return G
  })), e.d(i, "CA", (function () {
    return K
  })), e.d(i, "CC", (function () {
    return W
  })), e.d(i, "CD", (function () {
    return _
  })), e.d(i, "CF", (function () {
    return Y
  })), e.d(i, "CG", (function () {
    return Z
  })), e.d(i, "CH", (function () {
    return J
  })), e.d(i, "CI", (function () {
    return q
  })), e.d(i, "CK", (function () {
    return X
  })), e.d(i, "CL", (function () {
    return Q
  })), e.d(i, "CM", (function () {
    return tt
  })), e.d(i, "CN", (function () {
    return nt
  })), e.d(i, "CO", (function () {
    return et
  })), e.d(i, "CR", (function () {
    return it
  })), e.d(i, "CU", (function () {
    return at
  })), e.d(i, "CV", (function () {
    return rt
  })), e.d(i, "CW", (function () {
    return ot
  })), e.d(i, "CX", (function () {
    return lt
  })), e.d(i, "CY", (function () {
    return ct
  })), e.d(i, "CZ", (function () {
    return st
  })), e.d(i, "DE", (function () {
    return ht
  })), e.d(i, "DJ", (function () {
    return ut
  })), e.d(i, "DK", (function () {
    return ft
  })), e.d(i, "DM", (function () {
    return vt
  })), e.d(i, "DO", (function () {
    return pt
  })), e.d(i, "DZ", (function () {
    return gt
  })), e.d(i, "EC", (function () {
    return dt
  })), e.d(i, "EE", (function () {
    return mt
  })), e.d(i, "EG", (function () {
    return Ft
  })), e.d(i, "EH", (function () {
    return Mt
  })), e.d(i, "ER", (function () {
    return wt
  })), e.d(i, "ES", (function () {
    return zt
  })), e.d(i, "ET", (function () {
    return yt
  })), e.d(i, "FI", (function () {
    return At
  })), e.d(i, "FJ", (function () {
    return Ut
  })), e.d(i, "FK", (function () {
    return Ht
  })), e.d(i, "FM", (function () {
    return xt
  })), e.d(i, "FO", (function () {
    return Et
  })), e.d(i, "FR", (function () {
    return St
  })), e.d(i, "GA", (function () {
    return Bt
  })), e.d(i, "GB", (function () {
    return Dt
  })), e.d(i, "GD", (function () {
    return bt
  })), e.d(i, "GE", (function () {
    return Nt
  })), e.d(i, "GF", (function () {
    return jt
  })), e.d(i, "GG", (function () {
    return Lt
  })), e.d(i, "GH", (function () {
    return Ct
  })), e.d(i, "GI", (function () {
    return Tt
  })), e.d(i, "GL", (function () {
    return It
  })), e.d(i, "GM", (function () {
    return Rt
  })), e.d(i, "GN", (function () {
    return Vt
  })), e.d(i, "GP", (function () {
    return kt
  })), e.d(i, "GQ", (function () {
    return Ot
  })), e.d(i, "GR", (function () {
    return Pt
  })), e.d(i, "GS", (function () {
    return Gt
  })), e.d(i, "GT", (function () {
    return Kt
  })), e.d(i, "GU", (function () {
    return Wt
  })), e.d(i, "GW", (function () {
    return _t
  })), e.d(i, "GY", (function () {
    return Yt
  })), e.d(i, "HK", (function () {
    return Zt
  })), e.d(i, "HM", (function () {
    return Jt
  })), e.d(i, "HN", (function () {
    return qt
  })), e.d(i, "HR", (function () {
    return Xt
  })), e.d(i, "HT", (function () {
    return $t
  })), e.d(i, "HU", (function () {
    return Qt
  })), e.d(i, "ID", (function () {
    return tn
  })), e.d(i, "IE", (function () {
    return nn
  })), e.d(i, "IL", (function () {
    return en
  })), e.d(i, "IM", (function () {
    return an
  })), e.d(i, "IN", (function () {
    return rn
  })), e.d(i, "IO", (function () {
    return on
  })), e.d(i, "IQ", (function () {
    return ln
  })), e.d(i, "IR", (function () {
    return cn
  })), e.d(i, "IS", (function () {
    return sn
  })), e.d(i, "IT", (function () {
    return hn
  })), e.d(i, "JE", (function () {
    return un
  })), e.d(i, "JM", (function () {
    return fn
  })), e.d(i, "JO", (function () {
    return vn
  })), e.d(i, "JP", (function () {
    return pn
  })), e.d(i, "KE", (function () {
    return gn
  })), e.d(i, "KG", (function () {
    return dn
  })), e.d(i, "KH", (function () {
    return mn
  })), e.d(i, "KI", (function () {
    return Fn
  })), e.d(i, "KM", (function () {
    return Mn
  })), e.d(i, "KN", (function () {
    return wn
  })), e.d(i, "KP", (function () {
    return zn
  })), e.d(i, "KR", (function () {
    return yn
  })), e.d(i, "KW", (function () {
    return An
  })), e.d(i, "KY", (function () {
    return Un
  })), e.d(i, "KZ", (function () {
    return Hn
  })), e.d(i, "LA", (function () {
    return xn
  })), e.d(i, "LB", (function () {
    return En
  })), e.d(i, "LC", (function () {
    return Sn
  })), e.d(i, "LI", (function () {
    return Bn
  })), e.d(i, "LK", (function () {
    return Dn
  })), e.d(i, "LR", (function () {
    return bn
  })), e.d(i, "LS", (function () {
    return Nn
  })), e.d(i, "LT", (function () {
    return jn
  })), e.d(i, "LU", (function () {
    return Ln
  })), e.d(i, "LV", (function () {
    return Cn
  })), e.d(i, "LY", (function () {
    return Tn
  })), e.d(i, "MA", (function () {
    return In
  })), e.d(i, "MC", (function () {
    return Rn
  })), e.d(i, "MD", (function () {
    return Vn
  })), e.d(i, "ME", (function () {
    return kn
  })), e.d(i, "MF", (function () {
    return On
  })), e.d(i, "MG", (function () {
    return Pn
  })), e.d(i, "MH", (function () {
    return Gn
  })), e.d(i, "MK", (function () {
    return Kn
  })), e.d(i, "ML", (function () {
    return Wn
  })), e.d(i, "MM", (function () {
    return _n
  })), e.d(i, "MN", (function () {
    return Yn
  })), e.d(i, "MO", (function () {
    return Zn
  })), e.d(i, "MP", (function () {
    return Jn
  })), e.d(i, "MQ", (function () {
    return qn
  })), e.d(i, "MR", (function () {
    return Xn
  })), e.d(i, "MS", (function () {
    return $n
  })), e.d(i, "MT", (function () {
    return Qn
  })), e.d(i, "MU", (function () {
    return te
  })), e.d(i, "MV", (function () {
    return ne
  })), e.d(i, "MW", (function () {
    return ee
  })), e.d(i, "MX", (function () {
    return ie
  })), e.d(i, "MY", (function () {
    return ae
  })), e.d(i, "MZ", (function () {
    return re
  })), e.d(i, "NA", (function () {
    return oe
  })), e.d(i, "NC", (function () {
    return le
  })), e.d(i, "NE", (function () {
    return ce
  })), e.d(i, "NF", (function () {
    return se
  })), e.d(i, "NG", (function () {
    return he
  })), e.d(i, "NI", (function () {
    return ue
  })), e.d(i, "NL", (function () {
    return fe
  })), e.d(i, "NO", (function () {
    return ve
  })), e.d(i, "NP", (function () {
    return pe
  })), e.d(i, "NR", (function () {
    return ge
  })), e.d(i, "NU", (function () {
    return de
  })), e.d(i, "NZ", (function () {
    return me
  })), e.d(i, "OM", (function () {
    return Fe
  })), e.d(i, "PA", (function () {
    return Me
  })), e.d(i, "PE", (function () {
    return we
  })), e.d(i, "PF", (function () {
    return ze
  })), e.d(i, "PG", (function () {
    return ye
  })), e.d(i, "PH", (function () {
    return Ae
  })), e.d(i, "PK", (function () {
    return Ue
  })), e.d(i, "PL", (function () {
    return He
  })), e.d(i, "PM", (function () {
    return xe
  })), e.d(i, "PN", (function () {
    return Ee
  })), e.d(i, "PR", (function () {
    return Se
  })), e.d(i, "PS", (function () {
    return Be
  })), e.d(i, "PT", (function () {
    return De
  })), e.d(i, "PW", (function () {
    return be
  })), e.d(i, "PY", (function () {
    return Ne
  })), e.d(i, "QA", (function () {
    return je
  })), e.d(i, "RE", (function () {
    return Le
  })), e.d(i, "RO", (function () {
    return Ce
  })), e.d(i, "RS", (function () {
    return Te
  })), e.d(i, "RU", (function () {
    return Ie
  })), e.d(i, "RW", (function () {
    return Re
  })), e.d(i, "SA", (function () {
    return Ve
  })), e.d(i, "SB", (function () {
    return ke
  })), e.d(i, "SC", (function () {
    return Oe
  })), e.d(i, "SD", (function () {
    return Pe
  })), e.d(i, "SE", (function () {
    return Ge
  })), e.d(i, "SG", (function () {
    return Ke
  })), e.d(i, "SH", (function () {
    return We
  })), e.d(i, "SI", (function () {
    return _e
  })), e.d(i, "SJ", (function () {
    return Ye
  })), e.d(i, "SK", (function () {
    return Ze
  })), e.d(i, "SL", (function () {
    return Je
  })), e.d(i, "SM", (function () {
    return qe
  })), e.d(i, "SN", (function () {
    return Xe
  })), e.d(i, "SO", (function () {
    return $e
  })), e.d(i, "SR", (function () {
    return Qe
  })), e.d(i, "SS", (function () {
    return ti
  })), e.d(i, "ST", (function () {
    return ni
  })), e.d(i, "SV", (function () {
    return ei
  })), e.d(i, "SX", (function () {
    return ii
  })), e.d(i, "SY", (function () {
    return ai
  })), e.d(i, "SZ", (function () {
    return ri
  })), e.d(i, "TA", (function () {
    return oi
  })), e.d(i, "TC", (function () {
    return li
  })), e.d(i, "TD", (function () {
    return ci
  })), e.d(i, "TF", (function () {
    return si
  })), e.d(i, "TG", (function () {
    return hi
  })), e.d(i, "TH", (function () {
    return ui
  })), e.d(i, "TJ", (function () {
    return fi
  })), e.d(i, "TK", (function () {
    return vi
  })), e.d(i, "TL", (function () {
    return pi
  })), e.d(i, "TM", (function () {
    return gi
  })), e.d(i, "TN", (function () {
    return di
  })), e.d(i, "TO", (function () {
    return mi
  })), e.d(i, "TR", (function () {
    return Fi
  })), e.d(i, "TT", (function () {
    return Mi
  })), e.d(i, "TV", (function () {
    return wi
  })), e.d(i, "TW", (function () {
    return zi
  })), e.d(i, "TZ", (function () {
    return yi
  })), e.d(i, "UA", (function () {
    return Ai
  })), e.d(i, "UG", (function () {
    return Ui
  })), e.d(i, "US", (function () {
    return Hi
  })), e.d(i, "UY", (function () {
    return xi
  })), e.d(i, "UZ", (function () {
    return Ei
  })), e.d(i, "VA", (function () {
    return Si
  })), e.d(i, "VC", (function () {
    return Bi
  })), e.d(i, "VE", (function () {
    return Di
  })), e.d(i, "VG", (function () {
    return bi
  })), e.d(i, "VI", (function () {
    return Ni
  })), e.d(i, "VN", (function () {
    return ji
  })), e.d(i, "VU", (function () {
    return Li
  })), e.d(i, "WF", (function () {
    return Ci
  })), e.d(i, "WS", (function () {
    return Ti
  })), e.d(i, "XK", (function () {
    return Ii
  })), e.d(i, "YE", (function () {
    return Ri
  })), e.d(i, "YT", (function () {
    return Vi
  })), e.d(i, "ZA", (function () {
    return ki
  })), e.d(i, "ZM", (function () {
    return Oi
  })), e.d(i, "ZW", (function () {
    return Pi
  }));
  e(166), e(407);
  var a = e(87),
    r = e(164),
    o = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#0052B4" d="M0 0h513v342H0z"/><path fill="#FFF" d="M440.1 181.1c-.1 39.2-6.4 81.4-57.4 101.5-51.1-20.1-57.3-62.3-57.4-101.5h114.8z"/><path fill="#29DBFF" d="M439.6 197.7c-2.8 34.9-12.4 67.4-57 85-44.4-17.6-54.5-51.2-56.9-84.9"/><path fill="#FFF" d="M437.8 214.1c-3.2 24.3-16.7 53.5-55.1 68.6-38.4-15.1-50.5-42.5-55.1-68.4"/><path fill="#29DBFF" d="M434.2 230.3c-5.7 17.7-19.3 39.4-51.3 52.8-32-12.6-45.2-33.8-51.4-53"/><path fill="#FFF" d="M426.7 246.9c-6.5 11.3-17.7 25.4-44 35.9-27.5-11.5-37.4-25.3-44-36.1"/><path fill="#29DBFF" d="M412.4 265.1c-8.1 7.2-12 11.2-29.6 17.9-20.1-7.9-22.6-11.6-29.2-17.5"/><path fill="#5CC85C" d="M383.3 231.6c-.2-.2-27.9 35.7-27.9 35.7-1.8-1.3-10-9.5-13.3-15l41.3-50.1 40.2 49.7c-3.9 6.5-11.4 13.6-13.2 15M382.6 85.3l-26.5 45h53z"/><ellipse transform="rotate(-82.3 291.431 225.686)" fill="#F7A226" cx="291.4" cy="225.7" rx="48.7" ry="15.7"/><ellipse transform="rotate(-68.099 303.087 164.67)" fill="#DDC7AB" cx="303.1" cy="164.7" rx="11.7" ry="7.2"/><ellipse transform="rotate(-81.738 291.697 271.697)" fill="#DDC7AB" cx="291.7" cy="271.7" rx="11.4" ry="3.3"/><ellipse transform="matrix(.9986 -.05353 .05353 .9986 -13.992 16.424)" fill="#DDC7AB" cx="299.6" cy="269.4" rx="3.3" ry="11"/><ellipse transform="rotate(-21.518 314.54 201.06)" fill="#DDC7AB" cx="314.5" cy="201.1" rx="4.1" ry="13.7"/><ellipse transform="rotate(-21.518 317.511 178.077)" fill="#DDC7AB" cx="317.5" cy="178.1" rx="13.7" ry="4.1"/><ellipse transform="rotate(-7.7 473.781 225.857)" fill="#F7A226" cx="473.6" cy="225.9" rx="15.7" ry="48.7"/><ellipse transform="rotate(-21.901 462.057 164.866)" fill="#DDC7AB" cx="462" cy="164.9" rx="7.2" ry="11.7"/><ellipse transform="rotate(-8.27 473.27 271.908)" fill="#DDC7AB" cx="473.4" cy="271.9" rx="3.3" ry="11.4"/><ellipse transform="matrix(.05353 -.9986 .9986 .05353 171.34 719.998)" fill="#DDC7AB" cx="465.5" cy="269.6" rx="11" ry="3.3"/><ellipse transform="rotate(-68.482 450.552 201.247)" fill="#DDC7AB" cx="450.6" cy="201.2" rx="13.7" ry="4.1"/><ellipse transform="rotate(-68.482 447.58 178.265)" fill="#DDC7AB" cx="447.6" cy="178.3" rx="4.1" ry="13.7"/><path fill="#B0C6CC" d="M373.3 130.3 356.1 155l17.8 26.1H396l4.7-25.4-5.4-25.4z"/><path fill="#FFF" d="M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z"/><path fill="#D80027" d="M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"/><path fill="#2E52B2" d="M256 22.7v30.7h-46.1z"/><g><path fill="#D80027" d="M0 170.7v-11l62.5-42.3h22.6L7.3 170.7z"/></g><path fill="#D80027" d="m7.3.1 77.8 53.2H62.5L0 11.1V.1zM256 .1v11l-62.5 42.3h-22.6L248.7.1zM248.7 170.7l-77.8-53.3h22.6l62.5 42.3v11z"/></svg>',
    l = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><style></style><path fill="#FFDA44" d="M0 0h513v342H0z"/><path fill="#0052B4" d="M0 0h171v342H0z"/><path fill="#D80027" d="M342 0h171v342H342zM198.9 113.6H256v64.8h-57.1z"/><g stroke="#D80027" stroke-width="7"><path d="M267.6 113.6v64.7M284.2 113.6v64.7M300.8 113.6v64.7"/></g><g stroke="#D80027" stroke-width="5"><path d="M247.4 178.4v64.7M234.1 178.4v64.7M220.8 178.5v53.9M207.1 178.5v47.1"/></g><path fill="#FFDA44" d="m199.9 146 27.6-32.4 28.5 32.3-28.1 32.4z"/><path fill="#BC8B00" d="M182.2 95.9v92.2c0 34.3 27.3 54.2 48.6 64.5-.8 1.4 25.1 8.3 25.1 8.3s25.9-6.9 25.1-8.3c21.4-10.3 48.6-30.1 48.6-64.5V95.9H182.2zm129.9 92.2c0 16.9-10 29.4-32.8 43.9-8.6 5.5-17.5 9-23.3 11-5.8-2-14.7-5.5-23.3-11-22.8-14.5-32.8-28-32.8-43.9v-74.5h112.2v74.5z"/><path fill="#D80027" d="M264.4 188.9h29.5v8.6h-29.5zM264.4 206.5h29.5v8.6h-29.5z"/></svg>',
    c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#FFF" d="M0 0h513v342H0z"/><path fill="#009e49" d="M0 0h513v114H0z"/><path d="M0 228h513v114H0z"/><path fill="#ce1126" d="M0 0h171v342H0z"/></svg>',
    s = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#DB3E00" d="M0 0h513v342H0z"/><path fill="#479900" d="M331 0h182v342H331z"/><path d="M0 0h181.8v342H0z"/><path fill="#FFF" d="M256 126.7c-19.4 0-35.2 15.8-35.2 35.2v52.8h70.4v-52.8c0-19.5-15.8-35.2-35.2-35.2z"/><path fill="#FFF" d="M256 84.3c-47.7 0-86.4 38.7-86.4 86.4S208.3 257 256 257s86.4-38.7 86.4-86.4-38.7-86.3-86.4-86.3zm0 157.7c-39.4 0-71.4-32-71.4-71.4 0-39.4 32-71.4 71.4-71.4 39.4 0 71.4 32 71.4 71.4 0 39.5-32 71.4-71.4 71.4z"/></svg>',
    h = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path d="M0 0h513v342H0z"/><path fill="#0072c6" d="M88.8 136.5c-2.2 12.9-3.4 26.2-3.4 39.8 0 13.6 1.2 27 3.4 39.8L256 228.3l167.2-12.1c2.2-12.9 3.4-26.2 3.4-39.8s-1.2-27-3.4-39.8"/><path fill="#FFF" d="M423.2 219H88.8c15.8 69.8 84.7 122.3 167.2 122.3S407.4 288.8 423.2 219z"/><path fill="#FFDA44" d="M365.9 136.5H146.1l44.9-21.1-23.9-43.5 48.8 9.4L222 32l34 36.2L290 32l6.1 49.3 48.8-9.4-23.9 43.5z"/><g fill="#ce1126"><path d="M256.5 342 0 0v342z"/><path d="M513 342V0L256 342z"/></g></svg>',
    u = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#00318b" d="M0 0h513v342H0z"/><path fill="#FFF" d="M454.8 265.38c7.94-10.93 13.24-24.27 13.24-40.42V104.89a59.754 59.754 0 0 1-36.02 12.01c-19.64 0-37.07-9.43-48.03-24.01-10.95 14.58-28.39 24.01-48.03 24.01-13.52 0-25.99-4.47-36.02-12v120.06c0 16.16 5.3 29.5 13.24 40.42H454.8z"/><path fill="#8DCCFF" d="M310.23 260.98C332.65 296.96 384 309 384 309s51.35-12.04 73.77-48.02H310.23z"/><path fill="#D87B00" d="M396.66 172.21c.32 1.42 8.72 10.17 17.56 20.15 1.39 1.57-8.74 12.63-6.91 12.59 4.75-.12 19.27-17.26 19.34 6.65.05 15.94-30 27.51-30 27.51h17.47l.65 14.96s4.97-13.34 7.59-16.57c8.1-9.97 20.18-30.07 34.59-27.1 14.41 2.97-13.66-13.92-13.66-13.92s-5.2-15.19-16.63-16.97c-10.06-1.57-14.29-2.51-26.64-7.3-1.68-.65-3.88-2.32-3.36 0z"/><path fill="#D87B00" d="M359.69 198.69c1.07-.99 4.46-12.63 8.69-25.28.67-1.99 15.31 1.27 14.35-.3-2.47-4.06-24.58-8.08-3.9-20.08 13.79-8 38.82 12.27 38.82 12.27l-8.72-15.14 12.64-8.03s-14.05 2.35-18.14 1.69c-12.68-2.04-36.13-2.48-40.75-16.45-4.62-13.97-5.25 18.79-5.25 18.79s-10.56 12.08-6.4 22.88c3.66 9.5 4.96 13.64 6.97 26.73.29 1.79-.06 4.53 1.69 2.92z"/><path fill="#D87B00" d="M395.67 219.87c-1.39-.43-13.16 2.49-26.22 5.18-2.06.42-6.59-13.88-7.47-12.26-2.27 4.17 5.36 25.31-15.41 13.45-13.84-7.91-8.89-39.73-8.89-39.73l-8.71 15.14-13.29-6.9s9.09 10.96 10.57 14.84c4.6 11.99 16 32.49 6.24 43.49-9.76 11.01 18.88-4.9 18.88-4.9s15.76 3.07 23-5.96c6.38-7.94 9.3-11.14 19.61-19.45 1.43-1.12 3.97-2.19 1.69-2.9z"/><path fill="#FFF" d="M256.5 0h-23.1L160 48.9V0H96v48.9L22.6 0H0v22.7l46.1 30.7H0v64h46.1L0 148.1V171h22.6L96 121.8V171h64v-49.2l73.4 49.2h23.1v-22.9l-46.6-30.7h46.6v-64h-46.6l46.6-30.7z"/><path fill="#D80027" d="M144 0h-32v69.4H0v32h112V171h32v-69.6h112.5v-32H144z"/><path fill="#D80027" d="M0 171v-11.3l62.5-42.3h22.6L7.3 171zM7.3.1l77.8 53.2H62.5L0 11.1V.1zM256.5.1v11l-63 42.3h-22.6L248.7.1zM248.7 171l-77.8-53.6h22.6l63 42.3V171z"/></svg>',
    f = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 60"><path fill="#ED2024" d="M0 0h90v60H0z"/><path fill="#212121" d="M32.5 12.2v16l7.1 2.5-5 4.9 2.4 3 5.3-5.5 1.2 2.3-3 4.9 3.6 5.6-1.8 2.6 2.8 3.6 2.7-3.7-1.5-2.6 3-5.8-2.7-4.6 1.2-2.3 5.2 5.5 2.5-2.9-5.2-5.1 7.2-2.6V12.2l-5.2 1.9-.1 3.8-3.3.3v-2.6l1.7-2.3 5.6-2.2-2.3-.4 1.4-1.2.9.4-.8-1.4L54 9l-1-1.1L47.5 9l1.4 1.1-3.8 4.9-3.8-4.8 1.3-1.1-5-1.2L36.2 9l-1.5-.4-.8 1.4.9-.6 1.6 1.1-2.3.5 5.5 2 1.6 2.3v2.9l-3.3-.3v-3.6z"/><g fill="#212121"><path d="M26.2 25h6.4v2.5h-6.4zM26.2 20.9h6.4v2.7h-6.4zM26.2 16.7h6.4v2.6h-6.4zM26.2 12.7h6.4v2.5h-6.4z"/></g><g fill="#212121"><path d="M57.4 25h6.4v2.5h-6.4zM57.4 20.9h6.4v2.7h-6.4zM57.4 16.7h6.4v2.6h-6.4zM57.4 12.7h6.4v2.5h-6.4z"/></g><path fill="#212121" d="M53.4 36.1h6.4V38h-6.4zM30.2 36.1h6.4V38h-6.4z"/></svg>',
    v = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#0052B4" d="M0 0h513v342H0z"/><path fill="#D80027" d="M0 0h513v114H0z"/><path fill="#FF9811" d="M0 228h513v114H0z"/></svg>',
    p = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path d="M0 171h513v171H0z"/><path fill="#D80027" class="st0" d="M0 0h513v171H0z"/><g fill="#FFDA44"><path d="m332.7 135.6 17.5-8.6-7.4-19-18.7 6.2zM287.1 79.6l5.5-18.8-19.1-7.2-8 18zM316.5 102.8l12.2-15.3-14.9-13.9-14.2 13.6zM335.9 171.7l19.5-.8v-21.3l-22.9.2zM323.3 209.8l18.8 5.5 7.3-19-18-8zM294.3 242.2l14.9 12.7 14.4-14.4-13.1-14.7zM247.3 94.5l9.8 19.9 21.9 3.3-15.9 15.5 3.6 21.9-19.6-10.4-19.7 10.2 3.8-21.9-15.8-15.5 22-3.1z"/><path d="m250.8 61.3-2.7 18.3c43.1 3.2 77 39.2 77 83.1 0 46-37.3 82.9-83.4 83.4-29.2.3-51.3-14.8-67-33.7l-13.9 12.3c15 19 40.8 39.9 80.9 39.9 56.3 0 101.9-45.6 101.9-101.9.1-53.2-40.7-96.9-92.8-101.4z"/><path fill="#000" d="m291.9 223.4-11.8 14s51.9 38.9 53.6 40.4c1.7 1.5 5.2 2 9.1-2.7 3.7-4.5 2.8-8.1.9-9.7-2-1.5-51.8-42-51.8-42z"/><path d="M206.1 157.2c-7.7 10.3-7.5 23.1 2.8 30.9 0 0 135.2 101.5 136.9 103 1.7 1.5 5.2 2 9.1-2.7 3.7-4.5 2.8-8.1.9-9.7-1.9-1.5-149.7-121.5-149.7-121.5zM253.8 256.3l7.3 18.2 19.5-6-4.8-19.1zM213.4 252.6l-2 19.5 20.1 3.6 4.5-19.1zM177.7 231.4 167.4 248l16.4 12.1 12.5-15.2z"/></g></svg>',
    g = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 744 496"><path fill="#3A7DCE" d="M0 0h744v496H0V0z"/><path fill="#fff" d="m120 125 90 63 54-14 23-81 61-36 92 14 105 55 6 90 34 12v92l-65 115-78 24-72-17 18-30-8-32-10 9-162-25-49-85 20-46-49-62z"/></svg>',
    d = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#FFF" d="M0 0h512v342H0z"/><path fill="#338AF3" d="M0 0h512v114H0zM0 228h512v114H0z"/><circle fill="#FFDA44" stroke="#d6ab00" stroke-width="5" cx="256.5" cy="171" r="40"/></svg>',
    m = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#10338c" d="M0 0h513v342H0z"/><path fill="#D80027" d="M513 33 95.3 171 513 310.76v30.57L0 171 513 0z"/><path fill="#FFF" d="M513 287.18v24.58L81.72 171 513 30v24.16"/><path fill="#A2001D" d="m476.98 140.21-21.89 10.68-3.18-15.32 31.19-29.77s-9.42-40.65-13.75-44.98l-112.32 55.82-6.84 36.76-31.9 28.59-.4 34.2 34.29-22.76 67.23-2.66-1.51 38.11h22.23l11.9-44.64 31.55-24.61-6.6-19.42z"/><path fill="#EFC100" stroke="#231F20" stroke-miterlimit="10" d="m317.89 238.41-22.24-11.11 22.24-11.11h144.46v22.22z"/></svg>',
    F = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#FFF" d="M0 114h513v114H0z"/><path fill="#D80027" d="M0 0h513v114H0zM0 228h513v114H0z"/></svg>',
    M = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#10338c" d="M0 0h513v342H0z"/><g fill="#FFF"><path d="M222.2 170.7c.3-.3.5-.6.8-.9-.2.3-.5.6-.8.9zM188 212.6l11 22.9 24.7-5.7-11 22.8 19.9 15.8-24.8 5.6.1 25.4-19.9-15.9-19.8 15.9.1-25.4-24.8-5.6 19.9-15.8-11.1-22.8 24.8 5.7zM385.9 241.1l5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6v12.2l-9.4-7.6-9.5 7.6.1-12.2-11.8-2.6 9.5-7.5-5.3-10.9 11.8 2.7zM337.3 125.1l5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6.1-12.1-11.9-2.7 9.5-7.5-5.3-10.9L332 136zM385.9 58.9l5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6.1-12.1-11.8-2.7 9.5-7.5-5.3-10.9 11.8 2.7zM428.4 108.6l5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6V150l-9.4-7.6-9.5 7.6v-12.2l-11.8-2.6 9.5-7.5-5.3-10.9 11.8 2.7zM398 166.5l4.1 12.7h13.3l-10.8 7.8 4.2 12.7-10.8-7.9-10.8 7.9 4.1-12.7-10.7-7.8h13.3z"/><path d="M254.8 0v30.6l-45.1 25.1h45.1V115h-59.1l59.1 32.8v22.9h-26.7l-73.5-40.9v40.9H99v-48.6l-87.4 48.6H-1.2v-30.6L44 115H-1.2V55.7h59.1L-1.2 22.8V0h26.7L99 40.8V0h55.6v48.6L242.1 0z"/></g><path fill="#D80027" d="M142.8 0h-32v69.3h-112v32h112v69.4h32v-69.4h112v-32h-112z"/><path fill="#0052B4" d="m154.6 115 100.2 55.7v-15.8L183 115z"/><path fill="#FFF" d="m154.6 115 100.2 55.7v-15.8L183 115z"/><g fill="#D80027"><path d="m154.6 115 100.2 55.7v-15.8L183 115zM70.7 115l-71.9 39.9v15.8L99 115z"/></g><path fill="#0052B4" d="M99 55.7-1.2 0v15.7l71.9 40z"/><path fill="#FFF" d="M99 55.7-1.2 0v15.7l71.9 40z"/><g fill="#D80027"><path d="M99 55.7-1.2 0v15.7l71.9 40zM183 55.7l71.8-40V0L154.6 55.7z"/></g></svg>',
    w = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 363 242"><path fill="#338AF3" d="M0 0h363v242H0z"/><path fill="#FFF" d="M57 96.9 14.7 78.2 57 59.6l18.6-42.2 18.6 42.2 42.3 18.6-42.3 18.7-18.6 42.2z"/><path fill="#f30028" d="m75.6 40.6 11.5 26.1 26.1 11.5-26.1 11.5-11.5 26.1-11.5-26.1L38 78.2l26.1-11.5z"/><g fill="#FFDA44"><path d="M0 152.2h363v15.7H0zM0 183.6h363v15.7H0z"/></g></svg>',
    z = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#0052B4" d="M0 0h513v342H0z"/><path fill="#FFDA44" d="M513 210.9H202.2V342h-79.8V210.9H0V131.1h122.4V0h79.8v131.1H513v61.2z"/><path fill="#D80027" d="M513 149.7v42.6H183.7V342H141V192.3H0v-42.6h141V0h42.7v149.7z"/></svg>',
    y = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#ef3340" d="M0 0h513v342H0z"/><path fill="#00b5e2" d="M0 0h513v114H0z"/><path fill="#509e2f" d="M0 228h513v114H0z"/><g fill="#FFF"><path d="M265.6 212.6c-23 0-41.6-18.6-41.6-41.6s18.6-41.6 41.6-41.6c7.2 0 13.9 1.8 19.8 5-9.2-9-21.9-14.6-35.8-14.6-28.3 0-51.2 22.9-51.2 51.2s22.9 51.2 51.2 51.2c13.9 0 26.6-5.6 35.8-14.6-5.9 3.2-12.6 5-19.8 5z"/><path d="m297.6 142.2 5.5 15.5 14.9-7.1-7.1 14.9 15.5 5.5-15.5 5.5 7.1 14.9-14.9-7.1-5.5 15.5-5.5-15.5-14.9 7.1 7.1-14.9-15.5-5.5 15.5-5.5-7.1-14.9 14.9 7.1z"/></g></svg>',
    A = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#10338C" d="M0 0h513.1v342H0z"/><path fill="#F6C500" d="M99.9 0h342v342"/><g fill="#FFF"><path d="M19.9 21.1 40.3 6.2 60.9 21 54 0H26.7z"/><path d="M92.3 25.5 84.4 1.3l-7.8 24.2H51.3l20.5 14.8-7.8 24 20.4-14.8L105 64.3l-7.9-24 20.5-14.9z"/><path d="m136.3 69.2-7.8-24-7.8 24H95.5l20.4 14.9-7.8 24 20.4-14.8 20.6 14.8-7.8-24 20.4-14.9z"/><path d="m179.4 112.3-7.8-24.1-7.8 24.1h-25.3l20.5 14.9-7.8 24 20.4-14.8 20.6 14.8-7.9-24 20.5-15z"/><path d="m222.5 155.3-7.8-24-7.8 24h-25.4l20.6 15-7.8 24 20.4-14.9 20.4 14.9-7.8-24 20.6-15z"/><path d="m265.6 198.4-7.8-24-7.8 24h-25.4l20.6 14.9-7.8 24.1 20.4-14.9 20.4 14.9-7.8-24.2 20.5-14.8z"/><path d="m308.7 241.5-7.9-24-7.8 24h-25.3l20.5 14.8-7.9 24.2 20.6-14.9 20.4 14.8-7.8-24.1 20.5-14.8z"/><path d="m351.7 284.6-7.8-24.2-7.8 24.2h-25.3l20.4 14.8-7.8 24.1 20.5-14.9 20.5 14.9-7.8-24.1 20.4-14.8z"/><path d="m387 303.5-7.9 24.1-25.3.1 19.8 14.3h26.6l19.9-14.4h-25.3z"/></g></svg>',
    U = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#ffc726" d="M0 0h513v342H0z"/><g fill="#00267f"><path d="M0 0h171v342H0zM342 0h171v342H342z"/></g><path d="m325.74 101.02-31.97 12.4c-.68 1.35-5.79 7.54-8.18 53.06h-17.05v-60.42L256 78.68l-12.54 27v60.8H226.4c-2.39-45.53-7.8-52.48-8.47-53.84l-31.68-11.63c.15.31 15.4 31.34 15.4 78.01v12.54h41.81v71.07h25.08v-71.07h41.81v-12.54c0-24.13 4.17-44.02 7.68-56.46 3.82-13.57 7.7-21.49 7.74-21.57l-.03.03z"/></svg>',
    H = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 513 342"><path fill="#2d6e41" d="M0 85.331h513v342H0z"/><circle fill="#F40B32" cx="218.902" cy="256.5" r="115"/></svg>',
    x = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#fdda25" d="M0 0h513v342H0z"/><path d="M0 0h171v342H0z"/><path fill="#ef3340" d="M342 0h171v342H342z"/></svg>',
    E = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#3d944f" d="M0 0h513v342H0z"/><path fill="#ef2b2d" d="M0 0h513v171H0z"/><path fill="#FFDA44" d="m256 102.6 16.9 52h54.7l-44.2 32.2 16.8 52-44.2-32.1-44.2 32.1 16.8-52-44.2-32.2h54.7z"/></svg>',
    S = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#00966e" d="M0 85.337h512v341.326H0z"/><path fill="#FFF" d="M0 85.337h512v113.775H0z"/><path fill="#d62612" d="M0 312.888h512v113.775H0z"/></svg>',
    B = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 341.3"><path fill="#D80027" d="M0 0h512v341.3H0z"/><path fill="#FFF" d="m222.8 34.3-85.2 34.2 85.2 34.1-85.2 34.1 85.2 34.1-85.2 34.1 85.2 34.1-85.2 34.1 85.2 34.1-85.2 34.1H0V0h137.6z"/></svg>',
    D = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#D80027" d="M0 0h513v342H0z"/><g fill="#47a644"><path d="M215.9 170.7 0 314.6V26.8zM513 26.8v287.8L297.1 170.7z"/></g><path fill="#0052B4" d="M512 26.8 296.1 170.7 512 314.6v26.7h-40.1L256 197.4 40.1 341.3H0v-26.7l215.9-143.9L0 26.8V0h40.1L256 143.9 471.9 0H512z"/><path fill="#FFF" d="M513 26.8 297.1 170.7 513 314.6V342h-40L256 197.4 39 342H0v-27.4l215.9-143.9L0 26.8V0h40.1L256 143.9 471.9 0H513z"/><circle fill="#FFF" cx="251.6" cy="170.7" r="100.2"/><g fill="#D80027" stroke="#47a644" stroke-width="3"><path d="m251.4 103.6 7.4 12.9h14.8l-7.4 12.8 7.4 12.8h-14.8l-7.4 12.9-7.4-12.9h-14.8l7.4-12.8-7.4-12.8H244zM290.2 170.3l7.4 12.9h14.8L305 196l7.4 12.8h-14.8l-7.4 12.9-7.4-12.9h-14.9l7.4-12.8-7.4-12.8h14.9zM213 170.3l7.4 12.9h14.9l-7.4 12.8 7.4 12.8h-14.9l-7.4 12.9-7.4-12.9h-14.8l7.4-12.8-7.4-12.8h14.8z"/></g></svg>',
    b = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 513 342"><path fill="#008751" d="M0 85.333h513v342H0z"/><path fill="#fcd116" d="M196.666 85.333H513v171H196.666z"/><path fill="#e8112d" d="M196.666 256H513v171H196.666z"/></svg>',
    N = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 341.33"><path fill="#FFF" d="M0 0h512v341.33H0z"/><path fill="#E6BC00" d="M157.31 199.76s-9.04 43.93-19.31 40.39c-10.62-3.54-17.53-18.76-17.53-18.76l-14.52 21.24s38.18 8.48 41.01 5.47c1.22-1.14 8.21-15.1 10.34-26.05v-22.29zm-56.13 60.57s-2.48 20.18-1.06 22.66c1.24 2.3 39.48 11.33 39.48 11.33s-24.96 16.46-29.74 20.54L91.8 284.94l-.71-24.61h10.09zM112.51 94.64s39.65 41.6 40.36 45.5c.71 3.72-4.25 3.19-4.25 3.19s-44.79-37.53-49.92-41.07c-5.31-3.55 13.81-7.62 13.81-7.62z"/><path fill="#ADADAD" d="M99.41 104.73s16.99-.71 16.64-11.51c-.35-10.62-11.15-14.87-19.12-12.39-7.97 2.3-23.01 13.45-13.63 35.05 9.38 21.42 23.37 29.39 26.2 47.8 0 0-5.46 9.86-19.12.35-16.9-11.77-6.2-38.24-10.44-44.96-4.25-7.08-40.95-38.92-40.95-38.92s-30.24 39.37-18 74.92c16.95 49.21 51.74 31.98 64.61 36.76 0 0-42.13 61.96-49.57 67.09 0 0 24.08 8.32 47.8-18.76 0 0 5.84 9.74 7.08 20.18h10.27c4.78-26.2 51.51-64.26 49.92-82.32-1.77-21.25-49.21-49.39-51.69-73.29z"/><path fill="#E6BC00" d="M359.17 201.27s8.96 42.43 19.23 38.89c10.62-3.54 17.53-18.76 17.53-18.76l14.52 21.24s-37 8.48-39.83 5.47c-1.21-1.14-9.32-13.79-11.52-24.66l.07-22.18zm56.05 59.06s2.48 20.18 1.06 22.66c-1.24 2.3-39.48 11.33-39.48 11.33s24.96 16.46 29.74 20.54l18.06-29.92.71-24.61h-10.09zM403.89 94.64s-39.65 41.6-40.36 45.5c-.71 3.72 4.25 3.19 4.25 3.19s44.79-37.53 49.92-41.07c5.14-3.55-13.81-7.62-13.81-7.62z"/><path fill="#125ECC" d="M157.31 87.06H359.1v145.46c0 16.06-9.69 21.39-21.91 31.85l-45.92 39.41c-18.25 15.62-47.91 15.57-66.07 0l-46.01-39.43c-12.08-10.35-21.88-15.71-21.88-31.82V87.06z"/><path fill="#FFE600" d="M200.55 147.71c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zm57.65-3c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zm57.65 3c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zM214.96 274.43c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41c.01 7.96-6.45 14.41-14.41 14.41zm43.24 14.42c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41c0 7.95-6.45 14.41-14.41 14.41zm43.24-14.42c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41z"/><path fill="#D60537" d="M157.31 175.36H359.1v57.65H157.31v-57.65z"/><path fill="#EACE00" d="M142.9 43.82s57.65-14.41 115.31-14.41 115.31 14.41 115.31 14.41l-14.41 57.65s-50.45-14.41-100.89-14.41-100.89 14.41-100.89 14.41L142.9 43.82z"/><path fill="#7A6920" d="M258.2 72.65c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zm57.65 5c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zm-115.3 0c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41z"/><path fill="#ADADAD" d="M365.08 178.02c-1.59 18.06 45.14 56.12 49.92 82.32h10.27c1.24-10.44 7.08-20.18 7.08-20.18 23.72 27.09 47.8 18.76 47.8 18.76-7.44-5.13-49.57-67.09-49.57-67.09 12.88-4.78 47.67 12.45 64.61-36.76 12.24-35.55-18-74.92-18-74.92s-36.7 31.84-40.95 38.92c-4.25 6.73 6.46 33.2-10.44 44.96-13.66 9.51-19.12-.35-19.12-.35 2.83-18.41 16.82-26.38 26.2-47.8 9.38-21.6-5.66-32.75-13.63-35.05-7.97-2.48-18.76 1.77-19.12 12.39-.35 10.8 16.64 11.51 16.64 11.51-2.48 23.9-49.92 52.04-51.69 73.29z"/><circle fill="#FFF" cx="258.2" cy="204.19" r="16.93"/></svg>',
    j = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#c8102e" d="M0 0h513v342H0z"/><path fill="#012169" d="M0 .1h256.5v171H0z"/><path fill="#FFF" d="M256 0h-22.6L160 48.9V0H96v48.9L22.6 0H0v22.7l46.1 30.7H0v64h46.1L0 148.1v22.6h22.6L96 121.8v48.9h64v-48.9l73.4 48.9H256v-22.6l-46.1-30.7H256v-64h-46.1L256 22.7z"/><path fill="#c8102e" d="M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"/><path fill="#c8102e" d="M0 170.7v-11l62.5-42.3h22.6L7.3 170.7zM7.3.1l77.8 53.2H62.5L0 11.1V.1zM256 .1v11l-62.5 42.3h-22.6L248.7.1zM248.7 170.7l-77.8-53.3h22.6l62.5 42.3v11z"/><g transform="translate(13 5)"><path fill="#fff" d="M303.9 94.94v99.69c0 59.81 79.75 99.69 79.75 99.69s79.75-39.88 79.75-99.69V94.94H303.9z"/><path fill="#2F8F22" d="M436.37 254.44H330.93c23.13 25.08 52.72 39.88 52.72 39.88s29.59-14.8 52.72-39.88z"/><circle fill="#65B5D2" cx="383.65" cy="214.56" r="39.88"/><circle fill="#c8102e" cx="343.77" cy="194.63" r="19.94"/><circle fill="#c8102e" cx="423.52" cy="194.63" r="19.94"/><circle fill="#c8102e" cx="383.65" cy="154.75" r="19.94"/></g></svg>',
    L = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 341.33"><path fill="#FFDA44" d="M0 0h512v341.33H0z"/><path d="m0 193.74 512 127.19V214.26L0 97.08z"/><path fill="#FFF" d="M512 234.26v-86.67L0 20.41v86.67"/><g fill="#D80027" stroke="#231F20" stroke-width="3" stroke-miterlimit="10"><path d="M306.4 134.01a50.28 50.28 0 0 1 6.07 24.02c0 21.55-13.51 39.94-32.52 47.19v-59.51c5.7-1.19 10-6.37 10-12.59 6.9 0 12.5-5.75 12.5-12.85h-.42c6.9 0 12.91-5.75 12.91-12.85h-34.99V76.58l-14.99-27.71-15 27.71v30.84h-34.99c0 7.1 6.01 12.85 12.91 12.85h-.42c0 7.1 5.6 12.85 12.5 12.85 0 6.22 4.29 11.4 9.99 12.59v61.37c-22.09-5.39-38.48-25.3-38.48-49.05 0-8.7 2.2-16.88 6.07-24.02-10.96 11.21-17.72 26.53-17.72 43.44 0 34.32 27.82 62.15 62.15 62.15s62.15-27.83 62.15-62.15c0-16.91-6.77-32.24-17.72-43.44z"/><path d="M198.46 226.81s20.69 27.71 66.5 27.71 66.5-27.71 66.5-27.71l13.47 28.37s-21.03 27.71-79.97 27.71-79.97-27.71-79.97-27.71l13.47-28.37zM129.24 133.18h20.88l24.93 27.26v73.45h-26.28v-68.37zM400 133.18h-20.88l-24.93 27.26v73.45h26.27v-68.37z"/></g></svg>',
    C = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#007934" d="M0 85.337h512v341.326H0z"/><path fill="#d52b1e" d="M0 85.337h512v113.775H0z"/><path fill="#f9e300" d="M0 312.888h512v113.775H0z"/></svg>',
    T = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 341.3"><path fill="#FFF" d="M0 0h512v341.3H0z"/><path fill="#012a87" d="M0 341.3h512V0z"/><path fill="#f9d90f" d="M250.4 0H0v166.9z"/><path fill="#dc171d" d="m140.4 118.3 12.2 21.2h24.5l-12.3 21.1 12.3 21.2h-24.5L140.4 203l-12.2-21.2h-24.5l12.3-21.2-12.3-21.1h24.5z"/><circle fill="none" stroke="#000" stroke-width="9" stroke-miterlimit="10" cx="140.4" cy="160.6" r="57.7"/></svg>',
    I = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#009b3a" d="M0 0h513v342H0z"/><path fill="#fedf00" d="m256.5 19.3 204.9 151.4L256.5 322 50.6 170.7z"/><circle fill="#FFF" cx="256.5" cy="171" r="80.4"/><path fill="#002776" d="M215.9 165.7c-13.9 0-27.4 2.1-40.1 6 .6 43.9 36.3 79.3 80.3 79.3 27.2 0 51.3-13.6 65.8-34.3-24.9-31-63.2-51-106-51zM334.9 186c.9-5 1.5-10.1 1.5-15.4 0-44.4-36-80.4-80.4-80.4-33.1 0-61.5 20.1-73.9 48.6 10.9-2.2 22.1-3.4 33.6-3.4 46.8.1 89 19.5 119.2 50.6z"/></svg>',
    R = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#ffc72c" d="M0 85.337h512v341.326H0z"/><g fill="#00778b"><path d="M0 85.337h512v113.775H0zM0 312.888h512v113.775H0z"/></g><path d="M256 256.006 0 426.668V85.331z"/></svg>',
    V = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 341.3"><path fill="#FF7415" d="M0 0h512v341.3H0z"/><path fill="#FFDA44" d="M512 0H0v341.3"/><path fill="none" stroke="#FFF" stroke-width="42" stroke-miterlimit="10" d="M128.7 255.5s35 54 67.3 32.4c56.9-37.9-68.9-108.6-2.9-152.6 58.3-38.8 76.6 103.5 137.6 62.8 59-39.3-64.7-111.4-9.2-148.4 33.4-22.2 67.1 32.6 67.1 32.6"/></svg>',
    k = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 33.333 1100 733.333"><path fill="#ef2b2d" d="M0 0h1100v800H0z"/><path fill="#fff" d="M300 0h200v800H300z"/><path fill="#fff" d="M0 300h1100v200H0z"/><path fill="#002868" d="M350 0h100v800H350z"/><path fill="#002868" d="M0 350h1100v100H0z"/></svg>',
    O = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#FFF" d="M0 0h513v342H0z"/><g fill="#6da9d2"><path d="M0 238h513v104H0zM0 0h513v104H0z"/></g><path d="M0 125.5h513v89.656H0z"/></svg>',
    P = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#007C30" d="M0 0h513v342H0z"/><path fill="#CE1720" d="M0 230h513V0H0"/><path fill="#FFF" d="M100 230V0H0v342h513-413z"/><g fill="#CE1720"><path d="M28 159.6 8.6 128.2 28 97.4l19.3 30.8zM72.6 159.6l-19.3-31.4 19.3-30.8L92 128.2zM28 241.2 8.6 209.8 28 179l19.3 30.8zM72.6 241.2l-19.3-31.4L72.6 179 92 209.8z"/></g><g fill="none" stroke="#CE1720" stroke-width="7"><path d="m28 73.8-16.1-26L28 22.2l16 25.6zM72.6 73.8l-16-26 16-25.6 16.1 25.6zM28 318l-16.1-26.1L28 266.3l16 25.6zM72.6 318l-16-26.1 16-25.6 16.1 25.6z"/></g></svg>',
    G = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 341.3"><path fill="#003e87" d="M0 0h512v341.3H0z"/><circle fill="#FFF" cx="260.9" cy="170.9" r="118.9"/><circle fill="none" stroke="#6DA544" stroke-width="18" stroke-miterlimit="10" cx="261.9" cy="173.1" r="94.5"/><g stroke="#000"><path fill="#003e87" d="m261.9 151.5-50.6 23.4v20c0 11.8 6.1 22.8 16.2 28.9L262 239l34.5-15.2c10-6.2 16.2-17.1 16.2-28.9v-20l-50.8-23.4z"/><path fill="#FFDA44" d="M211.3 128.1h101.3v46.7H211.3z"/></g><g fill="#ce1127"><path d="M0 0h512v35H0zM0 306h512v35H0z"/></g></svg>',
    K = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#FFF" d="M0 0h513v342H0z"/><g fill="red"><path d="M0 0h142v342H0zM371 0h142v342H371zM306.5 206l50.4-25.2-25.2-12.6V143l-50.4 25.2 25.2-50.4h-25.2L256.1 80l-25.2 37.8h-25.2l25.2 50.4-50.4-25.2v25.2l-25.2 12.6 50.4 25.2-12.6 25.2h50.4V269h25.2v-37.8h50.4z"/></g></svg>',
    W = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 341.3"><path fill="green" d="M0 0h512v341.3H0z"/><g fill="#FFDA44"><path d="m422.7 252.4 6.2 12.8 13.8-3.2-6.2 12.8 11.2 8.8-13.9 3.2V301l-11.1-8.9-11.1 8.9v-14.2l-13.8-3.2 11.1-8.8-6.2-12.8 13.9 3.2zM376.1 116.1l6.2 12.9 13.8-3.2-6.2 12.8 11.2 8.8-13.9 3.1v14.3l-11.1-8.9-11.1 8.9.1-14.3-13.9-3.1 11.1-8.8-6.2-12.8L370 129zM413.1 38.3l6.2 12.8 13.8-3.2-6.2 12.8 11.2 8.9-13.9 3.1v14.2L413.1 78 402 86.9l.1-14.2-13.9-3.1 11.1-8.9-6.2-12.8 13.9 3.2zM464.9 96.7l6.2 12.8 13.9-3.2-6.3 12.8 11.2 8.9-13.9 3.1.1 14.2-11.2-8.9-11.1 8.9.1-14.2L440 128l11.2-8.9-6.3-12.8 13.9 3.2zM436.9 164.8l4.9 14.8h15.6l-12.6 9.2 4.8 14.9-12.7-9.2-12.6 9.2 4.8-14.9-12.6-9.2h15.6z"/></g><path fill="#FFDA44" d="M306.8 254.7c-49.2 0-89.1-39.9-89.1-89.1s39.9-89.1 89.1-89.1c15.3 0 29.8 3.9 42.4 10.7C329.4 67.9 302.3 56 272.5 56c-60.5 0-109.6 49.1-109.6 109.6S212 275.3 272.5 275.3c29.8 0 56.9-11.9 76.6-31.3-12.6 6.8-27 10.7-42.3 10.7zM140.4 59.5C129.7 41 109.7 28.6 86.8 28.6S44 41 33.3 59.5h107.1zM140.6 59.9l-53.8 53.8-53.7-53.8C28 68.9 25 79.3 25 90.5c0 34.2 27.7 61.9 61.9 61.9s61.9-27.7 61.9-61.9c-.1-11.2-3.1-21.6-8.2-30.6z"/><path fill="#A2001D" d="M71.4 98.2v52.2c4.9 1.3 10.1 1.9 15.5 1.9s10.5-.7 15.5-1.9V98.2h-31z"/></svg>',
    _ = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 341.3"><path fill="#338AF3" d="M0 0h512v341.3H0z"/><path fill="#FFDA44" d="M512 66.9V0H411.7L0 274.4v66.9h100.3z"/><path fill="#D80027" d="M512 0v40.1L60.2 341.3H0v-40.1L451.8 0z"/><path fill="#FFDA44" d="m93.6 31.2 16.3 50.4H163l-42.9 31.2 16.4 50.5-42.9-31.2-43 31.2L67 112.8 24.1 81.6h53.1z"/></svg>',
    Y = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 341.3"><path fill="#d21034" d="M0 0h512v341.3H0z"/><g fill="#3a9927"><path d="M0 170.7h211.5V256H0zM300.5 170.7H512V256H300.5z"/></g><path fill="#003082" d="M0 0v85.3h211.5V0h89v85.3H512V0z"/><g fill="#FFF"><path d="M300.5 85.3H512v85.3H300.5zM0 85.3h211.5v85.3H0z"/></g><g fill="#ffce00"><path d="M300.5 341.3h-89V256H0v85.3h512V256H300.5zM105.7 8.6l8.6 26.2h27.5L119.5 51l8.6 26.2L105.7 61 83.4 77.2 91.9 51 69.6 34.8h27.6z"/></g></svg>',
    Z = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 513 342"><path fill="#da1a35" d="M0 85.331h513v342H0z"/><path fill="#009543" d="M443.726 85.331 102.4 426.657H0V85.331z"/><path fill="#fbde4a" d="M500.124 85.331 158.798 426.657H11.876L353.202 85.331z"/></svg>',
    J = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 513 342"><path fill="red" d="M0 85.337h513v342H0z"/><path fill="#FFF" d="M356.174 222.609h-66.783v-66.783h-66.782v66.783h-66.783v66.782h66.783v66.783h66.782v-66.783h66.783z"/></svg>',
    q = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.331h512v341.326H0z"/><path fill="#009e60" d="M330.207 85.331H512v341.337H330.207z"/><path fill="#f77f00" d="M0 85.331h181.793v341.337H0z"/></svg>',
    X = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 513 342"><path fill="#01237a" d="M0 85.332h513v342H0z"/><g fill="#FFF"><path d="m384 156.705 5.283 16.254h17.089l-13.826 10.045 5.281 16.254L384 189.211l-13.825 10.047 5.28-16.254-13.825-10.045h17.089zM313.791 185.786l15.228 7.758 12.084-12.083-2.673 16.879 15.227 7.759-16.879 2.673-2.674 16.88-7.76-15.227-16.878 2.673 12.086-12.084zM284.71 255.995l16.254-5.281.001-17.089 10.044 13.825 16.254-5.282-10.046 13.827 10.046 13.826-16.254-5.28-10.044 13.825v-17.09zM313.791 326.204l7.759-15.229-12.084-12.084 16.881 2.674 7.757-15.227 2.674 16.879 16.879 2.672-15.227 7.759 2.673 16.882-12.084-12.087zM384 355.284l-5.281-16.253h-17.091l13.827-10.045-5.28-16.254L384 322.776l13.827-10.044-5.281 16.254 13.826 10.045h-17.089zM454.209 326.204l-15.229-7.758-12.083 12.084 2.673-16.882-15.227-7.756 16.879-2.675 2.675-16.879 7.756 15.227 16.881-2.674-12.086 12.085zM483.29 255.995l-16.254 5.281v17.09l-10.045-13.826-16.254 5.281 10.046-13.826-10.046-13.827 16.254 5.282 10.045-13.825v17.089zM454.209 185.788l-7.757 15.226 12.082 12.084-16.881-2.673-7.756 15.227-2.675-16.88-16.879-2.675 15.227-7.757-2.673-16.878 12.084 12.082zM0 186.665v16h46.069L0 233.377v7.539l57.377-38.252H80L0 255.998h112v-69.334H0zm96 69.331H22.628L96 207.083v48.913zM176 138.665l80-53.334H144v69.334h112v-16h-46.069L256 107.951v-7.539l-57.377 38.251H176v.002zm-16-53.332h73.372L160 134.246V85.333zM144 255.998h112l-80-53.334h22.623L256 240.917v-7.539l-46.069-30.713H256v-16H144v69.333zm16-48.915 73.372 48.913H160v-48.913zM112 85.331H0l80 53.334H57.377L0 100.413v7.539l46.069 30.712H0v16h112V85.331zm-16 48.915L22.628 85.333H96v48.913z"/></g><g fill="#D80027"><path d="M144 85.331h-32v69.334H0v32h112v69.333h32v-69.333h112v-32H144z"/><path d="M80 138.665 0 85.331v15.082l57.377 38.252zM176 138.665h22.623L256 100.413V85.331zM57.377 202.665 0 240.917v15.081l80-53.333zM176 202.665l80 53.333v-15.081l-57.377-38.252z"/></g></svg>',
    Q = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#D80027" d="M0 0h513v342H0z"/><path fill="#FFF" d="M196 0h317v171H196z"/><path fill="#0037A1" d="M0 0h196v171H0z"/><path fill="#FFF" d="M98 24.5 113.1 71H162l-39.6 28.7 15.2 46.5L98 117.5l-39.6 28.7 15.2-46.5L34 71h48.9z"/></svg>',
    tt = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#ce1126" d="M0 0h513v342H0z"/><path fill="#007a5e" d="M0 0h171v342H0z"/><g fill="#fcd116"><path d="M342 0h171v342H342zM256 102.2l17.2 53H329L283.9 188l17.2 53-45.1-32.7-45.1 32.7 17.2-53-45.1-32.8h55.8z"/></g></svg>',
    nt = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#D80027" d="M0 0h513v342H0z"/><g fill="#FFDA44"><path d="m226.8 239.2-9.7-15.6-17.9 4.4 11.9-14.1-9.7-15.6 17.1 6.9 11.8-14.1-1.3 18.4 17.1 6.9-17.9 4.4zM290.6 82l-10.1 15.4 11.6 14.3-17.7-4.8-10.1 15.5-1-18.4-17.7-4.8 17.2-6.6-1-18.4 11.6 14.3zM236.2 25.4l-2 18.3 16.8 7.6-18 3.8-2 18.3-9.2-16-17.9 3.8 12.3-13.7-9.2-15.9 16.8 7.5zM292.8 161.8l-14.9 10.9 5.8 17.5-14.9-10.8-14.9 11 5.6-17.6-14.9-10.7 18.4-.1 5.6-17.6 5.8 17.5zM115 46.3l17.3 53.5h56.2l-45.4 32.9 17.3 53.5-45.4-33-45.5 33 17.4-53.5-45.5-32.9h56.3z"/></g></svg>',
    et = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFDA44" d="M0 85.337h512v341.326H0z"/><path fill="#D80027" d="M0 343.096h512v83.567H0z"/><path fill="#0052B4" d="M0 256h512v87.096H0z"/></svg>',
    it = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.331h512v341.326H0z"/><path fill="#D80027" d="M0 211.473h512v89.043H0z"/><g fill="#0052B4"><path d="M0 352.462h512v74.207H0zM0 85.331h512v74.207H0z"/></g></svg>',
    at = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 341.3"><path fill="#FF9811" d="M0-40.8v422.9-211.4z"/><path fill="#FFF" d="M0 0h512v341.3H0z"/><g fill="#0052B4"><path d="M0 0h512v68.3H0zM0 136.5h512v68.3H0zM0 273.1h512v68.3H0z"/></g><path fill="#D80027" d="M256 170.7 0 341.3V0z"/><path fill="#FFF" d="m86.5 111.4 12.7 39.2h41.3l-33.4 24.2 12.8 39.3-33.4-24.2-33.4 24.2 12.8-39.3-33.4-24.2h41.2z"/></svg>',
    rt = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#003893" d="M0 0h513v342H0z"/><path fill="#cf2027" d="M0 182.2h513v41.4H0z"/><path fill="#FFF" d="M0 140.8h513v41.4H0zM0 223.6h513V265H0z"/><g fill="#f7d116" stroke="#000"><path d="m150.4 70 6.9 21.1h22.2l-18 13.1 6.9 21.1-18-13.1-17.9 13.1 6.8-21.1-17.9-13.1h22.2zM150.4 279.7l6.9 21.1h22.2l-18 13 6.9 21.2-18-13.1-17.9 13.1 6.8-21.2-17.9-13h22.2zM52.8 208.8l6.9 21.1h22.2l-18 13 6.9 21.2-18-13.1-17.9 13.1 6.8-21.2-17.9-13H46zM90.1 91l6.9 21.1h22.2l-18 13 6.9 21.2-18-13.1-17.9 13.1 6.8-21.2-18-13h22.3zM23.8 162H46l6.8-21.1 6.9 21.1h22.2l-18 13.1 6.9 21.1-18-13-17.9 13 6.8-21.1zM72.2 310.9l6.8-21.1-18-13h22.3l6.8-21.2 6.9 21.2h22.2l-18 13 6.9 21.1-18-13zM248 208.8l-6.9 21.1h-22.2l18 13-6.9 21.2 18-13.1 18 13.1-6.9-21.2 18-13h-22.2zM210.7 91l-6.8 21.1h-22.2l17.9 13-6.8 21.2 17.9-13.1 18 13.1-6.9-21.2 18-13h-22.2zM277.1 162h-22.2l-6.9-21.1-6.9 21.1h-22.2l18 13.1-6.9 21.1 18-13 18 13-6.9-21.1zM228.7 310.9l-6.9-21.1 18-13h-22.2l-6.9-21.2-6.8 21.2h-22.2l17.9 13-6.8 21.1 17.9-13z"/></g></svg>',
    ot = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#002b7f" d="M0 0h513v342H0z"/><path fill="#f9e814" d="M0 233.5h513v51H0z"/><g fill="#FFF"><path d="m168.7 86.5 12.9 39.8h41.8l-33.8 24.5 12.9 39.7-33.8-24.5-33.8 24.5 12.9-39.7-33.8-24.5h41.8zM85.4 32.5l7.8 23.9h25L97.9 71.1l7.8 23.8-20.3-14.7-20.3 14.7 7.8-23.8-20.3-14.7h25.1z"/></g></svg>',
    lt = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 341.3"><path fill="#0021ad" d="M0 0h512v341.3H0z"/><path fill="#1c8a42" d="M0 0h512v341.3"/><g fill="#FFF"><path d="m77.6 272 5.7 11.9 12.8-3-5.7 11.9 10.3 8.1-12.8 2.9V317l-10.3-8.3-10.2 8.3v-13.2l-12.8-2.9 10.3-8.1-5.8-11.9 12.9 3zM40.5 173.1l5.7 11.9 12.8-3-5.7 11.8 10.3 8.2-12.9 2.9.1 13.2-10.3-8.3-10.3 8.3.1-13.2-12.9-2.9 10.4-8.2L22 182l12.8 3zM77.6 92.2l5.7 11.8 12.8-2.9-5.7 11.8 10.3 8.2-12.8 2.9v13.1l-10.3-8.2-10.2 8.2V124l-12.8-2.9 10.3-8.2-5.8-11.8L72 104zM123.7 155.1l5.7 11.9 12.8-3-5.7 11.9 10.3 8.1-12.8 2.9v13.2l-10.3-8.2-10.2 8.2v-13.2l-12.8-2.9 10.3-8.1-5.7-11.9 12.8 3zM90.8 209.1l4.4 13.7h14.5L98 231.3l4.5 13.7-11.7-8.4-11.7 8.4 4.5-13.7-11.7-8.5h14.4z"/></g><circle fill="#ffc639" cx="267.1" cy="170.7" r="74.5"/><path fill="#1c8a42" d="M267.1 220.3h24.8s10.8-19 0-37.2l24.8-24.8-12.4-24.8h-12.4s-6.2 18.6-31 18.6-31-18.6-31-18.6h-12.4l12.4 24.8-12.4 24.8 12.4 12.4s12.4-24.8 37.2-12.4c0 0 10.5 15.5 0 37.2z"/><path fill="#ffc639" d="M464.4 92.2c.6-2.9-.2-17.6-.2-20.7 0-21.3-13.9-39.4-33.2-45.7 5.9 12 9.2 25.4 9.2 39.7 0 4.8-.4 9.5-1.1 14.1-2.9-4.7-6.6-8.9-11.2-12.6-17.1-13.6-40.6-14-57.9-2.5 13.4 2.9 26.3 8.9 37.7 18 9 7.1 16.2 16.8 21.7 26.1 0 0-17.8 10.9-31 15.1s-42.3 7.9-42.3 7.9c72 12 132-36 132-36-6.5-13.4-15.8-4-23.7-3.4z"/></svg>',
    ct = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#FFF" d="M0 0h513v342H0z"/><path fill="#DB7D00" d="M141.7 154.7s.2 67.1 74.7 65.3l4.5 13.9h8.9s-7.4-41.1 60.1-41.5c0 0 0-27.6 27.6-27.6H359s-66-51.8 58.9-118l1.8-13.1s-129.9 71-198.9 57.2c0 0 10.7 42.5-10.8 42.5-10.8 0-9.7-8.1-32.3-8.1-18.7 0-17.3 19.7-26.3 19.5-8.9-.2-18.8-12.3-19.6-10.2-.7 2.1 9.9 20.1 9.9 20.1z"/><g fill="#006651"><path d="M237.2 308.1c6.9-5 13-6.6 22.4-8.3s19.4-4.4 24.6-5.8-17.7 6.6-23.5 8.3c-5.8 1.6-23.5 5.8-23.5 5.8zM275.1 293.4c-1.9-11.9 2.8-24.3 13.5-29.3 2.5 8.6-5.2 23.2-13.5 29.3zM293.3 287.2c-5.8-9.8 4-22.6 11.1-28.8 3.3 6-2.5 23.7-11.1 28.8zM310.2 279.6c-6.2-8.4 1.1-23.2 8.8-29 3.1 8.2.1 23.2-8.8 29zM327.1 269c-5.6-8-1.7-20.4 6.3-28.4 5.8 6.6.9 21-6.3 28.4zM340.6 258.3c-4.7-7.5 1.1-25.4 8.6-30.4 3.3 6.6.8 25.4-8.6 30.4zM351.4 255.5c-1.4-10.8 17.4-22.7 25.2-22.4-.9 8.9-8.9 18.6-25.2 22.4zM340.9 267.7c8.8-9.1 26-9.1 32.1-7.2-1.7 5.3-21.9 16.9-32.1 7.2z"/><path d="M328.7 276.8c12.4-3.3 20.5-6.1 27.9 1.7-5.2 6.6-25.4 4.7-27.9-1.7zM311 284.8c11.9-6.4 26.3 3 28.5 8.6-13.3 5.5-28.7-7.2-28.5-8.6zM294.7 294c10.8-4.1 23.2 1.4 28.2 7.5-5.8 2.7-21 5.7-28.2-7.5zM279.8 298.7c12.4-1.4 24.4 8 27 13.4-15.9 1.5-22-3.2-27-13.4zM275.8 308.1c-6.9-5-13-6.6-22.4-8.3-9.4-1.7-19.4-4.4-24.6-5.8-5.3-1.4 17.7 6.6 23.5 8.3 5.8 1.6 23.5 5.8 23.5 5.8zM237.9 293.4c1.9-11.9-2.8-24.3-13.5-29.3-2.5 8.6 5.2 23.2 13.5 29.3zM219.7 287.2c5.8-9.8-4-22.6-11.1-28.8-3.3 6 2.5 23.7 11.1 28.8zM202.8 279.6c6.2-8.4-1.1-23.2-8.8-29-3.1 8.2-.1 23.2 8.8 29zM185.9 269c5.6-8 1.7-20.4-6.3-28.4-5.8 6.6-.9 21 6.3 28.4zM172.4 258.3c4.7-7.5-1.1-25.4-8.6-30.4-3.3 6.6-.8 25.4 8.6 30.4zM161.6 255.5c1.4-10.8-17.4-22.7-25.2-22.4.9 8.9 8.9 18.6 25.2 22.4zM172.1 267.7c-8.8-9.1-26-9.1-32.1-7.2 1.7 5.3 21.9 16.9 32.1 7.2z"/><path d="M184.3 276.8c-12.4-3.3-20.5-6.1-27.9 1.7 5.2 6.6 25.4 4.7 27.9-1.7zM202 284.8c-11.9-6.4-26.3 3-28.5 8.6 13.3 5.5 28.7-7.2 28.5-8.6zM218.3 294c-10.8-4.1-23.2 1.4-28.2 7.5 5.8 2.7 21 5.7 28.2-7.5zM233.2 298.7c-12.4-1.4-24.4 8-27 13.4 15.9 1.5 22-3.2 27-13.4z"/></g></svg>',
    st = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#11457e" d="M0 85.337h512v341.326H0z"/><path fill="#d7141a" d="M512 256v170.663H0L215.185 256z"/><path fill="#FFF" d="M512 85.337V256H215.185L0 85.337z"/></svg>',
    ht = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#D80027" d="M0 85.331h512v341.337H0z"/><path d="M0 85.331h512v113.775H0z"/><path fill="#FFDA44" d="M0 312.882h512v113.775H0z"/></svg>',
    ut = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 341.3"><path fill="#12ad2b" d="M0 0h512v341.3H0z"/><path fill="#6ab2e7" d="M512 0v166.7L0 170.8V0z"/><path fill="#FFF" d="M256 170.7 0 341.3V0z"/><path fill="#d7141a" d="m89.8 92.5 17 52.4H162l-44.6 32.5 17 52.4-44.6-32.4-44.6 32.4 17-52.4-44.6-32.5h55.2z"/></svg>',
    ft = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#c60c30" d="M0 0h513v342H0z"/><path fill="#FFF" d="M190 0h-60v140H0v60h130v142h60V200h323v-60H190z"/></svg>',
    vt = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 341.3"><path fill="#496E2D" d="M0 0h512v341.3H0z"/><path d="M0 110.7v120h512v-120z"/><path fill="#FFDA44" d="M0 110.7h512v40H0z"/><path fill="#FFF" d="M0 190.7h512v40H0z"/><path d="M196 0h120v341.3H196z"/><path fill="#FFDA44" d="M196 0h40v341.3h-40z"/><path fill="#FFF" d="M274.7 0h40v341.3h-40z"/><circle fill="#D80027" cx="256" cy="170.7" r="123.1"/><g fill="#496E2D"><path d="m256 58.6 4.6 14.2h15l-12.1 8.9 4.6 14.2-12.1-8.8-12.1 8.8 4.6-14.2-12.1-8.9h15zM190.1 80l12.2 8.8 12.1-8.8-4.6 14.3 12.1 8.8h-15l-4.6 14.2-4.7-14.2h-15l12.1-8.8zM149.4 136h15l4.6-14.2 4.7 14.2h15l-12.2 8.8 4.7 14.3-12.2-8.8-12.1 8.8 4.6-14.3zM149.4 205.3l12.1-8.8-4.6-14.3L169 191l12.2-8.8-4.7 14.3 12.2 8.8h-15l-4.7 14.3-4.6-14.3zM190.1 261.4l4.6-14.3-12.1-8.8h15l4.7-14.3 4.6 14.3h15l-12.1 8.8 4.6 14.3-12.1-8.9zM256 282.8l-4.6-14.3h-15l12.1-8.8-4.6-14.3 12.1 8.8 12.1-8.8-4.6 14.3 12.1 8.8h-15zM321.9 261.4l-12.2-8.9-12.1 8.9 4.6-14.3-12.1-8.8h15l4.6-14.3 4.7 14.3h15l-12.1 8.8zM362.6 205.3h-15l-4.6 14.3-4.7-14.3h-15l12.2-8.8-4.7-14.3L343 191l12.1-8.8-4.6 14.3zM362.6 136l-12.1 8.8 4.6 14.3-12.1-8.8-12.2 8.8 4.7-14.3-12.2-8.8h15l4.7-14.2 4.6 14.2zM321.9 80l-4.6 14.3 12.1 8.8h-15l-4.7 14.2-4.6-14.2h-15l12.1-8.8-4.6-14.3 12.1 8.8z"/></g><path fill="#496E2D" d="M279.3 168.7c-11-21.1-14.5-25.1-14.5-25.1s.4-9.7.4-15.6c0-8.8-7.4-15.8-16.5-15.8-8.6 0-15.7 2.9-16.5 11-4.2.9-8.6 4.1-8.6 10.7 0 4.8 1 7.3 5.2 9.3 2.1-4.6 4.3-4.8 9.3-6.4.8.6 1.7 3 2.6 3.4l.3 1s-13.3 6.6-13.3 30.9c0 29.5 22 45.4 22 45.4l-1.8.3-1.9 7.1h22v-7.2l11 17.5c.3-.3 10.2-47.6.3-66.5z"/></svg>',
    pt = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 341.3"><path fill="#FFF" d="M0 0h512v341.3H0z"/><path fill="#D80027" d="M0 215.2h211.5v126.1H0z"/><path fill="#0052B4" d="M0 0h211.5v126.2H0z"/><path fill="#D80027" d="M300.5 0H512v126.2H300.5z"/><path fill="#0052B4" d="M300.5 215.2H512v126.1H300.5z"/><g stroke="#FFF" stroke-width="5" stroke-miterlimit="10"><path fill="#0052B4" d="M256 130h-49.9v49.4s19.5 6 49.9 6V130z"/><path fill="#D80027" d="M206.1 179.4v6c0 27.5 22.3 49.9 49.9 49.9v-49.9c-30.4 0-49.9-6-49.9-6z"/><path fill="#0052B4" d="M256 235.3c27.5 0 49.9-22.3 49.9-49.9v-6s-19.5 6-49.9 6v49.9z"/><path fill="#D80027" d="M256 130v55.4c30.4 0 49.9-6 49.9-6V130H256z"/></g></svg>',
    gt = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 341.3"><path fill="#41662E" d="M0 0h512v341.3H0z"/><path fill="#FFF" d="M256 0h256v341.3H256z"/><g fill="#D80027"><path d="m341.5 105.3-29.4 40.4-47.5-15.4 29.4 40.4-29.4 40.4 47.5-15.4 29.4 40.4v-50l47.5-15.5-47.5-15.4z"/><path d="M309.9 276.7c-58.5 0-106-47.5-106-106s47.5-106 106-106c18.3 0 35.4 4.6 50.4 12.7-23.5-23-55.7-37.2-91.2-37.2-72 0-130.4 58.4-130.4 130.4S197.1 301 269.1 301c35.5 0 67.7-14.2 91.2-37.2-14.9 8.2-32.1 12.9-50.4 12.9z"/></g></svg>',
    dt = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 341.3"><path fill="#FFDA44" d="M0 0h512v341.3H0z"/><path fill="#0052B4" d="M0 170.7h512V256H0z"/><path fill="#D80027" d="M0 256h512v85.3H0z"/><circle fill="#FFDA44" cx="256" cy="170.7" r="59.4"/><path fill="#4C1F00" d="M369.2 79.9s-27.2-13.8-33.9-16c-6.7-2.2-49.1-13.2-49.1-7 0 10.3-13.5 12-15.5 12s-2-5.3-14.8-5.3-13.7 4.8-15.8 4.8c-2.2 0-14.5-1-14.5-11.5 0-5.2-42.9 4-49.1 7-6.1 3.1-33.9 16-33.9 16s45.8 2.7 53.9 6.2 43.8 16.5 43.8 16.5l-2.8 13.3h37.8l-3.8-13.3s35.1-12.7 43.8-16.5 53.9-6.2 53.9-6.2z"/><path fill="#57BA17" d="M217.7 171.7c0 21.1 17.2 38.3 38.3 38.3 21.1 0 38.3-17.2 38.3-38.3v-11.5h-76.5v11.5z"/><path fill="#338AF3" d="M256 110.5c-21.1 0-38.3 17.2-38.3 38.3v11.5h76.5v-11.5c.1-21.1-17.1-38.3-38.2-38.3z"/></svg>',
    mt = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#111" d="M0 85.337h512v341.326H0z"/><path fill="#368FD8" d="M0 85.337h512v113.775H0z"/><path fill="#FFF" d="M0 312.888h512v113.775H0z"/></svg>',
    Ft = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 341.3"><path fill="#FFF" d="M0 0h512v341.3H0z"/><path fill="#D80027" d="M0 0h512v113.8H0z"/><path d="M0 227.6h512v113.8H0z"/><path fill="#C09300" d="M220.3 204.4s0-58.4 4.5-64.7c3.1-4.3 16.8 5.2 22.7 4.5 0 0 4.2-7.5 4.5-12 .3-4.6-1.1-7.6-4.9-6.2 0 0-1.2-2.1.5-3.3 1.6-1.2 5.6.1 5.6.1s-.5-1 1.6-.9c2.9.2 7.2 1.4 7.4 5.6.2 3.1.3 7.7.4 8.7.7 6.8 2.7 8.7 2.7 8.7s18.4-9.2 22-5.2c3.3 3.8 4.5 64.7 4.5 64.7l-18.1-16.8 12.1 29.5s-14.4 2.4-28.9 2.4c-14.5 0-31.1-4.2-31.1-4.2l13.8-28.2-19.3 17.3z"/></svg>',
    Mt = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 341.3"><path fill="#FFF" d="M0 0h512v341.3H0z"/><path d="M0 0h512v113.8H0z"/><path fill="#428823" d="M0 227.6h512v113.8H0z"/><g fill="#D80027"><path d="M256 170.7 0 341.3V0zM309.1 170.7c0-22.9 13.1-42.1 34.6-46.8-3.3-.7-6.7-1.1-10.3-1.1-26.4 0-47.9 21.4-47.9 47.9s21.4 47.9 47.9 47.9c3.5 0 7-.4 10.3-1.1-21.5-4.8-34.6-23.9-34.6-46.8z"/><path d="m365 129.2 10.3 31.7h33.3l-27 19.6 10.3 31.7-26.9-19.6-27 19.6 10.3-31.7-27-19.6h33.4z"/></g></svg>',
    wt = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 341.3"><path fill="#338AF3" d="M0 0h512v341.3H0z"/><path fill="#56AF35" d="M0 0h512v170.7H0z"/><path fill="#D80027" d="m0 341.3 512-170.7L0 0v341.3z"/><g fill="#ffc945"><path d="M134.7 231.5c33.6 0 60.8-27.2 60.8-60.8s-27.2-60.8-60.8-60.8-60.8 27.2-60.8 60.8 27.2 60.8 60.8 60.8zm0 24.3c-47 0-85.2-38.1-85.2-85.2s38.1-85.2 85.2-85.2 85.2 38.1 85.2 85.2-38.2 85.2-85.2 85.2z"/><circle cx="119.5" cy="148.3" r="17.5"/><circle cx="148.9" cy="158.5" r="17.5"/><circle cx="134.7" cy="135.2" r="17.5"/><circle cx="119.5" cy="172.7" r="17.5"/><circle cx="149.9" cy="182.8" r="17.5"/><circle cx="122.5" cy="198" r="17.5"/><circle cx="145.9" cy="205.2" r="17.5"/></g></svg>',
    zt = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFDA44" d="M0 85.331h512v341.337H0z"/><g fill="#D80027"><path d="M0 85.331h512v113.775H0zM0 312.882h512v113.775H0z"/></g></svg>',
    yt = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.5 15"><path fill="#20AA46" d="M0 0h22.5v5H0V0z"/><path fill="#E92F3B" d="M0 10h22.5v5H0v-5z"/><path fill="#FADF50" d="M0 5h22.5v5H0V5z"/><circle fill="#205CCA" cx="11.3" cy="7.5" r="5.2"/><g stroke="#FFDB3D" fill="none"><g stroke-width=".5"><path d="m11.3 8.8-2.1 1.5.8-2.4-2-1.5h2.5l.8-2.3.8 2.3h2.6l-2.1 1.5.8 2.4-2.1-1.5zM10.3 6.4h1.9M9.9 7.8l1.3 1M12 6.2l.7 1.8M10 7.9l.6-1.8M11 9l1.6-1.1"/></g><g stroke-width=".25"><path d="m8.7 3.9 1.1 1.6M13.8 3.8l-1 1.6M11.3 10.1V12M8.9 8.3 7.1 9M15.5 9l-1.8-.7"/></g></g></svg>',
    At = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 341.3"><path fill="#FFF" d="M0 0h512v341.3H0z"/><path fill="#2E52B2" d="M512 129.3V212H203.7v129.3H121V212H0v-82.7h121V0h82.7v129.3z"/></svg>',
    Ut = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 341.3"><path fill="#2E52B2" d="M0 0h512v341.3H0z"/><path fill="#FFF" d="M256 0v22.6l-46.1 30.7H256v64h-46.1L256 148v22.7h-22.6l-73.4-49v49H96v-49l-73.4 49H0V148l46.1-30.7H0v-64h46.1L0 22.6V0h22.6L96 48.9V0h64v48.9L233.4 0z"/><g fill="#D80027"><path d="M144 0h-32v69.3H0v32h112v69.4h32v-69.4h112v-32H144z"/><path d="M0 0v15.1l57.4 38.2H80zM256 0v15.1l-57.4 38.2H176z"/><path d="M0 0v15.1l57.4 38.2H80zM256 0v15.1l-57.4 38.2H176zM0 170.7v-15.1l57.4-38.3H80zM256 170.7v-15.1l-57.4-38.3H176z"/></g><path fill="#F3F3F3" d="M307.1 127.1v92c0 61.6 80.5 80.5 80.5 80.5s80.4-19 80.4-80.6v-92l-80.5-23-80.4 23.1z"/><path fill="#D80027" d="M468 132.8V98.3H307.1v34.5h69v69h-69v23h69V296c6.9 2.5 11.5 3.5 11.5 3.5s4.6-1.1 11.5-3.5v-71.2h69v-23h-69v-69H468z"/></svg>',
    Ht = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 341.3"><path fill="#0052B4" d="M0 0h512v341.3H0z"/><path fill="#FFF" d="M256 0v30.6l-45.2 25.1H256V115h-59.1l59.1 32.8v22.9h-26.7l-73.5-40.9v40.9h-55.6v-48.6l-87.5 48.6H0v-30.6L45.2 115H0V55.7h59.1L0 22.8V0h26.7l73.5 40.8V0h55.6v48.6L243.3 0z"/><path fill="#D80027" d="M144 0h-32v69.3H0v32h112v69.4h32v-69.4h112v-32H144z"/><path fill="#0052B4" d="M155.8 115 256 170.7v-15.8L184.2 115z"/><path fill="#FFF" d="M155.8 115 256 170.7v-15.8L184.2 115z"/><g fill="#D80027"><path d="M155.8 115 256 170.7v-15.8L184.2 115zM71.8 115 0 154.9v15.8L100.2 115z"/></g><path fill="#0052B4" d="M100.2 55.6 0 0v15.7l71.8 39.9z"/><path fill="#FFF" d="M100.2 55.6 0 0v15.7l71.8 39.9z"/><g fill="#D80027"><path d="M100.2 55.6 0 0v15.7l71.8 39.9zM184.2 55.6 256 15.7V0L155.8 55.6z"/></g><path fill="#1F8BDE" d="M312.2 194.2v-90c0-8.5 6.5-15.3 15-15.3h120.5c8.3 0 15 6.8 15 15.3v90c0 75.2-75.2 105.3-75.2 105.3s-75.3-30.1-75.3-105.3z"/><path fill="#FFF" d="M312.2 194.2v-90c0-8.5 6.5-15.3 15-15.3h120.5c8.3 0 15 6.8 15 15.3v90c0 75.2-75.2 105.3-75.2 105.3s-75.3-30.1-75.3-105.3zm79.6 86.3c7.9-4.5 15.9-10 23.2-16.7 20.5-18.5 32.6-41.4 32.6-69.7v-90c0-.3-120.4-.3-120.4-.3v90.3c0 28.3 12.1 51.2 32.6 69.7 8.3 7.5 17.6 13.9 27.6 19 1.4-.6 2.8-1.4 4.4-2.3z"/><path fill="#187536" d="M347.1 193.4c-2.6-7.9 1.7-14.3 10.1-14.3h60.5c8.2 0 12.8 6.3 10.1 14.3l-5.5 16.5c-2.6 7.9-8.9 9.2-15.8 4 0 0 2.6-4.8-19.1-4.8-21.7 0-19.1 4.8-19.1 4.8-6.1 5.7-13.1 4-15.8-4 .1.1-5.4-16.5-5.4-16.5z"/><path fill="#FFF" d="M357.4 179.1c8.1 1.6 17.8-15 30.1-15 13.1 0 21.8 17.1 30.1 15 7.4-1.8 15-22.2 15-30.1 0-16.6-20.2-30.1-45.1-30.1-24.9 0-45.1 13.5-45.1 30.1-.1 8.5 6.6 28.5 15 30.1zM356 270.7c6.2.4 12.5-1.8 17.2-6.5l9-9c2.9-2.9 7.5-2.9 10.4 0l9 9c4.7 4.7 11 6.9 17.1 6.5 5.3-.3 32.5-33.5 25.7-32.6-4.6.6-9.1 2.8-12.7 6.3l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-8.7-8.8-22.9-8.8-31.7-.1l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-3.5-3.5-7.8-5.6-12.3-6.3-6.7-1.1 20.1 32.2 25.3 32.5zM322.1 210c2.9-2.9 7.5-2.9 10.4 0l9 9c8.8 8.7 22.9 8.7 31.7 0l9-9c2.9-2.9 7.5-2.9 10.4 0l9 9c8.8 8.7 22.9 8.7 31.7 0l9-9c2.9-2.9 7.5-2.9 10.4 0 0 0 5.5-14.8 2.5-15.9-7.9-2.9-17.2-1.2-23.5 5.2l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-8.7-8.8-22.9-8.8-31.7-.1l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-6.2-6.2-15.1-8-22.8-5.5-3.1 1.1 1.9 16.1 1.9 16.1z"/></svg>',
    xt = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 341.3"><path fill="#338AF3" d="M0 0h512v341.3H0z"/><g fill="#FFF"><path d="m256 37.9 10.1 31.2H299l-26.6 19.3 10.2 31.2-26.6-19.3-26.6 19.3 10.2-31.2L213 69.1h32.9zM123.2 170.7l31.2-10.2v-32.8l19.3 26.6 31.2-10.2-19.3 26.6 19.3 26.5-31.2-10.1-19.3 26.5v-32.8zM256 303.5l-10.1-31.2H213l26.6-19.3-10.2-31.3L256 241l26.6-19.3-10.2 31.3 26.6 19.3h-32.9zM388.8 170.7l-31.2 10.1v32.8l-19.3-26.5-31.2 10.1 19.3-26.5-19.3-26.6 31.2 10.2 19.3-26.6v32.8z"/></g></svg>',
    Et = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 341.3"><path fill="#FFF" d="M0 0h512v341.3H0z"/><path fill="#0F61A5" d="M512 214.5H206.2v126.8H118.4V214.5H0v-87.7h118.4V0H206.2v126.8H512V192z"/><path fill="#E50E3D" d="M512 149.3V192H183.7v149.3H141V192H0v-42.7h141V0h42.7v149.3z"/></svg>',
    St = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.331h512v341.337H0z"/><path fill="#0052B4" d="M0 85.331h170.663v341.337H0z"/><path fill="#D80027" d="M341.337 85.331H512v341.337H341.337z"/></svg>',
    Bt = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFDA44" d="M0 85.337h512v341.326H0z"/><path fill="#6DA544" d="M0 85.337h512v113.775H0z"/><path fill="#0052B4" d="M0 312.888h512v113.775H0z"/></svg>',
    Dt = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.333h512V426.67H0z"/><path fill="#D80027" d="M288 85.33h-64v138.666H0v64h224v138.666h64V287.996h224v-64H288z"/><g fill="#0052B4"><path d="M393.785 315.358 512 381.034v-65.676zM311.652 315.358 512 426.662v-31.474l-143.693-79.83zM458.634 426.662l-146.982-81.664v81.664z"/></g><path fill="#FFF" d="M311.652 315.358 512 426.662v-31.474l-143.693-79.83z"/><path fill="#D80027" d="M311.652 315.358 512 426.662v-31.474l-143.693-79.83z"/><g fill="#0052B4"><path d="M90.341 315.356 0 365.546v-50.19zM200.348 329.51v97.151H25.491z"/></g><path fill="#D80027" d="M143.693 315.358 0 395.188v31.474l200.348-111.304z"/><g fill="#0052B4"><path d="M118.215 196.634 0 130.958v65.676zM200.348 196.634 0 85.33v31.474l143.693 79.83zM53.366 85.33l146.982 81.664V85.33z"/></g><path fill="#FFF" d="M200.348 196.634 0 85.33v31.474l143.693 79.83z"/><path fill="#D80027" d="M200.348 196.634 0 85.33v31.474l143.693 79.83z"/><g fill="#0052B4"><path d="M421.659 196.636 512 146.446v50.19zM311.652 182.482V85.331h174.857z"/></g><path fill="#D80027" d="M368.307 196.634 512 116.804V85.33L311.652 196.634z"/></svg>',
    bt = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 341.3"><path fill="#c60a0a" d="M0 0h512v341.3H0z"/><path fill="#3E8446" d="M256 170.7 44.5 296.8V44.5z"/><g fill="#FFDA44"><path d="m256 170.7 211.5 126.1h-423zM467.5 44.5 256 170.7 44.5 44.5z"/></g><path fill="#3E8446" d="M467.5 44.5v252.3L256 170.7z"/><g fill="#FFDA44"><path d="m256 10.4 3.3 10.2H270l-8.6 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zM170.1 10.4l3.3 10.2h10.7l-8.6 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zM341.9 10.4l3.3 10.2H356l-8.7 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zM256 304.2l3.3 10.2H270l-8.6 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zM170.1 304.2l3.3 10.2h10.7l-8.6 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zM341.9 304.2l3.3 10.2H356l-8.7 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7z"/></g><circle fill="#c60a0a" cx="244.5" cy="170.7" r="76.2"/><path fill="#FFDA44" d="m244.5 110.1 13.6 41.8h44l-35.6 25.8 13.6 41.8-35.6-25.8-35.5 25.8 13.6-41.8-35.6-25.8h44zM107.7 167.8c4.4 6.9 2.3 16.1-4.6 20.5s-16.1 2.3-20.5-4.6c-7.9-12.5-3.3-33-3.3-33s20.4 4.6 28.4 17.1z"/><circle fill="#A2001D" cx="99.1" cy="182.1" r="7.4"/></svg>',
    Nt = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.5 15"><path fill="#FFF" d="M.8 0h21v15H.8V0z"/><path fill="#eb000e" d="M9.8 6H0v3h9.8v6h3V9h9.8V6h-9.8V0h-3v6z"/><path fill="#eb000e" d="m17.3 2.7-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2zm-12.7 0-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2zm0 9-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2zm12.7 0-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2z"/></svg>',
    jt = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 60"><path fill="#FDEB01" d="m0 0 90 60H0z"/><path fill="#58A846" d="M90 0v60L0 0z"/><path fill="#ED3D24" d="m50.7 33.3 9.3-6.7H48.5L45 15.7l-3.5 10.9H30l9.3 6.7-3.6 11 9.3-6.7 9.3 6.7z"/></svg>',
    Lt = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#FFF" d="M0 0h513v342H0z"/><path fill="#D80027" d="M308 0H204v118.7H0v104h204V342h104V222.7h205v-104H308z"/><path fill="#FFDA44" d="m368.6 188 26 17.3V136l-26 17.3h-95.3V58.1l17.3-26h-69.2l17.3 26v95.2h-95.3l-26-17.3v69.3l26-17.3h95.3v95.2l-17.3 26h69.2l-17.3-26V188z"/></svg>',
    Ct = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFDA44" d="M0 85.337h512v341.326H0z"/><path fill="#D80027" d="M0 85.337h512v113.775H0z"/><path fill="#496E2D" d="M0 312.888h512v113.775H0z"/><path d="m255.883 199.111 14.119 43.458 40.366 3.2-36.969 26.861 19.453 40.259-36.969-26.859-36.97 26.859 14.123-43.459-36.969-26.861h45.696z"/></svg>',
    Tt = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#FFF" d="M0 0h513v342H0z"/><path fill="#D80027" d="M0 230h513v112H0z"/><path fill="#D80027" stroke="#000" stroke-miterlimit="10" d="M363.1 131.8V99.1H374V77.3h-21.9v10.9h-21.8V77.3h-21.8v21.8h10.9v32.7h-21.8V55.5h10.9V33.7h-21.8v10.9h-10.9V33.7H254v10.9h-10.9V33.7h-21.8v21.8h10.9v76.3h-21.8V99.1h10.9V77.3h-21.8v10.9h-21.8V77.3h-21.8v21.8h10.9v32.7H145V219h239.9v-87.2z"/><path fill="#FFDA44" stroke="#000" stroke-miterlimit="10" d="m264.9 235.5-24.2 18.2 19.1 14.3v31.3h-23.2v9h23v7.9h-23v9.3H270V268l19.1-14.3-24.2-18.2zm0 25.3-10.1-7.1 10.1-7.1 10.1 7.1-10.1 7.1z"/><path d="M239.6 209.7v-27.9s.1-22.3 25-22.3c24.8 0 25.7 22 25.7 22v28.2h-50.7zM170.5 209.7v-24.3s.1-18.7 19.6-18.7 20.2 18.4 20.2 18.4v24.5h-39.8z"/><path d="M169.1 209.7v-24.3s.1-18.7 19.6-18.7 20.2 18.4 20.2 18.4v24.5h-39.8zM320.9 209.7v-24.3s.1-18.7 19.6-18.7 20.2 18.4 20.2 18.4v24.5h-39.8zM329.3 132v-15.7s.1-12.1 11.3-12.1c11.3 0 11.7 11.9 11.7 11.9V132h-23zM250.5 132v-23.7s.1-18.3 14.3-18.3c14.2 0 14.7 18 14.7 18v24h-29zM177.5 132v-15.7s.1-12.1 11.3-12.1 11.7 11.9 11.7 11.9V132h-23z"/></svg>',
    It = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#D80027" d="M0 0h513v342H0z"/><path fill="#FFF" d="M513 0v171H0V0z"/><circle fill="#FFF" cx="185.8" cy="171.2" r="117.8"/><path fill="#D80027" d="M68 171c0-65.1 52.8-117.8 117.8-117.8 65.1 0 117.8 52.8 117.8 117.8"/></svg>',
    Rt = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.337h512v341.326H0z"/><path fill="#1a7e25" d="M0 322.783h512v103.88H0z"/><path fill="#cf0d19" d="M0 85.337h512v104.515H0z"/><path fill="#0052B4" d="M0 210.877h512v89.656H0z"/></svg>',
    Vt = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#FFDA44" d="M0 0h512v342H0z"/><path fill="#6DA544" d="M342 0h171v342H342z"/><path fill="#D80027" d="M0 0h171v342H0z"/></svg>',
    kt = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.331h512v341.337H0z"/><path fill="#0052B4" d="M0 85.331h170.663v341.337H0z"/><path fill="#D80027" d="M341.337 85.331H512v341.337H341.337z"/></svg>',
    Ot = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#FFF" d="M0 0h513v342H0z"/><path fill="#6DA544" d="M0 0h513v113.8H0z"/><path fill="#D80027" d="M0 227.6h513V342H0z"/><path fill="#0070C8" d="M126 170.7 0 341.3V0z"/><path fill="none" stroke="#000" stroke-miterlimit="10" d="M233.8 139.4v40.4c0 35.6 35.6 35.6 35.6 35.6s35.6 0 35.6-35.6v-40.4h-71.2z"/><path fill="#786145" d="M264.5 179.8h9.8l4 25.8h-17.8z"/><path fill="#6DA544" d="M287.2 162c0-9.8-8-14.8-17.8-14.8s-17.8 5-17.8 14.8c-4.9 0-8.9 4-8.9 8.9s4 8.9 8.9 8.9h35.6c4.9 0 8.9-4 8.9-8.9s-4-8.9-8.9-8.9z"/><g fill="#FFDA00" stroke="#000" stroke-miterlimit="10"><path d="m230.7 120 1.9 3.3h3.8l-1.9 3.3 1.9 3.2h-3.8l-1.9 3.3-1.9-3.3H225l1.9-3.2-1.9-3.3h3.8zM246 120l1.9 3.3h3.7l-1.9 3.3 1.9 3.2h-3.7l-1.9 3.3-1.9-3.3h-3.8l1.9-3.2-1.9-3.3h3.8zM261.3 120l1.9 3.3h3.7l-1.9 3.3 1.9 3.2h-3.7l-1.9 3.3-1.9-3.3h-3.8l1.9-3.2-1.9-3.3h3.8zM277.1 120l1.9 3.3h3.8l-1.9 3.3 1.9 3.2H279l-1.9 3.3-1.9-3.3h-3.7l1.8-3.2-1.8-3.3h3.7zM293.1 120l1.9 3.3h3.8l-1.9 3.3 1.9 3.2H295l-1.9 3.3-1.9-3.3h-3.7l1.8-3.2-1.8-3.3h3.7zM308.1 120l1.9 3.3h3.7l-1.9 3.3 1.9 3.2H310l-1.9 3.3-1.9-3.3h-3.8l1.9-3.2-1.9-3.3h3.8z"/></g></svg>',
    Pt = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#FFF" d="M0 0h513v342H0z"/><g fill="#0d5eaf"><path d="M0 0h513v38H0zM0 76h513v38H0zM0 152h513v38H0zM0 228h513v38H0zM0 304h513v38H0z"/><path d="M0 0h190v190H0z"/></g><g fill="#FFF"><path d="M0 76h190v38H0z"/><path d="M76 0h38v190H76z"/></g></svg>',
    Gt = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 341.3"><path fill="#0052B4" d="M0 0h512v341.3H0z"/><path fill="#FFF" d="M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z"/><path fill="#D80027" d="M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"/><path fill="#2E52B2" d="M256 22.7v30.7h-46.1z"/><path fill="#D80027" d="M0 170.7v-11l62.5-42.3h22.6L7.3 170.7zM7.3.1l77.8 53.2H62.5L0 11.1V.1zM256 .1v11l-62.5 42.3h-22.6L248.7.1zM248.7 170.7l-77.8-53.3h22.6l62.5 42.3v11z"/><g><ellipse fill="#FFF" cx="443.4" cy="233.6" rx="29" ry="43.5"/><ellipse fill="#FFCE00" cx="406.9" cy="317.7" rx="22" ry="9.3"/><ellipse fill="#FFCE00" cx="364" cy="317.7" rx="22" ry="9.3"/><path fill="#39B200" d="m342 190.1 43.4 86.9 43.5-86.9z"/><ellipse fill="#9B9B9B" cx="327.5" cy="233.6" rx="29" ry="43.5"/><path fill="#757575" d="m371 175.6-14.5 14.5h57.9l-14.5-14.5 14.5-43.5s-13-29-29-29-29 29-29 29l14.6 43.5z"/><circle fill="#C6B56F" cx="385.4" cy="67" r="29"/><circle fill="#A54A00" cx="386" cy="88.7" r="29"/><circle fill="#FFF" cx="443.4" cy="117.7" r="29"/><circle fill="#0049FF" cx="342.2" cy="146.7" r="29"/><circle fill="#0041F9" cx="429.8" cy="146.7" r="29"/><circle fill="#F7D71E" cx="386" cy="233.6" r="29"/><circle fill="#CEC851" cx="457.9" cy="190.1" r="29"/><circle fill="#FFF" cx="385.4" cy="289.5" r="29"/><path fill="#7C0B29" d="m371 135.7 14.5-3.5 14.5 3.5c0 7.5-14.5 11-14.5 11s-14.5-3.5-14.5-11z"/><circle fill="#FFF" cx="327.5" cy="117.4" r="29"/></g></svg>',
    Kt = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#FFF" d="M0 0h513v342H0z"/><g fill="#338AF3"><path d="M0 0h171v342H0zM342 0h171v342H342z"/></g><circle fill="#DCC26D" cx="256" cy="155.8" r="25.5"/><path fill="#628A40" d="M194.2 155.9c0 22.1 11.8 42.5 30.8 53.5 5.9 3.4 13.5 1.4 16.9-4.5 3.4-5.9 1.4-13.5-4.5-16.9-11.5-6.6-18.5-18.9-18.5-32.1 0-6.8-5.5-12.4-12.4-12.4s-12.3 5.5-12.3 12.4zm95.1 52.1c17.8-11.4 28.6-31 28.5-52.1 0-6.8-5.5-12.4-12.4-12.4-6.8 0-12.4 5.5-12.4 12.4 0 12.7-6.5 24.5-17.1 31.3-5.8 3.6-7.7 11.2-4.1 17 3.6 5.8 11.2 7.7 17 4.1.2-.1.3-.2.5-.3z"/></svg>',
    Wt = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#D80027" d="M0 0h512v341.3H0z"/><path fill="#0052B4" d="M11.1 11.1h489.7v319.1H11.1z"/><path fill="#7DBEF1" d="M256 285.3s76.4-51.3 76.4-114.6S256 56 256 56s-76.4 51.3-76.4 114.6S256 285.3 256 285.3z"/><path fill="#1C8AE6" d="M179.8 180.7h152.6l-29.3 64.9h-95.2z"/><path fill="#FFF042" d="M192.3 205.9s40.5 38.2 51 38.2c12.4 0 12.6-18.4 25.5-25.5 20.2-11.1 51-12.7 51-12.7L297 248.7l-41 36.6-46.8-39.7-16.9-39.7z"/><path fill="#259C7B" d="m256 157.5-22.5 15.6 7.9-26.2-21.8-16.5 27.4-.5 9-25.9 9 25.9 27.4.5-21.8 16.6 7.9 26.2-22.5-15.7z"/><path fill="#8E5715" d="M249.7 144.6c-.9 9.2-1.5 18.4-1.7 27.6-.3 11.9.3 20.7 2 26 2.2 6.6 7.2 12.9 14.2 18.9 5.3 4.6 10.6 8.1 14.2 10.1 3.1 1.7 7 .6 8.7-2.4 1.7-3.1.6-7-2.4-8.7-4.3-2.5-8.4-5.4-12.2-8.7-5.4-4.6-9.1-9.2-10.4-13.3-1.1-3.4-1.6-11.3-1.4-21.7.2-8.9.8-17.8 1.7-26.6.4-3.5-2.2-6.6-5.7-7-3.6-.3-6.7 2.3-7 5.8z"/><path fill="#FFF" d="m217.8 170.7 25.5 38.2h-25.5v-38.2z"/><path fill="none" stroke="#D80027" stroke-width="12" stroke-miterlimit="10" d="M256 285.3s76.4-51.3 76.4-114.6S256 56 256 56s-76.4 51.3-76.4 114.6S256 285.3 256 285.3z"/></svg>',
    _t = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#6DA544" d="M0 85.331h512v341.337H0z"/><path fill="#FFDA44" d="M0 85.331h512v170.663H0z"/><path fill="#D80027" d="M0 85.331h181.793v341.337H0z"/><path d="m98.32 195.127 15.107 46.497h48.894l-39.555 28.74 15.108 46.498-39.554-28.737-39.556 28.737 15.111-46.498-39.554-28.74h48.891z"/></svg>',
    Yt = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 600"><path fill="#009E49" d="M0 0h900v600H0V0z"/><path fill="#FFF" d="m0 0 947 300L0 600V0z"/><path fill="#FFD00D" d="M0 26.1 870 300 0 573.9V26.1z"/><path fill="#2D2D2D" d="m0 0 450 300L0 600V0z"/><path fill="#D3132F" d="m0 35 397.5 265L0 565V35z"/></svg>',
    Zt = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#D80027" d="M0 0h513v342H0z"/><g fill="#FFF"><path d="M274.2 119.8c-5.1 21.1-14.1 17.1-18.5 35.5-26.1-6.3-42.1-32.5-35.9-58.6 6.3-26.1 32.5-42.1 58.5-35.9-8.7 36.9.5 40.1-4.1 59zM206.6 135.4c18.5 11.3 11.9 18.7 28 28.6-14 22.9-43.9 30-66.8 16s-30-43.9-16-66.8c32.3 19.8 38.2 12.1 54.8 22.2zM200.6 204.6c16.5-14.1 21.4-5.5 35.8-17.8 17.4 20.4 15 51-5.4 68.4-20.4 17.4-51 15-68.4-5.4 28.7-24.6 23.2-32.6 38-45.2zM264.5 231.7c-8.3-20.1 1.4-22.1-5.9-39.6 24.8-10.3 53.2 1.5 63.4 26.3 10.3 24.8-1.5 53.2-26.3 63.4-14.5-35-23.8-32.2-31.2-50.1zM310 179.3c-21.6 1.7-20.6-8.1-39.5-6.6-2.1-26.7 17.9-50.1 44.6-52.2 26.7-2.1 50.1 17.9 52.2 44.6-37.7 2.9-37.9 12.7-57.3 14.2z"/></g></svg>',
    Jt = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#0052B4" d="M0 85.333h512V426.67H0z"/><g fill="#FFF"><path d="M223.397 255.996c.273-.304.543-.609.813-.916-.27.308-.546.61-.82.916h.007zM189.217 297.923l10.958 22.913 24.747-5.718-11.083 22.853 19.9 15.781-24.776 5.585.069 25.398-19.815-15.89-19.814 15.89.069-25.398-24.776-5.585 19.9-15.781-11.083-22.853 24.746 5.718zM387.076 326.387l5.227 10.929 11.803-2.728-5.286 10.9 9.492 7.528-11.818 2.663.032 12.114-9.45-7.578-9.45 7.578.032-12.114-11.817-2.663 9.491-7.528-5.285-10.9 11.803 2.728zM338.453 210.448l5.227 10.93 11.803-2.729-5.286 10.901 9.491 7.528-11.817 2.663.032 12.115-9.45-7.58-9.451 7.58.033-12.115-11.818-2.663 9.491-7.528-5.284-10.901 11.802 2.729zM387.076 144.198l5.227 10.93 11.803-2.73-5.286 10.902 9.491 7.527-11.817 2.664.032 12.114-9.45-7.58-9.45 7.58.032-12.114-11.817-2.664 9.491-7.527-5.285-10.902 11.803 2.73zM429.547 193.886l5.227 10.929 11.802-2.728-5.284 10.9 9.491 7.527-11.818 2.664.033 12.114-9.451-7.578-9.45 7.578.032-12.114-11.817-2.664 9.491-7.527-5.286-10.9 11.803 2.728zM399.179 251.856l4.11 12.652h13.304l-10.763 7.82 4.112 12.652-10.763-7.819-10.765 7.819 4.112-12.652-10.763-7.82h13.304z"/><path d="M256 85.333v30.553l-45.167 25.099H256v59.359h-59.103L256 233.179v22.817h-26.68l-73.494-40.826v40.826h-55.652v-48.573l-87.43 48.573H0v-30.553l45.167-25.099H0v-59.359h59.103L0 108.139V85.333h26.68l73.494 40.827V85.333h55.652v48.573l87.43-48.573z"/></g><path fill="#D80027" d="M144 85.33h-32v69.332H0v32h112v69.334h32v-69.334h112v-32H144z"/><path fill="#0052B4" d="M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"/><path fill="#FFF" d="M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"/><g fill="#D80027"><path d="M155.826 200.344 256 255.996v-15.737l-71.847-39.915zM71.846 200.344 0 240.259v15.737l100.174-55.652z"/></g><path fill="#0052B4" d="M100.174 140.982 0 85.33v15.737l71.847 39.915z"/><path fill="#FFF" d="M100.174 140.982 0 85.33v15.737l71.847 39.915z"/><g fill="#D80027"><path d="M100.174 140.982 0 85.33v15.737l71.847 39.915zM184.154 140.982 256 101.067V85.33l-100.174 55.652z"/></g></svg>',
    qt = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#FFF" d="M0 0h513v342H0z"/><g fill="#338AF3"><path d="M0 0h513v114H0zM0 228h513v114H0zM203.5 117.9l6.7 16.6 17.6 1-14 10.9 4.7 17.7-15-9.9-15 9.9 4.7-17.7-14-10.9 17.6-1zM308.5 117.9l6.7 16.6 17.6 1-14 10.9 4.7 17.7-15-9.9-15 9.9 4.7-17.7-14-10.9 17.6-1zM256 147.6l6.7 16.6 17.6 1-14 10.9 4.7 17.7-15-9.9-15 9.9 4.7-17.7-14-10.9 17.6-1zM203.5 177.3l6.7 16.6 17.6 1-14 10.9 4.7 17.6-15-9.9-15 9.9 4.7-17.6-14-10.9 17.6-1zM308.5 177.3l6.7 16.6 17.6 1-14 10.9 4.7 17.6-15-9.9-15 9.9 4.7-17.6-14-10.9 17.6-1z"/></g></svg>',
    Xt = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#FFF" d="M0 0h513v342H0z"/><path fill="#D80027" d="M0 0h513v114H0z"/><path fill="#0052B4" d="M0 228h513v114H0z"/><g fill="#338AF3"><path d="M309.3 113.2v-44l17.5-14.4 17.7 14.4v44zM203.7 113.2v-44l-17.3-14.4-17.9 14.4v44zM238.9 113.2v-44l17.6-14.4 17.6 14.4v44z"/></g><g fill="#0052B4"><path d="M309.3 113.2h-35.2v-44l17.5-14.4 17.7 14.4zM238.9 113.2h-35.2v-44l17.5-14.4 17.7 14.4z"/></g><path stroke="#D80027" fill="#FFF" d="M168.5 113.2v101.9c0 24.3 14.4 46.2 35.4 59.4 21.3 13.4 42.1 14.7 52.6 14.7s31.4-1.7 52.6-14.8c21-13 35.4-35.1 35.4-59.3V113.2h-176z"/><g fill="#D80027"><path d="M168.5 113.2h35.2v35.2h-35.2zM238.9 113.2h35.2v35.2h-35.2zM309.3 113.2h35.2v35.2h-35.2zM203.7 148.4h35.2v35.2h-35.2zM274.1 148.4h35.2v35.2h-35.2zM168.5 183.6h35.2v35.2h-35.2zM203.7 218.8h35.2V254h-35.2zM238.9 183.6h35.2v35.2h-35.2zM309.3 183.6h35.2v35.2h-35.2zM274.1 218.8h35.2V254h-35.2zM309.3 274.3c8.6-5.4 16.2-12.3 22-20.3h-22v20.3zM181.7 254c5.8 8 13.3 14.9 22 20.4V254h-22zM238.9 254v33.7c7.2 1.2 13.3 1.5 17.6 1.5 4.3 0 10.4-.3 17.6-1.6V254h-35.2z"/></g></svg>',
    $t = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#A2001D" d="M0 0h513v172H0z"/><path fill="#0052B4" d="M0 172h513v172H0z"/><path fill="#FFF" d="m381.4 251.5-110.7-13.8-110.8 13.8V85.4h221.5z"/><circle fill="#0052B4" cx="270.7" cy="182.3" r="55.4"/><circle fill="#A2001D" cx="270.7" cy="182.3" r="27.7"/><path fill="#6DA544" d="M229.1 113.1h83.1l-41.5 41.5z"/><path fill="#FFDA44" d="M256.8 140.8h27.7v83h-27.7z"/><path fill="#6DA544" d="M314.9 215.5h-88.5l-66.5 36h221.5z"/></svg>',
    Qt = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.337h512v341.326H0z"/><path fill="#D80027" d="M0 85.337h512v113.775H0z"/><path fill="#6DA544" d="M0 312.888h512v113.775H0z"/></svg>',
    tn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.333h512v341.333H0z"/><path fill="#E00" d="M0 85.333h512V256H0z"/></svg>',
    nn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.331h512v341.326H0z"/><path fill="#6DA544" d="M0 85.331h170.663v341.337H0z"/><path fill="#FF9811" d="M341.337 85.331H512v341.337H341.337z"/></svg>',
    en = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#FFF" d="M0 0h513v342H0z"/><g fill="#2E52B2"><path d="M340.6 122.4h-56.1l-28-48.6-28 48.6h-56.1l28 48.6-28 48.6h56.1l28 48.6 28-48.6h56.1l-28-48.6 28-48.6zM293.2 171 276 204.2h-38.9L219.8 171l17.2-33.2h38.9l17.3 33.2zm-36.7-71.8 11.9 23.3h-23.9l12-23.3zm-58.3 38.6h23.9l-10.8 21-13.1-21zm0 66.4 13-22.1 11.9 22.1h-24.9zm58.3 37.5-11.9-22.1h23.9l-12 22.1zm59.4-37.5h-25l11.9-22.1 13.1 22.1zm-26.1-66.4h26.1l-13 22.1-13.1-22.1zM0 21.3h512V64H0zM0 277.3h512V320H0z"/></g></svg>',
    an = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#E52D42" d="M0 0h513v342H0z"/><path fill="#FFF" d="M393.3 68.2h-45.8l-33.8 80.2-34.4-22.9s-24.7-59.1-34.4-68.2c-9.7-9.7-18.7-.6-48.9 7.8-29.6 8.4-30.8 18.7-42.2 18.7-4.8 0-19.9-17.5-27.7-22.3-12.1-7.8-16.9-4.2-13.9 7.2 1.2 4.8 10.9 10.9 16.9 19.9 7.8 11.5 12.7 25.9 12.7 25.9s10.9-10.3 16.9-12.1c9-2.4 19.3 1.8 31.4 0 15.1-2.4 31.4-10.9 31.4-10.9l4.2 43.4s-54.3 50.7-49.5 70.6 56.1 44.6 68.2 62.7c12.1 17.5-7.2 24.1-7.2 32.6s-1.8 19.9 7.2 16.3c9-3.6 10.3-18.1 18.7-31.4 6-9 10.3-13.9 11.5-17.5 1.8-9-23.5-32-37.4-48.9-6.6-7.8-19.9-18.7-19.9-18.7l39.2-29.6s67.6 27.7 82.6 18.7c15.1-9 19.3-98.3 19.3-98.3l47-11.5-12.1-11.7z"/><path fill="#F8DD4E" d="M279.3 262.4c-6 0-11.5-4.8-11.5-11.5s4.8-11.5 11.5-11.5c6 0 11.5 4.8 11.5 11.5s-5.5 11.5-11.5 11.5zm45.8-182.8c-6 0-11.5-4.8-11.5-11.5s4.8-11.5 11.5-11.5c6 0 11.5 4.8 11.5 11.5s-5.5 11.5-11.5 11.5zm0 91.1c-6 0-11.5-4.8-11.5-11.5 0-6 4.8-11.5 11.5-11.5 6 0 11.5 4.8 11.5 11.5-.6 6.7-5.5 11.5-11.5 11.5zm-136.9 45.8c-6 0-11.5-4.8-11.5-11.5 0-6 4.8-11.5 11.5-11.5 6.6 0 11.5 4.8 11.5 11.5s-5.5 11.5-11.5 11.5zm45.2-136.9c-6 0-11.5-4.8-11.5-11.5s4.8-11.5 11.5-11.5c6 0 11.5 4.8 11.5 11.5s-4.8 11.5-11.5 11.5zm22.9 91.1c-6 0-11.5-10.3-11.5-22.9s4.8-22.9 11.5-22.9c6 0 11.5 10.3 11.5 22.9s-4.8 22.9-11.5 22.9zm-114-45.2c-6 0-11.5-4.8-11.5-11.5 0-6.6 4.8-11.5 11.5-11.5 6.6 0 11.5 4.8 11.5 11.5 0 6.6-4.8 11.5-11.5 11.5z"/></svg>',
    rn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#181A93" d="M17.3 0h478.4v342H17.3V0z"/><path fill="#FFA44A" d="M0 0h513v114H0V0z"/><path fill="#1A9F0B" d="M0 228h513v114H0V228z"/><path fill="#FFF" d="M0 114h513v114H0V114z"/><circle fill="#FFF" cx="256.5" cy="171" r="34.2"/><path fill="#181A93" d="M256.5 216.6c-25.1 0-45.6-20.5-45.6-45.6s20.5-45.6 45.6-45.6 45.6 20.5 45.6 45.6-20.5 45.6-45.6 45.6zm0-11.4c18.2 0 34.2-16 34.2-34.2s-15.9-34.2-34.2-34.2-34.2 16-34.2 34.2 16 34.2 34.2 34.2z"/><circle fill="#181A93" cx="256.5" cy="171" r="22.8"/></svg>',
    on = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#FFF" d="M0-.3h513V342H0V-.3z"/><path fill="#0052B4" d="M462.9 198.1c-4 0-14-5-21-9-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12-9 0-20 6-31.1 12-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12-10 0-21 6-32.1 12-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-12-30.1-12v22l19 10c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-10 20-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-10 21-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 21 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 20 10c11 6 22 12 32.1 12s20-6 31.1-12l19-10v-22c-10 0-20 6-30.1 12-7 4-16 9-20 9zM0 31.7l19 10c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-10 20-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-10 21-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 21 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 20 10c11 6 22 12 32.1 12s20-6 31.1-12l19-10v-22c-10 1-20 6-30.1 12-7 4-16 9-20 9s-14-5-21-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12s-21 6-32.1 12c-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-11-30.1-12v22zm462.9 55.2c-4 0-14-5-21-9-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12-9 0-20 6-31.1 12-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12-10 0-21 6-32.1 12-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-12-30.1-12v22l19 9c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12l19-9v-22c-10 0-20 6-30.1 12-7 3.9-16 9-20 9zm50.1 34c-10 1-20 6-30.1 12-7 4-16 10-20 10s-14-6-21-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-14-6-20-10c-11-6-22-12-32.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-13-6-20-10c-11-6-22-12-31.1-12s-21 6-32.1 12c-6 4-16 10-20 10s-13-6-20-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 10-21 10s-13-6-20-10c-10-6-20-11-30.1-12v23c4 1 13 5 19 9 11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12c6-4 15-8 19-9v-23zm-50.1 133.3c-4 0-14-5-21-9-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12-9 0-20 6-31.1 12-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12-10 0-21 6-32.1 12-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-12-30.1-12v22l19 9c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12l19-9v-22c-10 0-20 6-30.1 12-7 4-16 9-20 9zm50.1 34c-10 1-20 6-30.1 12-7 4-16 10-20 10s-14-6-21-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-14-6-20-10c-11-6-22-12-32.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-13-6-20-10c-11-6-22-12-31.1-12s-21 6-32.1 12c-6 4-16 10-20 10s-13-6-20-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 10-21 10s-13-6-20-10c-10-6-20-11-30.1-12v23c4 0 13 5 19 9 11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12c6-4 15-9 19-9v-23z"/><path fill="#FFF" d="M0-.3h256v171H0V-.3z"/><path d="M389.8 119.9H408v78.8h-18.3l.1-78.8zm0 117.8H408v75.1h-18.3l.1-75.1z" fill="#A2001D"/><g fill="#D80027"><path d="M144-.3h-32v70H0v32h112v69h32v-69h112v-32H144v-70z"/><path d="M0-.3v15l57 39h23L0-.3zM256-.3v15l-57 39h-23l80-54z"/><path d="M0-.3v15l57 39h23L0-.3zM256-.3v15l-57 39h-23l80-54zM0 170.7v-15l57-38h23l-80 53zM256 170.7v-15l-57-38h-23l80 53z"/></g><g fill="#2E52B2"><path d="M0 22.7v31h46l-46-31zm96-23v49L23-.3h73zM256 22.7v31h-46l46-31zm-96-23v49l73-49h-73z"/><path d="M0 22.7v31h46l-46-31zm96-23v49L23-.3h73zM256 22.7v31h-46l46-31zm-96-23v49l73-49h-73zM0 147.7v-30h46l-46 30zm96 23v-49l-73 49h73zM256 147.7v-30h-46l46 30zm-96 23v-49l73 49h-73z"/></g><path fill="#5DA51E" stroke="#45602C" stroke-width="4" stroke-miterlimit="10" d="M462.8 91.5h-29.1l25.7-25.7c4.5-4.4 4.5-11.4 0-15.8l-3.4-3.4c-4.4-4.4-11.4-4.4-15.8 0l-25.9 25.9V37.4c0-6.2-5.1-11.3-11.3-11.3h-4.7c-6.2 0-11.3 5.1-11.3 11.3v31.7l-23.5-23.8c-4.7-4.7-12.2-4.7-16.9 0l-3.6 3.6c-4.7 4.7-4.7 12.4 0 17.2l25 25.4h-30.6c-6 0-10.9 4.9-10.9 10.9v4.6c0 6 4.9 10.9 10.9 10.9H369l-20.7 20.7c-4.4 4.4-4.4 11.4 0 15.8l3.4 3.4c4.4 4.4 11.4 4.4 15.8 0l19.6-19.6V167c0 6.1 5.1 11.1 11.3 11.3h4.7c6.2 0 11.3-5.1 11.3-11.3v-28.3l22.2 22.6c4.7 4.7 12.4 4.7 17.1 0l3.6-3.6c4.7-4.7 4.7-12.4 0-17.2L435.2 118h27.6c5.9 0 10.7-4.9 10.9-10.9v-4.6c0-6.1-4.9-11-10.9-11z"/><path fill="#E2DD24" stroke="#525625" stroke-width="4" stroke-miterlimit="10" d="M439.2 249.1h-79.8s-.9-13.4-6-21.8c-6.2-10.4-13.9-28.1-1.4-36.7 15.9-10.9 33.7.8 48.2.8 11.8.1 26.9-14 45-.8 12.2 8.9 3.9 28.2-1.3 36.7-7 11.5-4.7 21.8-4.7 21.8z"/></svg>',
    ln = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#FFF" d="M0 0h513v342H0z"/><path fill="#CE1126" d="M0 0h513v114H0z"/><path d="M0 228h513v114H0z"/><g fill="#547C31"><path d="M219.2 160.7h-29.3c1.5-5.7 6.6-9.9 12.8-9.9v-19.9c-18.3 0-33.1 14.9-33.1 33.1v16.5h49.6c1.8 0 3.3 1.5 3.3 3.3v6.6h-66.2v19.9h86.1v-26.5c0-12.7-10.4-23.1-23.2-23.1zM268.8 190.5v-59.6H249v79.5h33.1v-19.9zM335 190.5v-59.6h-19.8v59.6h-6.6v-19.8h-19.9v39.7h59.6v-19.9z"/></g></svg>',
    cn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#FFF" d="M0 0h512v342H0z"/><path fill="#6DA544" d="M0 0h513v114H0z"/><g fill="#D80027"><path d="M0 227.9h513v114H0zM278.8 134.8c.1 2 8.7 26.2 4.4 39.4-6.6 20.3-15.8 21.8-19.8 24.5V134l-6.9-4.2-6.9 4.2v64.7c-4-2.7-12.4-2.4-19.8-24.5-4.3-12.7 5.7-37.3 5.8-39.2 0 0-9.5 8.1-15.8 24-5.9 14.8 1.9 49.6 29.5 54.8 2.3.4 4.7 5.6 7.2 5.6 2.1 0 4.1-5.2 6-5.5 28.4-4.6 35-41.7 29.9-55.6-5.4-14.6-13.6-23.5-13.6-23.5z"/></g><g fill="#FFF" opacity=".5"><path d="M44.6 98.9h22.3v24.4H44.6zM0 98.9h22.3v24.4H0zM89.2 98.9h22.3v24.4H89.2zM133.8 98.9h22.3v24.4h-22.3zM178.4 98.9h22.3v24.4h-22.3zM223 98.9h22.3v24.4H223zM267.7 98.9H290v24.4h-22.3zM312.3 98.9h22.3v24.4h-22.3zM356.9 98.9h22.3v24.4h-22.3zM401.5 98.9h22.3v24.4h-22.3zM446.1 98.9h22.3v24.4h-22.3zM490.7 98.9H513v24.4h-22.3zM44.6 216.9h22.3v25.5H44.6zM0 216.9h22.3v25.5H0zM89.2 216.9h22.3v25.5H89.2zM133.8 216.9h22.3v25.5h-22.3zM178.4 216.9h22.3v25.5h-22.3zM223 216.9h22.3v25.5H223zM267.7 216.9H290v25.5h-22.3zM312.3 216.9h22.3v25.5h-22.3zM356.9 216.9h22.3v25.5h-22.3zM401.5 216.9h22.3v25.5h-22.3zM446.1 216.9h22.3v25.5h-22.3zM490.7 216.9H513v25.5h-22.3z"/></g></svg>',
    sn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#0052B4" d="M0 85.334h512v341.337H0z"/><path fill="#FFF" d="M512 295.883H202.195v130.783H122.435V295.883H0V216.111h122.435V85.329H202.195v130.782H512V277.329z"/><path fill="#D80027" d="M512 234.666v42.663H183.652v149.337h-42.674V277.329H0v-42.663h140.978V85.329h42.674v149.337z"/></svg>',
    hn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M341.334 85.33H0v341.332h512V85.33z"/><path fill="#6DA544" d="M0 85.333h170.663V426.67H0z"/><path fill="#D80027" d="M341.337 85.333H512V426.67H341.337z"/></svg>',
    un = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#FFF" d="M0 0h513v342H0z"/><path fill="#D80027" d="M301.8 171 513 30.2V0h-45.3L256.5 140.8 45.3 0H0v30.2L211.2 171 0 311.8V342h45.3l211.2-140.8L467.7 342H513v-30.2z"/><path fill="#FFDA44" d="m233.7 44.6 22.3 5.6 22.3-5.6 4-20.9-14.9 6.5L256 14.8l-11.4 15.4-14.9-6.5z"/><path fill="#D80027" d="M233.7 44.6s-4 12.9-4 29.9c0 27.9 26.3 41.3 26.3 41.3s26.3-15.5 26.3-41.3c0-15.4-4-29.9-4-29.9s-8.1-5-22.3-5-22.3 5-22.3 5z"/></svg>',
    fn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#6DA544" d="M0 85.337h512v341.326H0z"/><path d="M215.864 256.006 0 399.911V112.089zM512 112.089v287.822L296.136 256.006z"/><path fill="#0052B4" d="M512 112.089 296.136 256.006 512 399.911v26.757h-40.125L256 282.752 40.125 426.668H0v-26.757l215.864-143.905L0 112.089V85.331h40.125L256 229.248 471.875 85.331H512z"/><path fill="#FFDA44" d="M512 112.089 296.136 256.006 512 399.911v26.757h-40.125L256 282.752 40.125 426.668H0v-26.757l215.864-143.905L0 112.089V85.331h40.125L256 229.248 471.875 85.331H512z"/></svg>',
    vn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.339h512v341.326H0z"/><path d="M0 85.339h512v113.775H0z"/><path fill="#6DA544" d="M0 312.89h512v113.775H0z"/><path fill="#D80027" d="M256 256.006 0 426.669V85.331z"/><path fill="#FFF" d="m77.913 224.802 7.876 16.469 17.786-4.11-7.965 16.426 14.303 11.343-17.808 4.014.049 18.255-14.241-11.421-14.241 11.421.05-18.255-17.809-4.014 14.303-11.343-7.965-16.426 17.786 4.11z"/></svg>',
    pn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.331h512v341.337H0z"/><circle fill="#D80027" cx="256" cy="255.994" r="96"/></svg>',
    gn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.331h512v341.337H0z"/><path d="M0 85.331h512v90.579H0z"/><path fill="#496E2D" d="M0 336.089h512v90.568H0z"/><path fill="#A2001D" d="M0 198.606h512v114.799H0z"/><g fill="#FFF"><path d="m323.265 139.803-25.583-11.809L256 222.376l-41.682-94.382-25.583 11.809 51.749 116.191-51.749 116.192 25.583 11.808L256 289.613l41.682 94.381 25.583-11.808-51.749-116.192z"/><path d="M273.376 150.931C263.472 140.115 256 133.898 256 133.898s-7.472 6.216-17.376 17.032v210.127C248.528 371.873 256 378.091 256 378.091s7.472-6.216 17.376-17.033V150.931z"/></g><g fill="#A2001D"><path d="M209.04 191.226v129.535c10.465 18.542 23.274 33.742 32.872 43.818V147.408c-9.599 10.076-22.408 25.275-32.872 43.818zM302.96 191.226c-10.465-18.543-23.274-33.742-32.872-43.818V364.58c9.599-10.077 22.407-25.276 32.872-43.818V191.226z"/></g><path d="M302.96 191.226v129.535c10.594-18.774 18.784-40.973 18.784-64.767s-8.19-45.993-18.784-64.768zM209.04 191.226v129.535c-10.594-18.774-18.784-40.973-18.784-64.767s8.19-45.993 18.784-64.768z"/></svg>',
    dn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 342"><g fill="#D80027"><path d="M0 0h513v342H0z"/><circle cx="256" cy="170.7" r="170.7"/></g><path fill="#FFDA44" d="M382.4 170.7 330.8 195l27.5 50-56.1-10.7-7.1 56.6-39.1-41.7-39.1 41.7-7.1-56.6-56.1 10.7 27.5-50-51.6-24.3 51.6-24.3-27.5-50.1 56.1 10.8 7.1-56.7L256 92.1l39.1-41.7 7.1 56.7 56.1-10.8-27.5 50.1z"/><circle fill="#D80027" cx="257.4" cy="170.7" r="71.6"/><g fill="#FFDA44"><path d="M214.2 170.7c-2.1 0-4.1.1-6.2.3.1 12 4.4 22.9 11.6 31.5 3.8-10.3 9.5-19.6 16.7-27.7-6.9-2.7-14.3-4.1-22.1-4.1zM240.8 217.2c5.2 1.9 10.8 2.9 16.6 2.9 5.8 0 11.4-1 16.6-2.9-2.8-11.1-8.7-21-16.6-28.8-7.9 7.8-13.8 17.7-16.6 28.8zM300.2 146c-8.5-14.8-24.5-24.7-42.8-24.7-18.3 0-34.2 9.9-42.8 24.7 15.6.1 30.2 4.3 42.8 11.6 12.6-7.3 27.2-11.6 42.8-11.6zM278.5 174.8c7.2 8 12.9 17.4 16.7 27.7 7.2-8.5 11.5-19.5 11.6-31.5-2-.2-4.1-.3-6.2-.3-7.7 0-15.2 1.4-22.1 4.1z"/></g></svg>',
    mn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#D80027" d="M0 85.337h512v341.326H0z"/><g fill="#0052B4"><path d="M0 85.337h512v113.775H0zM0 312.888h512v113.775H0z"/></g><path fill="#FFF" d="M303.49 281.971v-17.809h-11.873v-23.745l-11.872-11.872-11.872 11.872v-23.744L256 204.8l-11.873 11.873v23.744l-11.872-11.872-11.872 11.872v23.745H208.51v17.809h-11.872v17.808h118.724v-17.808z"/></svg>',
    Fn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 450 300"><path fill="#CE1126" d="M0 0h450v300H0V0z"/><g fill="#FCD116"><circle cx="227.6" cy="161.2" r="56.2"/><path d="m254.1 73.4-23.7 26 28.6 6.5zM202.6 73.6l-4.8 33.1 28.5-8zM296.9 100.3l-34.7 8.5 20.1 23.7zM158.6 98.5l15.5 32.7 20.2-22.7zM317.6 143.8l-34.4-9.9 5.6 29.5zM135.6 141.2l31.9 19.8 5.2-27.7z"/></g><path fill="#003F87" d="M0 175h450v125H0V175z"/><path fill="#FFF" d="M0 267c15 0 30 13 45 13s30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13v-21c-15 0-30 13-45 13s-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13v21zm0-43c15 0 30 13 45 13s30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13v-21c-15 0-30 13-45 13s-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13v21zm0-43c15 0 30 13 45 13s30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13v-21c-15 0-30 13-45 13s-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13v21z"/><path fill-rule="evenodd" clip-rule="evenodd" fill="#FCD116" d="m183.2 48.3-1.1-5.3 22.4-3.7s-30.1-7.1-40-10.7c-14.3-5.1-16.3-12.1-16.3-12.1s44.7 11 64.8 11c4.3 0 12.8 10.7 12.8 10.7s14.8-14.9 21.9-15.4c32.1-2.3 66.6-6.4 66.6-6.4s-10 6.7-16 8.5c-16.2 4.9-50.6 11.7-50.6 11.7l-4.8 7.5H277l-14.4 4.3 7.4 6.9s-7.8-4.1-18.1-2.1c-7.1 1.3-15.4 6-22.9 8-18.7 4.8-29.9-12.8-29.9-12.8l-15.9-.1z"/></svg>',
    Mn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#0052B4" d="M0 85.337h512v341.326H0z"/><path fill="#FFDA44" d="M0 85.337h512v85.337H0z"/><path fill="#FFF" d="M0 170.663h512V256H0z"/><path fill="#D80027" d="M0 256h512v85.337H0z"/><path fill="#6DA544" d="M256 256.006 0 426.668V85.331z"/><g fill="#FFF"><path d="M68.638 256c0-24.865 17.476-45.638 40.812-50.734a52.059 52.059 0 0 0-11.13-1.208c-28.688 0-51.942 23.255-51.942 51.942s23.255 51.942 51.942 51.942c3.822 0 7.543-.425 11.13-1.208-23.337-5.096-40.812-25.869-40.812-50.734z"/><path d="m108.877 211.478 2.762 8.503h8.94l-7.232 5.256 2.762 8.502-7.232-5.255-7.234 5.255 2.764-8.502-7.234-5.256h8.94zM108.877 233.739l2.762 8.503h8.94l-7.232 5.255 2.762 8.503-7.232-5.255-7.234 5.255 2.764-8.503-7.234-5.255h8.94zM108.877 256l2.762 8.503h8.94l-7.232 5.255 2.762 8.503-7.232-5.255-7.234 5.255 2.764-8.503-7.234-5.255h8.94zM108.877 278.261l2.762 8.502h8.94l-7.232 5.256 2.762 8.503-7.232-5.255-7.234 5.255 2.764-8.503-7.234-5.256h8.94z"/></g></svg>',
    wn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#D80027" d="M0 0h513v342H0z"/><path fill="#6DA544" d="M512 0H0v342"/><path fill="#FFDA44" d="M307.7 0 0 194.5V342h206.9L513 148.5V0z"/><path d="M513 0H385.2L0 249.4V341l126.2 1L513 91.6z"/><g fill="#FFF"><path d="m141.1 187 31.2 24 32.3-22.2-13.1 37 31.1 23.9-39.2-1.1-13.2 37-11.1-37.6-39.2-1.1 32.3-22.2zM310.6 70.8l31.2 23.9 32.3-22.2-13.1 37 31.1 23.9-39.2-1.1-13.2 37-11.1-37.6-39.2-1.1 32.4-22.2z"/></g></svg>',
    zn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#91DC5A" d="M0 85.331h512v341.337H0z"/><path fill="#FFF" d="M0 85.331h512v341.337H0z"/><g fill="#0052B4"><path d="M0 85.331h512v57.188H0zM0 369.48h512v57.177H0z"/></g><path fill="#D80027" d="M0 165.215h512v181.582H0z"/><circle fill="#FFF" cx="190.33" cy="255.994" r="65.668"/><path fill="#D80027" d="m190.332 190.332 14.734 45.346h47.757l-38.65 28.028 14.849 45.481-38.69-28.16-38.631 28.107 14.79-45.428-38.616-28.028h47.722z"/></svg>',
    yn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 600"><path fill="#FFF" d="M0 0h900v600H0z"/><g transform="rotate(-56.31)"><g stroke="#000" stroke-width="25"><path d="M-75 228.3H75m-150 37.5H75m-150 37.5H75M-75 778.3H75m-150 37.5H75m-150 37.5H75"/></g><path stroke="#FFF" stroke-width="12.5" d="M0 753.3v125"/><circle fill="#ca163a" cy="540.8" r="150"/><path fill="#0e4896" d="M0 390.8c-41.4 0-75 33.6-75 75s33.6 75 75 75 75 33.6 75 75-33.6 75-75 75c-82.8 0-150-67.2-150-150s67.2-150 150-150z"/></g><g stroke="#000" stroke-width="25"><path d="m231.56 535.73-83.205-124.808M262.76 514.928l-83.205-124.807m114.407 104.006-83.205-124.808M689.187 230.644l-83.205-124.807M720.39 209.843 637.184 85.036m114.407 104.006L668.386 64.234"/></g><path stroke="#FFF" stroke-width="12.5" d="m205.6 462.897 31.202-20.8m389.981-259.989 36.444-24.296m31.202-20.801 31.202-20.801"/></svg>',
    An = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.337h512v341.326H0z"/><path fill="#6DA544" d="M0 85.337h512v113.775H0z"/><path fill="#D80027" d="M0 312.888h512v113.775H0z"/><path d="M166.957 312.889 0 426.663V85.337l166.957 113.774z"/></svg>',
    Un = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#0052B4" d="M0 85.334h512v341.337H0z"/><circle fill="#6DA544" cx="384" cy="181.79" r="29.682"/><path fill="#D80027" d="M332.054 174.377h103.88v44.522h-103.88z"/><path fill="#496E2D" d="M435.942 255.997v-.001.001z"/><path fill="#FFDA44" d="M332.058 285.678v29.682h15.616c9.364 9.176 22.18 14.84 36.326 14.84 14.147 0 26.962-5.664 36.326-14.84h15.616v-29.682H332.058z"/><path fill="#338AF3" d="M332.058 211.475v44.522c0 39.759 51.942 51.942 51.942 51.942s51.942-12.182 51.942-51.942v-44.522H332.058z"/><g fill="#F3F3F3"><path d="M383.997 235.256c-12.985 0-12.985 11.873-25.97 11.873s-12.985-11.873-25.97-11.873v20.777c12.985 0 12.985 11.873 25.97 11.873s12.985-11.873 25.97-11.873c12.986 0 12.986 11.873 25.973 11.873 12.986 0 12.986-11.873 25.973-11.873v-20.777c-12.986 0-12.986 11.873-25.973 11.873-12.986-.001-12.986-11.873-25.973-11.873zM383.997 193.666c-12.985 0-12.985 11.873-25.97 11.873s-12.985-11.873-25.97-11.873v20.777c12.985 0 12.985 11.873 25.97 11.873s12.985-11.873 25.97-11.873c12.986 0 12.986 11.873 25.973 11.873 12.986 0 12.986-11.873 25.973-11.873v-20.777c-12.986 0-12.986 11.873-25.973 11.873-12.986 0-12.986-11.873-25.973-11.873z"/></g><path fill="#FFF" d="M256 85.334v22.617l-46.069 30.709H256v64h-46.069L256 233.38v22.617h-22.628L160 207.078v48.919H96v-48.919l-73.372 48.919H0V233.38l46.069-30.72H0v-64h46.069L0 107.951V85.334h22.628L96 134.241V85.334h64v48.907l73.372-48.907z"/><g fill="#D80027"><path d="M144 85.329h-32v69.334H0v32h112v69.334h32v-69.334h112v-32H144z"/><path d="M0 85.329v15.082l57.377 38.252H80zM256 85.329v15.082l-57.377 38.252H176z"/><path d="M0 85.329v15.082l57.377 38.252H80zM256 85.329v15.082l-57.377 38.252H176zM0 255.997v-15.082l57.377-38.252H80zM256 255.997v-15.082l-57.377-38.252H176z"/></g></svg>',
    Hn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#36B6CC" d="M0 0h513v342H0V0z"/><circle fill="#FFD400" cx="256.5" cy="170.9" r="68.4"/><path fill="#FFD400" d="m256.5 251.5-27.9 41.7-7.1-49.7-43.2 25.5 15.2-47.8-50 4.2 34.4-36.5-46.9-18 46.8-18-34.4-36.5 50 4.2-15.2-47.8 43.2 25.4 7.1-49.7 27.9 41.7 27.9-41.7 7.1 49.7 43.2-25.4-15.2 47.8 50-4.2-34.3 36.6 46.8 17.9-46.8 18 34.4 36.5-50-4.2 15.2 47.8-43.2-25.4-7.1 49.7c0-.1-27.9-41.8-27.9-41.8zm0-.8c44.1 0 79.9-35.8 79.9-79.9S300.6 91 256.5 91s-79.9 35.8-79.9 79.9 35.8 79.8 79.9 79.8zM22.8 28.3c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6V28.3zm0 45.7c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6V74zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.7c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm22.8-22.8c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7V245c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0-45.7c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6V188zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6V96.8zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6V51.2z"/></svg>',
    xn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#0052B4" d="M0 0h513v342H0z"/><g fill="#D80027"><path d="M0 .1h513v90.7H0zM0 251.3h513V342H0z"/></g><circle fill="#FFF" cx="256.5" cy="171" r="65.9"/></svg>',
    En = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#FFF" d="M0 0h513v342H0z"/><g fill="#D80027"><path d="M0 .2h513v90.7H0zM.5 251.3H513V342H.5z"/></g><path fill="#6DA544" d="M290.3 193.5 256 130.7l-34.3 62.8h25.7v17.2h17.2v-17.2z"/><path fill="#14AF5A" d="M241.3 213.1c4.4-4.4 4.4-11.6-.1-16l4.7 4.7c-5.2-4.7-12.2-6.6-19.1-5.3l-23.5 5.9c-6.1 1.5-6.8-.4-1.8-4.2l27.1-20.3c5.1-3.8 4.2-6.9-2.3-6.9h-11c-6.4 0-7-2.3-1.5-5.1l25.3-12.7c5.6-2.8 5.1-5.1-1.5-5.1h-11c-6.4 0-7.4-3.1-2.3-6.9l27.1-20.3c5.6-3.8 12.9-3.8 18.5 0l27.1 20.3c5.1 3.8 4.2 6.9-2.3 6.9h-11c-6.4 0-7 2.3-1.5 5.1l25.3 12.7c5.6 2.8 5.1 5.1-1.5 5.1h-11c-6.4 0-7.4 3.1-2.3 6.9l27.1 20.3c5.1 3.8 4.4 5.7-1.8 4.2l-23.5-5.9c-6.8-1.3-13.9.6-19.1 5.3l4.7-4.7c-4.4 4.4-4.5 11.5-.1 16l6.8 6.8c4.4 4.4 3.1 8-3.3 8h-45.8c-6.2 0-7.7-3.6-3.3-8 .1.1 6.9-6.8 6.9-6.8z"/></svg>',
    Sn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#55B2FF" d="M0 0h513v342H0z"/><path fill="#F3F3F3" d="M148.5 298.1h216l-108-254.2z"/><path fill="#333" d="m186 272.7 70.5-160.3L327 272.7z"/><path fill="#FFDA44" d="M148.5 298.1h216l-108-101.7z"/></svg>',
    Bn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#D80027" d="M0 0h513v342H0z"/><path fill="#0052B4" d="M0 0h513v171H0z"/><path fill="#FFDA44" d="M149.3 98.1c0-14-11.3-25.3-25.3-25.3-6.5 0-12.4 2.4-16.9 6.4V64.4h8.4V47.5h-8.4v-8.4H90.3v8.4h-8.4v16.9h8.4v14.9c-4.5-4-10.4-6.4-16.9-6.4-14 0-25.3 11.3-25.3 25.3 0 7.5 3.3 14.2 8.4 18.8v14.9h84.3V117c5.3-4.7 8.5-11.5 8.5-18.9z"/></svg>',
    Dn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#FFDA44" d="M0 0h513v342H0z"/><path fill="#A2001D" d="M222.6 22.3h267.1v296.8H222.6z"/><path fill="#D80027" d="M22.3 22.3h200.3v296.8H22.3z"/><path fill="#FFDA44" d="M200.3 0h22.3v342h-22.3z"/><path fill="#6DA544" d="M22.3 22.3h89v296.8h-89z"/><path fill="#FF9811" d="M111.3 22.3h89v296.8h-89z"/><path fill="#FFDA44" d="M368.2 156.8c-1.4-2 0-37.9 0-37.9.9-7.4.1-8.4 1-11.4.9-2.9 5.4-11.6 5.4-11.6s-6-2.3-10.3-.6c-4.3 1.7-24.7-7.5-31.2 3.4-4.4 7-23.6 16.2-24.6 14-1-2.2-5.9-5-6.9-2.9s-.7 13.9 0 16c.8 2.6 9.8 2 12.3 3.1 3.7 1.8 12.2 8.2 11.9 10.7-.3 2.5-22.5-6-24.2-4.5-1.4 1.2-1.9 13.2-.4 15 1.8 2.1 23.4 5.6 25 7.5 1.6 1.9-13.1 7.4-12.3 25 .7 14.7 8 17.4 8 17.4s-2.4 3.6-7.8 3.1c-6.2-.6-27.4-17.7-27.4-17.7s-3.5-109 3.6-121.4c4.9-8.5-22.7 10.1-22.7 50.8V151c0 6.6-1.4 22.4 2.6 34 0 0-.4 46.9 1.5 49.6s12.7 2.2 14.8 0 0-30 0-30c7.7.2 18.3 17.5 32.5 16.4 20.6-1.6 28.7-9.9 34.3-5 8.1 7.1 5.5 23.2.4 31.5-2.2 3.5-14.3 4.7-15.7 7.6-1.4 2.9.5 5.4.5 5.4h29.7s1.4-20.5 2.7-26.1c1.3-5.7-.6-10.7 5.9-10.4 23.5 1.1 39.8-15.3 45.5-8 3.2 4.1 5.6 29.9 3.3 33.3-2.2 3.4-13.8 2.8-15.2 6.7-1.4 4 .8 4.4.8 4.4h29.7s-.4-21.2 2.5-27.7 4.9-10.4 9.3-17.2c4.4-6.8 11.3-15.7 11.3-36.2 0-14.2-8.1-22.8-8.1-22.8H417c-14.1.2-47.4 2.3-48.8.3zM232.2 32.3c10.7-10.6 20.2-2.7 22.2 2.1 1.9 4.8 2.1 8.2 2.8 13.6.9 6.9 4.9 14 4.9 14s-7.1-3.8-14.7-4.2c-4.7-.3-9-.6-13.6-2.5-5.7-2.3-11.7-12.9-1.6-23zM480.6 32.2c10.7 10.6 2.8 20.2-2 22.2s-8.2 2.1-13.6 2.8c-6.9.9-14 5-14 5s3.7-7.1 4.2-14.7c.3-4.7.6-9.1 2.4-13.6 2.2-5.7 12.8-11.8 23-1.7zM480.7 309.1c-10.7 10.6-20.2 2.6-22.2-2.2-1.9-4.8-2.1-8.2-2.7-13.6-.8-6.9-4.9-14.1-4.9-14.1s7 3.8 14.7 4.3c4.7.3 9 .6 13.6 2.5 5.7 2.4 11.7 13.1 1.5 23.1zM232.5 309c-10.6-10.7-2.7-20.2 2.1-22.2 4.8-1.9 8.2-2.1 13.6-2.8 6.9-.9 14-4.9 14-4.9s-3.8 7.1-4.2 14.7c-.3 4.7-.6 9-2.5 13.6-2.3 5.7-12.9 11.8-23 1.6z"/><path fill="none" stroke="#FFDA44" stroke-width="6" stroke-miterlimit="10" d="M446.9 162.4s7.5-2.6 8.4-16.1c.6-8.6-19.8-16-39-11.5-19.7 4.6-34-3.1-34-14.6 0-22.9 29.7-16.2 38.9-11.3 9.1 4.9 29.7 23.5 35.1 9.4"/></svg>',
    bn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><g fill="#bf0a30"><path d="M0 0h512v31.1H0zM0 62.2h512v31.1H0zM0 124.5h512v31.1H0zM0 186.8h512v31.1H0zM0 249.3h512v31.1H0zM0 310.9h512V342H0z"/></g><path fill="#002868" d="M0 0h155.6v155.6H0z"/><path fill="#FFF" d="m77.8 30.2 10.7 32.9h34.6l-28 20.4 10.7 32.9-28-20.3-28 20.3 10.7-32.9-28-20.4h34.6z"/></svg>',
    Nn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#FFF" d="M0 0h513v342H0z"/><path fill="#0052B4" d="M0 0h513v114H0z"/><path fill="#6DA544" d="M0 227.6h513v114H0z"/><path d="m245.2 171 7.7-23.1c2-5.9 5.1-6 7.1 0l7.7 23.1 19.4 29.1c1.7 2.6 1.3 6.3-1.2 8 0 0-6.9 8-29.5 8s-29.5-8-29.5-8c-2.4-2-2.9-5.4-1.2-8l19.5-29.1z"/><path d="M256.5 171c-12.5 0-22.6-10.1-22.6-22.6 0-12.5 10.1-22.6 22.6-22.6s22.6 10.1 22.6 22.6c0 12.5-10.2 22.6-22.6 22.6zm0 0c6.2 0 11.3-16.3 11.3-22.6 0-6.2-5.1-11.3-11.3-11.3-6.2 0-11.3 5.1-11.3 11.3 0 6.3 5 22.6 11.3 22.6z"/></svg>',
    jn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#6DA544" d="M0 85.337h512v341.326H0z"/><path fill="#FFDA44" d="M0 85.337h512v113.775H0z"/><path fill="#D80027" d="M0 312.888h512v113.775H0z"/></svg>',
    Ln = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.337h512v341.326H0z"/><path fill="#D80027" d="M0 85.337h512v113.775H0z"/><path fill="#338AF3" d="M0 312.888h512v113.775H0z"/></svg>',
    Cn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#FFF" d="M0 0h513v342H0z"/><g fill="#A2001D"><path class="st1" d="M0 0h513v127.6H0zM0 214.4h513V342H0z"/></g></svg>',
    Tn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path d="M0 85.337h512v341.326H0z"/><path fill="#D80027" d="M0 85.337h512v113.775H0z"/><path fill="#496E2D" d="M0 312.888h512v113.775H0z"/><g fill="#FFF"><path d="m281.424 236.026 8.962 12.35 14.513-4.706-8.975 12.339 8.961 12.349-14.509-4.724-8.976 12.34.01-15.258-14.51-4.725 14.514-4.706z"/><path d="M256.965 286.868c-17.048 0-30.868-13.821-30.868-30.868s13.821-30.868 30.868-30.868a30.742 30.742 0 0 1 14.684 3.71c-6.851-6.698-16.218-10.833-26.556-10.833-20.982 0-37.992 17.01-37.992 37.992s17.01 37.992 37.992 37.992c10.338 0 19.706-4.135 26.556-10.833a30.738 30.738 0 0 1-14.684 3.708z"/></g></svg>',
    In = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#D80027" d="M0 85.337v341.326h512V85.337z"/><path fill="#20661b" d="M352 226.484h-73.337L256 156.738l-22.663 69.748H160l59.331 43.107-22.663 69.749L256 296.232l59.332 43.107-22.663-69.749L352 226.484zm-116.063 37.711 7.663-23.585h24.8l7.663 23.585v.001L256 278.772l-20.063-14.577zm27.873-37.711h-15.619L256 202.447l7.81 24.037zm24.269 28.982-4.827-14.856h25.274l-20.447 14.856zm-59.331-14.856-4.827 14.856-20.447-14.856h25.274zm-5.211 61.748 7.81-24.036 12.636 9.181-20.446 14.855zm44.479-14.856 12.636-9.181 7.81 24.036-20.446-14.855z"/></svg>',
    Rn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.333h512v341.333H0z"/><path fill="#c70000" d="M0 85.333h512V256H0z"/></svg>',
    Vn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#FFDA44" d="M0 0h513v342H0z"/><path fill="#D80027" d="M342 0h171v342H342z"/><path fill="#0052B4" d="M0 0h171v342H0z"/><path fill="#AF7F59" d="M206.2 129.1h33.2L256 79.3l16.6 49.8h33.2v99.6L256 262l-49.8-33.2v-99.7zm33.2 33.3v49.8h33.2v-49.8h-33.2z"/></svg>',
    kn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#E6BE53" d="M0 0h513v342H0z"/><path fill="#E01D24" d="M20 20h473v302H20z"/><path fill="#E6BE53" d="M248.5 112.9c4.4 4.4 11.6 4.4 16 0l-4.7 4.7 22.7-22.7c4.9-4.5 12.1-5.6 18.2-2.8l2.1 1c5.7 2.9 6.7 8.7 2.3 13.1l4.7-4.7-22.8 22.8c-4.5 4.9-5.6 12.1-2.8 18.2l1 2.1c2.9 5.7 5.1 15.4 5.1 21.6v-11.3c0 6.2 4.4 9.1 10.2 6.2l2.1-1c5.7-2.9 6.7-8.7 2.3-13.1l4.7 4.7c-4.4-4.4-4.4-11.6 0-16l-4.7 4.7c5.2-5.5 9.6-11.6 13.1-18.2l1-2.1c2.9-5.7 6.3-15.1 7.9-21.2l5.8-23.3c1.5-6 5.9-6.8 9.6-1.8l20.2 26.9c3.8 5.1 6.9 14 6.9 20.6v22.4c0 6.3-2.2 15.8-5.1 21.7l-1 2.1c-3.5 6.6-7.9 12.7-13.1 18.2l-6.8 6.8c-5.4 5.2-11.5 9.6-18.2 13.1l-2.1 1c-5.7 2.9-15.5 5.1-21.6 5.1-6.2 0-6.9 2.2-1.1 5.1l2.1 1c5.7 2.9 13.8 8.7 18.2 13.1l-4.7-4.7c4.4 4.4 11.6 4.4 16 0l-4.7 4.7c4.4-4.4 11.6-4.4 16 0L339 226c4.6 4.9 5.7 12.1 2.9 18.2l-1 2.1c-2.9 5.7-10.4 10.2-16.4 10.2-7.5-.3-14.8-2-21.6-5.1l-2.1-1c-6.5-3.6-11.8-8.9-15.4-15.4l-1-2.1c-2.9-5.7-8.7-6.7-13.1-2.3l4.7-4.7c-4.4 4.7-5.2 11.8-1.8 17.3l10.3 15.4c3.4 5.1 2 12.1-3.1 15.5L266 284.4c-5.7 3.4-12.8 3.4-18.6 0L232 274.1c-5.1-3.4-6.5-10.3-3.1-15.5l10.3-15.4c3.4-5.5 2.6-12.6-1.8-17.3l4.7 4.7c-4.4-4.4-10.2-3.6-13.1 2.3l-1 2.1c-2.9 5.7-9.5 12.4-15.4 15.4l-2.1 1c-5.7 2.9-15.5 5.1-21.6 5.1-6.9-.3-13.1-4.2-16.4-10.2l-1-2.1c-2.8-6.1-1.6-13.3 2.9-18.2l-4.7 4.7c4.4-4.4 11.6-4.4 16 0L181 226c4.4 4.4 11.6 4.4 16 0l-4.7 4.7c5.5-5.2 11.6-9.6 18.2-13.1l2.1-1c5.7-2.9 5-5.1-1.1-5.1-7.5-.3-14.8-2-21.6-5.1l-2.1-1c-6.6-3.5-12.7-7.9-18.2-13.1l-6.8-6.8c-5.2-5.4-9.6-11.5-13.1-18.2l-1-2.1c-3.1-6.8-4.9-14.2-5.1-21.7V121c0-6.3 3.1-15.6 6.9-20.6l20.2-26.9c3.8-5.1 8.1-4.3 9.6 1.8l5.8 23.3c2 7.3 4.6 14.4 7.9 21.2l1 2.1c2.9 5.7 8.7 13.8 13.1 18.2l-4.7-4.7c4.4 4.4 4.4 11.6 0 16l4.7-4.7c-4.4 4.4-3.6 10.2 2.3 13.1l2.1 1c5.7 2.9 10.2 0 10.2-6.2v11.3c0-6.2 2.2-15.7 5.1-21.6l1-2.1c2.8-6.1 1.7-13.2-2.8-18.2l-22.7-22.7 4.7 4.7c-4.4-4.4-3.6-10.2 2.3-13.1l2.1-1c6.1-2.8 13.2-1.7 18.2 2.8l22.7 22.7-4.8-4.5zm-18-40.7c-4.4-4.4-3.2-9.5 2.8-11.5l12.4-4.2c6-2 15.5-2 21.5 0l12.4 4.2c6 2 7.2 7.1 2.8 11.5l-6.8 6.8c-5.3 4.7-12.1 7.5-19.2 7.9-6.2 0-14.8-3.5-19.2-7.9.1 0-6.7-6.8-6.7-6.8z"/><path fill="#215F90" d="M233.9 200.2c0 6.2 1.7 6.4 4.2.5 0 0 7.1-23.2 18.4-23.2 11.3 0 18.6 23.6 18.6 23.6 2.2 5.7 4 5.3 4-1.1v-11.2c0-18.7-10.1-33.9-22.6-33.9-12.5 0-22.6 15.2-22.6 33.9v11.4z"/></svg>',
    On = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 108 72"><path d="M0 0h108v72H0z" fill="#003787"/><path d="M0 0h108L60 48v24H48V48z" fill="#fff"/><circle cx="54" cy="30" r="8" fill="#f9d90f"/><path d="M44 30h20L54 48z" fill="#fff"/><path d="M54 48 38 33h32z" fill="#cf142b"/></svg>',
    Pn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#6DA544" d="M512 426.666V85.329H0v341.337h512z"/><path fill="#D80027" d="M512 85.331H0v170.666h512V85.331z"/><path fill="#FFF" d="M0 85.334h181.793v341.337H0z"/></svg>',
    Gn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#1E509C" d="M0 0h513v342H0z"/><path fill="#FFF" d="M513 176.1V81.3L0 342l513-165.9z"/><path fill="#F18D36" d="M513 0v81.3L0 342 513 0z"/><path fill="#FFF" d="m126.7 99.3-7.8-54.1-7.7 54.1-20.8-23.7 10.7 31.6-31.5-10.7 23.6 20.8-54.1 7.7 54.1 7.7-23.6 20.8 31.5-10.7-10.7 31.6 20.8-23.7 7.7 54.1 7.8-54.1 20.7 23.7-10.6-31.6 31.5 10.7-23.6-20.8 54-7.7-54-7.7 23.6-20.8-31.5 10.7 10.6-31.6z"/></svg>',
    Kn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFDA44" d="M0 85.333h512V426.67H0z"/><g fill="#D80027"><path d="M383.875 426.662 256 252.286l26.827 174.376zM133.565 85.33 256 252.286 230.314 85.33zM229.171 426.662 256 252.286 128.124 426.662zM0 85.33V212.9l256 39.386L28.333 85.33zM0 426.662h18.212L256 252.286 0 291.67zM256 252.286 512 212.9V85.33h-28.331zM281.686 85.33 256 252.286 378.434 85.33zM512 426.662V291.671l-256-39.385 237.787 174.376z"/><circle cx="256" cy="252.29" r="59.359"/></g><circle fill="#FFDA44" cx="256" cy="252.29" r="44.522"/></svg>',
    Wn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFDA44" d="M0 85.331h512v341.337H0z"/><path fill="#6DA544" d="M0 85.331h170.663v341.337H0z"/><path fill="#D80027" d="M341.337 85.331H512v341.337H341.337z"/></svg>',
    _n = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#6DA544" d="M0 85.337h512v341.326H0z"/><path fill="#FFDA44" d="M0 85.337h512v113.775H0z"/><path fill="#D80027" d="M0 312.888h512v113.775H0z"/><path fill="#FFF" d="M384 227.261h-97.783L256 134.265l-30.217 92.997H128l79.108 57.475-30.217 92.998L256 320.925l79.108 56.81-30.217-92.998L384 227.261z"/></svg>',
    Yn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#095FAD" d="M0 0h513v342H0z"/><g fill="#BE1229"><path d="M342 0h171v342H342zM0 0h171v342H0z"/></g><g fill="#FFDA44"><path d="M108.3 166.3h14.8v74.2h-14.8zM48.9 166.3h14.8v74.2H48.9z"/><circle cx="86" cy="203.4" r="14.8"/><path d="M71.2 225.7h29.7v14.8H71.2zM71.2 166.3h29.7v14.8H71.2z"/><circle cx="86" cy="144" r="14.8"/><path d="M76.3 123.9h19.5L86 108.3z"/></g></svg>',
    Zn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#00745a" d="M0 85.331h512v341.337H0z"/><path fill="#FFF" d="M285.682 248.878c-4.19 0-8.166.836-11.861 2.164 2.023-4.509 3.379-9.527 3.379-14.885 0-21.201-21.201-37.101-21.201-37.101s-21.201 15.901-21.201 37.101c0 5.357 1.356 10.375 3.379 14.885-3.693-1.328-7.671-2.164-11.861-2.164-21.201 0-37.101 21.201-37.101 21.201s15.901 21.201 37.101 21.201c12.429 0 23.031-7.286 29.682-13.315 6.65 6.03 17.251 13.315 29.682 13.315 21.201 0 37.101-21.201 37.101-21.201s-15.899-21.201-37.099-21.201z"/><g fill="#FFDA44"><path d="m256 152.111 4.38 13.476h14.171l-11.464 8.332 4.376 13.476-11.463-8.33-11.463 8.33 4.376-13.476-11.464-8.332h14.171zM202.112 175.683l8.425 7.585 9.818-5.667-4.61 10.355 8.423 7.588-11.274-1.185-4.611 10.355-2.358-11.088-11.275-1.185 9.818-5.669zM162.662 215.132l11.09 2.358 5.668-9.818 1.186 11.274 11.089 2.358-10.357 4.61 1.186 11.274-7.587-8.423-10.357 4.61 5.669-9.818zM309.889 175.683l-8.425 7.585-9.818-5.667 4.611 10.355-8.425 7.588 11.275-1.185 4.61 10.355 2.359-11.088 11.275-1.185-9.818-5.669zM349.338 215.132l-11.089 2.358-5.669-9.818-1.186 11.274-11.088 2.358 10.357 4.61-1.185 11.274 7.586-8.423 10.357 4.61-5.669-9.818z"/></g><g fill="#FFF"><path d="M256 350.642c16.84 0 32.363-5.619 44.816-15.073h-89.63c12.451 9.454 27.974 15.073 44.814 15.073zM187.977 306.12a74.138 74.138 0 0 0 8.85 15.073h118.345a74.13 74.13 0 0 0 8.85-15.073H187.977z"/></g></svg>',
    Jn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 750 500"><path fill="#0071BC" d="M0 0h750v500H0V0z"/><g fill="#FFF" stroke="#000" stroke-width="1.9"><circle cx="375" cy="245" r="225" fill="#fff"/><circle cx="375" cy="245" r="165" fill="#0071BC"/></g><g stroke="#000"><path fill="#8C8A8C" stroke-width="1.9" d="M444.7 450c.7 11-7.8 20-18.8 20H323.6c-11 0-19.5-9-19-20l16.7-325c.6-11 10-20 21-20h61.4c11 0 20.5 9 21.2 20l19.8 325z"/><path fill="#FFF" stroke-width="2" stroke-linejoin="round" d="m373 114 30 93h97l-78 56 29 92-78-56-78 57 30-93-79-57h97l30-92z"/></g></svg>',
    qn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#0052B4" d="M0 0h513v342H0z"/><g fill="#fff"><path d="M512 148.4v44.5H278.3v148.4h-44.6V192.9H0v-44.5h233.7V0h44.6v148.4z"/><path d="M101 36.1c4.2-.2 8.3-.1 12.5.2 5.5.4 9.4 1.6 9.1.5-.5-1.8-.1-2.2-.8-1.8-1.3 1 .7-.2-7.4 4.4-11.8 6.7-16.9 11.8-14.3 21 2.3 8.1 8.2 10.3 22.3 12.5l1.9.3c5.6.9 8.1 1.4 9.8 2.2.4.2-.3-1-.1-1.7-.2.6-3.9 2.1-13.3 3.9l-4.7.9c-18.1 3.7-27.1 8.5-28.5 21-1.5 13.7 12.7 23.3 30.6 25.6 18.2 2.4 34.1-3.6 35.7-18.4 1-9.4-5.5-15-15.9-17.1-7-1.4-16.3-1.4-27.4-.3-12.4 1.3-24.7 3.4-36.9 6.3-3.6.7-5.9 4.2-5.2 7.8.7 3.6 4.2 5.9 7.8 5.2.2 0 .3-.1.5-.1 11.6-2.7 23.3-4.7 35.1-5.9 9.9-1 18-1 23.4.1 4.4.9 5.3 1.7 5.2 2.6-.5 5.1-8.9 8.2-20.7 6.7-11.6-1.5-19.5-6.8-19.1-11 .5-4.3 5.3-6.8 17.9-9.4l4.6-.9c15.5-3 21.1-5.3 23.5-13.2 1.9-6.5-1.3-11.6-7.2-14.2-3.2-1.4-6.3-2.1-13.2-3.1l-1.8-.3c-8-1.3-11.4-2.6-11.5-3-.1-.4 1.8-2.3 8.1-5.9l4.4-2.5c1.5-.8 2.9-1.8 4.3-2.7 4.6-3.4 7.2-7.1 5.8-12.3-1.9-7.3-9-9.5-20.9-10.4-4.7-.3-9.3-.4-14-.3l-2 .1c-3.7.2-6.5 3.4-6.3 7 .2 3.7 3.4 6.5 7 6.3l1.7-.1zM385 36.1c4.2-.2 8.3-.1 12.5.2 5.5.4 9.4 1.6 9.1.5-.5-1.8-.1-2.2-.8-1.8-1.3 1 .7-.2-7.4 4.4-11.8 6.7-16.9 11.8-14.3 21 2.3 8.1 8.2 10.3 22.3 12.5l1.9.3c5.6.9 8.1 1.4 9.8 2.2.4.2-.3-1-.1-1.7-.2.6-3.9 2.1-13.3 3.9l-4.7.9c-18.1 3.7-27.1 8.5-28.5 21-1.5 13.7 12.7 23.3 30.6 25.6 18.2 2.4 34.1-3.6 35.7-18.4 1-9.4-5.5-15-15.9-17.1-7-1.4-16.3-1.4-27.4-.3-12.4 1.3-24.7 3.4-36.9 6.3-3.6.7-5.9 4.2-5.2 7.8.7 3.6 4.2 5.9 7.8 5.2.2 0 .3-.1.5-.1 11.6-2.7 23.3-4.7 35.1-5.9 9.9-1 18-1 23.4.1 4.4.9 5.3 1.7 5.2 2.6-.5 5.1-8.9 8.2-20.7 6.7-11.6-1.5-19.5-6.8-19.1-11 .5-4.3 5.3-6.8 17.9-9.4l4.6-.9c15.5-3 21.1-5.3 23.5-13.2 1.9-6.5-1.3-11.6-7.2-14.2-3.2-1.4-6.3-2.1-13.2-3.1l-1.8-.3c-8-1.3-11.4-2.6-11.5-3-.1-.4 1.8-2.3 8.1-5.9l4.4-2.5c1.5-.8 2.9-1.8 4.3-2.7 4.6-3.4 7.2-7.1 5.8-12.3-1.9-7.3-9-9.5-20.9-10.4-4.7-.3-9.3-.4-14-.3l-2 .1c-3.7.2-6.5 3.4-6.3 7 .2 3.7 3.4 6.5 7 6.3l1.7-.1zM379.6 235.1c4.2-.2 8.3-.1 12.5.2 5.5.4 9.4 1.6 9.1.5-.5-1.8-.1-2.2-.8-1.8-1.3 1 .7-.2-7.4 4.4-11.8 6.7-16.9 11.8-14.3 21 2.3 8.1 8.2 10.3 22.3 12.5l1.9.3c5.6.9 8.1 1.4 9.8 2.2.4.2-.3-1-.1-1.7-.2.6-3.9 2.1-13.3 3.9l-4.7.9c-18.1 3.7-27.1 8.5-28.5 21-1.5 13.7 12.7 23.3 30.6 25.6 18.2 2.4 34.1-3.6 35.7-18.4 1-9.4-5.5-15-15.9-17.1-7-1.4-16.3-1.4-27.4-.3-12.4 1.3-24.7 3.4-36.9 6.3-3.6.7-5.9 4.2-5.2 7.8.7 3.6 4.2 5.9 7.8 5.2.2 0 .3-.1.5-.1 11.6-2.7 23.3-4.7 35.1-5.9 9.9-1 18-1 23.4.1 4.4.9 5.3 1.7 5.2 2.6-.5 5.1-8.9 8.2-20.7 6.7-11.6-1.5-19.5-6.8-19.1-11 .5-4.3 5.3-6.8 17.9-9.4l4.6-.9c15.5-3 21.1-5.3 23.5-13.2 1.9-6.5-1.3-11.6-7.2-14.2-3.2-1.4-6.3-2.1-13.2-3.1l-1.8-.3c-8-1.3-11.4-2.6-11.5-3-.1-.4 1.8-2.3 8.1-5.9l4.4-2.5c1.5-.8 2.9-1.8 4.3-2.7 4.6-3.4 7.2-7.1 5.8-12.3-1.9-7.3-9-9.5-20.9-10.4-4.7-.3-9.3-.4-14-.3l-2 .1c-3.7.2-6.5 3.4-6.3 7s3.4 6.5 7 6.3l1.7-.1zM101 235.1c4.2-.2 8.3-.1 12.5.2 5.5.4 9.4 1.6 9.1.5-.5-1.8-.1-2.2-.8-1.8-1.3 1 .7-.2-7.4 4.4-11.8 6.7-16.9 11.8-14.3 21 2.3 8.1 8.2 10.3 22.3 12.5l1.9.3c5.6.9 8.1 1.4 9.8 2.2.4.2-.3-1-.1-1.7-.2.6-3.9 2.1-13.3 3.9l-4.7.9c-18.1 3.7-27.1 8.5-28.5 21-1.5 13.7 12.7 23.3 30.6 25.6 18.2 2.4 34.1-3.6 35.7-18.4 1-9.4-5.5-15-15.9-17.1-7-1.4-16.3-1.4-27.4-.3-12.4 1.3-24.7 3.4-36.9 6.3-3.6.7-5.9 4.2-5.2 7.8s4.2 5.9 7.8 5.2c.2 0 .3-.1.5-.1 11.6-2.7 23.3-4.7 35.1-5.9 9.9-1 18-1 23.4.1 4.4.9 5.3 1.7 5.2 2.6-.5 5.1-8.9 8.2-20.7 6.7-11.6-1.5-19.5-6.8-19.1-11 .5-4.3 5.3-6.8 17.9-9.4l4.6-.9c15.5-3 21.1-5.3 23.5-13.2 1.9-6.5-1.3-11.6-7.2-14.2-3.2-1.4-6.3-2.1-13.2-3.1l-1.8-.3c-8-1.3-11.4-2.6-11.5-3-.1-.4 1.8-2.3 8.1-5.9l4.4-2.5c1.5-.8 2.9-1.8 4.3-2.7 4.6-3.4 7.2-7.1 5.8-12.3-1.9-7.3-9-9.5-20.9-10.4-4.7-.3-9.3-.4-14-.3l-2 .1c-3.7.2-6.5 3.4-6.3 7 .2 3.7 3.4 6.5 7 6.3l1.7-.1z"/></g></svg>',
    Xn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#496E2D" d="M0 85.331h512v341.337H0z"/><g fill="#FFDA44"><path d="M256 298.851c-45.956 0-84.348-32.298-93.767-75.429A96.288 96.288 0 0 0 160 243.994c0 53.02 42.979 96 96 96s96-42.98 96-96c0-7.066-.785-13.942-2.233-20.572-9.419 43.131-47.811 75.429-93.767 75.429z"/><path d="m255.999 171.994 8.935 27.502h28.918l-23.394 16.996 8.936 27.503-23.395-16.998-23.394 16.998 8.937-27.503-23.394-16.996h28.915z"/></g></svg>',
    $n = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#1B4991" d="M0 0h513v342H0z"/><path fill="#00A2B8" stroke="#FFF" stroke-width="3" d="M318.2 106.7v106.5c0 51.9 67.8 67.8 67.8 67.8s67.8-15.9 67.8-67.8V106.7H318.2z"/><path fill="#A35023" d="M319.7 212.7c0 50.8 66.3 66.3 66.3 66.3s66.3-15.6 66.3-66.3H319.7z"/><path d="M415.1 155.1h-19.4v-19.4h-19.4v19.4H357v19.4h19.3v58.1h19.4v-58.1h19.4z"/><path fill="#FFF" d="M256 0v30.6l-45.2 25.1H256V115h-59.1l59.1 32.8v22.9h-26.7l-73.5-40.9v40.9h-55.6v-48.6l-87.5 48.6H0v-30.6L45.2 115H0V55.7h59.1L0 22.8V0h26.7l73.5 40.8V0h55.6v48.6L243.3 0z"/><path fill="#D80027" d="M144 0h-32v69.3H0v32h112v69.4h32v-69.4h112v-32H144z"/><path fill="#0052B4" d="M155.8 115 256 170.7v-15.8L184.2 115z"/><path fill="#FFF" d="M155.8 115 256 170.7v-15.8L184.2 115z"/><path fill="#D80027" d="M155.8 115 256 170.7v-15.8L184.2 115zM71.8 115 0 154.9v15.8L100.2 115z"/><path fill="#0052B4" d="M100.2 55.6 0 0v15.7l71.8 39.9z"/><path fill="#FFF" d="M100.2 55.6 0 0v15.7l71.8 39.9z"/><path fill="#D80027" d="M100.2 55.6 0 0v15.7l71.8 39.9zM184.2 55.6 256 15.7V0L155.8 55.6z"/></svg>',
    Qn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#FFF" d="M0 0h513v342H0z"/><path fill="#C31B28" d="M256 0h256.5v342H256z"/><path fill="#ACABB1" stroke="#C31B28" stroke-width="2" d="M101.2 68.2V33H66v35.2H30.8v35.2H66v35.2h35.2v-35.2h35.2V68.2z"/></svg>',
    te = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#f7ce00" d="M0 85.331h512v341.326H0z"/><path fill="#e32737" d="M0 85.331h512v85.337H0z"/><path fill="#191f6a" d="M0 170.657h512v85.337H0z"/><path fill="#00a04e" d="M0 341.331h512v85.337H0z"/></svg>',
    ne = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#d01920" d="M0 85.331h512v341.333H0z"/><path fill="#017c3b" d="M144.696 174.375h222.609v163.25H144.696z"/><path fill="#FFF" d="M283.484 304.226c-26.637 0-48.232-21.594-48.232-48.232s21.594-48.232 48.232-48.232c8.306 0 16.12 2.1 22.943 5.797-10.703-10.467-25.341-16.927-41.494-16.927-32.784 0-59.362 26.577-59.362 59.362s26.578 59.362 59.362 59.362c16.154 0 30.791-6.461 41.494-16.927-6.822 3.698-14.636 5.797-22.943 5.797z"/></svg>',
    ee = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 342"><path fill="#272727" d="M0 0h512v114H0z"/><path fill="#e40112" d="M0 114h512v114H0z"/><path fill="#07893f" d="M0 228h512v114H0z"/><circle fill="#e40112" cx="256" cy="125" r="95"/></svg>',
    ie = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#dc2339" d="M342 0H0v341.3h513V0z"/><path fill="#11865d" d="M0 0h171v342H0z"/><path fill="#FFF" d="M171 0h171v342H171z"/><path fill="#8C9157" d="M195.8 171.2c0 21.6 11.5 41.7 30.3 52.5 5.8 3.4 13.2 1.4 16.6-4.4 3.4-5.8 1.4-13.2-4.4-16.6-11.3-6.5-18.2-18.5-18.2-31.5 0-6.7-5.4-12.1-12.1-12.1-6.7 0-12.2 5.4-12.2 12.1zm93.4 51.1c17.5-11.1 28-30.4 28-51.1 0-6.7-5.4-12.1-12.1-12.1s-12.1 5.4-12.1 12.1c0 12.4-6.3 24-16.8 30.7-5.7 3.5-7.5 10.9-4.1 16.7s10.9 7.5 16.7 4.1c0-.2.2-.3.4-.4z"/><ellipse fill="#C59262" cx="256.5" cy="159.1" rx="24.3" ry="36.4"/></svg>',
    ae = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#FFF" d="M0 0h513v342H0z"/><g fill="#c00"><path d="M0 0h513v24.4H0zM0 48.9h513v24.4H0zM0 97.7h513v24.4H0zM0 146.6h513V171H0zM0 195.4h513v24.4H0zM0 244.3h513v24.4H0zM0 293.1h513v24.4H0z"/></g><path fill="#006" d="M0 0h256.5v195.4H0z"/><path d="M153.3 42.1C122.6 30.7 88.5 46.3 77.1 77s4.2 64.8 34.9 76.2c13.3 5 28 5 41.4 0-30.7 24.5-75.4 19.6-100-11.1s-19.6-75.4 11.1-100c26-20.7 62.9-20.7 88.8 0zm26.7 75-20.6 23.3 5.4-30.6-31-1.6 27.3-14.9L143 68l28.6 12 8.4-29.9 8.4 29.9L217 68l-18 25.4 27.3 14.9-31 1.6 5.4 30.6-20.7-23.4z" fill="#fc0"/></svg>',
    re = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 513 342"><path fill="#FFF" d="M0 85.333h513v342H0z"/><path fill="#f4d900" d="M0 323.333h513v104H0z"/><path fill="#006d66" d="M0 85.333h513v104H0z"/><path d="M0 204.333h513v104H0z"/><path fill="#cb0f31" d="M256 256.006 0 426.668V85.331z"/><path fill="#f4d900" d="m83.477 195.132 15.107 46.498h48.894l-39.554 28.739 15.107 46.499-39.554-28.738-39.555 28.738 15.11-46.499-39.554-28.739H68.37z"/></svg>',
    oe = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#496E2D" d="M0 85.337h512v341.326H0z"/><path fill="#0052B4" d="M0 426.663V85.337h512"/><path fill="#FFF" d="M512 152.222V85.337H411.67L0 359.778v66.885h100.33z"/><path fill="#A2001D" d="M512 85.337v40.125L60.193 426.663H0v-40.125L451.807 85.337z"/><path fill="#FFDA44" d="m187.737 189.212-22.741 10.696 12.11 22.024-24.693-4.724-3.129 24.945-17.199-18.347-17.2 18.347-3.129-24.945-24.693 4.723 12.109-22.023-22.739-10.696 22.74-10.697-12.11-22.022 24.693 4.722 3.13-24.944 17.199 18.347 17.2-18.347 3.128 24.944 24.693-4.722-12.108 22.024z"/></svg>',
    le = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 426.7"><path fill="#009543" d="M0 293h640v133.7H0V293z"/><path fill="#ED4135" d="M0 132h640v161.3H0V132z"/><path fill="#0035AD" d="M0 0h640v133.3H0V0z"/><circle fill="#FAE600" stroke="#000" stroke-width="5.3" cx="240" cy="213.3" r="157.3"/><path d="m307.9 354.5-31.8 12-36.1 4.2-37.8-2.4-35.9-15.5s28.6-29.3 40.7-33.5c8.6-3 22.4-3.7 22.4-3.7V122l-.3-66H246l-.5 67.5v191.7s15.3 1.2 22.1 4.1c11.3 4.9 40.3 35.2 40.3 35.2z"/><path d="m212.727 102.375 42.955-21.418 5.577 11.187-42.955 21.417z"/><ellipse cx="237.8" cy="280.5" rx="16.8" ry="26.5"/><circle cx="237.4" cy="143.4" r="20.9"/><ellipse cx="238.4" cy="211.1" rx="19.9" ry="12.1"/><path d="M213.8 177h47v10h-47zM213.8 234h47v10h-47z"/></svg>',
    ce = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.337h512v341.326H0z"/><path fill="#e05206" d="M0 85.337h512v113.775H0z"/><path fill="#0db02b" d="M0 312.888h512v113.775H0z"/><circle fill="#e05206" cx="256" cy="256" r="32"/></svg>',
    se = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.5 513 342"><path fill="#FFF" d="M0 85.5h513v342H0z"/><g fill="#007b23"><path d="M0 85.5h171v342H0zM342 85.5h171v342H342zM304 311.995l-48-152.001-48 152.001h36v39.999h24v-39.999z"/></g></svg>',
    he = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.5 513 342"><path fill="#FFF" d="M0 85.5h513v342H0z"/><g fill="#007b23"><path d="M0 85.5h171v342H0zM342 85.5h171v342H342z"/></g></svg>',
    ue = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.337h512v341.326H0z"/><g fill="#338AF3"><path d="M0 85.337h512v113.775H0zM0 312.888h512v113.775H0z"/></g><path fill="#FFDA44" d="M256 214.447c-22.949 0-41.553 18.603-41.553 41.553S233.05 297.553 256 297.553c22.949 0 41.553-18.603 41.553-41.553S278.949 214.447 256 214.447zm0 65.298c-13.114 0-23.745-10.631-23.745-23.745s10.631-23.745 23.745-23.745 23.745 10.631 23.745 23.745-10.631 23.745-23.745 23.745z"/><path fill="#0052B4" d="M276.563 261.936 256 256l-20.563 5.936-6.855 11.873h54.836z"/><path fill="#338AF3" d="m256 226.32-13.709 23.744L256 256l13.709-5.936z"/><path fill="#6DA544" d="M235.437 261.936h41.126l-6.854-11.872h-27.418z"/></svg>',
    fe = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.5 513 342"><path fill="#FFF" d="M0 85.5h513v342H0z"/><path fill="#cd1f2a" d="M0 85.5h513v114H0z"/><path fill="#1d4185" d="M0 312h513v114H0z"/></svg>',
    ve = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#D80027" d="M0 85.334h512v341.337H0z"/><path fill="#FFF" d="M512 295.883H202.195v130.783H122.435V295.883H0V216.111h122.435V85.329H202.195v130.782H512V277.329z"/><path fill="#2E52B2" d="M512 234.666v42.663H183.652v149.337h-42.674V277.329H0v-42.663h140.978V85.329h42.674v149.337z"/></svg>',
    pe = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.337h512v341.326H0z"/><path fill="#0052B4" d="M0 426.663V85.337l280.419 174.75H87.61l183.576 166.576z"/><path fill="#D80027" d="M244.769 249.888 10.199 103.71v312.754h234.57L61.193 249.888z"/><g fill="#FFF"><path d="m98.003 324.433-14.589-6.863 7.77-14.13-15.844 3.03-2.008-16.005-11.035 11.772-11.036-11.772-2.008 16.005-15.843-3.031 7.77 14.131-14.591 6.863 14.591 6.862-7.77 14.13 15.844-3.029 2.007 16.004 11.036-11.772L73.332 358.4l2.008-16.004 15.843 3.03-7.769-14.13zM88.268 191.662l-10.612-4.991 5.651-10.278-11.523 2.205-1.461-11.641-8.026 8.561-8.026-8.561-1.46 11.641-11.525-2.205 5.652 10.278-10.613 4.991 25.972 5.194z"/><path d="M93.462 191.662c0 17.212-13.953 31.165-31.165 31.165s-31.165-13.953-31.165-31.165"/></g></svg>',
    ge = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#0052B4" d="M0 85.337h512v341.326H0z"/><path fill="#FFDA44" d="M0 239.994h512v32H0z"/><path fill="#FFF" d="m174.802 341.329-19.124 8.996 10.184 18.521-20.767-3.973-2.631 20.978L128 370.422l-14.465 15.429-2.63-20.978-20.767 3.973 10.183-18.521-19.123-8.996 19.124-8.995-10.184-18.52 20.766 3.971 2.632-20.978L128 312.236l14.465-15.429 2.63 20.978 20.767-3.971-10.183 18.521z"/></svg>',
    de = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFDA44" d="M0 85.334h512v341.337H0z"/><path fill="#FFF" d="M0 85.334h256v170.663H0z"/><g fill="#D80027"><path d="M144 85.33h-32v69.333H0v32h112v69.334h32v-69.334h112v-32H144z"/><path d="M0 85.329v15.083l57.377 38.251H80z"/></g><g fill="#2E52B2"><path d="M0 107.951v30.712h46.069zM96 85.331v48.913L22.628 85.331z"/></g><path fill="#D80027" d="M256 85.329v15.083l-57.377 38.251H176z"/><g fill="#2E52B2"><path d="M256 107.951v30.712h-46.069zM160 85.331v48.913l73.372-48.913z"/></g><path fill="#D80027" d="M0 85.329v15.083l57.377 38.251H80z"/><g fill="#2E52B2"><path d="M0 107.951v30.712h46.069zM96 85.331v48.913L22.628 85.331z"/></g><path fill="#D80027" d="M256 85.329v15.083l-57.377 38.251H176z"/><g fill="#2E52B2"><path d="M256 107.951v30.712h-46.069zM160 85.331v48.913l73.372-48.913z"/></g><path fill="#D80027" d="M0 255.997v-15.082l57.377-38.252H80z"/><g fill="#2E52B2"><path d="M0 233.376v-30.713h46.069zM96 255.994v-48.912l-73.372 48.912z"/></g><path fill="#D80027" d="M256 255.997v-15.082l-57.377-38.252H176z"/><g fill="#2E52B2"><path d="M256 233.376v-30.713h-46.069zM160 255.994v-48.912l73.372 48.912z"/><circle cx="128" cy="170.66" r="22.627"/></g><g fill="#FFDA44"><path d="m128 154.663 3.97 12.222h12.854l-10.398 7.556 3.971 12.222L128 179.109l-10.398 7.554 3.972-12.222-10.398-7.556h12.853zM128 219.803l2.364 7.278h7.653l-6.19 4.498 2.364 7.278-6.191-4.498-6.191 4.498 2.364-7.278-6.19-4.498h7.652zM128 102.469l2.364 7.278h7.653l-6.19 4.498 2.364 7.278-6.191-4.498-6.191 4.498 2.364-7.278-6.19-4.498h7.652zM197.931 161.136l2.365 7.277h7.653l-6.192 4.499 2.365 7.279-6.191-4.498-6.191 4.498 2.365-7.279-6.191-4.499h7.652zM58.069 161.136l2.364 7.277h7.653l-6.191 4.499 2.364 7.279-6.19-4.498-6.191 4.498 2.365-7.279-6.192-4.499h7.653z"/></g></svg>',
    me = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#0052B4" d="M0 85.334h512v341.337H0z"/><g fill="#D80027"><path d="m425.301 233.745 3.388 10.428h10.963l-8.87 6.444 3.388 10.427-8.869-6.444-8.871 6.444 3.388-10.427-8.87-6.444h10.963zM386.107 308.817l5.083 15.642h16.445l-13.305 9.667 5.082 15.64-13.305-9.667-13.305 9.667 5.083-15.64-13.305-9.667h16.445zM387.588 185.971l4.236 13.036h13.704l-11.088 8.054 4.235 13.034-11.087-8.056-11.088 8.056 4.235-13.034-11.087-8.054h13.704zM349.876 233.291l5.082 15.641h16.446l-13.306 9.666 5.084 15.641-13.306-9.666-13.305 9.666 5.082-15.641-13.305-9.666h16.445z"/></g><path fill="#FFF" d="M256.003 85.329v30.564l-45.178 25.088h45.178v59.359H196.89l59.113 32.846v22.806h-26.69l-73.484-40.826v40.826h-55.652v-48.573l-87.429 48.573H.003v-30.553l45.168-25.099H.003v-59.359h59.103L.003 108.147V85.329h26.68l73.494 40.838V85.329h55.652v48.573l87.43-48.573z"/><path fill="#D80027" d="M144 85.33h-32v69.334H0v32h112v69.334h32v-69.334h112v-32H144z"/><path fill="#0052B4" d="M155.826 200.344 256 255.998v-15.739l-71.847-39.915z"/><path fill="#FFF" d="M155.826 200.344 256 255.998v-15.739l-71.847-39.915z"/><g fill="#D80027"><path d="M155.826 200.344 256 255.998v-15.739l-71.847-39.915zM71.846 200.344 0 240.259v15.739l100.174-55.654z"/></g><path fill="#0052B4" d="M100.174 140.983 0 85.33v15.738l71.847 39.915z"/><path fill="#FFF" d="M100.174 140.983 0 85.33v15.738l71.847 39.915z"/><g fill="#D80027"><path d="M100.174 140.983 0 85.33v15.738l71.847 39.915zM184.154 140.983 256 101.068V85.33l-100.174 55.653z"/></g></svg>',
    Fe = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#D80027" d="M0 0h513v342H0z"/><path fill="#FFF" d="M138 0h377v114H138z"/><path fill="#4A7C3A" d="M138 230h377v114H138z"/><g fill="none" stroke="#FFF" stroke-width="10" stroke-miterlimit="2"><path d="M40.3 35.2s37.1 48 50.8 54.5c13.7 6.5 17.1 5.7 17.1 5.7"/><path d="M100 35.2S62.9 80.6 53.3 87.6c-9.6 7-18.7 7.8-18.7 7.8M51.7 65.3h37.9M70.7 35.2v30.1"/></g></svg>',
    Me = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.337h512v341.326H0z"/><path fill="#0052B4" d="M256 256v170.663H0V256h256z"/><path fill="#D80027" d="M512 85.337V256H256V85.337h256z"/><path fill="#0052B4" d="m128 123.034 11.824 36.389h38.263l-30.955 22.491 11.823 36.389L128 195.813l-30.955 22.49 11.823-36.389-30.955-22.491h38.263z"/><path fill="#D80027" d="m384 293.697 11.824 36.389h38.263l-30.955 22.491 11.823 36.389L384 366.476l-30.955 22.49 11.823-36.389-30.955-22.491h38.263z"/></svg>',
    we = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.331h512v341.326H0z"/><g fill="#D80027"><path d="M0 85.331h170.663v341.337H0zM341.337 85.331H512v341.337H341.337z"/></g></svg>',
    ze = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.337h512v341.326H0z"/><g fill="#D80027"><path d="M0 85.337h512v113.775H0zM0 312.888h512v113.775H0z"/></g><path fill="#FFDA44" d="M293.991 256c0 20.982-17.01 33.243-37.992 33.243S218.008 276.982 218.008 256s17.01-37.992 37.992-37.992 37.991 17.01 37.991 37.992z"/><path fill="#0052B4" d="M293.991 256c0 20.982-17.01 37.992-37.992 37.992s-37.992-17.01-37.992-37.992"/><g fill="#D80027"><path d="M232.259 246.506h9.498v19h-9.498zM270.247 246.506h9.498v19h-9.498zM251.247 232.259h9.498v33.243h-9.498z"/></g></svg>',
    ye = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path d="M0 85.333h512V426.67H0z"/><path fill="#A2001D" d="M0 85.33h512v341.332"/><g fill="#FFF"><path d="m204.631 326.488 2.762 8.504h8.941l-7.233 5.255 2.763 8.502-7.233-5.254-7.233 5.254 2.762-8.502-7.233-5.255h8.94zM181.797 244.866l4.605 14.172h14.901l-12.056 8.757 4.605 14.172-12.055-8.759-12.055 8.759 4.606-14.172-12.056-8.757h14.901zM181.797 348.749l4.604 14.173h14.902l-12.057 8.757 4.606 14.173-12.055-8.759-12.055 8.759 4.604-14.173-12.054-8.757h14.899zM225.363 281.967l4.606 14.172h14.901l-12.056 8.758 4.605 14.172-12.056-8.759-12.054 8.759 4.606-14.172-12.056-8.758h14.901zM138.23 281.967l4.606 14.172h14.899l-12.054 8.758 4.603 14.172-12.054-8.759-12.055 8.759 4.605-14.172-12.055-8.758h14.9z"/></g><path fill="#FFDA44" d="M376.526 204.163c-7.628-7.628-17.538-12.133-28.189-12.908l31.88-24.795c-12.698-12.698-29.714-18.431-46.319-17.218a44.31 44.31 0 0 0-11.396-19.511l-12.593 25.186a18.47 18.47 0 0 0-3.148-4.197c-7.245-7.245-18.991-7.244-26.234 0s-7.245 18.99 0 26.234a18.536 18.536 0 0 0 4.197 3.148l-25.186 12.593a44.303 44.303 0 0 0 19.519 11.399c-1.217 16.606 4.511 33.619 17.209 46.317L324.12 214.6a11.053 11.053 0 0 1 7.807-3.202c2.973 0 5.768 1.158 7.87 3.26a11.055 11.055 0 0 1 3.26 7.87c0 2.974-1.158 5.768-3.26 7.87l10.494 10.494c4.905-4.905 7.607-11.428 7.607-18.364 0-5.675-1.81-11.071-5.153-15.534a29.492 29.492 0 0 1 13.288 7.662c11.573 11.572 11.573 30.403 0 41.975l10.494 10.494c8.409-8.409 13.039-19.59 13.039-31.481-.001-11.892-4.632-23.072-13.04-31.481z"/></svg>',
    Ae = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.337h512v341.326H0z"/><path fill="#0052B4" d="M512 85.337V256H256L0 85.337z"/><path fill="#D80027" d="M512 256v170.663H0L256 256z"/><g fill="#FFDA44"><path d="m161.908 256-27.288-12.835 14.532-26.428-29.632 5.668-3.755-29.933-20.64 22.015-20.639-22.015-3.755 29.933-29.631-5.669 14.531 26.428L28.343 256l27.288 12.835L41.1 295.263l29.633-5.668 3.753 29.933 20.639-22.015 20.64 22.015 3.755-29.933 29.631 5.669-14.532-26.427zM21.789 117.607l9.081 12.696 14.879-4.714-9.268 12.56 9.081 12.694-14.809-4.932-9.268 12.559.117-15.608-14.809-4.934 14.88-4.712zM21.789 353.53l9.081 12.696 14.879-4.714-9.268 12.56 9.081 12.695-14.809-4.933-9.268 12.558.117-15.607-14.809-4.934 14.88-4.712zM210.395 235.569l-9.081 12.695-14.879-4.713 9.268 12.559-9.081 12.696 14.809-4.933 9.268 12.558-.117-15.607 14.809-4.934-14.88-4.713z"/></g></svg>',
    Ue = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><g fill="#FFF"><path d="m393.508 170.516 17.512 18.875 23.363-10.821-12.541 22.487 17.513 18.876-25.263-4.978-12.539 22.488-3.073-25.564-25.263-4.978 23.363-10.82z"/><path d="M0 85.343h512v341.326H0z"/></g><path fill="#01411c" d="M128 85.331h384v341.337H128z"/><g fill="#FFF"><path d="M361.909 298.793c-31.037 22.426-74.378 15.446-96.804-15.592-22.427-31.038-15.446-74.379 15.593-96.804 9.677-6.992 20.55-11.125 31.613-12.563-21.283-3.183-43.777 1.613-62.598 15.211-38.2 27.602-46.792 80.944-19.191 119.145 27.601 38.199 80.944 46.792 119.145 19.189 18.82-13.598 30.436-33.448 34.096-54.655-4.839 10.05-12.176 19.076-21.854 26.069zM360.58 172.889l17.484 18.842 23.322-10.802-12.519 22.447 17.483 18.844-25.219-4.968-12.519 22.45-3.067-25.521-25.22-4.969 23.323-10.802z"/></g></svg>',
    He = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><g fill="#FFF"><path d="M0 85.337h512v341.326H0z"/><path d="M0 85.337h512V256H0z"/></g><path fill="#D80027" d="M0 256h512v170.663H0z"/></svg>',
    xe = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 26.666 640 426.666"><g fill-rule="evenodd" stroke-width="1pt"><path fill="#fff" d="M0 0h640v480H0z"/><path fill="#00267f" d="M0 0h213.3v480H0z"/><path fill="#f31830" d="M426.7 0H640v480H426.7z"/></g></svg>',
    Ee = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#0052B4" d="M0 85.333h512V426.67H0z"/><path fill="#ACABB1" d="M400.696 219.822 384 225.387l-16.696-5.565-5.565-13.913 5.565-13.913h33.392l-5.566 13.913z"/><path fill="#338AF3" d="M345.043 219.822v61.217c0 29.821 38.957 38.957 38.957 38.957s38.957-9.137 38.957-38.957v-61.217h-77.914z"/><path fill="#6DA544" d="M348.555 295.541C358.131 313.927 384 319.996 384 319.996s25.869-6.069 35.445-24.455L384 236.518l-35.445 59.023z"/><path fill="#FFDA44" d="M422.957 280.421 384 219.822l-38.957 60.599v.618c0 5.518 1.337 10.328 3.512 14.503L384 240.405l35.445 55.137c2.175-4.175 3.512-8.983 3.512-14.503v-.618z"/><path fill="#FFF" d="M256 85.333v30.553l-45.167 25.099H256v59.359h-59.103L256 233.179v22.817h-26.68l-73.494-40.826v40.826h-55.652v-48.573l-87.43 48.573H0v-30.554l45.167-25.098H0v-59.359h59.103L0 108.139V85.333h26.68l73.494 40.825V85.333h55.652v48.572l87.43-48.572z"/><path fill="#D80027" d="M144 85.33h-32v69.332H0v32h112v69.334h32v-69.334h112v-32H144z"/><path fill="#0052B4" d="M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"/><path fill="#FFF" d="M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"/><g fill="#D80027"><path d="M155.826 200.344 256 255.996v-15.737l-71.847-39.915zM71.846 200.344 0 240.259v15.737l100.174-55.652z"/></g><path fill="#0052B4" d="M100.174 140.982 0 85.33v15.737l71.847 39.915z"/><path fill="#FFF" d="M100.174 140.982 0 85.33v15.737l71.847 39.915z"/><g fill="#D80027"><path d="M100.174 140.982 0 85.33v15.737l71.847 39.915zM184.154 140.982 256 101.067V85.33l-100.174 55.652z"/></g></svg>',
    Se = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.337h512v341.326H0z"/><g fill="#D80027"><path d="M0 85.337h512V153.6H0zM0 221.863h512v68.263H0zM0 358.4h512v68.263H0z"/></g><path fill="#0052B4" d="M256 256.006 0 426.668V85.331z"/><path fill="#FFF" d="m83.477 195.132 15.107 46.498h48.894l-39.554 28.739 15.107 46.499-39.554-28.738-39.555 28.738 15.11-46.499-39.554-28.739H68.37z"/></svg>',
    Be = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.337h512v341.326H0z"/><path d="M0 85.337h512v113.775H0z"/><path fill="#268024" d="M0 312.888h512v113.775H0z"/><path fill="#e4312b" d="M256 256.006 0 426.668V85.331z"/></svg>',
    De = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#D80027" d="M0 85.337h512v341.326H0z"/><path fill="#6DA544" d="M196.641 85.337v341.326H0V85.337z"/><circle fill="#FFDA44" cx="196.641" cy="256" r="64"/><path fill="#D80027" d="M160.638 224v40.001c0 19.882 16.118 36 36 36s36-16.118 36-36V224h-72z"/><path fill="#FFF" d="M196.638 276c-6.617 0-12-5.383-12-12v-16h24.001v16c-.001 6.616-5.385 12-12.001 12z"/></svg>',
    be = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#338AF3" d="M0 85.331h512v341.337H0z"/><circle fill="#FFDA44" cx="218.902" cy="255.994" r="74.207"/></svg>',
    Ne = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.337h512v341.326H0z"/><path fill="#D80027" d="M0 85.337h512v113.775H0z"/><path fill="#0052B4" d="M0 312.888h512v113.775H0z"/><path fill="#6DA544" d="m289.579 216.738-12.592 12.592c5.37 5.372 8.693 12.792 8.693 20.988 0 16.392-13.289 29.68-29.68 29.68-16.392 0-29.68-13.289-29.68-29.68 0-8.195 3.322-15.616 8.693-20.988l-12.592-12.592c-8.594 8.594-13.91 20.466-13.91 33.579 0 26.228 21.261 47.489 47.489 47.489s47.489-21.261 47.489-47.489c0-13.112-5.316-24.985-13.91-33.579z"/><path fill="#FFDA44" d="m256 232.51 4.421 13.605h14.304l-11.573 8.408 4.421 13.604L256 259.719l-11.573 8.408 4.421-13.604-11.573-8.408h14.304z"/></svg>',
    je = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#751A46" d="M0 0h512v342H0z"/><path fill="#FFF" d="M0 0v342h150.3l37.7-19.6-37.7-18.9 37.7-19-37.7-18.9 37.7-19-37.7-19 37.7-18.9-37.7-19 37.7-19-37.7-18.9 37.7-19-37.7-18.9 37.7-19-37.7-19L188 57l-37.7-19L188 19.1 150.3 0z"/></svg>',
    Le = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 26.666 640 426.666"><g fill-rule="evenodd" stroke-width="1pt"><path fill="#fff" d="M0 0h640v480H0z"/><path fill="#00267f" d="M0 0h213.3v480H0z"/><path fill="#f31830" d="M426.7 0H640v480H426.7z"/></g></svg>',
    Ce = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFDA44" d="M0 85.331h512v341.326H0z"/><path fill="#0052B4" d="M0 85.331h170.663v341.337H0z"/><path fill="#D80027" d="M341.337 85.331H512v341.337H341.337z"/></svg>',
    Te = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#0052B4" d="M0 85.331h512v341.337H0z"/><path fill="#D80027" d="M0 85.331h512v113.775H0z"/><path fill="#FFF" d="M0 312.882h512v113.775H0z"/><path fill="#D80027" d="M129.468 181.793v85.136c0 48.429 63.267 63.267 63.267 63.267S256 315.356 256 266.929v-85.136H129.468z"/><g fill="#FFDA44"><path d="M155.634 196.634h74.201v-29.681l-14.841 7.42-22.261-22.26-22.259 22.26-14.84-7.42zM241.16 278.782l-48.231-48.231-48.231 48.231 15.741 15.74 32.49-32.49 32.49 32.49z"/></g><path fill="#FFF" d="M241.16 233.734h-22.504a14.74 14.74 0 0 0 2.001-7.418c0-8.196-6.645-14.84-14.84-14.84-5.663 0-10.581 3.172-13.083 7.836-2.502-4.663-7.421-7.836-13.083-7.836-8.195 0-14.84 6.644-14.84 14.84 0 2.706.736 5.235 2.001 7.418h-22.114c0 8.196 7.139 14.84 15.334 14.84h-.494c0 8.196 6.644 14.84 14.84 14.84 0 7.257 5.211 13.286 12.094 14.576l-11.694 26.401a48.075 48.075 0 0 0 18.149 3.544 48.079 48.079 0 0 0 18.149-3.544l-11.694-26.401c6.883-1.29 12.094-7.319 12.094-14.576 8.196 0 14.84-6.644 14.84-14.84h-.494c8.199 0 15.338-6.644 15.338-14.84z"/></svg>',
    Ie = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.33v341.332h512V85.33z"/><path fill="#0052B4" d="M0 85.333h512V426.67H0z"/><path fill="#FFF" d="M0 85.333h512v113.775H0z"/><path fill="#D80027" d="M0 312.884h512v113.775H0z"/></svg>',
    Re = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#338AF3" d="M0 85.331h512v341.337H0z"/><path fill="#FFDA44" d="M0 255.994h512v81.619H0z"/><path fill="#496E2D" d="M0 337.614h512v89.043H0z"/><path fill="#FFDA44" d="m278.261 185.209 20.844 9.804-11.099 20.186 22.632-4.33 2.868 22.865 15.765-16.816 15.766 16.816 2.867-22.865 22.633 4.33-11.099-20.186 20.843-9.804-20.844-9.805 11.1-20.185-22.633 4.329-2.868-22.864-15.765 16.816-15.766-16.816-2.867 22.864-22.634-4.329 11.1 20.187z"/></svg>',
    Ve = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#055e1c" d="M0 85.333h512v341.333H0z"/><g fill="#FFF"><path d="M183.548 289.386c0 12.295 9.731 22.261 21.736 22.261h65.208c0 10.244 8.11 18.551 18.114 18.551h21.736c10.004 0 18.114-8.306 18.114-18.551v-22.261H183.548zM330.264 181.791v51.942c0 8.183-6.5 14.84-14.491 14.84v22.261c19.976 0 36.226-16.643 36.226-37.101v-51.942h-21.735zM174.491 233.734c0 8.183-6.5 14.84-14.491 14.84v22.261c19.976 0 36.226-16.643 36.226-37.101v-51.942H174.49v51.942z"/><path d="M297.661 181.788h21.736v51.942h-21.736zM265.057 211.473c0 2.046-1.625 3.71-3.623 3.71-1.998 0-3.623-1.664-3.623-3.71v-29.682h-21.736v29.682c0 2.046-1.625 3.71-3.623 3.71s-3.623-1.664-3.623-3.71v-29.682h-21.736v29.682c0 14.32 11.376 25.971 25.358 25.971 5.385 0 10.38-1.733 14.491-4.677 4.11 2.944 9.106 4.677 14.491 4.677 1.084 0 2.15-.078 3.2-.215-1.54 6.499-7.255 11.345-14.068 11.345v22.261c19.976 0 36.226-16.643 36.226-37.101v-51.943h-21.736l.002 29.682z"/><path d="M207.093 248.57h32.601v22.261h-32.601z"/></g></svg>',
    ke = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#496E2D" d="M0 85.334h512v341.337H0z"/><path fill="#0052B4" d="M0 426.663V85.329h512"/><path fill="#FFDA44" d="M0 396.494v30.169h45.255L512 115.499v-30.17h-45.255z"/><g fill="#FFF"><path d="m85.688 108.787 5.12 15.756h16.566l-13.403 9.737 5.12 15.757-13.403-9.738-13.405 9.738 5.12-15.757L64 124.543h16.567zM170.312 108.787l5.121 15.756H192l-13.403 9.737 5.12 15.757-13.405-9.738-13.403 9.738 5.12-15.757-13.403-9.737h16.566zM85.688 191.289l5.12 15.756h16.566l-13.403 9.738 5.12 15.757-13.403-9.739-13.405 9.739 5.12-15.757L64 207.045h16.567zM170.312 191.289l5.121 15.756H192l-13.403 9.738 5.12 15.757-13.405-9.739-13.403 9.739 5.12-15.757-13.403-9.738h16.566zM128 150.037l5.12 15.756h16.568l-13.405 9.738 5.12 15.758L128 181.55l-13.403 9.739 5.12-15.758-13.405-9.738h16.568z"/></g></svg>',
    Oe = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.337h512v341.326H0z"/><path fill="#FFDA44" d="M235.454 85.337 0 426.663 427.345 85.337z"/><path fill="#6DA544" d="M512 329.393 0 426.663h512z"/><path fill="#D80027" d="M512 85.337h-84.655L0 426.663l512-204.512z"/><path fill="#0052B4" d="M0 85.337v341.326L235.454 85.337z"/></svg>',
    Pe = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.337h512v341.326H0z"/><path fill="#D80027" d="M0 85.337h512v113.775H0z"/><path d="M0 312.888h512v113.775H0z"/><path fill="#496E2D" d="M0 426.668V85.331l256 170.675z"/></svg>',
    Ge = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#0052B4" d="M0 85.333h512V426.67H0z"/><path fill="#FFDA44" d="M192 85.33h-64v138.666H0v64h128v138.666h64V287.996h320v-64H192z"/></svg>',
    Ke = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.337h512v341.326H0z"/><path fill="#D80027" d="M0 85.337h512V256H0z"/><g fill="#FFF"><path d="M83.478 170.666c0-24.865 17.476-45.637 40.812-50.734a52.059 52.059 0 0 0-11.13-1.208c-28.688 0-51.942 23.254-51.942 51.941s23.255 51.942 51.942 51.942c3.822 0 7.543-.425 11.13-1.208-23.336-5.095-40.812-25.867-40.812-50.733zM150.261 122.435l3.684 11.337h11.921l-9.645 7.007 3.684 11.337-9.644-7.006-9.645 7.006 3.685-11.337-9.645-7.007h11.921z"/><path d="m121.344 144.696 3.683 11.337h11.921l-9.645 7.007 3.684 11.337-9.643-7.006-9.645 7.006 3.685-11.337-9.645-7.007h11.921zM179.178 144.696l3.684 11.337h11.921l-9.645 7.007 3.684 11.337-9.644-7.006-9.644 7.006 3.685-11.337-9.645-7.007h11.921zM168.047 178.087l3.684 11.337h11.921l-9.644 7.007 3.684 11.337-9.645-7.006-9.643 7.006 3.684-11.337-9.644-7.007h11.92zM132.474 178.087l3.683 11.337h11.921l-9.644 7.007 3.684 11.337-9.644-7.006-9.644 7.006 3.684-11.337-9.644-7.007h11.92z"/></g></svg>',
    We = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 341.3"><path fill="#0052B4" d="M0 0h512v341.3H0z"/><path fill="#FFF" d="M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z"/><g fill="#D80027"><path d="M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"/><path d="M0 0v15.1l57.4 38.3H80zM256 0v15.1l-57.4 38.3H176z"/></g><path fill="#2E52B2" d="M256 22.7v30.7h-46.1z"/><g fill="#D80027"><path d="M0 0v15.1l57.4 38.3H80zM256 0v15.1l-57.4 38.3H176z"/></g><path fill="#2E52B2" d="M256 22.7v30.7h-46.1z"/><g fill="#D80027"><path d="M0 170.7v-15.1l57.4-38.2H80zM256 170.7v-15.1l-57.4-38.2H176z"/></g><path fill="#29DBFF" d="M449 139.7c-.1 44.4-7.2 92.1-65 114.9-57.8-22.8-64.9-70.5-65-114.9h130z"/><path fill="#ffda44" d="M449 139.7c0-16.7-.9-32.9-.5-47.1C426.9 83 398.4 81 383.9 81s-42.9 2-64.6 11.6c.4 14.2-.5 30.4-.5 47.1H449z"/><path fill="#BF521B" d="m369.5 204.5.3 10.3-12.8.2 4.9 13.2h-17.3c-18-20.2-23.4-42.4-24.9-68.1l9.1-9.7 8.3 14.3 10.8-12.8 7 7.8.8 15.7 13.8 29.1z"/><path fill="#474747" d="m436.6 192.5-8.6 18.3h-47l-29.2-19.5 25.7 10.5h25.1l3.7-6.5 7.2.2 2-3z"/></svg>',
    _e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.337h512v341.326H0z"/><path fill="#0052B4" d="M0 199.112h512v113.775H0z"/><path fill="#D80027" d="M0 312.888h512v113.775H0z"/><path fill="#FFF" d="M233.606 196.639v14.837c0 34.081-44.522 44.522-44.522 44.522s-44.522-10.44-44.522-44.522v-14.837l-.145-44.188 89.043-.266.146 44.454z"/><path fill="#0052B4" d="M233.606 196.639v14.837c0 34.081-44.522 44.522-44.522 44.522s-44.522-10.44-44.522-44.522v-14.837l-.145-44.188 89.043-.266.146 44.454z"/><path fill="#FFF" d="M233.606 196.639v14.837c0 34.081-44.522 44.522-44.522 44.522s-44.522-10.44-44.522-44.522v-14.837l14.848 14.837 29.674-22.261 29.685 22.261 14.837-14.837z"/></svg>',
    Ye = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#D80027" d="M0 85.334h512v341.337H0z"/><path fill="#FFF" d="M512 295.883H202.195v130.783H122.435V295.883H0V216.111h122.435V85.329H202.195v130.782H512V277.329z"/><path fill="#2E52B2" d="M512 234.666v42.663H183.652v149.337h-42.674V277.329H0v-42.663h140.978V85.329h42.674v149.337z"/></svg>',
    Ze = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.337h512v341.326H0z"/><path fill="#0052B4" d="M0 196.641h512v118.717H0z"/><path fill="#D80027" d="M0 315.359h512v111.304H0z"/><path fill="#FFF" d="M129.468 181.799v85.136c0 48.429 63.267 63.267 63.267 63.267S256 315.362 256 266.935v-85.136H129.468z"/><path fill="#D80027" d="M146.126 184.294v81.941c0 5.472 1.215 10.64 3.623 15.485h85.97c2.408-4.844 3.623-10.012 3.623-15.485v-81.941h-93.216z"/><path fill="#FFF" d="M221.301 241.427h-21.425v-14.283h14.284v-14.283h-14.284v-14.284h-14.283v14.284h-14.282v14.283h14.282v14.283h-21.426v14.284h21.426v14.283h14.283v-14.283h21.425z"/><path fill="#0052B4" d="M169.232 301.658c9.204 5.783 18.66 9.143 23.502 10.636 4.842-1.494 14.298-4.852 23.502-10.636 9.282-5.833 15.79-12.506 19.484-19.939a24.878 24.878 0 0 0-14.418-4.583c-1.956 0-3.856.232-5.682.657-3.871-8.796-12.658-14.94-22.884-14.94-10.227 0-19.013 6.144-22.884 14.94a25.048 25.048 0 0 0-5.682-.657 24.88 24.88 0 0 0-14.418 4.583c3.691 7.433 10.198 14.106 19.48 19.939z"/></svg>',
    Je = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.337h512v341.326H0z"/><path fill="#6DA544" d="M0 85.337h512v113.775H0z"/><path fill="#338AF3" d="M0 312.888h512v113.775H0z"/></svg>',
    qe = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#338AF3" d="M0 85.34h512v341.326H0z"/><path fill="#FFF" d="M512 85.334v166.69L0 256.175V85.334z"/><path fill="#6DA544" d="M323.744 203.099 256 270.843l-67.744-67.744a81.156 81.156 0 0 0-13.879 45.483v22.261c0 35.744 23.097 66.193 55.148 77.213-4.277 8.385-3.556 18.848 2.712 26.671l24.258-19.439 24.258 19.439c6.342-7.915 7.011-18.534 2.564-26.968 31.614-11.261 54.308-41.485 54.308-76.916v-22.261a81.174 81.174 0 0 0-13.881-45.483z"/><path fill="#FFDA44" d="M256 330.206c-32.732 0-59.362-26.63-59.362-59.362v-22.261c0-32.733 26.63-59.363 59.362-59.363s59.362 26.63 59.362 59.362v22.261c0 32.733-26.63 59.363-59.362 59.363z"/><path fill="#338AF3" d="M293.101 270.843v-22.261c0-20.458-16.643-37.101-37.101-37.101s-37.101 16.643-37.101 37.101v22.261L256 278.264l37.101-7.421z"/><path fill="#6DA544" d="M218.899 270.843c0 20.458 16.643 37.101 37.101 37.101s37.101-16.643 37.101-37.101h-74.202z"/><path fill="#FFDA44" d="M300.522 189.22c0-12.295-9.966-22.261-22.261-22.261a22.173 22.173 0 0 0-14.84 5.672v-13.093h7.421v-14.84h-7.421v-7.421h-14.84v7.421h-7.421v14.84h7.421v13.093a22.177 22.177 0 0 0-14.841-5.672c-12.295 0-22.261 9.966-22.261 22.261 0 6.591 2.867 12.512 7.421 16.589v13.093h74.203v-13.093c4.552-4.077 7.419-9.997 7.419-16.589z"/></svg>',
    Xe = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFDA44" d="M0 85.331h512v341.326H0z"/><path fill="#D80027" d="M330.207 85.331H512v341.337H330.207z"/><g fill="#496E2D"><path d="M0 85.331h181.793v341.337H0zM255.999 196.632l14.733 45.347h47.685l-38.576 28.029 14.734 45.348-38.576-28.026-38.577 28.026 14.737-45.348-38.576-28.029h47.681z"/></g></svg>',
    $e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#338AF3" d="M0 85.331h512v341.337H0z"/><path fill="#FFF" d="m256 157.273 22.663 69.748H352l-59.332 43.106 22.664 69.749L256 296.769l-59.332 43.107 22.664-69.749L160 227.021h73.337z"/></svg>',
    Qe = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.331h512v341.337H0z"/><path fill="#A2001D" d="M0 196.636h512v118.728H0z"/><g fill="#6DA544"><path d="M0 352.462h512v74.207H0zM0 85.331h512v74.207H0z"/></g><path fill="#FFDA44" d="m256.742 218.003 9.43 29.021h30.518L272 264.963l9.431 29.023-24.689-17.937-24.689 17.937 9.431-29.023-24.69-17.939h30.518z"/></svg>',
    ti = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.337h512v341.326H0z"/><path fill="#496E2D" d="M0 322.783h512v103.88H0z"/><path d="M0 85.337h512v104.515H0z"/><path fill="#A2001D" d="M0 210.877h512v89.656H0z"/><path fill="#0052B4" d="M256 256.006 0 426.668V85.331z"/><path fill="#FFDA44" d="m73.178 209.188 20.831 29.067 34.084-10.83-21.207 28.795 20.83 29.069-33.939-11.271-21.208 28.794.234-35.762-33.94-11.273 34.083-10.83z"/></svg>',
    ni = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFDA44" d="M0 85.337h512v341.326H0z"/><g fill="#6DA544"><path d="M0 85.337h512v113.775H0zM0 312.888h512v113.775H0z"/></g><path fill="#D80027" d="M256 256.006 0 426.668V85.331z"/><path d="m302.049 226.318 7.368 22.674h23.842l-19.288 14.016 7.366 22.674-19.288-14.015-19.287 14.015 7.366-22.674-19.288-14.016h23.842zM376.252 226.318l7.367 22.674h23.842l-19.288 14.016 7.367 22.674-19.288-14.015-19.288 14.015 7.367-22.674-19.288-14.016h23.842z"/></svg>',
    ei = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.337h512v341.326H0z"/><g fill="#0052B4"><path d="M0 85.337h512v113.775H0zM0 312.888h512v113.775H0z"/></g><path fill="#FFDA44" d="M228.582 261.936 256 214.447l27.418 47.489z"/><path fill="#6DA544" d="M291.616 277.616 256 295.425l-35.616-17.809v-23.744h71.232z"/><path fill="#FFDA44" d="m289.579 216.485-12.592 12.592c5.37 5.372 8.693 12.791 8.693 20.988 0 16.392-13.289 29.68-29.68 29.68-16.392 0-29.68-13.289-29.68-29.68 0-8.195 3.322-15.616 8.693-20.988l-12.592-12.592c-8.594 8.594-13.91 20.466-13.91 33.579 0 26.228 21.261 47.489 47.489 47.489s47.489-21.261 47.489-47.489c0-13.114-5.316-24.987-13.91-33.579z"/></svg>',
    ii = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#0052B4" d="M0 85.337h512v341.326H0z"/><path fill="#D80027" d="M512 85.331v166.69L0 256.173V85.331z"/><path fill="#FFF" d="M256 256.006 0 426.668V85.331z"/><g fill="#FFDA44"><path d="M59.621 256a59.546 59.546 0 0 0-.193 4.57c0 32.821 26.607 59.429 59.429 59.429s59.429-26.607 59.429-59.429c0-1.539-.078-3.061-.193-4.57H59.621z"/><circle cx="118.862" cy="210.287" r="18.286"/></g><path fill="#D80027" d="M77.715 205.714v59.429c0 31.494 41.144 41.143 41.144 41.143s41.144-9.649 41.144-41.143v-59.429H77.715z"/><path fill="#338AF3" d="M118.877 287.148c-7.632-2.746-22.876-9.767-22.876-22.006v-41.144h45.715v41.144c-.001 12.28-15.244 19.283-22.839 22.006z"/><path fill="#F3F3F3" d="M128.001 246.856v-9.142l-9.144-4.571-9.142 4.571v9.142l-4.571 4.573v18.285h27.428v-18.285z"/></svg>',
    ai = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.331h512v341.337H0z"/><path fill="#D80027" d="M0 85.331h512v113.775H0z"/><path d="M0 312.882h512v113.775H0z"/><g fill="#6DA544"><path d="m187.31 215.184 9.208 28.341h29.802l-24.11 17.518 9.209 28.342-24.109-17.516-24.11 17.516 9.209-28.342-24.109-17.518h29.801zM324.69 215.184l9.209 28.341H363.7l-24.109 17.518 9.209 28.342-24.11-17.516-24.109 17.516 9.209-28.342-24.11-17.518h29.802z"/></g></svg>',
    ri = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 600"><path fill="#2B5DEA" d="M0 0h900v600H0V0z"/><path fill="#FFDF29" d="M0 100h900v400H0V100z"/><path fill="#D70000" d="M0 150h900v300H0V150z"/><path fill="#FFF" d="M450 171.4v257.2c114.3 0 171.4-85.7 214.3-128.6-42.9-42.9-100-128.6-214.3-128.6z"/><path d="M450 171.4c-100 0-171.4 85.7-214.3 128.6C278.6 342.9 350 428.6 450 428.6V171.4z"/><path fill="#FFF" d="M346.3 254.3h21v91.3h-21zM398.2 254.3h21v91.3h-21z"/><path d="M477.8 254.3h21v91.3h-21zM529.7 254.3h21v91.3h-21z"/></svg>',
    oi = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 341.3"><path fill="#0052B4" d="M0 0h512v341.3H0z"/><path fill="#FFF" d="M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z"/><g fill="#D80027"><path d="M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"/><path d="M0 0v15.1l57.4 38.3H80zM256 0v15.1l-57.4 38.3H176z"/></g><path fill="#2E52B2" d="M256 22.7v30.7h-46.1z"/><g fill="#D80027"><path d="M0 0v15.1l57.4 38.3H80zM256 0v15.1l-57.4 38.3H176z"/></g><path fill="#2E52B2" d="M256 22.7v30.7h-46.1z"/><g fill="#D80027"><path d="M0 170.7v-15.1l57.4-38.2H80zM256 170.7v-15.1l-57.4-38.2H176z"/></g><path fill="#29DBFF" d="M448.9 169.5c0 9.6-.3 29.6-1.4 39.2-4.1 34.9-23.5 68.8-62.1 85.9-45.3-17.9-60.8-51-64.9-85.9-1.1-9.6-1.5-19.4-1.5-29l.3-47.1h129.2l.4 36.9z"/><path fill="#FFF" d="M447.5 208.7c-.2 1.6-.4 3.3-.6 4.9-4.8 33.1-22.9 65.4-61.5 81-43.2-17-59.4-47.9-64.2-81-.2-1.6-.4-3.2-.6-4.9"/><path fill="#29DBFF" d="m385.4 251.7-22.9-43h45.8z"/><path fill="#FFF" d="m385.4 165.8-22.9 42.9h45.8z"/><ellipse fill="#FFBE57" cx="474.8" cy="236.8" rx="16.8" ry="43.3"/><ellipse fill="#FFBE57" cx="295.3" cy="236.8" rx="16.8" ry="43.3"/><path fill="#FFF" d="m385.4 31.5-33.4 44h68.5zM315.5 280s33.8 29.5 69.9 29.5 67.1-29.5 67.1-29.5l8.5 14.6S439.2 326 385.4 326 307 294.6 307 294.6l8.5-14.6z"/><ellipse fill="#A5A5A5" cx="386.3" cy="104.3" rx="34.3" ry="23.3"/></svg>',
    li = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#0052B4" d="M0 85.333h512V426.67H0z"/><path fill="#FFDA44" d="M332.058 191.996v78.221c0 38.103 51.942 49.779 51.942 49.779s51.942-11.675 51.942-49.779v-78.221H332.058z"/><path fill="#FF9811" d="M376.579 220.44c0 7.855-6.644 28.445-14.84 28.445s-14.84-20.589-14.84-28.445c0-7.856 14.84-14.222 14.84-14.222s14.84 6.367 14.84 14.222z"/><path fill="#A2001D" d="M415.961 235.93c2.394-5.6 4.257-13.785 4.257-17.86 0-6.546-8.904-11.852-8.904-11.852s-8.904 5.306-8.904 11.852c0 4.075 1.862 12.26 4.257 17.86l-5.141 11.123a26.898 26.898 0 0 0 9.788 1.831c3.463 0 6.766-.654 9.788-1.831l-5.141-11.123z"/><path fill="#6DA544" d="M372.87 270.217s-7.421 14.222-7.421 28.445h37.101c0-14.222-7.421-28.445-7.421-28.445l-11.13-7.111-11.129 7.111z"/><path fill="#D80027" d="M395.13 270.217v-3.555c0-5.891-4.983-10.666-11.13-10.666-6.147 0-11.13 4.776-11.13 10.666v3.555h22.26z"/><path fill="#FFF" d="M256 85.333v30.553l-45.167 25.099H256v59.359h-59.103L256 233.179v22.817h-26.68l-73.494-40.826v40.826h-55.652v-48.573l-87.43 48.573H0v-30.554l45.167-25.098H0v-59.359h59.103L0 108.139V85.333h26.68l73.494 40.825V85.333h55.652v48.572l87.43-48.572z"/><path fill="#D80027" d="M144 85.33h-32v69.332H0v32h112v69.334h32v-69.334h112v-32H144z"/><path fill="#0052B4" d="M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"/><path fill="#FFF" d="M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"/><g fill="#D80027"><path d="M155.826 200.344 256 255.996v-15.737l-71.847-39.915zM71.846 200.344 0 240.259v15.737l100.174-55.652z"/></g><path fill="#0052B4" d="M100.174 140.982 0 85.33v15.737l71.847 39.915z"/><path fill="#FFF" d="M100.174 140.982 0 85.33v15.737l71.847 39.915z"/><g fill="#D80027"><path d="M100.174 140.982 0 85.33v15.737l71.847 39.915zM184.154 140.982 256 101.067V85.33l-100.174 55.652z"/></g></svg>',
    ci = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFDA44" d="M0 85.331h512v341.337H0z"/><path fill="#0052B4" d="M0 85.331h170.663v341.337H0z"/><path fill="#D80027" d="M341.337 85.331H512v341.337H341.337z"/></svg>',
    si = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.5 15"><path fill="#FFF" d="M0 0h21v15H0V0z"/><path fill="#073AB6" d="M0 0h22.5v15H0V0z"/><path fill="#FFF" d="M0 0h11.3v7.5H0V0z"/><path fill="#F44653" d="M7.1 0h3.6v7H7.1V0z"/><path fill="#1035BB" d="M0 0h3.6v7H0V0z"/><path fill="#FFF" d="M3.6 0h3.6v7H3.6V0zM14.5 6h5L19 7h-1.5v.5h1l-.5 1h-.5V10h-1V7H15l-.5-1zm4 2.5 1 1.5h-2l1-1.5zm-3 0 1 1.5h-2l1-1.5zm1.5 3L16 10h2l-1 1.5zM20 8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm-6 0c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm1 4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm4 0c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm-2 1c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5z"/></svg>',
    hi = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFDA44" d="M0 85.337h512v341.326H0z"/><g fill="#496E2D"><path d="M0 85.337h512V153.6H0zM0 358.4h512v68.263H0zM0 221.863h512v68.263H0z"/></g><path fill="#D80027" d="M0 85.337h204.054v204.054H0z"/><path fill="#FFF" d="m102.026 133.938 13.26 40.812h42.916l-34.718 25.226 13.26 40.814-34.718-25.224-34.719 25.224 13.263-40.814-34.718-25.226h42.913z"/></svg>',
    ui = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.334h512V426.66H0z"/><path fill="#0052B4" d="M0 194.056h512v123.882H0z"/><g fill="#D80027"><path d="M0 85.334h512v54.522H0zM0 372.143h512v54.522H0z"/></g></svg>',
    fi = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.337h512v341.326H0z"/><path fill="#D80027" d="M0 85.337h512v113.775H0z"/><path fill="#6DA544" d="M0 312.888h512v113.775H0z"/><g fill="#FFDA44"><path d="M226.318 300.522h59.364v-25.23l-11.873 5.937L256 263.421l-17.809 17.808-11.873-5.937zM192.355 270.84l2.763 8.504h8.94l-7.233 5.255 2.763 8.502-7.233-5.255-7.234 5.255 2.763-8.502-7.233-5.255h8.94zM200.921 241.16l2.763 8.502h8.94l-7.233 5.255 2.763 8.504-7.233-5.256-7.234 5.256 2.763-8.504-7.233-5.255h8.94zM225.409 218.899l2.763 8.502h8.94l-7.233 5.255 2.763 8.504-7.233-5.256-7.234 5.256 2.763-8.504-7.233-5.255h8.94zM319.645 270.84l-2.763 8.504h-8.94l7.233 5.255-2.763 8.502 7.233-5.255 7.234 5.255-2.763-8.502 7.233-5.255h-8.94zM311.079 241.16l-2.763 8.502h-8.94l7.233 5.255-2.763 8.504 7.233-5.256 7.234 5.256-2.763-8.504 7.233-5.255h-8.94zM286.591 218.899l-2.763 8.502h-8.94l7.233 5.255-2.763 8.504 7.233-5.256 7.234 5.256-2.763-8.504 7.233-5.255h-8.94zM256 207.767l2.763 8.503h8.941l-7.234 5.256 2.763 8.502-7.233-5.254-7.233 5.254 2.763-8.502-7.234-5.256h8.941z"/></g></svg>',
    vi = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#0052B4" d="M0 85.337h512v341.326H0z"/><g fill="#FFF"><path d="m210.715 174.377 3.684 11.338h11.919l-9.643 7.006 3.684 11.337-9.644-7.007-9.644 7.007 3.684-11.337-9.645-7.006h11.921zM116.816 281.971l4.605 14.172h14.9l-12.055 8.757 4.606 14.173-12.056-8.76-12.055 8.76 4.604-14.173-12.054-8.757h14.899zM144.696 119.679l4.604 14.172h14.901l-12.056 8.758 4.606 14.171-12.055-8.759-12.056 8.759 4.606-14.171-12.055-8.758h14.9zM69.539 175.331l4.604 14.172h14.9l-12.055 8.758 4.606 14.171-12.055-8.758-12.056 8.758 4.606-14.171-12.055-8.758h14.9z"/></g><g fill="#FFDA44"><path d="M483.386 354.503H117.801s109.234-88.562 310.593-220.938c.001 0-88.443 128.935 54.992 220.938zM117.801 366.089c-11.177 0-11.195 17.37 0 17.37h365.585c11.177 0 11.195-17.37 0-17.37H117.801z"/></g></svg>',
    pi = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#D80027" d="M0 85.337h512v341.326H0z"/><path fill="#FFDA44" d="M256 256 0 90.691v44.242L155.826 256 0 377.067v44.242z"/><path d="M0 90.691v330.618L189.217 256z"/><path fill="#FFF" d="m44.184 213.36 24.912 23.577 30.121-16.41-14.723 30.98 24.911 23.575-34.012-4.43L60.67 301.63l-6.296-33.716-34.012-4.43 30.119-16.408z"/></svg>',
    gi = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#496E2D" d="M0 85.337h512v341.326H0z"/><g fill="#FFF"><path d="M357.208 183.679c8.397-23.404-1.036-48.858-21.281-61.536a52.131 52.131 0 0 1 10.884 2.621c27.002 9.688 41.038 39.428 31.35 66.431s-39.428 41.038-66.431 31.35a52.182 52.182 0 0 1-10.069-4.895c23.686 3.084 47.15-10.566 55.547-33.971zM310.637 115.729l-7.297 9.427-11.22-4.026 6.712 9.852-7.296 9.427 11.443-3.338 6.712 9.852.361-11.914 11.444-3.339-11.221-4.025z"/><path d="m330.338 146.448-7.296 9.427-11.221-4.026 6.712 9.852-7.296 9.427 11.443-3.339 6.712 9.853.36-11.915 11.445-3.34-11.221-4.024zM275.9 126.916l-7.296 9.427-11.219-4.024 6.711 9.851-7.296 9.426 11.443-3.338 6.712 9.852.361-11.915 11.444-3.337-11.221-4.027zM275.101 162.105l-7.296 9.427-11.221-4.026 6.712 9.852-7.296 9.427 11.444-3.338 6.711 9.852.362-11.915 11.443-3.338-11.22-4.026zM308.585 174.118l-7.296 9.427-11.22-4.026 6.712 9.853-7.297 9.426 11.444-3.338 6.712 9.852.36-11.915 11.443-3.338-11.219-4.025z"/></g><path fill="#D80027" d="M83.478 85.337h89.043v341.326H83.478z"/><path fill="#FFF" d="m117.458 175.191-14.908-11.105v-15.705l14.908-11.105h21.084l14.908 11.105v15.705l-14.908 11.105z"/><g fill="#FF9811"><path d="M128 137.276h-10.542l-14.908 11.105v7.678H128zM128 175.191h10.542l14.908-11.105v-8.012H128z"/></g><path fill="#FFF" d="m117.458 374.725-14.908-11.106v-15.704l14.908-11.105h21.084l14.908 11.105v15.704l-14.908 11.106z"/><g fill="#FF9811"><path d="M128 336.81h-10.542l-14.908 11.105v7.678H128zM128 374.725h10.542l14.908-11.106v-8.011H128z"/></g><g fill="#496E2D"><path d="m117.458 274.957-14.908-11.105v-15.703l14.908-11.106h21.084l14.908 11.106v15.703l-14.908 11.105zM153.971 299.391h-6.493v-6.493h-11.411l-8.068-8.068-8.067 8.068h-11.41v6.493h-6.493v12.986h6.493v6.492h11.41l8.068 8.069 8.068-8.069h11.41v-6.492h6.493zM153.971 199.623h-6.493v-6.492h-11.411l-8.068-8.069-8.067 8.069h-11.41v6.492h-6.493v12.986h6.493v6.492h11.41l8.068 8.07 8.068-8.07h11.41v-6.492h6.493z"/></g><g fill="#D80027"><path d="M120.576 248.576h14.84v14.84h-14.84z"/><circle cx="128" cy="206.113" r="7.421"/><circle cx="128" cy="305.887" r="7.421"/></g></svg>',
    di = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#D80027" d="M0 85.331h512v341.337H0z"/><circle fill="#FFF" cx="256" cy="255.994" r="96"/><g fill="#D80027"><path d="m267.826 219.291 16.47 22.695 26.673-8.649-16.496 22.676 16.468 22.695-26.664-8.681-16.495 22.676.017-28.04-26.664-8.682 26.674-8.648z"/><path d="M277.818 312.724c-31.33 0-56.727-25.397-56.727-56.727s25.397-56.727 56.727-56.727c9.769 0 18.96 2.47 26.985 6.819-12.589-12.31-29.804-19.909-48.803-19.909-38.558 0-69.818 31.259-69.818 69.818s31.26 69.818 69.818 69.818c18.999 0 36.215-7.599 48.803-19.909-8.026 4.347-17.216 6.817-26.985 6.817z"/></g></svg>',
    mi = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#D80027" d="M0 85.331h512v341.337H0z"/><path fill="#FFF" d="M0 85.331h256v170.663H0z"/><path fill="#D80027" d="M141.357 157.303V130.59h-26.714v26.713H87.93v26.713h26.713v26.713h26.714v-26.713h26.713v-26.713z"/></svg>',
    Fi = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#E30A17" d="M0 0h513v342H0z"/><path fill="#FFF" d="M259.7 118.6c-13.1-9.5-29-14.6-45.3-14.5-40.8 0-73.8 30.8-73.8 68.9s33.1 68.9 73.8 68.9c17.1 0 32.9-5.4 45.3-14.5-30 38.6-85.7 45.6-124.3 15.5s-45.6-85.7-15.5-124.3 85.7-45.6 124.3-15.5c5.8 4.5 11 9.8 15.5 15.5zm39.9 65.8-18.1 21.9 1.2-28.4-26.4-10.4 27.3-7.6 1.8-28.3 15.6 23.7 27.5-7.1-17.5 22 15.3 23.9-26.7-9.7z"/></svg>',
    Mi = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#D80027" d="M0 85.337h512v341.326H0z"/><path fill="#FFF" d="m6.066 85.337 207.961 212.636 131.584 128.69h160.323L297.973 214.027 166.389 85.337z"/><path d="M43.364 85.337 384.69 426.663h83.946L127.31 85.337z"/></svg>',
    wi = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 600"><path fill="#0052B4" d="M0 0h900v600H0z"/><path fill="#00B2EE" d="M0 300h450V0h450v600H0V300z"/><path fill="#FFDA44" d="m345.3 480.9 29.4 90.6-77.1-56H393l-77.1 56 29.4-90.6zM706.4 340l29.4 90.6-77.1-56H754l-77.1 56 29.5-90.6zM812.8 261.5l29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6zM812.8 37.4l29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6z"/><path fill="#FFF" d="M449.9 0v206.3h-81l81 54V300h-39.7l-129-85.9V300H168.7v-85.9L39.7 300H0v-39.7l81-54H0V93.8h81L0 39.9V0h39.7l129 85.9V0h112.5v85.9L410.2 0z"/><path fill="#D80027" d="M253.1 0h-56.3v122H0v56.2h196.8V300h56.3V178.2h196.8V122H253.1z"/><path fill="#2E52B2" d="M449.9 39.9v53.9h-81z"/><path fill="#D80027" d="M0 300v-19.3l109.9-74.4h39.7L12.8 300zM12.8.1l136.8 93.7h-39.7L0 19.4V.1zM449.9.2v19.3L340 93.8h-39.7L437.1.2zM437.1 300l-136.8-93.7H340l109.9 74.4V300z"/><path fill="#FFDA44" d="m719.9 131.6 29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6zM584 187.7l29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6zM614 430.6l29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6zM488 332l29.4 90.6-77.1-56h95.3l-77.1 56L488 332zM488 464l29.4 90.6-77.1-56h95.3l-77.1 56L488 464z"/></svg>',
    zi = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#D80027" d="M0 85.337h512v341.326H0z"/><path fill="#0052B4" d="M0 85.337h256V256H0z"/><path fill="#FFF" d="M186.435 170.669 162.558 181.9l12.714 23.125-25.927-4.961-3.286 26.192L128 206.993l-18.06 19.263-3.285-26.192-25.927 4.96 12.714-23.125-23.877-11.23 23.877-11.231-12.714-23.125 25.927 4.96 3.286-26.192L128 134.344l18.06-19.263 3.285 26.192 25.928-4.96-12.715 23.125z"/><circle fill="#0052B4" cx="128" cy="170.674" r="29.006"/><path fill="#FFF" d="M128 190.06c-10.692 0-19.391-8.7-19.391-19.391 0-10.692 8.7-19.391 19.391-19.391 10.692 0 19.391 8.7 19.391 19.391 0 10.691-8.699 19.391-19.391 19.391z"/></svg>',
    yi = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#338AF3" d="M0 85.337h512v341.326H0z"/><path fill="#6DA544" d="M0 426.663V85.337h512"/><path fill="#FFDA44" d="M512 152.222V85.337H411.67L0 359.778v66.885h100.33z"/><path d="M512 85.337v40.125L60.193 426.663H0v-40.125L451.807 85.337z"/></svg>',
    Ai = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFDA44" d="M0 85.337h512v341.326H0z"/><path fill="#338AF3" d="M0 85.337h512V256H0z"/></svg>',
    Ui = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 341.3"><path fill="#232323" d="M0 0h512v341.3H0z"/><path fill="#FFDA44" d="M0 56.9h512v56.9H0z"/><path fill="#D32300" d="M0 113.8h512v56.9H0z"/><path fill="#FFDA44" d="M0 227.6h512v56.9H0z"/><path fill="#D32300" d="M0 284.4h512v56.9H0z"/><circle fill="#FFF" cx="256" cy="170.7" r="80.7"/><path d="M234.5 127.5c.9-1.4-19.6-2-19.6-2 1.7-2.5 18.4-10.5 18.4-10.5s-.9-6 2.7-9.8l-4.5-9.8s7-3.4 18.4-3.4 19.9 7 21 13.1l-6.4 3.4c-.1 4.7 1.7 11.6-4.3 17.3-5.9 5.7-8.3 6.9-8.5 18.8 0 3.9 2.3 8.2 8.8 11.7 17.4 9.3 38.6 28.2 44.6 33.9 6.1 5.7 5.1 19.2 2.6 25.2s-12.1 14.3-14.3 13.6c-2.2-.6 1.2-9.2-3.5-11.6 0 0-8.9-7.6-16.8.6s-.2 25.2 3.9 28c4.1 2.8 1.7 5-1.9 5H247c-3.8 0-5.4-2.3-1.9-5 7.6-3.8 12.4-15.3 7.4-20.3-4.9-4.9-18.3 1.5-21.5 6.3-2.8 2.8-8.8 3.6-12.9-1.4s-4.1-10.4-1.1-12.5c7-4.8 0 0 .1-.1 0 0 11.9-8.6 29.9-9 3.9 0 4.8-2.2 2.2-4.8 0 0-30.9-27.4-28.1-44.2 3-18.3 20-26.3 13.4-32.5-1.3-1.8 0 0 0 0z"/></svg>',
    Hi = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#FFF" d="M0 0h513v342H0z"/><g fill="#D80027"><path d="M0 0h513v26.3H0zM0 52.6h513v26.3H0zM0 105.2h513v26.3H0zM0 157.8h513v26.3H0zM0 210.5h513v26.3H0zM0 263.1h513v26.3H0zM0 315.7h513V342H0z"/></g><path fill="#2E52B2" d="M0 0h256.5v184.1H0z"/><g fill="#FFF"><path d="m47.8 138.9-4-12.8-4.4 12.8H26.2l10.7 7.7-4 12.8 10.9-7.9 10.6 7.9-4.1-12.8 10.9-7.7zM104.1 138.9l-4.1-12.8-4.2 12.8H82.6l10.7 7.7-4 12.8 10.7-7.9 10.8 7.9-4-12.8 10.7-7.7zM160.6 138.9l-4.3-12.8-4 12.8h-13.5l11 7.7-4.2 12.8 10.7-7.9 11 7.9-4.2-12.8 10.7-7.7zM216.8 138.9l-4-12.8-4.2 12.8h-13.3l10.8 7.7-4 12.8 10.7-7.9 10.8 7.9-4.3-12.8 11-7.7zM100 75.3l-4.2 12.8H82.6L93.3 96l-4 12.6 10.7-7.8 10.8 7.8-4-12.6 10.7-7.9h-13.4zM43.8 75.3l-4.4 12.8H26.2L36.9 96l-4 12.6 10.9-7.8 10.6 7.8L50.3 96l10.9-7.9H47.8zM156.3 75.3l-4 12.8h-13.5l11 7.9-4.2 12.6 10.7-7.8 11 7.8-4.2-12.6 10.7-7.9h-13.2zM212.8 75.3l-4.2 12.8h-13.3l10.8 7.9-4 12.6 10.7-7.8 10.8 7.8-4.3-12.6 11-7.9h-13.5zM43.8 24.7l-4.4 12.6H26.2l10.7 7.9-4 12.7L43.8 50l10.6 7.9-4.1-12.7 10.9-7.9H47.8zM100 24.7l-4.2 12.6H82.6l10.7 7.9-4 12.7L100 50l10.8 7.9-4-12.7 10.7-7.9h-13.4zM156.3 24.7l-4 12.6h-13.5l11 7.9-4.2 12.7 10.7-7.9 11 7.9-4.2-12.7 10.7-7.9h-13.2zM212.8 24.7l-4.2 12.6h-13.3l10.8 7.9-4 12.7 10.7-7.9 10.8 7.9-4.3-12.7 11-7.9h-13.5z"/></g></svg>',
    xi = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#FFF" d="M0 0h513v342H0z"/><g fill="#0038a8"><path d="M0 38h513v38H0zM0 114h513v38H0zM0 190h513v38H0zM0 266h513v38H0z"/></g><path fill="#FFF" d="M0 0h256.5v190H0z"/><path fill="#FED443" d="m128.3 138.7-15.1 22.6-3.8-26.9L86 148.2l8.2-25.9-27.2 2.2 18.6-19.8L60.3 95l25.4-9.7L67 65.5l27.1 2.3-8.2-25.9 23.4 13.8 3.9-26.9 15.1 22.6 15.1-22.6 3.8 26.9 23.4-13.8-8.2 25.9 27.1-2.2-18.6 19.8 25.4 9.7-25.4 9.7 18.6 19.8-27.1-2.2 8.2 25.9-23.4-13.8-3.9 26.9-15-22.7zm0-.5c23.9.9 44-17.6 44.9-41.5.9-23.9-17.6-44-41.5-44.9h-3.4c-23.9.8-42.6 20.8-41.8 44.6.6 22.8 19 41.1 41.8 41.8zm0-10.6c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.3 34-34 34z"/></svg>',
    Ei = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#D80027" d="M0 85.337h512v341.326H0z"/><path fill="#6DA544" d="M0 322.783h512v103.88H0z"/><path fill="#338AF3" d="M0 85.337h512v104.515H0z"/><path fill="#FFF" d="M0 210.877h512v89.656H0z"/><path fill="#338AF3" d="M0 85.337h512v104.515H0z"/><g fill="#FFF"><path d="M188.688 137.589c0-15.984 11.234-29.339 26.236-32.614a33.531 33.531 0 0 0-7.155-.777c-18.442 0-33.391 14.949-33.391 33.391s14.949 33.391 33.391 33.391c2.458 0 4.85-.273 7.155-.777-15.002-3.275-26.236-16.63-26.236-32.614zM234.658 152.766l2.261 6.957h7.315l-5.918 4.301 2.261 6.956-5.919-4.3-5.918 4.3 2.261-6.956-5.918-4.301h7.315zM258.006 152.766l2.26 6.957h7.315l-5.918 4.301 2.261 6.956-5.918-4.3-5.918 4.3 2.26-6.956-5.917-4.301h7.314zM281.353 152.766l2.26 6.957h7.315l-5.917 4.301 2.26 6.956-5.918-4.3-5.918 4.3 2.26-6.956-5.918-4.301h7.315zM304.7 152.766l2.262 6.957h7.315l-5.919 4.301 2.261 6.956-5.919-4.3-5.918 4.3 2.262-6.956-5.919-4.301h7.314zM328.048 152.766l2.26 6.957h7.315l-5.918 4.301 2.261 6.956-5.918-4.3-5.918 4.3 2.26-6.956-5.917-4.301h7.314zM258.006 128.482l2.26 6.956h7.315l-5.918 4.3 2.261 6.957-5.918-4.299-5.918 4.299 2.26-6.957-5.917-4.3h7.314zM281.353 128.482l2.26 6.956h7.315l-5.917 4.3 2.26 6.957-5.918-4.299-5.918 4.299 2.26-6.957-5.918-4.3h7.315zM304.7 128.482l2.262 6.956h7.315l-5.919 4.3 2.261 6.957-5.919-4.299-5.918 4.299 2.262-6.957-5.919-4.3h7.314zM328.048 128.482l2.26 6.956h7.315l-5.918 4.3 2.261 6.957-5.918-4.299-5.918 4.299 2.26-6.957-5.917-4.3h7.314zM281.353 104.198l2.26 6.956h7.315l-5.917 4.3 2.26 6.957-5.918-4.3-5.918 4.3 2.26-6.957-5.918-4.3h7.315zM304.7 104.198l2.262 6.956h7.315l-5.919 4.3 2.261 6.957-5.919-4.3-5.918 4.3 2.262-6.957-5.919-4.3h7.314zM328.048 104.198l2.26 6.956h7.315l-5.918 4.3 2.261 6.957-5.918-4.3-5.918 4.3 2.26-6.957-5.917-4.3h7.314z"/></g></svg>',
    Si = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFDA44" d="M0 85.331h512v341.326H0z"/><path fill="#FFF" d="M256 85.331h256v341.337H256z"/><path fill="#ACABB1" d="m321.353 233.837 32.073 42.43c-5.053 7.651-5.026 17.961.817 25.692 7.414 9.807 21.374 11.748 31.182 4.335 9.807-7.414 11.748-21.374 4.334-31.182-5.843-7.731-15.756-10.568-24.495-7.795l-49.988-66.129-11.838 8.949-17.759 13.424 17.899 23.677 17.775-13.401zm46.175 48.78a7.421 7.421 0 1 1 8.95 11.84 7.421 7.421 0 0 1-8.95-11.84z"/><path fill="#FFDA44" d="m376.367 247.24 17.899-23.677-17.759-13.424-11.838-8.949-49.988 66.129c-8.74-2.775-18.651.063-24.495 7.795-7.414 9.808-5.473 23.768 4.334 31.182 9.808 7.414 23.768 5.473 31.182-4.335 5.845-7.731 5.871-18.041.817-25.692l32.073-42.43 17.775 13.401zm-62.504 45.771a7.42 7.42 0 1 1-11.84-8.95 7.42 7.42 0 0 1 11.84 8.95z"/></svg>',
    Bi = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFDA44" d="M0 85.331h512v341.337H0z"/><path fill="#338AF3" d="M0 85.331h170.663v341.337H0z"/><g fill="#6DA544"><path d="M341.337 85.331H512v341.337H341.337zM214.261 283.82l-33.393-50.086 33.392-50.087 33.392 50.087zM297.739 283.82l-33.391-50.086 33.391-50.087 33.393 50.087zM256 350.603l-33.391-50.087L256 250.429l33.391 50.087z"/></g></svg>',
    Di = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.5 15"><path fill="#FFCE00" d="M0 0h22.5v5H0z"/><path fill="#203899" d="M0 5h22.5v5H0z"/><path fill="#D82B2B" d="M0 10h22.5v5H0z"/><path fill="#FFF" d="m12.13 5.38.14.46.45.14-.39.27.01.48-.38-.29-.45.15.15-.44-.28-.38h.47zM10.36 5.38l.27.39h.47l-.28.38.15.45-.45-.16-.38.28.01-.47-.39-.28.45-.13zM13.8 5.94l-.01.48.39.27-.46.14-.14.45-.27-.38h-.48l.29-.38-.15-.45.45.16zM8.69 5.96l.4.27.44-.18-.13.46.3.36-.47.02-.26.4-.16-.44-.46-.12.37-.3zM15.24 7.13l-.2.44.25.4-.47-.05-.31.36-.1-.46-.43-.18.41-.24.03-.47.35.31zM15.43 8.25l.21.43.47.07-.34.33.08.46-.42-.22-.42.22.08-.46-.34-.33.47-.07zM7 8.2l.21.43.47.06-.34.33.08.47L7 9.27l-.42.22.08-.47-.34-.33.47-.06zM7.31 7.05l.45.14.38-.29v.48l.39.26-.45.15-.13.46-.28-.38-.47.01.27-.38z"/></svg>',
    bi = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#0052B4" d="M0 85.334h512v341.337H0z"/><path fill="#FFF" d="M256 85.334V202.66h-46.069L256 233.38v22.617h-22.628L160 207.078v48.919H96v-48.919l-73.372 48.919H0V233.38l46.069-30.72H0v-64h46.069L0 107.951V85.334h22.628L96 134.241V85.334h64v48.907l73.372-48.907z"/><g fill="#D80027"><path d="M144 85.33h-32v69.333H0v32h112v69.334h32v-69.334h112v-32H144z"/><path d="M0 85.329v15.083l57.377 38.251H80zM256 85.329v15.083l-57.377 38.251H176z"/></g><path fill="#2E52B2" d="M256 107.951v30.712h-46.069z"/><g fill="#D80027"><path d="M0 85.329v15.083l57.377 38.251H80zM256 85.329v15.083l-57.377 38.251H176z"/></g><path fill="#2E52B2" d="M256 107.951v30.712h-46.069z"/><g fill="#D80027"><path d="M0 255.997v-15.082l57.377-38.252H80zM256 255.997v-15.082l-57.377-38.252H176z"/></g><path fill="#FFDA44" d="m384 259.706-46.129 46.129c8.645 16.675 26.051 28.074 46.129 28.074s37.484-11.4 46.129-28.074L384 259.706z"/><path fill="#6DA544" d="M332.058 178.084V259.708c.001 39.759 51.942 51.941 51.942 51.941s51.941-12.182 51.942-51.942v-81.623H332.058z"/><path fill="#FFF" d="M372.87 215.181h22.261v59.359H372.87z"/><circle fill="#A2001D" cx="384" cy="215.181" r="11.13"/><g fill="#FFDA44"><path d="M346.902 192.92h14.84v14.84h-14.84zM346.902 226.312h14.84v14.84h-14.84zM346.902 259.703h14.84v14.84h-14.84zM406.261 192.92h14.84v14.84h-14.84zM406.261 226.312h14.84v14.84h-14.84zM406.261 259.703h14.84v14.84h-14.84z"/></g></svg>',
    Ni = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 341.3"><path fill="#FFF" d="M0 0h512v341.3H0z"/><path fill="#1583C4" d="m397.7 166.3-51 97.7c-1.1 2-.3 4.5 1.8 5.6 2 1.1 4.5.3 5.6-1.8l51-97.7c1-2.1.1-4.6-2-5.5-2-.9-4.3-.2-5.4 1.7z"/><path fill="#1583C4" d="m404.9 188-57.8 75.4c-1.3 1.9-.8 4.5 1.1 5.8 1.7 1.2 4.1.9 5.5-.7l57.8-75.4c1.4-1.8 1.1-4.4-.8-5.8-1.8-1.5-4.4-1.1-5.8.7z"/><path fill="#1583C4" d="m379 181.3-32.5 83.1c-.8 2.1.2 4.6 2.4 5.4 2.1.8 4.6-.2 5.4-2.4l32.5-83.1c.7-2.2-.4-4.5-2.6-5.3-2.1-.6-4.3.4-5.2 2.3z"/><path fill="#409347" d="M122.1 171.9c.4 1.7 1.2 4.7 2.2 8.5 1.7 6.4 3.6 12.8 5.6 18.7 2.3 6.9 14.7 31.4 20.2 39.1 6.9 9.7 14.1 19.3 21.5 28.6 1.6 1.9 4.5 2.1 6.4.5 1.8-1.6 2.1-4.3.7-6.2-7.3-9.2-14.4-18.6-21.2-28.2-4.2-5.8-17.2-31.1-19-36.7-2.9-8.7-5.4-17.6-7.6-26.5-.5-2.4-2.9-4-5.3-3.5s-4 2.9-3.5 5.3c-.1.2 0 .3 0 .4z"/><g fill="#FFD836" stroke="#231F20" stroke-miterlimit="10"><path d="M297.1 114.9S279.5 42.8 261 42.8c-6.9 0-11.9-.6-15.4 6.4-.9 1.7-20.7-1.6-19.1 20.8.5 6.9 1.1-9.8 14.9-3.4 6.3 3-16.4 48.2-16.4 48.2h72.1z"/><path d="m466.1 48.4-90.9 22c-75.3 18.3-42.1 44.4-42.1 44.4l-72.1 12-72.1-12s33.2-26.1-42.1-44.4l-90.9-22C43.1 45.3 38.1 51.8 45.3 63c0 0 106.6 104 126.8 112 20.2 8.1 40.8 0 40.8 0s-14.9 8.7-24 24c-9.2 15.3-4.6 34.7-38.9 40.2-5.5 6.6-5 14 2.9 19.9 7.9 5.8 72.1-48.1 72.1-48.1s-24 24.4-24 36.1c0 5.1 44.1 53.8 60.1 53.8s60.1-48.7 60.1-53.8c0-11.7-24-36.1-24-36.1s64.2 53.9 72.1 48.1 11.4-19.3 2.8-19.9c-28-1.8-29.7-24.9-38.9-40.2-9.2-15.3-24-24-24-24s20.6 8.1 40.8 0S476.7 63 476.7 63c7.2-11.2 2.3-17.7-10.6-14.6z"/></g><path fill="#FFF" stroke="#231F20" stroke-miterlimit="10" d="M201.3 111.8v80.3c0 45.7 59.7 59.7 59.7 59.7s59.7-14 59.7-59.7v-80.3H201.3z"/><g fill="#D80027"><path d="M225.2 137.7V235c8.2 6 17 10.2 23.9 12.9V137.7h-23.9zM296.8 137.7V235c-8.2 6-17 10.2-23.9 12.9V137.7h23.9z"/></g><path fill="#0052B4" d="M201.3 111.8h119.4v37.9H201.3z"/><path fill="#1583C4" d="m60.1 210.5-21.9-58.1H15.7l31.8 80.8h25.2l31.5-80.8H81.7zM451.5 151.9h18.9v81.7h-18.9z"/></svg>',
    ji = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#D80027" d="M196.641 85.337H0v341.326h512V85.337z"/><path fill="#FFDA44" d="m256 157.279 22.663 69.747H352l-59.332 43.106 22.664 69.749L256 296.774l-59.332 43.107 22.664-69.749L160 227.026h73.337z"/></svg>',
    Li = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path d="M0 85.337h512v341.326H0z"/><path fill="#6DA544" d="M512 256v170.663H0L215.185 256z"/><path fill="#D80027" d="M512 85.337V256H215.185L0 85.337z"/><path d="M221.001 239.304 26.868 85.337H8.956l208.168 165.098H512v-11.131zM8.956 426.663h17.912l194.133-153.967H512v-11.131H217.124zM0 92.44v14.206L188.317 256 0 405.354v14.205L206.229 256z"/><g fill="#FFDA44"><path d="M8.956 85.337H0v7.103L206.229 256 0 419.559v7.104h8.956l208.168-165.098H512v-11.13H217.124z"/><path d="M63.718 292.382v-14.295c14.265 0 25.87-11.606 25.87-25.869 0-10.092-8.211-18.303-18.304-18.303-6.875 0-12.469 5.593-12.469 12.469 0 4.397 3.577 7.974 7.974 7.974a4.514 4.514 0 0 0 4.508-4.508h14.295c0 10.368-8.435 18.804-18.802 18.804-12.279-.002-22.269-9.993-22.269-22.271 0-14.758 12.006-26.764 26.764-26.764 17.975 0 32.599 14.623 32.599 32.599 0 22.145-18.018 40.164-40.166 40.164z"/></g></svg>',
    Ci = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 100"><path fill="#ED2939" d="M0 0h150v100H0z"/><path fill="#002395" d="M0 0h20v44.33H0z"/><path fill="#FFF" d="M20 0h20v44.33H20z"/><path fill="none" stroke="#FFF" stroke-width="3" d="M0 44.33h62.75V0"/><path fill="#FFF" d="M108.08 43.29 87.96 23.17h40.25l-20.13 20.12zm-6.7 6.71L81.25 29.88v40.25L101.38 50zm6.7 6.71L87.96 76.83h40.25l-20.13-20.12zm6.71-6.71 20.13-20.13v40.25L114.79 50z"/></svg>',
    Ti = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#D80027" d="M0 85.331h512v341.337H0z"/><path fill="#0052B4" d="M0 85.331h256v170.663H0z"/><g fill="#FFF"><path d="m165.483 181.79 2.764 8.504h8.939l-7.232 5.254 2.763 8.503-7.234-5.255-7.233 5.255 2.763-8.503-7.233-5.254h8.94zM120.579 115.007l4.606 14.173h14.9l-12.055 8.757 4.605 14.171-12.056-8.758-12.054 8.758 4.605-14.171-12.056-8.757h14.901zM165.101 129.848l4.606 14.172h14.9l-12.055 8.757 4.604 14.173-12.055-8.76-12.054 8.76 4.604-14.173-12.055-8.757h14.9zM129.909 189.211l4.606 14.172h14.9l-12.055 8.758 4.604 14.171-12.055-8.759-12.054 8.759 4.604-14.171-12.055-8.758h14.9zM90.899 152.108l4.605 14.173h14.9l-12.055 8.757 4.604 14.173-12.054-8.76-12.055 8.76 4.604-14.173-12.055-8.757h14.9z"/></g></svg>',
    Ii = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 341.33"><path fill="#0052B4" d="M0 0h512v341.34H0z"/><g fill="#FFF"><path d="m220.72 42.63 7.95 16.11 17.77 2.58-12.86 12.54 3.04 17.7-15.9-8.36-15.9 8.36 3.03-17.7-12.86-12.54 17.78-2.58zM291.28 42.57l7.95 16.1 17.78 2.59-12.86 12.53 3.03 17.71-15.9-8.36-15.9 8.36 3.04-17.71-12.86-12.53 17.77-2.59zM353.36 53.93l7.95 16.11 17.77 2.58-12.86 12.54 3.04 17.7-15.9-8.35-15.9 8.35 3.04-17.7-12.87-12.54 17.78-2.58zM416.37 72.23l7.95 16.11 17.77 2.59-12.86 12.53 3.04 17.71-15.9-8.36-15.9 8.36 3.03-17.71-12.86-12.53 17.78-2.59zM158.64 53.93l7.95 16.11 17.78 2.58-12.87 12.54 3.04 17.7-15.9-8.35-15.9 8.35 3.04-17.7-12.86-12.54 17.77-2.58zM95.63 72.23l7.95 16.11 17.78 2.59-12.86 12.53 3.03 17.71-15.9-8.36-15.9 8.36 3.04-17.71-12.86-12.53 17.77-2.59z"/></g><path fill="#FFDA44" d="m217.53 259.33-27.22-13.61-27.22-54.43h27.22l27.22-27.22 13.61-27.22 27.22-13.61 13.61 13.61 27.22 13.61v13.61l13.61 13.61 40.83 27.22L340 245.73l-40.83 40.83-13.61-27.22-40.83 27.22v27.22l-13.61-13.61-13.59-40.84z"/></svg>',
    Ri = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.337h512v341.326H0z"/><path fill="#D80027" d="M0 85.337h512v113.775H0z"/><path d="M0 312.888h512v113.775H0z"/></svg>',
    Vi = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 60"><path fill="#FFF" d="M0 0h90v60H0z"/><path stroke="#7f7f7f" stroke-width=".25" fill="#ABABAB" d="M75.6 39.6c-1.1.7 0 1.8-.6 1.9-.6.1-1.5-1.4-.2-2.5 1.6-1.5 5.8 0 5.9 4.3 0 2.2-.9 6.8-7.2 6.8-7.6 0-11.4-5.7-11.4-11.4 0-4.8 3.7-13.5 6.5-14.6 3.1-1.2 6.7-3.5 6.8-5 0-.5-1.4-.1-3.3.9-3.1 1.7-6.6 2.5-6.6 1.4s2.9-3.1 4-4.6c1.2-1.6.9-5.5 3-5.5 7.6 0 9.9 7.7 7 11.7-1.9 2.6 4.3 1 4.3 1s0 5.3-3.2 7.3c-3 1.8-4.8 3.9-4.8 3.9s.2-4.6-.5-3.9c-.6.7-11.1 4.5-10.3 12 .3 3 4.5 5.4 8.5 5.2s5.7-2.4 5.8-4.9c.1-3.9-3-4.4-3.7-4zM10.7 43.6c.1 2.5 1.8 4.7 5.8 4.9s8.2-2.2 8.5-5.2c.8-7.5-9.7-11.3-10.3-12-.7-.7-.5 3.9-.5 3.9s-1.8-2.1-4.8-3.9c-3.2-2-3.2-7.3-3.2-7.3s6.2 1.6 4.3-1c-2.9-4-.6-11.7 7-11.7 2.1 0 1.8 3.9 3 5.5 1.1 1.5 4 3.5 4 4.6s-3.5.3-6.6-1.4c-1.9-1-3.3-1.4-3.3-.9.1 1.5 3.7 3.8 6.8 5 2.8 1.1 6.5 9.8 6.5 14.6 0 5.7-3.8 11.4-11.4 11.4-6.3 0-7.2-4.6-7.2-6.8.1-4.3 4.3-5.8 5.9-4.3 1.2 1.1.4 2.7-.2 2.5-.6-.1.6-1.2-.6-1.9-.6-.4-3.7.1-3.7 4z"/><path fill="#DE393A" d="M31 28.8v14c0 1.9 2.1 1.6 2.1 1.6h9.3c1.2 0 2.6 2.3 2.6 2.3s1.4-2.3 2.5-2.3h9.6s2 .2 2-1.8V28.7H31z"/><path fill="#3951A3" d="M31 13.1h28v15.7H31z"/><path fill="#FFF" d="M50.1 16.5c-.4 2.4-2.5 4.2-5.1 4.2-2.5 0-4.6-1.8-5.1-4.2-.5.9-.8 1.9-.8 3 0 3.3 2.6 5.9 5.9 5.9 3.3 0 5.9-2.6 5.9-5.9 0-1.1-.3-2.1-.8-3z"/><circle fill="#FEE05F" cx="39.1" cy="36.5" r="3"/><circle fill="#FEE05F" cx="50.9" cy="36.5" r="3"/></svg>',
    ki = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.337h512v341.326H0z"/><path d="M114.024 256.001 0 141.926v228.17z"/><path fill="#ffb915" d="M161.192 256 0 94.7v47.226l114.024 114.075L0 370.096v47.138z"/><path fill="#007847" d="M509.833 289.391c.058-.44.804-.878 2.167-1.318v-65.464H222.602L85.33 85.337H0V94.7L161.192 256 0 417.234v9.429h85.33l137.272-137.272h287.231z"/><path fill="#000c8a" d="M503.181 322.783H236.433l-103.881 103.88H512v-103.88z"/><path fill="#e1392d" d="M503.181 189.217H512V85.337H132.552l103.881 103.88z"/></svg>',
    Oi = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#496E2D" d="M0 85.331h512v341.337H0z"/><path fill="#FF9811" d="M490.668 195.476h-48c0-8.836-7.164-16-16-16s-16 7.164-16 16h-48c0 8.836 7.697 16 16.533 16h-.533c0 8.836 7.162 16 16 16 0 8.836 7.162 16 16 16h32c8.836 0 16-7.164 16-16 8.836 0 16-7.164 16-16h-.533c8.837 0 16.533-7.164 16.533-16z"/><path fill="#D80027" d="M341.337 255.994h56.888v170.663h-56.888z"/><path fill="#FF9811" d="M455.112 255.994H512v170.663h-56.888z"/><path d="M398.225 255.994h56.888v170.663h-56.888z"/></svg>',
    Pi = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path d="M0 85.333h512V426.67H0z"/><g fill="#FFDA44"><path d="M0 134.196h512v48.868H0zM0 329.668h512v48.868H0z"/></g><path fill="#057f44" d="M0 85.333h512v48.868H0z"/><g fill="#D80027"><path d="M0 183.069h512v48.868H0zM0 280.806h512v48.868H0z"/></g><path fill="#057f44" d="M0 378.542h512v48.128H0z"/><path fill="#FFF" d="M276.992 255.996 106.329 426.659H0V85.333h106.329z"/><path d="M256 255.996 85.334 426.662h20.987l170.667-170.666L106.321 85.33H85.334z"/><path fill="#D80027" d="m102.465 202.57 13.259 40.812h42.917l-34.718 25.226 13.26 40.814-34.718-25.224-34.72 25.224 13.262-40.814-34.718-25.226h42.915z"/><path fill="#FFDA44" d="m138.94 259.335-34.559-12.243s-2.553-23.955-2.708-24.766c-1.173-6.18-6.603-10.851-13.123-10.851-7.376 0-13.357 5.98-13.357 13.357 0 1.223.178 2.402.486 3.528l-9.689 9.755h17.229c0 17.882-13.344 17.882-13.344 35.691l7.402 17.809h44.522l7.422-17.809h-.004a17.782 17.782 0 0 0 1.381-5.231c6.397-2.589 8.342-9.24 8.342-9.24z"/></svg>';
  var Gi = ["United States", "United Kingdom", "European Union", "United Arab Emirates", "Saudi Arabia", "Kuwait", "Qatar", "Bahrain", "Oman", "Abkhazia", "Afghanistan", "Akrotiri and Dhekelia (Great Britain)", "Albania", "Algeria", "Andorra", "Armenia", "Artsakh", "Australia", "Austria", "Azerbaijan", "Bangladesh", "Belarus", "Belgium", "Bhutan", "Bosnia and Herzegovina", "British Indian Ocean Territory", "Brunei", "Bulgaria", "Cambodia", "Canada", "China", "Christmas Island", "Croatia", "Cyprus", "Czechia", "Denmark", "Djibouti", "Egypt", "Estonia", "Finland", "France", "Georgia", "Germany", "Greece", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy", "Japan", "Jordan", "Kazakhstan", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Liechtenstein", "Lithuania", "Luxembourg", "Macau", "Malaysia", "Maldives", "Malta", "Mauritania", "Mexico", "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Myanmar (Burma)", "Nepal", "Netherlands", "New Zealand", "North Korea", "North Macedonia", "Northern Cyprus", "Norway", "Pakistan", "Palestinian Territory", "Philippines", "Poland", "Portugal", "Romania", "Russia", "San Marino", "Serbia", "Singapore", "Slovakia", "Somalia", "South Korea", "South Ossetia", "Spain", "Sri Lanka", "Sudan", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Thailand", "Timor-Leste", "Tunisia", "Turkey", "Turkmenistan", "Ukraine", "Uzbekistan", "Holy See (Vatican City)", "Vietnam", "Yemen"],
    Ki = e(119),
    Wi = e.n(Ki);
  const _i = new URLSearchParams(window.location.search).get("countryCode"),
    Yi = Wi.a.get("selectedCountryCode");
  let Zi = !1;
  _i ? (Wi.a.set("selectedCountryCode", _i), Zi = _i) : Yi && (Zi = Yi);
  const Ji = ["US", "CA", "MX"],
    qi = ["AE", "BH", "JO", "KW", "OM", "QA", "SA"],
    Xi = '\n<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Ebene_1" x="0px" y="0px" viewBox="0 0 270 180" style="enable-background:new 0 0 270 180;" xml:space="preserve">\n<style type="text/css">\n\t.st0{fill:#003399;}\n\t.st1{fill:#FFEF52;}\n</style>\n<rect y="0" class="st0" width="270" height="180"/>\n<path class="st1" d="M135,20l2.2,6.9l7.3,0l-5.9,4.3l2.2,6.9l-5.9-4.3l-5.9,4.3l2.2-6.9l-5.9-4.3l7.3,0L135,20z"/>\n<path class="st1" d="M187,110l2.2,6.9l7.3,0l-5.9,4.3l2.2,6.9l-5.9-4.3l-5.9,4.3l2.2-6.9l-5.9-4.3l7.3,0L187,110z"/>\n<path class="st1" d="M135,140l2.2,6.9l7.3,0l-5.9,4.3l2.2,6.9l-5.9-4.3l-5.9,4.3l2.2-6.9l-5.9-4.3l7.3,0L135,140z"/>\n<path class="st1" d="M195,80l2.2,6.9l7.3,0l-5.9,4.3l2.2,6.9l-5.9-4.3l-5.9,4.3l2.2-6.9l-5.9-4.3l7.3,0L195,80z"/>\n<path class="st1" d="M75,80l2.2,6.9l7.3,0l-5.9,4.3l2.2,6.9L75,93.8l-5.9,4.3l2.2-6.9l-5.9-4.3l7.3,0L75,80z"/>\n<path class="st1" d="M165,28l2.2,6.9l7.3,0l-5.9,4.3l2.2,6.9l-5.9-4.3l-5.9,4.3l2.2-6.9l-5.9-4.3l7.3,0L165,28z"/>\n<path class="st1" d="M105,28l2.2,6.9l7.3,0l-5.9,4.3l2.2,6.9l-5.9-4.3l-5.9,4.3l2.2-6.9l-5.9-4.3l7.3,0L105,28z"/>\n<path class="st1" d="M105,132l2.2,6.9l7.3,0l-5.9,4.3l2.2,6.9l-5.9-4.3l-5.9,4.3l2.2-6.9l-5.9-4.3l7.3,0L105,132z"/>\n<path class="st1" d="M165,132l2.2,6.9l7.3,0l-5.9,4.3l2.2,6.9l-5.9-4.3l-5.9,4.3l2.2-6.9l-5.9-4.3l7.3,0L165,132z"/>\n<path class="st1" d="M187,50l2.2,6.9l7.3,0l-5.9,4.3l2.2,6.9l-5.9-4.3l-5.9,4.3l2.2-6.9l-5.9-4.3l7.3,0L187,50z"/>\n<path class="st1" d="M83,50l2.2,6.9l7.3,0l-5.9,4.3l2.2,6.9L83,63.8l-5.9,4.3l2.2-6.9l-5.9-4.3l7.3,0L83,50z"/>\n<path class="st1" d="M83,110l2.2,6.9l7.3,0l-5.9,4.3l2.2,6.9l-5.9-4.3l-5.9,4.3l2.2-6.9l-5.9-4.3l7.3,0L83,110z"/>\n</svg>',
    $i = (t, n) => `https://${qi.includes(t)?"me":Ji.includes(t)?"www":"GB"==t?"uk":"eu"}.whind.com?currency=${n}&countryCode=${t}`,
    Qi = Gi.reduce((t, n) => {
      const e = Object(r.byCountry)(n);
      if (e) {
        const n = a.countries[e.iso2],
          r = n.currency.split(",")[0];
        t[e.iso2] = {
          ...n,
          currency: r,
          flag: i[e.iso2],
          code: e.iso3,
          storeURL: $i(e.iso2, r)
        }
      }
      return t
    }, {}),
    ta = t => Qi[t],
    na = t => {
      const n = {
        USD: Qi.US,
        EUR: {
          storeURL: "https://eu.whind.com/?currency=EUR",
          flag: Xi,
          name: "EU",
          code: "EU",
          currency: "EUR"
        }
      };
      return n[t] ? n[t] : Object.values(Qi).find(n => n.currency == t)
    },
    ea = document.querySelector(".selectcountry-container-header"),
    ia = document.querySelector(".language_selector_mobile"),
    aa = ea.querySelector(".language_selector_desktop"),
    ra = ea.querySelector(".languages"),
    oa = ia.dataset.currency;
  window.addEventListener("DOMContentLoaded", async () => {
    const t = await (async () => {
        const t = await fetch("https://ipwhois.pro/json/?key=y8tsPaatbxTvWyDY");
        return await t.json()
      })(),
      n = "shown" == localStorage.getItem("popState");
    (t => {
      let n, e;
      const i = ta(t.country_code);
      !1 === Zi ? (n = na(oa), e = i.currency === n.currency ? i.name : n.name) : (n = ta(Zi), e = n.name);
      const a = Object.values(Qi).map(t => `\n    <option value="${t.name === 'United Kingdom' ? 'https://whind.com?currency=GBP&countryCode=GB' : t.storeURL}">\n      ${t.name}\n    </option>\n    `);
      ia.innerHTML = `\n    <option>${e}</option>\n    ${a.join("\n")}\n  `, aa.innerHTML = e;
      const r = Object.values(Qi).map(t => `\n    <li>\n      <a href="${t.name === 'United Kingdom' ? 'https://whind.com?currency=GBP&countryCode=GB' : t.storeURL}">\n        <span>${t.name}</span>\n      </a>\n    </li>\n    `);
      ra.innerHTML = r.join("\n"), aa.addEventListener("click", () => {
        ra.classList.toggle("active")
      })
    })(t);
    const e = Qi[t.country_code] ? Qi[t.country_code] : {
      storeURL: "https://eu.whind.com?currency=EUR",
      flag: i[t.country_code],
      name: t.country,
      currency: "EUR"
    };
    let a;
    a = Zi ? ta(t.country_code) : na(oa);
    if (a.currency != e.currency && !n) {
      const t = document.getElementById("popup"),
        n = document.getElementsByClassName("close-popup")[0],
        i = document.querySelector("#suggested_store"),
        r = document.querySelector("#current_store");
      n.onclick = function () {
        t.style.display = "none"
      }, window.onclick = function (n) {
        n.target == t && (t.style.display = "none")
      }, i.innerHTML = `<a href="${e.name === 'United Kingdom' ? 'https://whind.com?currency=GBP&countryCode=GB' : e.storeURL}">\n        ${e.flag}\n        ${e.name}\n      </a>`, r.innerHTML = `<a href="/"">\n        ${a.flag}\n        ${a.name}\n      </a>`, $("#popup").fadeIn(), localStorage.setItem("popState", "shown")
    }
  }), $("#bundleProducts").on("click", (function () {
    const t = $("#bundleFirstProductId").val(),
      n = $("#bundleSecondProductId").val();
    CartJS.addItems([{
      id: t,
      quantity: 1
    }, {
      id: n,
      quantity: 1
    }], {
      success: function (t, n, e) {
        $(".lightboxbg").show(), $(".cart_container").show(), anime({
          targets: ".cart_container",
          duration: 500,
          translateX: -400,
          easing: "easeOutSine"
        })
      },
      error: function (t, n, e) {
        $("#message").addClass("message-error"), $("#message").html("There was a problem adding to the cart!"), anime({
          targets: "#message",
          duration: 500,
          scaleY: [0, 1],
          easing: "easeOutSine"
        })
      }
    })
  }));
  const la = document.querySelector("#productPrice"),
    ca = document.querySelector("#stickyCart");
  if (ca && la) {
    new IntersectionObserver((function (t) {
      t.map(t => {
        t.boundingClientRect.top > 0 || t.isIntersecting ? ca.classList.remove("sticky-cart--visible") : ca.classList.add("sticky-cart--visible")
      })
    })).observe(la), $("#AddToCartSticky").click((function () {
      var t = $("#quantity").val(),
        n = $("#getvID").val();
      CartJS.addItem(n, t, {}, {
        success: function (t, n, e) {
          $(".lightboxbg").show(), $(".cart_container").show(), anime({
            targets: ".cart_container",
            duration: 500,
            translateX: -400,
            easing: "easeOutSine"
          })
        },
        error: function (t, n, e) {
          $("#message").addClass("message-error"), $("#message").html("There was a problem adding to the cart!"), anime({
            targets: "#message",
            duration: 500,
            scaleY: [0, 1],
            easing: "easeOutSine"
          })
        }
      })
    }))
  }
  const sa = (t, n = {}) => {
      const e = "shopify-section-" + t;
      return ha(t, n).then(n => {
        document.querySelector("#" + e) && (document.querySelector("#" + e).outerHTML = n, document.querySelector("#" + e).classList.add("section-api-loaded"), $(window).trigger("ajaxLoaded", [t]), console.log("ajaxLoaded", t))
      })
    },
    ha = (t, n = {}) => {
      const e = new URL(window.location.href);
      let i = new URLSearchParams(e.search.slice(1));
      i.append("section_id", t);
      for (const [t, e] of Object.entries(n)) i.append(t, e);
      return e.search = new URLSearchParams(i), fetch(e, {
        credentials: "same-origin"
      }).then(t => {
        if (!t.ok) throw Error(t.statusText);
        return t.text()
      }).catch(t => {
        console.error(t)
      })
    };
  $(document).on("cart.requestComplete", (function (t, n) {
    document.querySelector("klarna-placement").dataset.purchaseAmount = n.items_subtotal_price, window.KlarnaOnsiteService = window.KlarnaOnsiteService || [], window.KlarnaOnsiteService.push({
      eventName: "refresh-placements"
    }), sa("cart-recommendations"), sa("cart-gift-boxes")
  }))
}]);